import { c } from "react/compiler-runtime";
import { Menu } from "@base-ui/react/menu";
import { ArrowDownIcon, ArrowRight, ArrowUpIcon, CalendarIcon, Check, CheckIcon, ChevronDown, ChevronDownIcon, ChevronLeft, ChevronLeftIcon, ChevronRight, ChevronRightIcon, ChevronUpIcon, ChevronsUpDownIcon, CircleCheckIcon, CircleXIcon, Download, FileDownIcon, FilterIcon, InfoIcon, LayoutDashboardIcon, Loader2Icon, LogOut, MinusIcon, PanelLeftIcon, PlusIcon, SearchIcon, SlidersHorizontalIcon, SparklesIcon, TriangleAlertIcon, TriangleIcon, XIcon } from "lucide-react";
import * as React from "react";
import { createContext, forwardRef, use, useCallback, useContext, useEffect, useId, useLayoutEffect, useMemo, useReducer, useRef, useState } from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Avatar } from "@base-ui/react/avatar";
import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";
import { cva } from "class-variance-authority";
import { Collapsible as Collapsible$1 } from "@base-ui/react/collapsible";
import { Button as Button$1 } from "@base-ui/react/button";
import { Input as Input$1 } from "@base-ui/react/input";
import { Separator as Separator$1 } from "@base-ui/react/separator";
import { Dialog as Dialog$1 } from "@base-ui/react/dialog";
import { Tooltip as Tooltip$1 } from "@base-ui/react/tooltip";
import { Subscribe, columnFacetingFeature, columnFilteringFeature, columnResizingFeature, columnSizingFeature, columnVisibilityFeature, createExpandedRowModel, createFacetedRowModel, createFacetedUniqueValues, createFilteredRowModel, createSortedRowModel, createTableHook, filterFn_arrHas, filterFn_includesString, functionalUpdate, metaHelper, rowExpandingFeature, rowSelectionFeature, rowSortingFeature, sortFn_alphanumeric, tableFeatures } from "@tanstack/react-table";
import { Checkbox as Checkbox$1 } from "@base-ui/react/checkbox";
import { Popover as Popover$1 } from "@base-ui/react/popover";
import { useDebouncedCallback } from "@tanstack/react-pacer";
import Fuse from "fuse.js";
import { useVirtualizer } from "@tanstack/react-virtual";
import { Radio } from "@base-ui/react/radio";
import { RadioGroup as RadioGroup$1 } from "@base-ui/react/radio-group";
import { format } from "date-fns";
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { MessageScroller as MessageScroller$1, useMessageScroller, useMessageScrollerScrollable, useMessageScrollerVisibility } from "@shadcn/react/message-scroller";
import { Slider as Slider$1 } from "@base-ui/react/slider";
import { Tabs as Tabs$1 } from "@base-ui/react/tabs";
import { Combobox as Combobox$1 } from "@base-ui/react";
import { Select as Select$1 } from "@base-ui/react/select";
import { Switch as Switch$1 } from "@base-ui/react/switch";
import { Toast as Toast$1 } from "@base-ui/react/toast";
import { Toggle } from "@base-ui/react/toggle";
import { ToggleGroup as ToggleGroup$1 } from "@base-ui/react/toggle-group";
import useEmblaCarousel from "embla-carousel-react";
//#region src/tokens/chart-theme-tokens.ts
const seriesPalettes = {
	vibrant: [
		"#00bfff",
		"#2e8b57",
		"#ffd700",
		"#6363df",
		"#f3733f",
		"#ff2d55"
	],
	monoBlue: [
		"#bddeff",
		"#85c1f5",
		"#5ba7f7",
		"#378ce4",
		"#1976d2",
		"#0d47a1"
	],
	balanced: [
		"#8bb6c7",
		"#a8c09a",
		"#d4b483",
		"#c4a5c7",
		"#d19b9b",
		"#9eaab0"
	]
};
const chartThemeTokens = {
	seriesPalettes,
	dark: {
		background: "#0d1228",
		foreground: "#f8f8f8",
		mutedForeground: "#a1a6ab",
		disabledForeground: "#6c737a",
		grid: "#4d5b88",
		border: "#4d5b88",
		accent: "#e84e0f",
		accentForeground: "#070818",
		tooltipBackground: "#121836",
		tooltipForeground: "#f8f8f8",
		navigatorBackground: "#070818",
		hoverBackground: "#1a224d",
		palette: seriesPalettes.vibrant,
		watermark: "/watermark-black.svg"
	},
	light: {
		background: "#f8f8f8",
		foreground: "#0d1228",
		mutedForeground: "#4f5458",
		disabledForeground: "#6c737a",
		grid: "#8390b9",
		border: "#8390b9",
		accent: "#e84e0f",
		accentForeground: "#070818",
		tooltipBackground: "#0d1228",
		tooltipForeground: "#f8f8f8",
		navigatorBackground: "#f8f8f8",
		hoverBackground: "#bddeff",
		palette: seriesPalettes.monoBlue,
		watermark: "/watermark-color.svg"
	},
	fontFamily: "Cairo, sans-serif"
};
//#endregion
//#region src/lib/utils.ts
function cn(...inputs) {
	return twMerge(clsx(inputs));
}
//#endregion
//#region src/components/ui/dropdown-menu.tsx
function DropdownMenu(t0) {
	const $ = c(5);
	if ($[0] !== "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Menu.Root, {
			"data-slot": "dropdown-menu",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function DropdownMenuTrigger(t0) {
	const $ = c(5);
	if ($[0] !== "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Menu.Trigger, {
			"data-slot": "dropdown-menu-trigger",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function DropdownMenuContent(t0) {
	const $ = c(25);
	if ($[0] !== "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf") {
		for (let $i = 0; $i < 25; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf";
	}
	let anchor;
	let className;
	let positionerClassName;
	let props;
	let t1;
	let t2;
	let t3;
	let t4;
	if ($[1] !== t0) {
		({align: t1, alignOffset: t2, side: t3, sideOffset: t4, anchor, className, positionerClassName, ...props} = t0);
		$[1] = t0;
		$[2] = anchor;
		$[3] = className;
		$[4] = positionerClassName;
		$[5] = props;
		$[6] = t1;
		$[7] = t2;
		$[8] = t3;
		$[9] = t4;
	} else {
		anchor = $[2];
		className = $[3];
		positionerClassName = $[4];
		props = $[5];
		t1 = $[6];
		t2 = $[7];
		t3 = $[8];
		t4 = $[9];
	}
	const align = t1 === void 0 ? "start" : t1;
	const alignOffset = t2 === void 0 ? 0 : t2;
	const side = t3 === void 0 ? "bottom" : t3;
	const sideOffset = t4 === void 0 ? 4 : t4;
	let t5;
	if ($[10] !== positionerClassName) {
		t5 = cn("isolate z-[var(--z-menu)] outline-none", positionerClassName);
		$[10] = positionerClassName;
		$[11] = t5;
	} else t5 = $[11];
	let t6;
	if ($[12] !== className) {
		t6 = cn("max-h-(--available-height) w-(--anchor-width) min-w-32 origin-(--transform-origin) overflow-x-hidden overflow-y-auto rounded-lg bg-popover p-1 text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 outline-none data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:overflow-hidden data-closed:fade-out-0 data-closed:zoom-out-95 motion-reduce:animate-none motion-reduce:transition-none", className);
		$[12] = className;
		$[13] = t6;
	} else t6 = $[13];
	let t7;
	if ($[14] !== props || $[15] !== t6) {
		t7 = /* @__PURE__ */ jsx(Menu.Popup, {
			"data-slot": "dropdown-menu-content",
			className: t6,
			...props
		});
		$[14] = props;
		$[15] = t6;
		$[16] = t7;
	} else t7 = $[16];
	let t8;
	if ($[17] !== align || $[18] !== alignOffset || $[19] !== anchor || $[20] !== side || $[21] !== sideOffset || $[22] !== t5 || $[23] !== t7) {
		t8 = /* @__PURE__ */ jsx(Menu.Portal, { children: /* @__PURE__ */ jsx(Menu.Positioner, {
			"data-slot": "dropdown-menu-positioner",
			className: t5,
			align,
			alignOffset,
			anchor,
			side,
			sideOffset,
			children: t7
		}) });
		$[17] = align;
		$[18] = alignOffset;
		$[19] = anchor;
		$[20] = side;
		$[21] = sideOffset;
		$[22] = t5;
		$[23] = t7;
		$[24] = t8;
	} else t8 = $[24];
	return t8;
}
function DropdownMenuGroup(t0) {
	const $ = c(5);
	if ($[0] !== "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Menu.Group, {
			"data-slot": "dropdown-menu-group",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function DropdownMenuLabel(t0) {
	const $ = c(11);
	if ($[0] !== "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf") {
		for (let $i = 0; $i < 11; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf";
	}
	let className;
	let inset;
	let props;
	if ($[1] !== t0) {
		({className, inset, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = inset;
		$[4] = props;
	} else {
		className = $[2];
		inset = $[3];
		props = $[4];
	}
	let t1;
	if ($[5] !== className) {
		t1 = cn("px-1.5 py-1 text-xs font-medium text-muted-foreground data-inset:pl-7", className);
		$[5] = className;
		$[6] = t1;
	} else t1 = $[6];
	let t2;
	if ($[7] !== inset || $[8] !== props || $[9] !== t1) {
		t2 = /* @__PURE__ */ jsx(Menu.GroupLabel, {
			"data-slot": "dropdown-menu-label",
			"data-inset": inset,
			className: t1,
			...props
		});
		$[7] = inset;
		$[8] = props;
		$[9] = t1;
		$[10] = t2;
	} else t2 = $[10];
	return t2;
}
function DropdownMenuItem(t0) {
	const $ = c(13);
	if ($[0] !== "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf") {
		for (let $i = 0; $i < 13; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf";
	}
	let className;
	let inset;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, inset, variant: t1, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = inset;
		$[4] = props;
		$[5] = t1;
	} else {
		className = $[2];
		inset = $[3];
		props = $[4];
		t1 = $[5];
	}
	const variant = t1 === void 0 ? "default" : t1;
	let t2;
	if ($[6] !== className) {
		t2 = cn("group/dropdown-menu-item relative flex cursor-default items-center gap-1.5 rounded-md px-1.5 py-1 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-highlighted:bg-accent data-highlighted:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground not-data-[variant=destructive]:data-highlighted:**:text-accent-foreground data-inset:pl-7 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:data-highlighted:bg-destructive/10 data-[variant=destructive]:data-highlighted:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 dark:data-[variant=destructive]:data-highlighted:bg-destructive/20 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 data-[variant=destructive]:*:[svg]:text-destructive", className);
		$[6] = className;
		$[7] = t2;
	} else t2 = $[7];
	let t3;
	if ($[8] !== inset || $[9] !== props || $[10] !== t2 || $[11] !== variant) {
		t3 = /* @__PURE__ */ jsx(Menu.Item, {
			"data-slot": "dropdown-menu-item",
			"data-inset": inset,
			"data-variant": variant,
			className: t2,
			...props
		});
		$[8] = inset;
		$[9] = props;
		$[10] = t2;
		$[11] = variant;
		$[12] = t3;
	} else t3 = $[12];
	return t3;
}
function DropdownMenuSub(t0) {
	const $ = c(5);
	if ($[0] !== "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Menu.SubmenuRoot, {
			"data-slot": "dropdown-menu-sub",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function DropdownMenuSubTrigger(t0) {
	const $ = c(17);
	if ($[0] !== "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf") {
		for (let $i = 0; $i < 17; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf";
	}
	let children;
	let className;
	let hideIcon;
	let inset;
	let props;
	if ($[1] !== t0) {
		({className, inset, hideIcon, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = hideIcon;
		$[5] = inset;
		$[6] = props;
	} else {
		children = $[2];
		className = $[3];
		hideIcon = $[4];
		inset = $[5];
		props = $[6];
	}
	let t1;
	if ($[7] !== className) {
		t1 = cn("flex cursor-default items-center gap-1.5 rounded-md px-1.5 py-1 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-highlighted:bg-accent data-highlighted:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground not-data-[variant=destructive]:data-highlighted:**:text-accent-foreground data-inset:pl-7 data-popup-open:bg-accent data-popup-open:text-accent-foreground data-open:bg-accent data-open:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className);
		$[7] = className;
		$[8] = t1;
	} else t1 = $[8];
	let t2;
	if ($[9] !== hideIcon) {
		t2 = !hideIcon && /* @__PURE__ */ jsx(ChevronRightIcon, { className: "ml-auto" });
		$[9] = hideIcon;
		$[10] = t2;
	} else t2 = $[10];
	let t3;
	if ($[11] !== children || $[12] !== inset || $[13] !== props || $[14] !== t1 || $[15] !== t2) {
		t3 = /* @__PURE__ */ jsxs(Menu.SubmenuTrigger, {
			"data-slot": "dropdown-menu-sub-trigger",
			"data-inset": inset,
			className: t1,
			...props,
			children: [children, t2]
		});
		$[11] = children;
		$[12] = inset;
		$[13] = props;
		$[14] = t1;
		$[15] = t2;
		$[16] = t3;
	} else t3 = $[16];
	return t3;
}
function DropdownMenuSubContent(t0) {
	const $ = c(17);
	if ($[0] !== "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf") {
		for (let $i = 0; $i < 17; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf";
	}
	let className;
	let props;
	let t1;
	let t2;
	let t3;
	let t4;
	if ($[1] !== t0) {
		({align: t1, alignOffset: t2, side: t3, sideOffset: t4, className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
		$[5] = t2;
		$[6] = t3;
		$[7] = t4;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
		t2 = $[5];
		t3 = $[6];
		t4 = $[7];
	}
	const align = t1 === void 0 ? "start" : t1;
	const alignOffset = t2 === void 0 ? -3 : t2;
	const side = t3 === void 0 ? "right" : t3;
	const sideOffset = t4 === void 0 ? 0 : t4;
	let t5;
	if ($[8] !== className) {
		t5 = cn("w-auto min-w-[96px] rounded-lg bg-popover p-1 text-popover-foreground shadow-lg ring-1 ring-foreground/10 duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 motion-reduce:animate-none motion-reduce:transition-none", className);
		$[8] = className;
		$[9] = t5;
	} else t5 = $[9];
	let t6;
	if ($[10] !== align || $[11] !== alignOffset || $[12] !== props || $[13] !== side || $[14] !== sideOffset || $[15] !== t5) {
		t6 = /* @__PURE__ */ jsx(DropdownMenuContent, {
			"data-slot": "dropdown-menu-sub-content",
			className: t5,
			align,
			alignOffset,
			side,
			sideOffset,
			...props
		});
		$[10] = align;
		$[11] = alignOffset;
		$[12] = props;
		$[13] = side;
		$[14] = sideOffset;
		$[15] = t5;
		$[16] = t6;
	} else t6 = $[16];
	return t6;
}
function DropdownMenuCheckboxItem(t0) {
	const $ = c(16);
	if ($[0] !== "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf") {
		for (let $i = 0; $i < 16; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf";
	}
	let checked;
	let children;
	let className;
	let inset;
	let props;
	if ($[1] !== t0) {
		({className, children, checked, inset, ...props} = t0);
		$[1] = t0;
		$[2] = checked;
		$[3] = children;
		$[4] = className;
		$[5] = inset;
		$[6] = props;
	} else {
		checked = $[2];
		children = $[3];
		className = $[4];
		inset = $[5];
		props = $[6];
	}
	let t1;
	if ($[7] !== className) {
		t1 = cn("relative flex cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-highlighted:bg-accent data-highlighted:text-accent-foreground focus:**:text-accent-foreground data-highlighted:**:text-accent-foreground data-inset:pl-7 data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className);
		$[7] = className;
		$[8] = t1;
	} else t1 = $[8];
	let t2;
	if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = /* @__PURE__ */ jsx("span", {
			className: "pointer-events-none absolute right-2 flex items-center justify-center",
			"data-slot": "dropdown-menu-checkbox-item-indicator",
			children: /* @__PURE__ */ jsx(Menu.CheckboxItemIndicator, { children: /* @__PURE__ */ jsx(CheckIcon, {}) })
		});
		$[9] = t2;
	} else t2 = $[9];
	let t3;
	if ($[10] !== checked || $[11] !== children || $[12] !== inset || $[13] !== props || $[14] !== t1) {
		t3 = /* @__PURE__ */ jsxs(Menu.CheckboxItem, {
			"data-slot": "dropdown-menu-checkbox-item",
			"data-inset": inset,
			className: t1,
			checked,
			...props,
			children: [t2, children]
		});
		$[10] = checked;
		$[11] = children;
		$[12] = inset;
		$[13] = props;
		$[14] = t1;
		$[15] = t3;
	} else t3 = $[15];
	return t3;
}
function DropdownMenuSeparator(t0) {
	const $ = c(9);
	if ($[0] !== "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "cdce5ac2d58d2612a902b30619248bbaf7b4d5bb0eec33626ee06683b4c09fcf";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("-mx-1 my-1 h-px bg-border", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Menu.Separator, {
			"data-slot": "dropdown-menu-separator",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/app-sidebar-open-paths.ts
const normalizePathsAtLevel = (value) => {
	const raw = value;
	if (Array.isArray(raw)) return raw;
	if (raw === "") return [""];
	return raw ? [raw] : [];
};
const isExplicitlyOpen = ({ pathsAtLevel, fullPath, hasItemPath }) => {
	return pathsAtLevel.includes(fullPath) || !hasItemPath && pathsAtLevel.includes("");
};
const shouldOpenWhenDescendantActive = ({ level, isMenuOpen, openPaths, isExplicitlyOpenAtLevel }) => {
	if (!isMenuOpen) return true;
	if (!(level in openPaths)) return true;
	return isExplicitlyOpenAtLevel;
};
/** Whether the node identified by `fullPath` (see {@link resolveFullId}) should render open, given the current tree-wide open-state map. */
const getShouldBeOpen = ({ openPaths, level, isAnyDescendantActive, isMenuOpen, fullPath, hasItemPath }) => {
	const pathsAtLevel = normalizePathsAtLevel(openPaths[level]);
	const explicitlyOpen = isExplicitlyOpen({
		pathsAtLevel,
		fullPath,
		hasItemPath
	});
	if (isAnyDescendantActive) return shouldOpenWhenDescendantActive({
		level,
		isMenuOpen,
		openPaths,
		isExplicitlyOpenAtLevel: explicitlyOpen
	});
	if (!isMenuOpen) return false;
	if (level === 0 && pathsAtLevel.includes("")) return true;
	return explicitlyOpen;
};
const pruneDeeperLevels = ({ updated, level, shouldKeep }) => {
	for (const key of Object.keys(updated)) {
		const keyNum = Number(key);
		if (keyNum > level) {
			const filtered = (updated[keyNum] || []).filter(shouldKeep);
			if (filtered.length) updated[keyNum] = filtered;
			else delete updated[keyNum];
		}
	}
};
const closeOpenPath = ({ updated, level, fullPath, currentAtLevel }) => {
	updated[level] = currentAtLevel.filter((p) => p !== fullPath);
	pruneDeeperLevels({
		updated,
		level,
		shouldKeep: (path) => !path.startsWith(fullPath)
	});
};
const openLevel0 = (updated, fullPath) => {
	updated[0] = fullPath ? [fullPath] : [];
};
const openLevel1 = (updated, fullPath) => {
	updated[1] = [fullPath];
	pruneDeeperLevels({
		updated,
		level: 1,
		shouldKeep: (path) => path.startsWith(fullPath)
	});
};
const openDeeperLevel = ({ updated, level, fullPath, currentAtLevel }) => {
	updated[level] = [...currentAtLevel, fullPath];
};
/**
* Computes the next tree-wide open-state map after clicking the node identified by
* `fullPath` at `level`. Sibling-exclusive accordion at level 0/1 (opening one closes any
* other open sibling at that level); level 2+ branches can stay open simultaneously
* (append, not replace). Closing always keeps the level's key present (as `[]`) so a
* manually-closed branch doesn't get silently re-opened by the active-descendant auto-open.
*/
const getNextOpenPaths = (prev, level, fullPath, { isMenuOpen, isCurrentlyOpen }) => {
	const currentAtLevel = normalizePathsAtLevel(prev[level]);
	const updated = { ...prev };
	if (level === 0 && !isMenuOpen) {
		openLevel0(updated, fullPath);
		return updated;
	}
	if (isCurrentlyOpen) {
		closeOpenPath({
			updated,
			level,
			fullPath,
			currentAtLevel
		});
		return updated;
	}
	if (level === 0) {
		openLevel0(updated, fullPath);
		return updated;
	}
	if (level === 1) {
		openLevel1(updated, fullPath);
		return updated;
	}
	openDeeperLevel({
		updated,
		level,
		fullPath,
		currentAtLevel
	});
	return updated;
};
/**
* Computes a stable, globally-unique identity string for a menu node, used as the
* `fullPath` key in {@link getShouldBeOpen}/{@link getNextOpenPaths}. Mirrors client-ui's
* route-based `resolveFullPath`: a node with its own `to` uses that (absolute, like a
* route); otherwise its identity is derived by joining its label onto the parent's.
*/
const resolveFullId = (parentId, item) => item.to ?? (parentId ? `${parentId}/${item.label}` : item.label);
//#endregion
//#region src/components/ui/avatar.tsx
function Avatar$1(t0) {
	const $ = c(11);
	if ($[0] !== "df12d756a084f66595bacf4f74d7d0631a80eef4068213903c06c06387f8474f") {
		for (let $i = 0; $i < 11; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "df12d756a084f66595bacf4f74d7d0631a80eef4068213903c06c06387f8474f";
	}
	let className;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, size: t1, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
	}
	const size = t1 === void 0 ? "default" : t1;
	let t2;
	if ($[5] !== className) {
		t2 = cn("group/avatar relative flex size-8 shrink-0 rounded-full select-none after:absolute after:inset-0 after:rounded-full after:border after:border-border after:mix-blend-darken data-[size=lg]:size-10 data-[size=sm]:size-6 dark:after:mix-blend-lighten", className);
		$[5] = className;
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] !== props || $[8] !== size || $[9] !== t2) {
		t3 = /* @__PURE__ */ jsx(Avatar.Root, {
			"data-slot": "avatar",
			"data-size": size,
			className: t2,
			...props
		});
		$[7] = props;
		$[8] = size;
		$[9] = t2;
		$[10] = t3;
	} else t3 = $[10];
	return t3;
}
function AvatarFallback(t0) {
	const $ = c(9);
	if ($[0] !== "df12d756a084f66595bacf4f74d7d0631a80eef4068213903c06c06387f8474f") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "df12d756a084f66595bacf4f74d7d0631a80eef4068213903c06c06387f8474f";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex size-full items-center justify-center rounded-full bg-muted text-sm text-muted-foreground group-data-[size=sm]/avatar:text-xs", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Avatar.Fallback, {
			"data-slot": "avatar-fallback",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/ui/badge.tsx
const badgeVariants = cva("inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-md border border-transparent px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 [a&]:hover:opacity-90 [&>svg]:pointer-events-none [&>svg]:size-3", {
	variants: {
		variant: {
			muted: "bg-gx-action-bar-button-tile text-gx-text",
			accent: "bg-gx-highlight text-white",
			new: "bg-gx-tag-new-bg text-gx-tag-new-text",
			accentOutline: "rounded-full border-gx-highlight bg-gx-highlight/12 px-2 py-px text-[11px] font-extrabold tracking-[0.09em] text-gx-highlight",
			mutedOutline: "rounded-full border-[#333c5e] px-[7px] py-px text-[11px] font-bold tracking-[0.08em] text-gx-text-secondary uppercase",
			warningOutline: "rounded-full border-gx-warning bg-gx-warning/12 px-2 py-px text-[11px] font-extrabold tracking-[0.09em] text-gx-warning",
			neutralOutline: "rounded-full border-[#333c5e] px-2 py-px text-[11px] font-extrabold tracking-[0.09em] text-gx-text-disabled"
		},
		size: {
			default: "",
			sm: "h-4 min-w-4 px-1 py-0 text-[10px] leading-none"
		}
	},
	defaultVariants: {
		variant: "accent",
		size: "default"
	}
});
/**
* A small badge / status pill matching the app's tag colors. Seven variants:
* `muted` (neutral, the "beta" tag), `accent` (solid highlight fill), `new`
* (the catalog "NEW" blue), `accentOutline` (a highlight-bordered pill with a
* dim fill), `mutedOutline` (a neutral uppercase outline pill — the Morning
* Intel region tag), and the importance-pill family — `accentOutline` (high),
* `warningOutline` (medium), and `neutralOutline` (low) — which share identical
* geometry and typography (rounded-full, 11px/800/.09em, not uppercase) and
* differ only in color, used together for the Morning Intel "importance" chip.
* It is a non-interactive leaf: pass the
* `render` prop to turn it into a link or button (`[a&]` hover applies when
* rendered as an anchor), and compose an icon as a child
* (`<Badge><StarIcon />new</Badge>`).
*
* Import path: `@design-system/components/ui/badge`.
*/
function Badge(t0) {
	const $ = c(11);
	if ($[0] !== "71f8f72768102a791059c24d3b2c963ec0b3c880dfbbd852ec28c2d9d333ae35") {
		for (let $i = 0; $i < 11; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "71f8f72768102a791059c24d3b2c963ec0b3c880dfbbd852ec28c2d9d333ae35";
	}
	let render;
	let t1;
	let t2;
	let t3;
	if ($[1] !== t0) {
		const { className, variant, size, render: t4, ...props } = t0;
		render = t4;
		t3 = useRender;
		t1 = "span";
		t2 = mergeProps({ className: cn(badgeVariants({
			variant,
			size,
			className
		})) }, props);
		$[1] = t0;
		$[2] = render;
		$[3] = t1;
		$[4] = t2;
		$[5] = t3;
	} else {
		render = $[2];
		t1 = $[3];
		t2 = $[4];
		t3 = $[5];
	}
	let t4;
	if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
		t4 = { slot: "badge" };
		$[6] = t4;
	} else t4 = $[6];
	let t5;
	if ($[7] !== render || $[8] !== t1 || $[9] !== t2) {
		t5 = {
			defaultTagName: t1,
			props: t2,
			render,
			state: t4
		};
		$[7] = render;
		$[8] = t1;
		$[9] = t2;
		$[10] = t5;
	} else t5 = $[10];
	return t3(t5);
}
//#endregion
//#region src/components/ui/collapsible.tsx
function Collapsible(t0) {
	const $ = c(5);
	if ($[0] !== "6d693ba36de32ccbca71bd6ed821f3d6ee6956732ef64f054c312bef5475cfca") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6d693ba36de32ccbca71bd6ed821f3d6ee6956732ef64f054c312bef5475cfca";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Collapsible$1.Root, {
			"data-slot": "collapsible",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function CollapsibleTrigger(t0) {
	const $ = c(5);
	if ($[0] !== "6d693ba36de32ccbca71bd6ed821f3d6ee6956732ef64f054c312bef5475cfca") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6d693ba36de32ccbca71bd6ed821f3d6ee6956732ef64f054c312bef5475cfca";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Collapsible$1.Trigger, {
			"data-slot": "collapsible-trigger",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function CollapsibleContent(t0) {
	const $ = c(5);
	if ($[0] !== "6d693ba36de32ccbca71bd6ed821f3d6ee6956732ef64f054c312bef5475cfca") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6d693ba36de32ccbca71bd6ed821f3d6ee6956732ef64f054c312bef5475cfca";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Collapsible$1.Panel, {
			"data-slot": "collapsible-content",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
//#endregion
//#region src/components/ui/button.tsx
const buttonVariants = cva("group/button inline-flex shrink-0 items-center justify-center rounded-lg border border-transparent bg-clip-padding text-[13px] leading-[1.5] font-bold whitespace-nowrap transition-all outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", {
	variants: {
		variant: {
			default: "bg-[linear-gradient(160deg,var(--gx-accent-2),var(--primary))] text-primary-foreground shadow-[0_1px_0_rgba(255,255,255,0.15)_inset,0_6px_16px_-8px_var(--gx-accent-glow)] hover:shadow-[0_1px_0_rgba(255,255,255,0.2)_inset,0_8px_22px_-6px_var(--gx-accent-glow)]",
			outline: "border-border bg-background hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
			"outline-highlight": "border-gx-highlight bg-transparent text-gx-highlight hover:bg-gx-highlight/10",
			secondary: "bg-secondary text-secondary-foreground hover:bg-[color-mix(in_oklch,var(--secondary),var(--foreground)_5%)] aria-expanded:bg-secondary aria-expanded:text-secondary-foreground",
			ai: "bg-gx-ai text-[#0b0820] hover:brightness-110",
			ghost: "hover:bg-muted hover:text-foreground aria-expanded:bg-muted aria-expanded:text-foreground dark:hover:bg-muted/50",
			destructive: "bg-destructive/10 text-destructive hover:bg-destructive/20 focus-visible:border-destructive/40 focus-visible:ring-destructive/20 dark:bg-destructive/20 dark:hover:bg-destructive/30 dark:focus-visible:ring-destructive/40",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-9 gap-2 px-4 has-data-[icon=inline-end]:pr-3 has-data-[icon=inline-start]:pl-3",
			xs: "h-6 gap-1 rounded-[min(var(--radius-md),10px)] px-2 text-xs in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3",
			sm: "h-7 gap-1 rounded-[min(var(--radius-md),12px)] px-2.5 text-[0.8rem] in-data-[slot=button-group]:rounded-lg has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3.5",
			lg: "h-9 gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2",
			form: "h-9 w-full gap-1.5 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2 md:h-12",
			icon: "size-8",
			"icon-2xs": "relative size-4 rounded-[min(var(--radius-md),8px)] after:absolute after:-inset-1 [&_svg:not([class*='size-'])]:size-3",
			"icon-xs": "size-6 rounded-[min(var(--radius-md),10px)] in-data-[slot=button-group]:rounded-lg [&_svg:not([class*='size-'])]:size-3",
			"icon-sm": "size-7 rounded-[min(var(--radius-md),12px)] in-data-[slot=button-group]:rounded-lg",
			"icon-lg": "size-9"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function Button(t0) {
	const $ = c(13);
	if ($[0] !== "3639ca41440f601acc5595d01735651c37b7684336f33287c508e9def9afa9e5") {
		for (let $i = 0; $i < 13; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "3639ca41440f601acc5595d01735651c37b7684336f33287c508e9def9afa9e5";
	}
	let className;
	let props;
	let t1;
	let t2;
	if ($[1] !== t0) {
		({className, variant: t1, size: t2, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
		$[5] = t2;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
		t2 = $[5];
	}
	const variant = t1 === void 0 ? "default" : t1;
	const size = t2 === void 0 ? "default" : t2;
	let t3;
	if ($[6] !== className || $[7] !== size || $[8] !== variant) {
		t3 = cn(buttonVariants({
			variant,
			size,
			className
		}));
		$[6] = className;
		$[7] = size;
		$[8] = variant;
		$[9] = t3;
	} else t3 = $[9];
	let t4;
	if ($[10] !== props || $[11] !== t3) {
		t4 = /* @__PURE__ */ jsx(Button$1, {
			"data-slot": "button",
			className: t3,
			...props
		});
		$[10] = props;
		$[11] = t3;
		$[12] = t4;
	} else t4 = $[12];
	return t4;
}
//#endregion
//#region src/components/ui/input.tsx
function Input(t0) {
	const $ = c(11);
	if ($[0] !== "bc5848d7394845a4d70e998703125215a9aba018191919c2a2cfa9094ef9475e") {
		for (let $i = 0; $i < 11; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "bc5848d7394845a4d70e998703125215a9aba018191919c2a2cfa9094ef9475e";
	}
	let className;
	let props;
	let type;
	if ($[1] !== t0) {
		({className, type, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = type;
	} else {
		className = $[2];
		props = $[3];
		type = $[4];
	}
	let t1;
	if ($[5] !== className) {
		t1 = cn("h-12 w-full min-w-0 rounded-lg border border-input bg-gx-tile-light px-2.5 py-1 text-base transition-colors outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40", className);
		$[5] = className;
		$[6] = t1;
	} else t1 = $[6];
	let t2;
	if ($[7] !== props || $[8] !== t1 || $[9] !== type) {
		t2 = /* @__PURE__ */ jsx(Input$1, {
			type,
			"data-slot": "input",
			className: t1,
			...props
		});
		$[7] = props;
		$[8] = t1;
		$[9] = type;
		$[10] = t2;
	} else t2 = $[10];
	return t2;
}
//#endregion
//#region src/components/ui/separator.tsx
function Separator(t0) {
	const $ = c(11);
	if ($[0] !== "edf73bbbfd3353c23bdfd027918795bda26e23e9c22b2e427c4da7fd52603302") {
		for (let $i = 0; $i < 11; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "edf73bbbfd3353c23bdfd027918795bda26e23e9c22b2e427c4da7fd52603302";
	}
	let className;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, orientation: t1, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
	}
	const orientation = t1 === void 0 ? "horizontal" : t1;
	let t2;
	if ($[5] !== className) {
		t2 = cn("shrink-0 bg-border data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-stretch", className);
		$[5] = className;
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] !== orientation || $[8] !== props || $[9] !== t2) {
		t3 = /* @__PURE__ */ jsx(Separator$1, {
			"data-slot": "separator",
			orientation,
			className: t2,
			...props
		});
		$[7] = orientation;
		$[8] = props;
		$[9] = t2;
		$[10] = t3;
	} else t3 = $[10];
	return t3;
}
//#endregion
//#region src/components/ui/sheet.tsx
function Sheet(t0) {
	const $ = c(5);
	if ($[0] !== "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Dialog$1.Root, {
			"data-slot": "sheet",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function SheetTrigger(t0) {
	const $ = c(5);
	if ($[0] !== "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Dialog$1.Trigger, {
			"data-slot": "sheet-trigger",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function SheetClose(t0) {
	const $ = c(5);
	if ($[0] !== "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Dialog$1.Close, {
			"data-slot": "sheet-close",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function SheetPortal(t0) {
	const $ = c(5);
	if ($[0] !== "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Dialog$1.Portal, {
			"data-slot": "sheet-portal",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function SheetOverlay(t0) {
	const $ = c(9);
	if ($[0] !== "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("fixed inset-0 z-50 bg-black/10 transition-opacity duration-150 data-ending-style:opacity-0 data-starting-style:opacity-0 supports-backdrop-filter:backdrop-blur-xs", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Dialog$1.Backdrop, {
			"data-slot": "sheet-overlay",
			"data-testid": "sheet-overlay",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SheetContent(t0) {
	const $ = c(25);
	if ($[0] !== "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998") {
		for (let $i = 0; $i < 25; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998";
	}
	let children;
	let className;
	let container;
	let props;
	let t1;
	let t2;
	let t3;
	if ($[1] !== t0) {
		({className, children, side: t1, showCloseButton: t2, container, hideOverlay: t3, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = container;
		$[5] = props;
		$[6] = t1;
		$[7] = t2;
		$[8] = t3;
	} else {
		children = $[2];
		className = $[3];
		container = $[4];
		props = $[5];
		t1 = $[6];
		t2 = $[7];
		t3 = $[8];
	}
	const side = t1 === void 0 ? "right" : t1;
	const showCloseButton = t2 === void 0 ? true : t2;
	const hideOverlay = t3 === void 0 ? false : t3;
	let t4;
	if ($[9] !== hideOverlay) {
		t4 = !hideOverlay && /* @__PURE__ */ jsx(SheetOverlay, {});
		$[9] = hideOverlay;
		$[10] = t4;
	} else t4 = $[10];
	let t5;
	if ($[11] !== className) {
		t5 = cn("fixed z-50 flex flex-col gap-4 bg-popover bg-clip-padding text-sm text-popover-foreground shadow-lg transition duration-200 ease-in-out data-ending-style:opacity-0 data-starting-style:opacity-0 data-[side=bottom]:inset-x-0 data-[side=bottom]:bottom-0 data-[side=bottom]:h-auto data-[side=bottom]:border-t data-[side=bottom]:data-ending-style:translate-y-[2.5rem] data-[side=bottom]:data-starting-style:translate-y-[2.5rem] data-[side=left]:inset-y-0 data-[side=left]:left-0 data-[side=left]:h-full data-[side=left]:w-3/4 data-[side=left]:border-r data-[side=left]:data-ending-style:translate-x-[-2.5rem] data-[side=left]:data-starting-style:translate-x-[-2.5rem] data-[side=right]:inset-y-0 data-[side=right]:right-0 data-[side=right]:h-full data-[side=right]:w-3/4 data-[side=right]:border-l data-[side=right]:data-ending-style:translate-x-[2.5rem] data-[side=right]:data-starting-style:translate-x-[2.5rem] data-[side=top]:inset-x-0 data-[side=top]:top-0 data-[side=top]:h-auto data-[side=top]:border-b data-[side=top]:data-ending-style:translate-y-[-2.5rem] data-[side=top]:data-starting-style:translate-y-[-2.5rem] data-[side=left]:sm:max-w-sm data-[side=right]:sm:max-w-sm", className);
		$[11] = className;
		$[12] = t5;
	} else t5 = $[12];
	let t6;
	if ($[13] !== showCloseButton) {
		t6 = showCloseButton && /* @__PURE__ */ jsxs(Dialog$1.Close, {
			"data-slot": "sheet-close",
			render: /* @__PURE__ */ jsx(Button, {
				variant: "ghost",
				className: "absolute top-3 right-3",
				size: "icon-sm"
			}),
			children: [/* @__PURE__ */ jsx(XIcon, {}), /* @__PURE__ */ jsx("span", {
				className: "sr-only",
				children: "Close"
			})]
		});
		$[13] = showCloseButton;
		$[14] = t6;
	} else t6 = $[14];
	let t7;
	if ($[15] !== children || $[16] !== props || $[17] !== side || $[18] !== t5 || $[19] !== t6) {
		t7 = /* @__PURE__ */ jsxs(Dialog$1.Popup, {
			"data-slot": "sheet-content",
			"data-side": side,
			className: t5,
			...props,
			children: [children, t6]
		});
		$[15] = children;
		$[16] = props;
		$[17] = side;
		$[18] = t5;
		$[19] = t6;
		$[20] = t7;
	} else t7 = $[20];
	let t8;
	if ($[21] !== container || $[22] !== t4 || $[23] !== t7) {
		t8 = /* @__PURE__ */ jsxs(SheetPortal, {
			container,
			children: [t4, t7]
		});
		$[21] = container;
		$[22] = t4;
		$[23] = t7;
		$[24] = t8;
	} else t8 = $[24];
	return t8;
}
function SheetHeader(t0) {
	const $ = c(9);
	if ($[0] !== "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex flex-col gap-0.5 p-4", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "sheet-header",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SheetFooter(t0) {
	const $ = c(9);
	if ($[0] !== "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("mt-auto flex flex-col gap-2 p-4", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "sheet-footer",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SheetTitle(t0) {
	const $ = c(9);
	if ($[0] !== "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("font-heading text-base font-medium text-foreground", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Dialog$1.Title, {
			"data-slot": "sheet-title",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SheetDescription(t0) {
	const $ = c(9);
	if ($[0] !== "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d8e4a25c608b77dbdde813994e3cc9fcf6f1a292400c125fe775b189c2307998";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("text-sm text-muted-foreground", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Dialog$1.Description, {
			"data-slot": "sheet-description",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/ui/skeleton.tsx
function Skeleton(t0) {
	const $ = c(9);
	if ($[0] !== "b115c870562402cf9d041ba3c3a3b19cd3a12ec9e0cd84a27be434948577b96a") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "b115c870562402cf9d041ba3c3a3b19cd3a12ec9e0cd84a27be434948577b96a";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("animate-pulse rounded-md bg-foreground/13 motion-reduce:animate-none motion-reduce:transition-none", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "skeleton",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/ui/tooltip.tsx
function TooltipProvider(t0) {
	const $ = c(7);
	if ($[0] !== "c60c5d664ea594a9971e50bb85b4ce99d75af337c05d044142446aee6debaeb5") {
		for (let $i = 0; $i < 7; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c60c5d664ea594a9971e50bb85b4ce99d75af337c05d044142446aee6debaeb5";
	}
	let props;
	let t1;
	if ($[1] !== t0) {
		({delay: t1, ...props} = t0);
		$[1] = t0;
		$[2] = props;
		$[3] = t1;
	} else {
		props = $[2];
		t1 = $[3];
	}
	const delay = t1 === void 0 ? 0 : t1;
	let t2;
	if ($[4] !== delay || $[5] !== props) {
		t2 = /* @__PURE__ */ jsx(Tooltip$1.Provider, {
			"data-slot": "tooltip-provider",
			delay,
			...props
		});
		$[4] = delay;
		$[5] = props;
		$[6] = t2;
	} else t2 = $[6];
	return t2;
}
function Tooltip(t0) {
	const $ = c(5);
	if ($[0] !== "c60c5d664ea594a9971e50bb85b4ce99d75af337c05d044142446aee6debaeb5") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c60c5d664ea594a9971e50bb85b4ce99d75af337c05d044142446aee6debaeb5";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Tooltip$1.Root, {
			"data-slot": "tooltip",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function TooltipTrigger(t0) {
	const $ = c(5);
	if ($[0] !== "c60c5d664ea594a9971e50bb85b4ce99d75af337c05d044142446aee6debaeb5") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c60c5d664ea594a9971e50bb85b4ce99d75af337c05d044142446aee6debaeb5";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Tooltip$1.Trigger, {
			"data-slot": "tooltip-trigger",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function TooltipContent(t0) {
	const $ = c(22);
	if ($[0] !== "c60c5d664ea594a9971e50bb85b4ce99d75af337c05d044142446aee6debaeb5") {
		for (let $i = 0; $i < 22; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c60c5d664ea594a9971e50bb85b4ce99d75af337c05d044142446aee6debaeb5";
	}
	let children;
	let className;
	let props;
	let t1;
	let t2;
	let t3;
	let t4;
	if ($[1] !== t0) {
		({className, side: t1, sideOffset: t2, align: t3, alignOffset: t4, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
		$[5] = t1;
		$[6] = t2;
		$[7] = t3;
		$[8] = t4;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
		t1 = $[5];
		t2 = $[6];
		t3 = $[7];
		t4 = $[8];
	}
	const side = t1 === void 0 ? "top" : t1;
	const sideOffset = t2 === void 0 ? 4 : t2;
	const align = t3 === void 0 ? "center" : t3;
	const alignOffset = t4 === void 0 ? 0 : t4;
	let t5;
	if ($[9] !== className) {
		t5 = cn("z-[var(--z-loading-backdrop)] inline-flex w-fit max-w-xs origin-(--transform-origin) items-center gap-1.5 rounded-md bg-foreground px-3 py-1.5 text-xs text-background has-data-[slot=kbd]:pr-1.5 data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 **:data-[slot=kbd]:relative **:data-[slot=kbd]:isolate **:data-[slot=kbd]:z-[var(--z-loading-backdrop)] **:data-[slot=kbd]:rounded-sm data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0 data-[state=delayed-open]:zoom-in-95 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 motion-reduce:animate-none motion-reduce:transition-none", className);
		$[9] = className;
		$[10] = t5;
	} else t5 = $[10];
	let t6;
	if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
		t6 = /* @__PURE__ */ jsx(Tooltip$1.Arrow, {
			"data-slot": "tooltip-arrow",
			className: "z-[var(--z-loading-backdrop)] size-2.5 translate-y-[calc(-50%-2px)] rotate-45 rounded-[2px] bg-foreground fill-foreground data-[side=bottom]:top-1 data-[side=inline-end]:top-1/2! data-[side=inline-end]:-left-1 data-[side=inline-end]:-translate-y-1/2 data-[side=inline-start]:top-1/2! data-[side=inline-start]:-right-1 data-[side=inline-start]:-translate-y-1/2 data-[side=left]:top-1/2! data-[side=left]:-right-1 data-[side=left]:-translate-y-1/2 data-[side=right]:top-1/2! data-[side=right]:-left-1 data-[side=right]:-translate-y-1/2 data-[side=top]:-bottom-2.5"
		});
		$[11] = t6;
	} else t6 = $[11];
	let t7;
	if ($[12] !== children || $[13] !== props || $[14] !== t5) {
		t7 = /* @__PURE__ */ jsxs(Tooltip$1.Popup, {
			"data-slot": "tooltip-content",
			className: t5,
			...props,
			children: [children, t6]
		});
		$[12] = children;
		$[13] = props;
		$[14] = t5;
		$[15] = t7;
	} else t7 = $[15];
	let t8;
	if ($[16] !== align || $[17] !== alignOffset || $[18] !== side || $[19] !== sideOffset || $[20] !== t7) {
		t8 = /* @__PURE__ */ jsx(Tooltip$1.Portal, { children: /* @__PURE__ */ jsx(Tooltip$1.Positioner, {
			align,
			alignOffset,
			side,
			sideOffset,
			className: "isolate z-[var(--z-loading-backdrop)]",
			children: t7
		}) });
		$[16] = align;
		$[17] = alignOffset;
		$[18] = side;
		$[19] = sideOffset;
		$[20] = t7;
		$[21] = t8;
	} else t8 = $[21];
	return t8;
}
//#endregion
//#region src/hooks/use-mobile.ts
const MOBILE_BREAKPOINT = 768;
function useIsMobile() {
	const $ = c(3);
	if ($[0] !== "975886722168518699167d999c53b5ea79a02ef828a71389455f916eb69eb69a") {
		for (let $i = 0; $i < 3; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "975886722168518699167d999c53b5ea79a02ef828a71389455f916eb69eb69a";
	}
	const [isMobile, setIsMobile] = React.useState(void 0);
	let t0;
	let t1;
	if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
		t0 = () => {
			const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
			const onChange = () => {
				setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
			};
			mql.addEventListener("change", onChange);
			setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
			return () => mql.removeEventListener("change", onChange);
		};
		t1 = [];
		$[1] = t0;
		$[2] = t1;
	} else {
		t0 = $[1];
		t1 = $[2];
	}
	React.useEffect(t0, t1);
	return !!isMobile;
}
//#endregion
//#region src/components/ui/sidebar.tsx
const SIDEBAR_COOKIE_NAME = "sidebar_state";
const SIDEBAR_COOKIE_MAX_AGE = 3600 * 24 * 7;
const SIDEBAR_WIDTH = "13.5rem";
const SIDEBAR_WIDTH_MOBILE = "18rem";
const SIDEBAR_WIDTH_ICON = "4rem";
const SIDEBAR_KEYBOARD_SHORTCUT = "b";
const SidebarContext = React.createContext(null);
function useSidebar() {
	const $ = c(1);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 1; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	const context = React.useContext(SidebarContext);
	if (!context) throw new Error("useSidebar must be used within a SidebarProvider.");
	return context;
}
function SidebarProvider(t0) {
	const $ = c(37);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 37; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let children;
	let className;
	let openProp;
	let props;
	let setOpenProp;
	let style;
	let t1;
	if ($[1] !== t0) {
		({defaultOpen: t1, open: openProp, onOpenChange: setOpenProp, className, style, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = openProp;
		$[5] = props;
		$[6] = setOpenProp;
		$[7] = style;
		$[8] = t1;
	} else {
		children = $[2];
		className = $[3];
		openProp = $[4];
		props = $[5];
		setOpenProp = $[6];
		style = $[7];
		t1 = $[8];
	}
	const defaultOpen = t1 === void 0 ? true : t1;
	const isMobile = useIsMobile();
	const [openMobile, setOpenMobile] = React.useState(false);
	const [_open, _setOpen] = React.useState(defaultOpen);
	const open = openProp ?? _open;
	let t2;
	if ($[9] !== open || $[10] !== setOpenProp) {
		t2 = (value) => {
			const openState = typeof value === "function" ? value(open) : value;
			if (setOpenProp) setOpenProp(openState);
			else _setOpen(openState);
			document.cookie = `${SIDEBAR_COOKIE_NAME}=${openState}; path=/; max-age=${SIDEBAR_COOKIE_MAX_AGE}`;
		};
		$[9] = open;
		$[10] = setOpenProp;
		$[11] = t2;
	} else t2 = $[11];
	const setOpen = t2;
	let t3;
	if ($[12] !== isMobile || $[13] !== setOpen) {
		t3 = () => isMobile ? setOpenMobile(_temp$19) : setOpen(_temp2$8);
		$[12] = isMobile;
		$[13] = setOpen;
		$[14] = t3;
	} else t3 = $[14];
	const toggleSidebar = t3;
	let t4;
	let t5;
	if ($[15] !== toggleSidebar) {
		t4 = () => {
			const handleKeyDown = (event) => {
				if (event.key === SIDEBAR_KEYBOARD_SHORTCUT && (event.metaKey || event.ctrlKey)) {
					event.preventDefault();
					toggleSidebar();
				}
			};
			window.addEventListener("keydown", handleKeyDown);
			return () => window.removeEventListener("keydown", handleKeyDown);
		};
		t5 = [toggleSidebar];
		$[15] = toggleSidebar;
		$[16] = t4;
		$[17] = t5;
	} else {
		t4 = $[16];
		t5 = $[17];
	}
	React.useEffect(t4, t5);
	const state = open ? "expanded" : "collapsed";
	let t6;
	if ($[18] !== isMobile || $[19] !== open || $[20] !== openMobile || $[21] !== setOpen || $[22] !== state || $[23] !== toggleSidebar) {
		t6 = {
			state,
			open,
			setOpen,
			isMobile,
			openMobile,
			setOpenMobile,
			toggleSidebar
		};
		$[18] = isMobile;
		$[19] = open;
		$[20] = openMobile;
		$[21] = setOpen;
		$[22] = state;
		$[23] = toggleSidebar;
		$[24] = t6;
	} else t6 = $[24];
	const contextValue = t6;
	let t7;
	if ($[25] !== style) {
		t7 = {
			"--sidebar-width": SIDEBAR_WIDTH,
			"--sidebar-width-icon": SIDEBAR_WIDTH_ICON,
			...style
		};
		$[25] = style;
		$[26] = t7;
	} else t7 = $[26];
	const t8 = t7;
	let t9;
	if ($[27] !== className) {
		t9 = cn("group/sidebar-wrapper flex min-h-svh w-full has-data-[variant=inset]:bg-sidebar", className);
		$[27] = className;
		$[28] = t9;
	} else t9 = $[28];
	let t10;
	if ($[29] !== children || $[30] !== props || $[31] !== t8 || $[32] !== t9) {
		t10 = /* @__PURE__ */ jsx("div", {
			"data-slot": "sidebar-wrapper",
			style: t8,
			className: t9,
			...props,
			children
		});
		$[29] = children;
		$[30] = props;
		$[31] = t8;
		$[32] = t9;
		$[33] = t10;
	} else t10 = $[33];
	let t11;
	if ($[34] !== contextValue || $[35] !== t10) {
		t11 = /* @__PURE__ */ jsx(SidebarContext.Provider, {
			value: contextValue,
			children: t10
		});
		$[34] = contextValue;
		$[35] = t10;
		$[36] = t11;
	} else t11 = $[36];
	return t11;
}
function _temp2$8(open_1) {
	return !open_1;
}
function _temp$19(open_0) {
	return !open_0;
}
function Sidebar$1(t0) {
	const $ = c(49);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 49; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let children;
	let className;
	let dir;
	let props;
	let t1;
	let t2;
	let t3;
	if ($[1] !== t0) {
		({side: t1, variant: t2, collapsible: t3, className, children, dir, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = dir;
		$[5] = props;
		$[6] = t1;
		$[7] = t2;
		$[8] = t3;
	} else {
		children = $[2];
		className = $[3];
		dir = $[4];
		props = $[5];
		t1 = $[6];
		t2 = $[7];
		t3 = $[8];
	}
	const side = t1 === void 0 ? "left" : t1;
	const variant = t2 === void 0 ? "sidebar" : t2;
	const collapsible = t3 === void 0 ? "offcanvas" : t3;
	const { isMobile, state, openMobile, setOpenMobile } = useSidebar();
	if (collapsible === "none") {
		let t4;
		if ($[9] !== className) {
			t4 = cn("flex h-full w-(--sidebar-width) flex-col bg-sidebar text-sidebar-foreground", className);
			$[9] = className;
			$[10] = t4;
		} else t4 = $[10];
		let t5;
		if ($[11] !== children || $[12] !== props || $[13] !== t4) {
			t5 = /* @__PURE__ */ jsx("div", {
				"data-slot": "sidebar",
				className: t4,
				...props,
				children
			});
			$[11] = children;
			$[12] = props;
			$[13] = t4;
			$[14] = t5;
		} else t5 = $[14];
		return t5;
	}
	if (isMobile) {
		let t4;
		if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
			t4 = { "--sidebar-width": SIDEBAR_WIDTH_MOBILE };
			$[15] = t4;
		} else t4 = $[15];
		let t5;
		if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
			t5 = /* @__PURE__ */ jsxs(SheetHeader, {
				className: "sr-only",
				children: [/* @__PURE__ */ jsx(SheetTitle, { children: "Sidebar" }), /* @__PURE__ */ jsx(SheetDescription, { children: "Displays the mobile sidebar." })]
			});
			$[16] = t5;
		} else t5 = $[16];
		let t6;
		if ($[17] !== children) {
			t6 = /* @__PURE__ */ jsx("div", {
				className: "flex h-full w-full flex-col",
				children
			});
			$[17] = children;
			$[18] = t6;
		} else t6 = $[18];
		let t7;
		if ($[19] !== dir || $[20] !== side || $[21] !== t6) {
			t7 = /* @__PURE__ */ jsxs(SheetContent, {
				dir,
				"data-sidebar": "sidebar",
				"data-slot": "sidebar",
				"data-mobile": "true",
				className: "w-(--sidebar-width) bg-sidebar p-0 text-sidebar-foreground [&>button]:hidden",
				style: t4,
				side,
				children: [t5, t6]
			});
			$[19] = dir;
			$[20] = side;
			$[21] = t6;
			$[22] = t7;
		} else t7 = $[22];
		let t8;
		if ($[23] !== openMobile || $[24] !== props || $[25] !== setOpenMobile || $[26] !== t7) {
			t8 = /* @__PURE__ */ jsx(Sheet, {
				open: openMobile,
				onOpenChange: setOpenMobile,
				...props,
				children: t7
			});
			$[23] = openMobile;
			$[24] = props;
			$[25] = setOpenMobile;
			$[26] = t7;
			$[27] = t8;
		} else t8 = $[27];
		return t8;
	}
	const t4 = state === "collapsed" ? collapsible : "";
	const t5 = variant === "floating" || variant === "inset" ? "group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon)";
	let t6;
	if ($[28] !== t5) {
		t6 = cn("relative w-(--sidebar-width) bg-transparent transition-[width] duration-200 ease-linear", "group-data-[collapsible=offcanvas]:w-0", "group-data-[side=right]:rotate-180", t5);
		$[28] = t5;
		$[29] = t6;
	} else t6 = $[29];
	let t7;
	if ($[30] !== t6) {
		t7 = /* @__PURE__ */ jsx("div", {
			"data-slot": "sidebar-gap",
			className: t6
		});
		$[30] = t6;
		$[31] = t7;
	} else t7 = $[31];
	const t8 = variant === "floating" || variant === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4))+2px)]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l";
	let t9;
	if ($[32] !== className || $[33] !== t8) {
		t9 = cn("fixed inset-y-0 z-10 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear data-[side=left]:left-0 data-[side=left]:group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)] data-[side=right]:right-0 data-[side=right]:group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)] md:flex", t8, className);
		$[32] = className;
		$[33] = t8;
		$[34] = t9;
	} else t9 = $[34];
	let t10;
	if ($[35] !== children) {
		t10 = /* @__PURE__ */ jsx("div", {
			"data-sidebar": "sidebar",
			"data-slot": "sidebar-inner",
			className: "flex size-full flex-col bg-sidebar group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:shadow-sm group-data-[variant=floating]:ring-1 group-data-[variant=floating]:ring-sidebar-border",
			children
		});
		$[35] = children;
		$[36] = t10;
	} else t10 = $[36];
	let t11;
	if ($[37] !== props || $[38] !== side || $[39] !== t10 || $[40] !== t9) {
		t11 = /* @__PURE__ */ jsx("div", {
			"data-slot": "sidebar-container",
			"data-side": side,
			className: t9,
			...props,
			children: t10
		});
		$[37] = props;
		$[38] = side;
		$[39] = t10;
		$[40] = t9;
		$[41] = t11;
	} else t11 = $[41];
	let t12;
	if ($[42] !== side || $[43] !== state || $[44] !== t11 || $[45] !== t4 || $[46] !== t7 || $[47] !== variant) {
		t12 = /* @__PURE__ */ jsxs("div", {
			className: "group peer hidden text-sidebar-foreground md:block",
			"data-state": state,
			"data-collapsible": t4,
			"data-variant": variant,
			"data-side": side,
			"data-slot": "sidebar",
			children: [t7, t11]
		});
		$[42] = side;
		$[43] = state;
		$[44] = t11;
		$[45] = t4;
		$[46] = t7;
		$[47] = variant;
		$[48] = t12;
	} else t12 = $[48];
	return t12;
}
function SidebarTrigger(t0) {
	const $ = c(16);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 16; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let className;
	let onClick;
	let props;
	if ($[1] !== t0) {
		({className, onClick, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = onClick;
		$[4] = props;
	} else {
		className = $[2];
		onClick = $[3];
		props = $[4];
	}
	const { toggleSidebar } = useSidebar();
	let t1;
	if ($[5] !== className) {
		t1 = cn(className);
		$[5] = className;
		$[6] = t1;
	} else t1 = $[6];
	let t2;
	if ($[7] !== onClick || $[8] !== toggleSidebar) {
		t2 = (event) => {
			onClick?.(event);
			toggleSidebar();
		};
		$[7] = onClick;
		$[8] = toggleSidebar;
		$[9] = t2;
	} else t2 = $[9];
	let t3;
	let t4;
	if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
		t3 = /* @__PURE__ */ jsx(PanelLeftIcon, {});
		t4 = /* @__PURE__ */ jsx("span", {
			className: "sr-only",
			children: "Toggle Sidebar"
		});
		$[10] = t3;
		$[11] = t4;
	} else {
		t3 = $[10];
		t4 = $[11];
	}
	let t5;
	if ($[12] !== props || $[13] !== t1 || $[14] !== t2) {
		t5 = /* @__PURE__ */ jsxs(Button, {
			"data-sidebar": "trigger",
			"data-slot": "sidebar-trigger",
			variant: "ghost",
			size: "icon-sm",
			className: t1,
			onClick: t2,
			...props,
			children: [t3, t4]
		});
		$[12] = props;
		$[13] = t1;
		$[14] = t2;
		$[15] = t5;
	} else t5 = $[15];
	return t5;
}
function SidebarInset(t0) {
	const $ = c(9);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("relative flex min-w-0 flex-1 flex-col bg-background md:peer-data-[variant=inset]:m-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow-sm md:peer-data-[variant=inset]:peer-data-[state=collapsed]:ml-2", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("main", {
			"data-slot": "sidebar-inset",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SidebarHeader(t0) {
	const $ = c(9);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex flex-col gap-2 p-4", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "sidebar-header",
			"data-sidebar": "header",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SidebarFooter(t0) {
	const $ = c(9);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex flex-col gap-0 border-t border-sidebar-border p-0", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "sidebar-footer",
			"data-sidebar": "footer",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SidebarSeparator(t0) {
	const $ = c(9);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("my-0 w-full bg-sidebar-border", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Separator, {
			"data-slot": "sidebar-separator",
			"data-sidebar": "separator",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SidebarContent(t0) {
	const $ = c(9);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex min-h-0 flex-1 flex-col gap-0 overflow-auto group-data-[collapsible=icon]:overflow-hidden", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "sidebar-content",
			"data-sidebar": "content",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SidebarGroup(t0) {
	const $ = c(9);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("relative mb-[18px] flex w-full min-w-0 flex-col", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "sidebar-group",
			"data-sidebar": "group",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SidebarGroupLabel(t0) {
	const $ = c(11);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 11; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let render;
	let t1;
	let t2;
	let t3;
	if ($[1] !== t0) {
		const { className, render: t4, ...props } = t0;
		render = t4;
		t3 = useRender;
		t1 = "div";
		t2 = mergeProps({ className: cn("mb-1 flex max-h-8 shrink-0 items-center overflow-hidden rounded-none px-5 text-[11px] font-bold tracking-[0.14em] text-gx-text-tertiary uppercase opacity-100 ring-sidebar-ring outline-hidden transition-[max-height,margin,opacity] duration-200 focus-visible:ring-2 group-data-[collapsible=icon]:mb-0 group-data-[collapsible=icon]:max-h-0 group-data-[collapsible=icon]:opacity-0 [&>svg]:size-4 [&>svg]:shrink-0", className) }, props);
		$[1] = t0;
		$[2] = render;
		$[3] = t1;
		$[4] = t2;
		$[5] = t3;
	} else {
		render = $[2];
		t1 = $[3];
		t2 = $[4];
		t3 = $[5];
	}
	let t4;
	if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
		t4 = {
			slot: "sidebar-group-label",
			sidebar: "group-label"
		};
		$[6] = t4;
	} else t4 = $[6];
	let t5;
	if ($[7] !== render || $[8] !== t1 || $[9] !== t2) {
		t5 = {
			defaultTagName: t1,
			props: t2,
			render,
			state: t4
		};
		$[7] = render;
		$[8] = t1;
		$[9] = t2;
		$[10] = t5;
	} else t5 = $[10];
	return t3(t5);
}
function SidebarGroupContent(t0) {
	const $ = c(9);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("w-full text-sm", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "sidebar-group-content",
			"data-sidebar": "group-content",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SidebarMenu(t0) {
	const $ = c(9);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex w-full min-w-0 flex-col gap-0", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("ul", {
			"data-slot": "sidebar-menu",
			"data-sidebar": "menu",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SidebarMenuItem(t0) {
	const $ = c(9);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("group/menu-item relative", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("li", {
			"data-slot": "sidebar-menu-item",
			"data-sidebar": "menu-item",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
const sidebarMenuButtonVariants = cva("peer/menu-button group/menu-button flex w-full cursor-pointer items-center justify-start gap-3 overflow-hidden rounded-none border-b-2 border-transparent px-5 py-2 text-left text-sm font-semibold text-gx-text-secondary ring-sidebar-ring outline-hidden [--sidebar-active-color:var(--gx-highlight)] [--sidebar-active-dim:var(--gx-accent-dim)] [--sidebar-active-glow:var(--gx-accent-glow)] transition-[width,height,padding,gap,background-color,color,border-color] duration-200 group-has-data-[sidebar=menu-action]/menu-item:pr-8 group-data-[collapsible=icon]:h-9! group-data-[collapsible=icon]:w-full! group-data-[collapsible=icon]:gap-0! group-data-[collapsible=icon]:px-[23px]! group-data-[collapsible=icon]:py-2.5! hover:bg-gx-tile-dark hover:text-gx-text focus-visible:ring-2 active:bg-gx-tile-dark active:text-gx-text disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:cursor-not-allowed aria-disabled:opacity-50 aria-expanded:bg-gx-tile-dark aria-expanded:text-gx-text data-active:border-[var(--sidebar-active-color)] data-active:bg-gx-tile-dark data-active:[background-image:linear-gradient(90deg,var(--sidebar-active-dim),transparent_65%)] data-active:font-semibold data-active:text-gx-text data-active:shadow-[inset_0_-2px_6px_-2px_var(--sidebar-active-glow)] data-active:[&>svg]:text-[var(--sidebar-active-color)] [&_svg]:size-4 [&_svg]:shrink-0 [&>span:last-child]:truncate", {
	variants: {
		variant: {
			default: "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
			outline: "bg-background shadow-[0_0_0_1px_var(--sidebar-border)] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_var(--sidebar-accent)]"
		},
		size: {
			default: "h-9 text-sm",
			sm: "h-7 text-xs",
			lg: "h-12 text-sm group-data-[collapsible=icon]:px-[15px]! group-data-[collapsible=icon]:py-0!"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function SidebarMenuButton(t0) {
	const $ = c(19);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 19; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let { render, isActive: t1, variant: t2, size: t3, tooltip, className, ...props } = t0;
	const isActive = t1 === void 0 ? false : t1;
	const variant = t2 === void 0 ? "default" : t2;
	const size = t3 === void 0 ? "default" : t3;
	const { isMobile, state } = useSidebar();
	const t4 = "button";
	const t5 = mergeProps({ className: cn(sidebarMenuButtonVariants({
		variant,
		size
	}), className) }, props);
	let t6;
	if ($[1] !== render || $[2] !== tooltip) {
		t6 = !tooltip ? render : /* @__PURE__ */ jsx(TooltipTrigger, { render });
		$[1] = render;
		$[2] = tooltip;
		$[3] = t6;
	} else t6 = $[3];
	let t7;
	if ($[4] !== isActive || $[5] !== size) {
		t7 = {
			slot: "sidebar-menu-button",
			sidebar: "menu-button",
			size,
			active: isActive
		};
		$[4] = isActive;
		$[5] = size;
		$[6] = t7;
	} else t7 = $[6];
	let t8;
	if ($[7] !== t5 || $[8] !== t6 || $[9] !== t7) {
		t8 = {
			defaultTagName: t4,
			props: t5,
			render: t6,
			state: t7
		};
		$[7] = t5;
		$[8] = t6;
		$[9] = t7;
		$[10] = t8;
	} else t8 = $[10];
	const comp = useRender(t8);
	if (!tooltip) return comp;
	if (typeof tooltip === "string") {
		let t9;
		if ($[11] !== tooltip) {
			t9 = { children: tooltip };
			$[11] = tooltip;
			$[12] = t9;
		} else t9 = $[12];
		tooltip = t9;
	}
	const t9 = state !== "collapsed" || isMobile;
	let t10;
	if ($[13] !== t9 || $[14] !== tooltip) {
		t10 = /* @__PURE__ */ jsx(TooltipContent, {
			side: "right",
			align: "center",
			hidden: t9,
			...tooltip
		});
		$[13] = t9;
		$[14] = tooltip;
		$[15] = t10;
	} else t10 = $[15];
	let t11;
	if ($[16] !== comp || $[17] !== t10) {
		t11 = /* @__PURE__ */ jsxs(Tooltip, { children: [comp, t10] });
		$[16] = comp;
		$[17] = t10;
		$[18] = t11;
	} else t11 = $[18];
	return t11;
}
function SidebarMenuSub(t0) {
	const $ = c(9);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex min-w-0 flex-col gap-0 border-l border-sidebar-border pl-0 group-data-[collapsible=icon]:hidden", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("ul", {
			"data-slot": "sidebar-menu-sub",
			"data-sidebar": "menu-sub",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SidebarMenuSubItem(t0) {
	const $ = c(9);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("group/menu-sub-item relative", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("li", {
			"data-slot": "sidebar-menu-sub-item",
			"data-sidebar": "menu-sub-item",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SidebarMenuSubButton(t0) {
	const $ = c(16);
	if ($[0] !== "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a") {
		for (let $i = 0; $i < 16; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a2e95b23b48575959de615c75119872bffe75a0c273f15e6c2da5630058a873a";
	}
	let isActive;
	let render;
	let size;
	let t1;
	let t2;
	let t3;
	if ($[1] !== t0) {
		const { render: t4, size: t5, isActive: t6, className, ...props } = t0;
		render = t4;
		size = t5 === void 0 ? "md" : t5;
		isActive = t6 === void 0 ? false : t6;
		t3 = useRender;
		t1 = "a";
		t2 = mergeProps({ className: cn("flex h-8 min-w-0 -translate-x-px cursor-pointer items-center gap-2 overflow-hidden rounded-none border-l-2 border-transparent px-5 font-medium text-gx-text-secondary ring-sidebar-ring outline-hidden group-data-[collapsible=icon]:hidden hover:bg-gx-tile-dark hover:text-gx-text focus-visible:ring-2 active:bg-gx-tile-dark active:text-gx-text disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:cursor-not-allowed aria-disabled:opacity-50 aria-expanded:bg-gx-tile-dark aria-expanded:text-gx-text data-[size=md]:text-[13px] data-[size=sm]:text-xs data-active:border-gx-highlight data-active:bg-gx-tile-dark data-active:text-gx-text [&>span:last-child]:truncate [&_svg]:size-4 [&_svg]:shrink-0 [&_svg]:text-gx-text-tertiary", className) }, props);
		$[1] = t0;
		$[2] = isActive;
		$[3] = render;
		$[4] = size;
		$[5] = t1;
		$[6] = t2;
		$[7] = t3;
	} else {
		isActive = $[2];
		render = $[3];
		size = $[4];
		t1 = $[5];
		t2 = $[6];
		t3 = $[7];
	}
	let t4;
	if ($[8] !== isActive || $[9] !== size) {
		t4 = {
			slot: "sidebar-menu-sub-button",
			sidebar: "menu-sub-button",
			size,
			active: isActive
		};
		$[8] = isActive;
		$[9] = size;
		$[10] = t4;
	} else t4 = $[10];
	let t5;
	if ($[11] !== render || $[12] !== t1 || $[13] !== t2 || $[14] !== t4) {
		t5 = {
			defaultTagName: t1,
			props: t2,
			render,
			state: t4
		};
		$[11] = render;
		$[12] = t1;
		$[13] = t2;
		$[14] = t4;
		$[15] = t5;
	} else t5 = $[15];
	return t3(t5);
}
//#endregion
//#region src/components/app-sidebar.tsx
const getInitials = (name) => name.split(" ").map((part) => part[0]).join("").toUpperCase();
/**
* The signed-in user's name and company, shown at the bottom of the sidebar.
* Clicking it (anywhere while expanded, or just the avatar while collapsed to
* the icon rail) expands a menu with a "Log out" action.
*/
const CurrentUserCard = (t0) => {
	const $ = c(22);
	if ($[0] !== "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0") {
		for (let $i = 0; $i < 22; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0";
	}
	const { user, onLogout } = t0;
	let t1;
	if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = /* @__PURE__ */ jsx(SidebarMenuButton, {
			render: /* @__PURE__ */ jsx("button", { type: "button" }),
			size: "lg"
		});
		$[1] = t1;
	} else t1 = $[1];
	let t2;
	if ($[2] !== user.name) {
		t2 = getInitials(user.name);
		$[2] = user.name;
		$[3] = t2;
	} else t2 = $[3];
	let t3;
	if ($[4] !== t2) {
		t3 = /* @__PURE__ */ jsx(Avatar$1, { children: /* @__PURE__ */ jsx(AvatarFallback, { children: t2 }) });
		$[4] = t2;
		$[5] = t3;
	} else t3 = $[5];
	let t4;
	if ($[6] !== user.name) {
		t4 = /* @__PURE__ */ jsx("span", {
			className: "truncate text-sm font-medium text-sidebar-foreground",
			children: user.name
		});
		$[6] = user.name;
		$[7] = t4;
	} else t4 = $[7];
	let t5;
	if ($[8] !== user.company) {
		t5 = /* @__PURE__ */ jsx("span", {
			className: "truncate text-xs text-muted-foreground",
			children: user.company
		});
		$[8] = user.company;
		$[9] = t5;
	} else t5 = $[9];
	let t6;
	if ($[10] !== t4 || $[11] !== t5) {
		t6 = /* @__PURE__ */ jsxs("div", {
			className: "flex max-w-40 min-w-0 flex-col overflow-hidden leading-tight opacity-100 transition-[max-width,opacity] duration-200 group-data-[collapsible=icon]:max-w-0 group-data-[collapsible=icon]:opacity-0",
			children: [t4, t5]
		});
		$[10] = t4;
		$[11] = t5;
		$[12] = t6;
	} else t6 = $[12];
	let t7;
	if ($[13] !== t3 || $[14] !== t6) {
		t7 = /* @__PURE__ */ jsxs(DropdownMenuTrigger, {
			render: t1,
			children: [t3, t6]
		});
		$[13] = t3;
		$[14] = t6;
		$[15] = t7;
	} else t7 = $[15];
	let t8;
	if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
		t8 = /* @__PURE__ */ jsx(LogOut, {});
		$[16] = t8;
	} else t8 = $[16];
	let t9;
	if ($[17] !== onLogout) {
		t9 = /* @__PURE__ */ jsx(DropdownMenuContent, {
			side: "top",
			align: "end",
			className: "min-w-56",
			children: /* @__PURE__ */ jsx(DropdownMenuGroup, { children: /* @__PURE__ */ jsxs(DropdownMenuItem, {
				onClick: onLogout,
				children: [t8, "Log out"]
			}) })
		});
		$[17] = onLogout;
		$[18] = t9;
	} else t9 = $[18];
	let t10;
	if ($[19] !== t7 || $[20] !== t9) {
		t10 = /* @__PURE__ */ jsxs(DropdownMenu, { children: [t7, t9] });
		$[19] = t7;
		$[20] = t9;
		$[21] = t10;
	} else t10 = $[21];
	return t10;
};
/** Finds the first `active` item in a subtree, at any depth — used to seed/resync the active-item state and to decide which ancestor groups start expanded. */
const findActiveItem = (items) => {
	for (const item of items) {
		if (item.active) return item;
		if (item.items) {
			const found = findActiveItem(item.items);
			if (found) return found;
		}
	}
};
/** Finds the first `active` item across all groups, used to seed/resync the active-item state. */
const findActiveItemInSchema = (menuSchema) => menuSchema.reduce((found, group) => found ?? findActiveItem(group.items), void 0);
/**
* Whether `activeItem` is present in this subtree, at any depth — used to
* highlight a parent whose child is active. Compares by object identity
* (not `label`) so items that happen to share a label in different branches
* of the schema are never confused with each other.
*/
const containsItem = (items, activeItem) => activeItem !== void 0 && items.some((item) => item === activeItem || (item.items ? containsItem(item.items, activeItem) : false));
/**
* Tracks which leaf item is currently active (by object identity, see
* {@link containsItem}), the tree-wide submenu open/closed state
* (`openPaths`, keyed by nesting level — see `app-sidebar-open-paths.ts`),
* and the shared `linkComponent` used by every node.
*/
const MenuStateContext = createContext(null);
const useMenuState = () => {
	const context = use(MenuStateContext);
	if (!context) throw new Error("useMenuState must be used within AppSidebar");
	return context;
};
/**
* Opening/closing a node at `level` updates the tree-wide `openPaths` map
* (sibling-exclusive at level 0/1, level 2+ branches can stay open
* together — see `getNextOpenPaths`), and, for a level-0 item clicked while
* the sidebar is collapsed to the icon rail, also force-expands the whole
* sidebar (mirrors the click bubbling to `setOpen(true)` in the old NavBar).
*/
const useToggleNode = (level) => {
	const $ = c(6);
	if ($[0] !== "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0") {
		for (let $i = 0; $i < 6; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0";
	}
	const { setOpenPaths } = useMenuState();
	const { state, setOpen } = useSidebar();
	const isMenuOpen = state === "expanded";
	let t0;
	if ($[1] !== isMenuOpen || $[2] !== level || $[3] !== setOpen || $[4] !== setOpenPaths) {
		t0 = (fullId, isCurrentlyOpen) => {
			if (level === 0 && !isMenuOpen) setOpen(true);
			setOpenPaths((prev) => getNextOpenPaths(prev, level, fullId, {
				isMenuOpen,
				isCurrentlyOpen
			}));
		};
		$[1] = isMenuOpen;
		$[2] = level;
		$[3] = setOpen;
		$[4] = setOpenPaths;
		$[5] = t0;
	} else t0 = $[5];
	return t0;
};
const AI_MENU_ITEM_CLASS_NAME = "text-gx-ai [--sidebar-active-color:var(--gx-ai)] [--sidebar-active-dim:var(--gx-ai-dim)] [--sidebar-active-glow:rgba(140,124,240,0.4)] hover:bg-gx-ai-dim hover:text-gx-ai";
const AI_GROUP_ITEM_CLASS_NAME = "[--sidebar-active-color:var(--gx-ai)] [--sidebar-active-dim:var(--gx-ai-dim)] [--sidebar-active-glow:rgba(140,124,240,0.4)]";
const COLLAPSIBLE_MENU_BUTTON_CLASS_NAME = "group/collapsible group-data-[panel-open]/collapsible:bg-gx-tile-dark group-data-[panel-open]/collapsible:text-gx-text";
const COLLAPSIBLE_ITEM_LABEL_CLASS_NAME = "min-w-0 max-w-full flex-1 overflow-hidden truncate opacity-100 transition-[max-width,opacity] duration-200 group-data-[collapsible=icon]:max-w-0 group-data-[collapsible=icon]:flex-none group-data-[collapsible=icon]:opacity-0";
/** Renders a parent row's optional `tag` (e.g. `"beta"`) inline next to its trailing chevron. */
const ChevronWithTag = (t0) => {
	const $ = c(6);
	if ($[0] !== "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0") {
		for (let $i = 0; $i < 6; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0";
	}
	const { tag } = t0;
	let t1;
	if ($[1] !== tag) {
		t1 = tag && /* @__PURE__ */ jsx(Badge, {
			variant: "accentOutline",
			className: "rounded-[3px] px-1.5 py-px text-[10px] tracking-[0.08em] uppercase",
			children: tag
		});
		$[1] = tag;
		$[2] = t1;
	} else t1 = $[2];
	let t2;
	if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = /* @__PURE__ */ jsx(ChevronDown, { className: "size-3.5 shrink-0 text-gx-text-tertiary transition-transform duration-200 group-data-[panel-open]/collapsible:rotate-180" });
		$[3] = t2;
	} else t2 = $[3];
	let t3;
	if ($[4] !== t1) {
		t3 = /* @__PURE__ */ jsxs("span", {
			className: "ml-auto flex max-w-32 items-center gap-1.5 overflow-hidden opacity-100 transition-[max-width,margin,opacity] duration-200 group-data-[collapsible=icon]:ml-0 group-data-[collapsible=icon]:max-w-0 group-data-[collapsible=icon]:opacity-0",
			children: [t1, t2]
		});
		$[4] = t1;
		$[5] = t3;
	} else t3 = $[5];
	return t3;
};
const LeafItemButton = (t0) => {
	const $ = c(23);
	if ($[0] !== "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0") {
		for (let $i = 0; $i < 23; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0";
	}
	const { item, ButtonComponent, className } = t0;
	const { activeItem, setActiveItem, linkComponent } = useMenuState();
	const Link = linkComponent;
	const isLink = Boolean(item.to) && Boolean(Link);
	let t1;
	if ($[1] !== item || $[2] !== setActiveItem) {
		t1 = () => {
			if (item.onClick) {
				item.onClick();
				return;
			}
			if (!item.to) setActiveItem(item);
		};
		$[1] = item;
		$[2] = setActiveItem;
		$[3] = t1;
	} else t1 = $[3];
	const handleClick = t1;
	const variantClassName = item.variant === "ai" ? AI_MENU_ITEM_CLASS_NAME : void 0;
	const t2 = activeItem === item;
	const t3 = variantClassName ?? className;
	let t4;
	if ($[4] !== Link || $[5] !== isLink || $[6] !== item.to) {
		t4 = isLink && Link ? /* @__PURE__ */ jsx(Link, { to: item.to }) : void 0;
		$[4] = Link;
		$[5] = isLink;
		$[6] = item.to;
		$[7] = t4;
	} else t4 = $[7];
	let t5;
	if ($[8] !== item.icon) {
		t5 = item.icon && /* @__PURE__ */ jsx(item.icon, {});
		$[8] = item.icon;
		$[9] = t5;
	} else t5 = $[9];
	let t6;
	if ($[10] !== item.label) {
		t6 = /* @__PURE__ */ jsx("span", {
			className: COLLAPSIBLE_ITEM_LABEL_CLASS_NAME,
			children: item.label
		});
		$[10] = item.label;
		$[11] = t6;
	} else t6 = $[11];
	let t7;
	if ($[12] !== item.tag) {
		t7 = item.tag && /* @__PURE__ */ jsx(Badge, {
			variant: "accentOutline",
			className: "ml-auto max-w-24 overflow-hidden rounded-[3px] px-1.5 py-px text-[10px] tracking-[0.08em] whitespace-nowrap uppercase opacity-100 transition-[max-width,margin,opacity,padding] duration-200 group-data-[collapsible=icon]:ml-0 group-data-[collapsible=icon]:max-w-0 group-data-[collapsible=icon]:px-0 group-data-[collapsible=icon]:opacity-0",
			children: item.tag
		});
		$[12] = item.tag;
		$[13] = t7;
	} else t7 = $[13];
	let t8;
	if ($[14] !== ButtonComponent || $[15] !== handleClick || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
		t8 = /* @__PURE__ */ jsxs(ButtonComponent, {
			isActive: t2,
			className: t3,
			render: t4,
			onClick: handleClick,
			children: [
				t5,
				t6,
				t7
			]
		});
		$[14] = ButtonComponent;
		$[15] = handleClick;
		$[16] = t2;
		$[17] = t3;
		$[18] = t4;
		$[19] = t5;
		$[20] = t6;
		$[21] = t7;
		$[22] = t8;
	} else t8 = $[22];
	return t8;
};
const SidebarSubMenuNode = (t0) => {
	const $ = c(38);
	if ($[0] !== "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0") {
		for (let $i = 0; $i < 38; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0";
	}
	const { item, level, parentId } = t0;
	const { activeItem, openPaths } = useMenuState();
	const { state } = useSidebar();
	const isMenuOpen = state === "expanded";
	const toggleNode = useToggleNode(level);
	let fullId;
	let t1;
	let t2;
	if ($[1] !== activeItem || $[2] !== isMenuOpen || $[3] !== item || $[4] !== level || $[5] !== openPaths || $[6] !== parentId) {
		t2 = Symbol.for("react.early_return_sentinel");
		bb0: {
			fullId = resolveFullId(parentId, item);
			if (!item.items) {
				const t3 = item.variant === "muted" ? "pl-10 text-muted-foreground" : "pl-10";
				let t4;
				if ($[10] !== item || $[11] !== t3) {
					t4 = /* @__PURE__ */ jsx(SidebarMenuSubItem, { children: /* @__PURE__ */ jsx(LeafItemButton, {
						item,
						ButtonComponent: SidebarMenuSubButton,
						className: t3
					}) });
					$[10] = item;
					$[11] = t3;
					$[12] = t4;
				} else t4 = $[12];
				t2 = t4;
				break bb0;
			}
			t1 = getShouldBeOpen({
				openPaths,
				level,
				isAnyDescendantActive: containsItem(item.items, activeItem),
				isMenuOpen,
				fullPath: fullId,
				hasItemPath: true
			});
		}
		$[1] = activeItem;
		$[2] = isMenuOpen;
		$[3] = item;
		$[4] = level;
		$[5] = openPaths;
		$[6] = parentId;
		$[7] = fullId;
		$[8] = t1;
		$[9] = t2;
	} else {
		fullId = $[7];
		t1 = $[8];
		t2 = $[9];
	}
	if (t2 !== Symbol.for("react.early_return_sentinel")) return t2;
	const shouldBeOpen = t1;
	let t3;
	if ($[13] !== fullId || $[14] !== shouldBeOpen || $[15] !== toggleNode) {
		t3 = () => toggleNode(fullId, shouldBeOpen);
		$[13] = fullId;
		$[14] = shouldBeOpen;
		$[15] = toggleNode;
		$[16] = t3;
	} else t3 = $[16];
	let t4;
	if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
		t4 = /* @__PURE__ */ jsx("button", { type: "button" });
		$[17] = t4;
	} else t4 = $[17];
	let t5;
	if ($[18] !== activeItem || $[19] !== item.items) {
		t5 = containsItem(item.items, activeItem);
		$[18] = activeItem;
		$[19] = item.items;
		$[20] = t5;
	} else t5 = $[20];
	let t6;
	if ($[21] !== item.label) {
		t6 = /* @__PURE__ */ jsx("span", {
			className: "min-w-0 flex-1 truncate",
			children: item.label
		});
		$[21] = item.label;
		$[22] = t6;
	} else t6 = $[22];
	let t7;
	if ($[23] !== item.tag) {
		t7 = /* @__PURE__ */ jsx(ChevronWithTag, { tag: item.tag });
		$[23] = item.tag;
		$[24] = t7;
	} else t7 = $[24];
	let t8;
	if ($[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
		t8 = /* @__PURE__ */ jsx(CollapsibleTrigger, { render: /* @__PURE__ */ jsxs(SidebarMenuSubButton, {
			render: t4,
			isActive: t5,
			className: `${COLLAPSIBLE_MENU_BUTTON_CLASS_NAME} pl-10`,
			children: [t6, t7]
		}) });
		$[25] = t5;
		$[26] = t6;
		$[27] = t7;
		$[28] = t8;
	} else t8 = $[28];
	const t9 = level + 1;
	let t10;
	if ($[29] !== fullId || $[30] !== item.items || $[31] !== t9) {
		t10 = /* @__PURE__ */ jsx(CollapsibleContent, { children: /* @__PURE__ */ jsx(SidebarMenuSub, { children: /* @__PURE__ */ jsx(SidebarSubMenuList, {
			items: item.items,
			level: t9,
			parentId: fullId
		}) }) });
		$[29] = fullId;
		$[30] = item.items;
		$[31] = t9;
		$[32] = t10;
	} else t10 = $[32];
	let t11;
	if ($[33] !== shouldBeOpen || $[34] !== t10 || $[35] !== t3 || $[36] !== t8) {
		t11 = /* @__PURE__ */ jsx(SidebarMenuSubItem, { children: /* @__PURE__ */ jsxs(Collapsible, {
			open: shouldBeOpen,
			onOpenChange: t3,
			children: [t8, t10]
		}) });
		$[33] = shouldBeOpen;
		$[34] = t10;
		$[35] = t3;
		$[36] = t8;
		$[37] = t11;
	} else t11 = $[37];
	return t11;
};
/**
* Renders a list of sibling sub-items. Opening one at level 0/1 closes any
* other open sibling at that same level (tree-wide, via `openPaths`); at
* level 2+ siblings can stay open together. Whichever sibling contains the
* active item (at any depth) starts expanded so the current selection is
* visible by default.
*/
const SidebarSubMenuList = (t0) => {
	const $ = c(10);
	if ($[0] !== "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0") {
		for (let $i = 0; $i < 10; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0";
	}
	const { items, level, parentId } = t0;
	let t1;
	if ($[1] !== items || $[2] !== level || $[3] !== parentId) {
		let t2;
		if ($[5] !== level || $[6] !== parentId) {
			t2 = (item, index) => /* @__PURE__ */ jsx(SidebarSubMenuNode, {
				item,
				level,
				parentId
			}, `${item.label}-${item.to ?? index}`);
			$[5] = level;
			$[6] = parentId;
			$[7] = t2;
		} else t2 = $[7];
		t1 = items.map(t2);
		$[1] = items;
		$[2] = level;
		$[3] = parentId;
		$[4] = t1;
	} else t1 = $[4];
	let t2;
	if ($[8] !== t1) {
		t2 = /* @__PURE__ */ jsx(Fragment, { children: t1 });
		$[8] = t1;
		$[9] = t2;
	} else t2 = $[9];
	return t2;
};
const MenuGroupSection = (t0) => {
	const $ = c(25);
	if ($[0] !== "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0") {
		for (let $i = 0; $i < 25; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0";
	}
	const { group, index } = t0;
	const { activeItem, openPaths } = useMenuState();
	const { state } = useSidebar();
	const isMenuOpen = state === "expanded";
	const toggleNode = useToggleNode(0);
	const groupItemClassName = group.variant === "ai" ? AI_GROUP_ITEM_CLASS_NAME : void 0;
	const t1 = group.label ?? index;
	const t2 = group.variant;
	const t3 = group.placement === "footer" ? "mb-0 py-3" : void 0;
	let t4;
	if ($[1] !== group.label || $[2] !== group.variant) {
		t4 = group.label && /* @__PURE__ */ jsxs(SidebarGroupLabel, {
			className: group.variant === "ai" ? "text-gx-ai" : void 0,
			children: [/* @__PURE__ */ jsx("span", {
				className: "shrink-0 whitespace-nowrap",
				children: group.label
			}), /* @__PURE__ */ jsx("span", { className: "h-px min-w-4 flex-1 bg-sidebar-border" })]
		});
		$[1] = group.label;
		$[2] = group.variant;
		$[3] = t4;
	} else t4 = $[3];
	let t5;
	if ($[4] !== activeItem || $[5] !== group.items || $[6] !== groupItemClassName || $[7] !== isMenuOpen || $[8] !== openPaths || $[9] !== toggleNode) {
		let t6;
		if ($[11] !== activeItem || $[12] !== groupItemClassName || $[13] !== isMenuOpen || $[14] !== openPaths || $[15] !== toggleNode) {
			t6 = (item) => {
				const fullId = resolveFullId("", item);
				if (!item.items) return /* @__PURE__ */ jsx(SidebarMenuItem, { children: /* @__PURE__ */ jsx(LeafItemButton, {
					item,
					ButtonComponent: SidebarMenuButton,
					className: groupItemClassName
				}) }, item.label);
				const shouldBeOpen = getShouldBeOpen({
					openPaths,
					level: 0,
					isAnyDescendantActive: containsItem(item.items, activeItem),
					isMenuOpen,
					fullPath: fullId,
					hasItemPath: true
				});
				return /* @__PURE__ */ jsx(SidebarMenuItem, { children: /* @__PURE__ */ jsxs(Collapsible, {
					open: shouldBeOpen,
					onOpenChange: () => toggleNode(fullId, shouldBeOpen),
					children: [/* @__PURE__ */ jsx(CollapsibleTrigger, { render: /* @__PURE__ */ jsxs(SidebarMenuButton, {
						isActive: containsItem(item.items, activeItem),
						className: cn(COLLAPSIBLE_MENU_BUTTON_CLASS_NAME, groupItemClassName),
						children: [
							/* @__PURE__ */ jsx(item.icon, {}),
							/* @__PURE__ */ jsx("span", {
								className: COLLAPSIBLE_ITEM_LABEL_CLASS_NAME,
								children: item.label
							}),
							/* @__PURE__ */ jsx(ChevronWithTag, { tag: item.tag })
						]
					}) }), /* @__PURE__ */ jsx(CollapsibleContent, { children: /* @__PURE__ */ jsx(SidebarMenuSub, { children: /* @__PURE__ */ jsx(SidebarSubMenuList, {
						items: item.items,
						level: 1,
						parentId: fullId
					}) }) })]
				}) }, item.label);
			};
			$[11] = activeItem;
			$[12] = groupItemClassName;
			$[13] = isMenuOpen;
			$[14] = openPaths;
			$[15] = toggleNode;
			$[16] = t6;
		} else t6 = $[16];
		t5 = group.items.map(t6);
		$[4] = activeItem;
		$[5] = group.items;
		$[6] = groupItemClassName;
		$[7] = isMenuOpen;
		$[8] = openPaths;
		$[9] = toggleNode;
		$[10] = t5;
	} else t5 = $[10];
	let t6;
	if ($[17] !== t5) {
		t6 = /* @__PURE__ */ jsx(SidebarGroupContent, { children: /* @__PURE__ */ jsx(SidebarMenu, { children: t5 }) });
		$[17] = t5;
		$[18] = t6;
	} else t6 = $[18];
	let t7;
	if ($[19] !== group.variant || $[20] !== t1 || $[21] !== t3 || $[22] !== t4 || $[23] !== t6) {
		t7 = /* @__PURE__ */ jsxs(SidebarGroup, {
			"data-variant": t2,
			className: t3,
			children: [t4, t6]
		}, t1);
		$[19] = group.variant;
		$[20] = t1;
		$[21] = t3;
		$[22] = t4;
		$[23] = t6;
		$[24] = t7;
	} else t7 = $[24];
	return t7;
};
/**
* Brand logo, plus the sidebar's own collapse/expand trigger in the same row.
* The logo itself also toggles the sidebar (most useful for reopening it once
* collapsed, when the trigger button shrinks away with the rest of the rail).
* The trigger only shows while expanded, since collapsing already has the
* logo as an affordance. Both reset `openPaths` (mirrors the old NavBar's
* hamburger-toggle behavior), so the active route's branch always
* auto-re-expands on open.
*/
const NavHeader = (t0) => {
	const $ = c(20);
	if ($[0] !== "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0") {
		for (let $i = 0; $i < 20; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0";
	}
	const { logoSrc, onToggle } = t0;
	const { state, toggleSidebar } = useSidebar();
	let t1;
	if ($[1] !== onToggle || $[2] !== toggleSidebar) {
		t1 = () => {
			toggleSidebar();
			onToggle();
		};
		$[1] = onToggle;
		$[2] = toggleSidebar;
		$[3] = t1;
	} else t1 = $[3];
	const t2 = state === "expanded" ? "Collapse sidebar" : "Expand sidebar";
	const t3 = `flex shrink-0 ${state === "expanded" ? "cursor-w-resize" : "cursor-e-resize"} items-center rounded-md ring-sidebar-ring outline-hidden focus-visible:ring-2`;
	let t4;
	if ($[4] !== logoSrc) {
		t4 = /* @__PURE__ */ jsx("img", {
			alt: "General Index",
			src: logoSrc,
			className: "size-7"
		});
		$[4] = logoSrc;
		$[5] = t4;
	} else t4 = $[5];
	let t5;
	if ($[6] !== state) {
		t5 = state === "expanded" && /* @__PURE__ */ jsx("span", {
			className: "ml-2 text-primary",
			children: "GO"
		});
		$[6] = state;
		$[7] = t5;
	} else t5 = $[7];
	let t6;
	if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
		t6 = /* @__PURE__ */ jsxs("button", {
			type: "button",
			onClick: t1,
			"aria-label": t2,
			className: t3,
			children: [t4, t5]
		});
		$[8] = t1;
		$[9] = t2;
		$[10] = t3;
		$[11] = t4;
		$[12] = t5;
		$[13] = t6;
	} else t6 = $[13];
	let t7;
	if ($[14] !== onToggle || $[15] !== state) {
		t7 = state === "expanded" && /* @__PURE__ */ jsx(SidebarTrigger, {
			className: "size-6 cursor-w-resize rounded-[3px] border border-input p-0 text-gx-text-tertiary hover:border-gx-text-secondary hover:bg-transparent hover:text-gx-text-secondary",
			onClick: onToggle
		});
		$[14] = onToggle;
		$[15] = state;
		$[16] = t7;
	} else t7 = $[16];
	let t8;
	if ($[17] !== t6 || $[18] !== t7) {
		t8 = /* @__PURE__ */ jsxs(SidebarHeader, {
			className: "flex-row items-center justify-between border-b border-sidebar-border px-5 py-4 transition-[padding] duration-200 group-data-[collapsible=icon]:justify-start group-data-[collapsible=icon]:px-[17px]",
			children: [t6, t7]
		});
		$[17] = t6;
		$[18] = t7;
		$[19] = t8;
	} else t8 = $[19];
	return t8;
};
/**
* The application shell's primary navigation, composed from the `Sidebar`
* primitive and a schema-driven menu (`MenuGroup[]`). Always collapses to an
* icon-only rail (`collapsible="icon"`) rather than hiding offcanvas, so the
* rail stays reachable to reopen. Must render inside `SidebarProvider`, as a
* sibling to the page content (`SidebarInset`), since both read the shared
* open/collapsed state via `useSidebar`.
*
* Clicking a link or action item leaves the sidebar open. Toggling the sidebar
* itself (the header logo or its own trigger) clears `openPaths`, so the active
* route's branch auto-re-expands; forcing the sidebar open from a collapsed
* level-0 click does not.
*
* Sibling collapsible groups behave as an accordion at levels 0 and 1
* (opening one closes any other open sibling at that level, tree-wide);
* level 2+ branches can stay open simultaneously. Whichever branch contains
* the schema's `active` item starts expanded by default.
*
* Import path: `@design-system/components/app-sidebar`.
*/
const AppSidebar = (t0) => {
	const $ = c(37);
	if ($[0] !== "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0") {
		for (let $i = 0; $i < 37; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "0b33d35231c40073b1f965c6b8704eede11e158fae9b269f3084b54551e525a0";
	}
	const { menuSchema, logoSrc, user, onLogout, linkComponent, headerExtra } = t0;
	const contentGroups = menuSchema.filter(_temp$18);
	const footerGroups = menuSchema.filter(_temp2$7);
	let t1;
	if ($[1] !== menuSchema) {
		t1 = () => findActiveItemInSchema(menuSchema);
		$[1] = menuSchema;
		$[2] = t1;
	} else t1 = $[2];
	const [activeItem, setActiveItem] = useState(t1);
	let t2;
	if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = {};
		$[3] = t2;
	} else t2 = $[3];
	const [openPaths, setOpenPaths] = useState(t2);
	const { state } = useSidebar();
	let t3;
	let t4;
	if ($[4] !== menuSchema) {
		t3 = () => {
			setActiveItem(findActiveItemInSchema(menuSchema));
		};
		t4 = [menuSchema];
		$[4] = menuSchema;
		$[5] = t3;
		$[6] = t4;
	} else {
		t3 = $[5];
		t4 = $[6];
	}
	useEffect(t3, t4);
	const T0 = MenuStateContext;
	let t5;
	if ($[7] !== activeItem || $[8] !== linkComponent || $[9] !== openPaths) {
		t5 = {
			activeItem,
			setActiveItem,
			openPaths,
			setOpenPaths,
			linkComponent
		};
		$[7] = activeItem;
		$[8] = linkComponent;
		$[9] = openPaths;
		$[10] = t5;
	} else t5 = $[10];
	const T1 = Sidebar$1;
	const t6 = "icon";
	let t7;
	if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
		t7 = () => setOpenPaths({});
		$[11] = t7;
	} else t7 = $[11];
	let t8;
	if ($[12] !== logoSrc) {
		t8 = /* @__PURE__ */ jsx(NavHeader, {
			logoSrc,
			onToggle: t7
		});
		$[12] = logoSrc;
		$[13] = t8;
	} else t8 = $[13];
	let t9;
	if ($[14] !== headerExtra || $[15] !== state) {
		t9 = headerExtra && state === "expanded" && /* @__PURE__ */ jsx("div", {
			className: "px-2",
			children: headerExtra
		});
		$[14] = headerExtra;
		$[15] = state;
		$[16] = t9;
	} else t9 = $[16];
	const t10 = contentGroups.map(_temp3$3);
	let t11;
	if ($[17] !== t10) {
		t11 = /* @__PURE__ */ jsx(SidebarContent, { children: t10 });
		$[17] = t10;
		$[18] = t11;
	} else t11 = $[18];
	const T2 = SidebarFooter;
	const t12 = footerGroups.map(_temp4$1);
	let t13;
	if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
		t13 = /* @__PURE__ */ jsx(SidebarSeparator, {});
		$[19] = t13;
	} else t13 = $[19];
	let t14;
	if ($[20] !== onLogout || $[21] !== user) {
		t14 = /* @__PURE__ */ jsx(CurrentUserCard, {
			user,
			onLogout
		});
		$[20] = onLogout;
		$[21] = user;
		$[22] = t14;
	} else t14 = $[22];
	let t15;
	if ($[23] !== T2 || $[24] !== t12 || $[25] !== t14) {
		t15 = /* @__PURE__ */ jsxs(T2, { children: [
			t12,
			t13,
			t14
		] });
		$[23] = T2;
		$[24] = t12;
		$[25] = t14;
		$[26] = t15;
	} else t15 = $[26];
	let t16;
	if ($[27] !== T1 || $[28] !== t11 || $[29] !== t15 || $[30] !== t8 || $[31] !== t9) {
		t16 = /* @__PURE__ */ jsxs(T1, {
			collapsible: t6,
			children: [
				t8,
				t9,
				t11,
				t15
			]
		});
		$[27] = T1;
		$[28] = t11;
		$[29] = t15;
		$[30] = t8;
		$[31] = t9;
		$[32] = t16;
	} else t16 = $[32];
	let t17;
	if ($[33] !== T0 || $[34] !== t16 || $[35] !== t5) {
		t17 = /* @__PURE__ */ jsx(T0, {
			value: t5,
			children: t16
		});
		$[33] = T0;
		$[34] = t16;
		$[35] = t5;
		$[36] = t17;
	} else t17 = $[36];
	return t17;
};
function _temp$18(group) {
	return group.placement !== "footer";
}
function _temp2$7(group_0) {
	return group_0.placement === "footer";
}
function _temp3$3(group_1, index) {
	return /* @__PURE__ */ jsx(MenuGroupSection, {
		group: group_1,
		index
	}, group_1.label ?? index);
}
function _temp4$1(group_2, index_0) {
	return /* @__PURE__ */ jsx(MenuGroupSection, {
		group: group_2,
		index: index_0
	}, group_2.label ?? index_0);
}
//#endregion
//#region src/components/data-table/data-table-filter-utils.ts
/**
* Adds or removes `value` from a column's array-based filter value (the
* shape `arrHas` and `DataTableFilterMenu`/`DataTableFilterPanel`/
* `DataTableActiveFilterChips` all share), clearing the filter entirely
* (`undefined`) once the last value is removed.
*
* Import path: `@design-system/components/data-table/data-table-filter-utils`.
*/
function toggleArrayFilterValue(column, value, checked) {
	const current = new Set(column.getFilterValue() ?? []);
	if (checked) current.add(value);
	else current.delete(value);
	column.setFilterValue(current.size ? Array.from(current) : void 0);
}
//#endregion
//#region src/components/data-table/data-table-active-filter-chips.tsx
function FilterChip(t0) {
	const $ = c(6);
	if ($[0] !== "4904393dc1ae692b9c2a82dbf59f8c3eca626e6f321dbf188ab844954c61689e") {
		for (let $i = 0; $i < 6; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "4904393dc1ae692b9c2a82dbf59f8c3eca626e6f321dbf188ab844954c61689e";
	}
	const { label, onRemove } = t0;
	const t1 = `Remove ${label} filter`;
	let t2;
	if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = /* @__PURE__ */ jsx(XIcon, { className: "size-3" });
		$[1] = t2;
	} else t2 = $[1];
	let t3;
	if ($[2] !== label || $[3] !== onRemove || $[4] !== t1) {
		t3 = /* @__PURE__ */ jsxs("button", {
			"aria-label": t1,
			className: "inline-flex h-7 items-center gap-1 rounded-md bg-gx-action-bar-button-tile px-2 text-xs text-gx-text hover:text-gx-highlight",
			type: "button",
			onClick: onRemove,
			children: [label, t2]
		});
		$[2] = label;
		$[3] = onRemove;
		$[4] = t1;
		$[5] = t3;
	} else t3 = $[5];
	return t3;
}
/**
* The active-filter summary bar: one dismissible chip per checked value,
* grouped by column label, plus any one-off `singleFilters` and a "Clear
* all" action. Renders nothing when no filter is active and no `children`
* are supplied — mount it unconditionally above a table and let it decide
* its own visibility.
*
* Import path: `@design-system/components/data-table/data-table-active-filter-chips`.
*/
function DataTableActiveFilterChips(t0) {
	const $ = c(22);
	if ($[0] !== "4904393dc1ae692b9c2a82dbf59f8c3eca626e6f321dbf188ab844954c61689e") {
		for (let $i = 0; $i < 22; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "4904393dc1ae692b9c2a82dbf59f8c3eca626e6f321dbf188ab844954c61689e";
	}
	const { groups, singleFilters: t1, onClearAll, children } = t0;
	let t2;
	if ($[1] !== t1) {
		t2 = t1 === void 0 ? [] : t1;
		$[1] = t1;
		$[2] = t2;
	} else t2 = $[2];
	const singleFilters = t2;
	let hasActiveFilters;
	let t3;
	let t4;
	let t5;
	let t6;
	if ($[3] !== children || $[4] !== groups || $[5] !== singleFilters) {
		t6 = Symbol.for("react.early_return_sentinel");
		bb0: {
			const activeGroups = groups.filter(_temp$17);
			hasActiveFilters = activeGroups.length > 0 || singleFilters.length > 0;
			if (!hasActiveFilters && !children) {
				t6 = null;
				break bb0;
			}
			t3 = "flex flex-wrap items-center gap-2";
			if ($[11] !== singleFilters) {
				t4 = singleFilters.map(_temp2$6);
				$[11] = singleFilters;
				$[12] = t4;
			} else t4 = $[12];
			t5 = activeGroups.map(_temp3$2);
		}
		$[3] = children;
		$[4] = groups;
		$[5] = singleFilters;
		$[6] = hasActiveFilters;
		$[7] = t3;
		$[8] = t4;
		$[9] = t5;
		$[10] = t6;
	} else {
		hasActiveFilters = $[6];
		t3 = $[7];
		t4 = $[8];
		t5 = $[9];
		t6 = $[10];
	}
	if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
	let t7;
	if ($[13] !== hasActiveFilters || $[14] !== onClearAll) {
		t7 = hasActiveFilters && onClearAll && /* @__PURE__ */ jsx(Button, {
			size: "sm",
			variant: "ghost",
			onClick: onClearAll,
			children: "Clear all"
		});
		$[13] = hasActiveFilters;
		$[14] = onClearAll;
		$[15] = t7;
	} else t7 = $[15];
	let t8;
	if ($[16] !== children || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t7) {
		t8 = /* @__PURE__ */ jsxs("div", {
			className: t3,
			children: [
				t4,
				t5,
				t7,
				children
			]
		});
		$[16] = children;
		$[17] = t3;
		$[18] = t4;
		$[19] = t5;
		$[20] = t7;
		$[21] = t8;
	} else t8 = $[21];
	return t8;
}
function _temp3$2(group_0) {
	return /* @__PURE__ */ jsxs("span", {
		className: "flex flex-wrap items-center gap-2",
		children: [/* @__PURE__ */ jsxs("span", {
			className: "text-sm font-medium text-muted-foreground",
			children: [group_0.label, ":"]
		}), group_0.values.map((value) => /* @__PURE__ */ jsx(FilterChip, {
			label: value,
			onRemove: () => toggleArrayFilterValue(group_0.column, value, false)
		}, value))]
	}, group_0.column.id);
}
function _temp2$6(single) {
	return /* @__PURE__ */ jsx(FilterChip, {
		label: single.label,
		onRemove: single.onRemove
	}, single.label);
}
function _temp$17(group) {
	return group.values.length > 0;
}
//#endregion
//#region src/components/data-table/data-table-column-header.tsx
/**
* A sortable column header: a plain label when the column can't sort,
* otherwise a button that toggles sorting directly on click (cycling
* ascending → descending → unsorted via `column.getToggleSortingHandler()`),
* with an icon reflecting the current direction. Column hide/show lives in
* `DataTableViewOptions`, not here.
*
* Import path: `@design-system/components/data-table/data-table-column-header`.
*/
function DataTableColumnHeader(t0) {
	const $ = c(18);
	if ($[0] !== "fc943da9563a3ab320fbc5bf9c1fd7aee0f36532e96d10072f3f907c86d72e6d") {
		for (let $i = 0; $i < 18; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "fc943da9563a3ab320fbc5bf9c1fd7aee0f36532e96d10072f3f907c86d72e6d";
	}
	const { column, title, className } = t0;
	if (!column.getCanSort()) {
		let t1;
		if ($[1] !== className) {
			t1 = cn("font-medium", className);
			$[1] = className;
			$[2] = t1;
		} else t1 = $[2];
		let t2;
		if ($[3] !== t1 || $[4] !== title) {
			t2 = /* @__PURE__ */ jsx("div", {
				className: t1,
				children: title
			});
			$[3] = t1;
			$[4] = title;
			$[5] = t2;
		} else t2 = $[5];
		return t2;
	}
	const sorted = column.getIsSorted();
	let t1;
	if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = /* @__PURE__ */ jsx(ChevronsUpDownIcon, { className: "text-muted-foreground" });
		$[6] = t1;
	} else t1 = $[6];
	let sortIcon = t1;
	if (sorted === "desc") {
		let t2;
		if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
			t2 = /* @__PURE__ */ jsx(ArrowDownIcon, {});
			$[7] = t2;
		} else t2 = $[7];
		sortIcon = t2;
	} else if (sorted === "asc") {
		let t2;
		if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
			t2 = /* @__PURE__ */ jsx(ArrowUpIcon, {});
			$[8] = t2;
		} else t2 = $[8];
		sortIcon = t2;
	}
	let t2;
	if ($[9] !== className) {
		t2 = cn("-ml-2.5 gap-1.5", className);
		$[9] = className;
		$[10] = t2;
	} else t2 = $[10];
	let t3;
	if ($[11] !== column) {
		t3 = column.getToggleSortingHandler();
		$[11] = column;
		$[12] = t3;
	} else t3 = $[12];
	let t4;
	if ($[13] !== sortIcon || $[14] !== t2 || $[15] !== t3 || $[16] !== title) {
		t4 = /* @__PURE__ */ jsxs(Button, {
			className: t2,
			size: "sm",
			variant: "ghost",
			onClick: t3,
			children: [title, sortIcon]
		});
		$[13] = sortIcon;
		$[14] = t2;
		$[15] = t3;
		$[16] = title;
		$[17] = t4;
	} else t4 = $[17];
	return t4;
}
//#endregion
//#region src/components/data-table/data-table-column-resize-handle.tsx
const DEFAULT_COLUMN_SIZE = 150;
const DEFAULT_MIN_SIZE = 20;
const DEFAULT_MAX_SIZE = Number.MAX_SAFE_INTEGER;
const DEFAULT_STEP = 8;
const SHIFT_STEP_MULTIPLIER = 5;
function clampSize(size, minSize, maxSize) {
	return Math.min(Math.max(size, minSize), maxSize);
}
/**
* An accessible resize separator for a TanStack DataTable header.
*
* Use Arrow Left and Arrow Right for keyboard resizing, hold Shift for a
* five-times larger step, and double-click to restore the column definition's
* default size.
*
* Public import path: `design-system`.
*/
function DataTableColumnResizeHandle(t0) {
	const $ = c(35);
	if ($[0] !== "d3d6c1d4298148fd684caa53a271101c3a45d01eda93860cb78a48bdb45d28bb") {
		for (let $i = 0; $i < 35; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d3d6c1d4298148fd684caa53a271101c3a45d01eda93860cb78a48bdb45d28bb";
	}
	const { header, label, step: t1, onResizeEnd } = t0;
	const step = t1 === void 0 ? DEFAULT_STEP : t1;
	const { column } = header;
	const minSize = column.columnDef.minSize ?? DEFAULT_MIN_SIZE;
	const maxSize = column.columnDef.maxSize ?? DEFAULT_MAX_SIZE;
	const size = column.getSize();
	const [, refreshSize] = useReducer(_temp$16, 0);
	if (!column.getCanResize()) return null;
	let t2;
	if ($[1] !== column.id || $[2] !== onResizeEnd) {
		t2 = (nextSize) => onResizeEnd?.(column.id, nextSize);
		$[1] = column.id;
		$[2] = onResizeEnd;
		$[3] = t2;
	} else t2 = $[3];
	const reportResizeEnd = t2;
	let t3;
	if ($[4] !== column.id || $[5] !== header.table || $[6] !== refreshSize || $[7] !== reportResizeEnd) {
		t3 = (nextSize_0) => {
			header.table.setColumnSizing((previous) => ({
				...previous,
				[column.id]: nextSize_0
			}));
			refreshSize();
			reportResizeEnd(nextSize_0);
		};
		$[4] = column.id;
		$[5] = header.table;
		$[6] = refreshSize;
		$[7] = reportResizeEnd;
		$[8] = t3;
	} else t3 = $[8];
	const setSize = t3;
	let t4;
	if ($[9] !== column || $[10] !== maxSize || $[11] !== minSize || $[12] !== refreshSize || $[13] !== reportResizeEnd) {
		t4 = () => {
			const defaultSize = clampSize(column.columnDef.size ?? DEFAULT_COLUMN_SIZE, minSize, maxSize);
			column.resetSize();
			refreshSize();
			reportResizeEnd(defaultSize);
		};
		$[9] = column;
		$[10] = maxSize;
		$[11] = minSize;
		$[12] = refreshSize;
		$[13] = reportResizeEnd;
		$[14] = t4;
	} else t4 = $[14];
	const reset = t4;
	let t5;
	if ($[15] !== maxSize || $[16] !== minSize || $[17] !== setSize || $[18] !== size || $[19] !== step) {
		t5 = (event) => {
			if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
			event.preventDefault();
			event.stopPropagation();
			const direction = event.key === "ArrowRight" ? 1 : -1;
			const multiplier = event.shiftKey ? SHIFT_STEP_MULTIPLIER : 1;
			setSize(clampSize(size + direction * step * multiplier, minSize, maxSize));
		};
		$[15] = maxSize;
		$[16] = minSize;
		$[17] = setSize;
		$[18] = size;
		$[19] = step;
		$[20] = t5;
	} else t5 = $[20];
	const handleKeyDown = t5;
	let t6;
	if ($[21] !== column || $[22] !== header || $[23] !== onResizeEnd || $[24] !== refreshSize || $[25] !== reportResizeEnd) {
		t6 = (event_0) => {
			event_0.preventDefault();
			event_0.stopPropagation();
			const endEvent = event_0.type === "touchstart" ? "touchend" : "mouseup";
			const contextDocument = event_0.currentTarget.ownerDocument;
			header.getResizeHandler()(event_0);
			contextDocument.addEventListener(endEvent, () => {
				refreshSize();
				if (onResizeEnd) queueMicrotask(() => reportResizeEnd(column.getSize()));
			}, { once: true });
		};
		$[21] = column;
		$[22] = header;
		$[23] = onResizeEnd;
		$[24] = refreshSize;
		$[25] = reportResizeEnd;
		$[26] = t6;
	} else t6 = $[26];
	const startPointerResize = t6;
	const t7 = `Resize ${label}`;
	let t8;
	if ($[27] !== handleKeyDown || $[28] !== maxSize || $[29] !== minSize || $[30] !== reset || $[31] !== size || $[32] !== startPointerResize || $[33] !== t7) {
		t8 = /* @__PURE__ */ jsx("div", {
			"aria-label": t7,
			"aria-orientation": "vertical",
			"aria-valuemax": maxSize,
			"aria-valuemin": minSize,
			"aria-valuenow": size,
			className: "absolute inset-y-0 right-0 z-10 w-2 cursor-col-resize touch-none select-none outline-none before:absolute before:inset-y-0 before:right-0 before:w-px before:bg-border before:transition-colors hover:before:bg-ring focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-inset active:before:bg-ring",
			"data-slot": "data-table-column-resize-handle",
			role: "separator",
			tabIndex: 0,
			onDoubleClick: reset,
			onKeyDown: handleKeyDown,
			onMouseDown: startPointerResize,
			onTouchStart: startPointerResize
		});
		$[27] = handleKeyDown;
		$[28] = maxSize;
		$[29] = minSize;
		$[30] = reset;
		$[31] = size;
		$[32] = startPointerResize;
		$[33] = t7;
		$[34] = t8;
	} else t8 = $[34];
	return t8;
}
function _temp$16(revision) {
	return revision + 1;
}
//#endregion
//#region src/components/ui/table.tsx
function Table(t0) {
	const $ = c(9);
	if ($[0] !== "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("w-full caption-bottom text-sm", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "table-container",
			className: "relative w-full overflow-x-auto",
			children: /* @__PURE__ */ jsx("table", {
				"data-slot": "table",
				className: t1,
				...props
			})
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function TableHeader(t0) {
	const $ = c(9);
	if ($[0] !== "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("[&_tr]:border-b", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("thead", {
			"data-slot": "table-header",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function TableBody(t0) {
	const $ = c(9);
	if ($[0] !== "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("[&_tr:last-child]:border-0 [&>tr:nth-child(odd_of_[data-slot=table-row])]:bg-gx-tile-light [&>tr:nth-child(even_of_[data-slot=table-row])]:bg-gx-tile-dark", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("tbody", {
			"data-slot": "table-body",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function TableFooter(t0) {
	const $ = c(9);
	if ($[0] !== "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("tfoot", {
			"data-slot": "table-footer",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function TableRow(t0) {
	const $ = c(9);
	if ($[0] !== "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("h-6 border-b transition-colors hover:bg-muted/50! has-aria-expanded:bg-muted/50! data-[state=selected]:bg-muted!", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("tr", {
			"data-slot": "table-row",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function TableHead(t0) {
	const $ = c(9);
	if ($[0] !== "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("h-10 px-2 text-left align-middle font-medium whitespace-nowrap text-foreground [&:has([role=checkbox])]:pr-0", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("th", {
			"data-slot": "table-head",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function TableCell(t0) {
	const $ = c(9);
	if ($[0] !== "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("h-6 px-2 py-0 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("td", {
			"data-slot": "table-cell",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function TableCaption(t0) {
	const $ = c(9);
	if ($[0] !== "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "96ce187cbebae290dccd1f478c33b6645dfd50208344d7bf5eae2b4c8d2ca7ee";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("mt-4 text-sm text-muted-foreground", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("caption", {
			"data-slot": "table-caption",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/data-table/data-table-detail-panel.tsx
/**
* A full-width detail row rendered directly below an expanded row —
* decoupled entirely from the parent table's column defs. Use this instead
* of `getSubRows` when expanded content needs its own columns/header (e.g. a
* "Comments" mini-table with completely different fields): every row in a
* TanStack table shares one column set, so `getSubRows` can't give sub-rows a
* different shape, but this panel can render anything.
*
* Renders nothing while `row.getIsExpanded()` is false. The row it belongs
* to needs `row.getCanExpand()` to be true, which requires passing
* `getRowCanExpand` to `useDataTable` (e.g. `() => true` to make every row
* expandable) since a row with no `getSubRows` result otherwise can't expand.
*
* Import path: `@design-system/components/data-table/data-table-detail-panel`.
*/
function DataTableDetailPanel(t0) {
	const $ = c(4);
	if ($[0] !== "1d2194d7c07b56d93d7bde1fe5ff51b3ecfe72561f49b06f02487327d611a483") {
		for (let $i = 0; $i < 4; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "1d2194d7c07b56d93d7bde1fe5ff51b3ecfe72561f49b06f02487327d611a483";
	}
	const { row, colSpan, children } = t0;
	if (!row.getIsExpanded()) return null;
	let t1;
	if ($[1] !== children || $[2] !== colSpan) {
		t1 = /* @__PURE__ */ jsx(TableRow, {
			"data-slot": "table-detail-row",
			children: /* @__PURE__ */ jsx(TableCell, {
				className: "bg-gx-tile-dark p-0",
				colSpan,
				children
			})
		});
		$[1] = children;
		$[2] = colSpan;
		$[3] = t1;
	} else t1 = $[3];
	return t1;
}
//#endregion
//#region src/hooks/use-data-table.ts
/**
* Keeps rows whose id is a member of the filter value — a matched-id set, not
* a column cell comparison. Pairs with `DataTableSearchInput`'s `fuzzy` mode:
* set a column's `filterFn` to `"fuzzyIds"` and its filter value to the
* matched-id set from a `Fuse` search.
*
* Accepts a plain `string[]` in addition to a `Set<string>` because
* `useUrlSyncedTableState` always restores column filters from URL params as
* arrays — without this, restoring a fuzzy-search column's filter from a
* bookmarked/shared URL would crash on `filterValue.has`.
*/
const filterFn_fuzzyIds = (row, _columnId, filterValue) => filterValue instanceof Set ? filterValue.has(row.id) : filterValue.includes(row.id);
/**
* Stock feature set shared by every table built with this toolkit: row
* selection, sorting, column filtering (`arrHas` for `DataTableFilterMenu`'s
* grouped checkboxes, `includesString` for `DataTableSearchInput`'s free-text
* search, `fuzzyIds` for its fuzzy-search mode), faceting (unique value
* counts for filter menus), column visibility, column sizing and resizing
* (`getSize()` and `getResizeHandler()`), and row expanding. Pagination is
* intentionally not registered — large tables use the virtualized body
* instead.
*/
const dataTableFeatures = tableFeatures({
	rowSelectionFeature,
	rowSortingFeature,
	columnFilteringFeature,
	columnFacetingFeature,
	columnSizingFeature,
	columnResizingFeature,
	columnVisibilityFeature,
	rowExpandingFeature,
	columnMeta: metaHelper(),
	sortedRowModel: createSortedRowModel(),
	filteredRowModel: createFilteredRowModel(),
	facetedRowModel: createFacetedRowModel(),
	facetedUniqueValues: createFacetedUniqueValues(),
	expandedRowModel: createExpandedRowModel(),
	sortFns: {
		alphanumeric: sortFn_alphanumeric,
		text: sortFn_alphanumeric
	},
	filterFns: {
		arrHas: filterFn_arrHas,
		includesString: filterFn_includesString,
		fuzzyIds: filterFn_fuzzyIds
	}
});
/**
* App-wide table factory bound to `dataTableFeatures`. `createAppColumnHelper`
* infers `TFeatures` automatically, so column defs elsewhere in the toolkit
* (e.g. `getSelectionColumn`) don't need to repeat the feature generic.
*/
const { createAppColumnHelper, useAppTable: useBaseAppTable, useTableContext } = createTableHook({ features: dataTableFeatures });
/**
* Keeps externally controlled table slices owned by the current React render.
*
* TanStack Table synchronizes `options.state` into its atom store while its
* hook is rendering. Without this selector composition, that synchronization
* notifies the subscription from the previous render and React reports a
* render-phase update. The previous selector closes over the previous external
* values, so controlled-slice synchronization is ignored by the subscription;
* internally owned slices still flow through and trigger renders normally.
*/
function useAppTable(tableOptions, selector) {
	const $ = c(4);
	if ($[0] !== "d56fc9b71276b6a84ec25b9aeb4b94639f62747ac99a3cb39fa9ede3e0d10aae") {
		for (let $i = 0; $i < 4; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d56fc9b71276b6a84ec25b9aeb4b94639f62747ac99a3cb39fa9ede3e0d10aae";
	}
	const externalState = tableOptions.state;
	let t0;
	if ($[1] !== externalState || $[2] !== selector) {
		t0 = (state) => {
			const stateWithExternalSlices = externalState ? {
				...state,
				...externalState
			} : state;
			return selector ? selector(stateWithExternalSlices) : stateWithExternalSlices;
		};
		$[1] = externalState;
		$[2] = selector;
		$[3] = t0;
	} else t0 = $[3];
	return useBaseAppTable(tableOptions, t0);
}
/**
* Wraps `useAppTable` with table-owned state for every registered feature
* slice (sorting, column filters, column visibility, row selection, row
* expanding, and column sizing). Consuming tables read and mutate state
* entirely through the returned table instance's methods (`table.setSorting`,
* `column.toggleVisibility`, `row.toggleSelected`, ...).
*
* Sorting and column filters can instead be handed off to an external owner
* (e.g. `useUrlSyncedTableState`, to sync them with the URL). Visibility,
* expansion, selection, and sizing support the same paired controlled-state
* contract.
*/
function useDataTable(t0) {
	const $ = c(47);
	if ($[0] !== "d56fc9b71276b6a84ec25b9aeb4b94639f62747ac99a3cb39fa9ede3e0d10aae") {
		for (let $i = 0; $i < 47; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d56fc9b71276b6a84ec25b9aeb4b94639f62747ac99a3cb39fa9ede3e0d10aae";
	}
	const { data, columns, getRowId, getSubRows, getRowCanExpand, sorting, onSortingChange, columnFilters, onColumnFiltersChange, columnVisibility, onColumnVisibilityChange, expanded, onExpandedChange, rowSelection, onRowSelectionChange, columnSizing, onColumnSizingChange } = t0;
	let t1;
	if ($[1] !== sorting) {
		t1 = sorting !== void 0 ? { sorting } : {};
		$[1] = sorting;
		$[2] = t1;
	} else t1 = $[2];
	let t2;
	if ($[3] !== columnFilters) {
		t2 = columnFilters !== void 0 ? { columnFilters } : {};
		$[3] = columnFilters;
		$[4] = t2;
	} else t2 = $[4];
	let t3;
	if ($[5] !== columnVisibility) {
		t3 = columnVisibility !== void 0 ? { columnVisibility } : {};
		$[5] = columnVisibility;
		$[6] = t3;
	} else t3 = $[6];
	let t4;
	if ($[7] !== expanded) {
		t4 = expanded !== void 0 ? { expanded } : {};
		$[7] = expanded;
		$[8] = t4;
	} else t4 = $[8];
	let t5;
	if ($[9] !== rowSelection) {
		t5 = rowSelection !== void 0 ? { rowSelection } : {};
		$[9] = rowSelection;
		$[10] = t5;
	} else t5 = $[10];
	let t6;
	if ($[11] !== columnSizing) {
		t6 = columnSizing !== void 0 ? { columnSizing } : {};
		$[11] = columnSizing;
		$[12] = t6;
	} else t6 = $[12];
	let t7;
	if ($[13] !== t1 || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
		t7 = {
			...t1,
			...t2,
			...t3,
			...t4,
			...t5,
			...t6
		};
		$[13] = t1;
		$[14] = t2;
		$[15] = t3;
		$[16] = t4;
		$[17] = t5;
		$[18] = t6;
		$[19] = t7;
	} else t7 = $[19];
	const controlledState = t7;
	let t8;
	if ($[20] !== controlledState) {
		t8 = Object.keys(controlledState).length > 0 ? { state: controlledState } : {};
		$[20] = controlledState;
		$[21] = t8;
	} else t8 = $[21];
	let t9;
	if ($[22] !== onSortingChange) {
		t9 = onSortingChange ? { onSortingChange } : {};
		$[22] = onSortingChange;
		$[23] = t9;
	} else t9 = $[23];
	let t10;
	if ($[24] !== onColumnFiltersChange) {
		t10 = onColumnFiltersChange ? { onColumnFiltersChange } : {};
		$[24] = onColumnFiltersChange;
		$[25] = t10;
	} else t10 = $[25];
	let t11;
	if ($[26] !== onColumnVisibilityChange) {
		t11 = onColumnVisibilityChange ? { onColumnVisibilityChange } : {};
		$[26] = onColumnVisibilityChange;
		$[27] = t11;
	} else t11 = $[27];
	let t12;
	if ($[28] !== onExpandedChange) {
		t12 = onExpandedChange ? { onExpandedChange } : {};
		$[28] = onExpandedChange;
		$[29] = t12;
	} else t12 = $[29];
	let t13;
	if ($[30] !== onRowSelectionChange) {
		t13 = onRowSelectionChange ? { onRowSelectionChange } : {};
		$[30] = onRowSelectionChange;
		$[31] = t13;
	} else t13 = $[31];
	let t14;
	if ($[32] !== onColumnSizingChange) {
		t14 = onColumnSizingChange ? { onColumnSizingChange } : {};
		$[32] = onColumnSizingChange;
		$[33] = t14;
	} else t14 = $[33];
	let t15;
	if ($[34] !== columns || $[35] !== data || $[36] !== getRowCanExpand || $[37] !== getRowId || $[38] !== getSubRows || $[39] !== t10 || $[40] !== t11 || $[41] !== t12 || $[42] !== t13 || $[43] !== t14 || $[44] !== t8 || $[45] !== t9) {
		t15 = {
			data,
			columns,
			getRowId,
			getSubRows,
			getRowCanExpand,
			...t8,
			...t9,
			...t10,
			...t11,
			...t12,
			...t13,
			...t14
		};
		$[34] = columns;
		$[35] = data;
		$[36] = getRowCanExpand;
		$[37] = getRowId;
		$[38] = getSubRows;
		$[39] = t10;
		$[40] = t11;
		$[41] = t12;
		$[42] = t13;
		$[43] = t14;
		$[44] = t8;
		$[45] = t9;
		$[46] = t15;
	} else t15 = $[46];
	return useAppTable(t15);
}
//#endregion
//#region src/components/data-table/data-table-expand-toggle.tsx
/**
* A chevron toggle for a row's expanded/collapsed state. Renders nothing for
* rows that can't expand (`row.getCanExpand()` false) so it's safe to render
* unconditionally in a cell.
*
* The consuming table owns what "expanded" means: sub-rows (via
* `getSubRows`) or a custom detail panel rendered alongside the row when
* `row.getIsExpanded()` is true.
*
* Import path: `@design-system/components/data-table/data-table-expand-toggle`.
*/
function DataTableExpandToggle(t0) {
	const $ = c(9);
	if ($[0] !== "6603ca5e315c13ab07e6a3e6eb7de2a1f4f8c4e0062835ceab48c1b0803f7592") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6603ca5e315c13ab07e6a3e6eb7de2a1f4f8c4e0062835ceab48c1b0803f7592";
	}
	const { row } = t0;
	if (!row.getCanExpand()) return null;
	let t1;
	if ($[1] !== row.id) {
		t1 = (expanded) => expanded === true || expanded[row.id];
		$[1] = row.id;
		$[2] = t1;
	} else t1 = $[2];
	let t2;
	if ($[3] !== row) {
		t2 = (isExpanded) => /* @__PURE__ */ jsx(Button, {
			"aria-expanded": isExpanded,
			"aria-label": isExpanded ? "Collapse row" : "Expand row",
			size: "icon-2xs",
			variant: "ghost",
			onClick: () => row.toggleExpanded(!isExpanded),
			children: /* @__PURE__ */ jsx(ChevronRightIcon, { className: cn("transition-transform", isExpanded && "rotate-90") })
		});
		$[3] = row;
		$[4] = t2;
	} else t2 = $[4];
	let t3;
	if ($[5] !== row.table.atoms.expanded || $[6] !== t1 || $[7] !== t2) {
		t3 = /* @__PURE__ */ jsx(Subscribe, {
			source: row.table.atoms.expanded,
			selector: t1,
			children: t2
		});
		$[5] = row.table.atoms.expanded;
		$[6] = t1;
		$[7] = t2;
		$[8] = t3;
	} else t3 = $[8];
	return t3;
}
/**
* An `expand` display column wrapping `DataTableExpandToggle`, for tables
* that want a dedicated expand/collapse column instead of composing the
* toggle into another column's cell.
*
* Import path: `@design-system/components/data-table/data-table-expand-toggle`.
*/
function getExpandColumn() {
	return createAppColumnHelper().display({
		id: "expand",
		cell: ({ row }) => /* @__PURE__ */ jsx(DataTableExpandToggle, { row }),
		enableSorting: false,
		enableHiding: false
	});
}
//#endregion
//#region src/components/data-table/data-table-hierarchy-cell.tsx
const HIERARCHY_INDENT_REM = 1.25;
function DataTableHierarchyCell(t0) {
	const $ = c(9);
	if ($[0] !== "57fc450f4cea8504cb91531bac64730a844f0406418b1e65b395bda1929d3d8d") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "57fc450f4cea8504cb91531bac64730a844f0406418b1e65b395bda1929d3d8d";
	}
	const { children, row } = t0;
	const t1 = `${row.depth * HIERARCHY_INDENT_REM}rem`;
	let t2;
	if ($[1] !== t1) {
		t2 = { paddingLeft: t1 };
		$[1] = t1;
		$[2] = t2;
	} else t2 = $[2];
	let t3;
	if ($[3] !== row) {
		t3 = /* @__PURE__ */ jsx(DataTableExpandToggle, { row });
		$[3] = row;
		$[4] = t3;
	} else t3 = $[4];
	let t4;
	if ($[5] !== children || $[6] !== t2 || $[7] !== t3) {
		t4 = /* @__PURE__ */ jsxs("div", {
			className: "flex items-center gap-1",
			"data-slot": "data-table-hierarchy-cell",
			style: t2,
			children: [t3, children]
		});
		$[5] = children;
		$[6] = t2;
		$[7] = t3;
		$[8] = t4;
	} else t4 = $[8];
	return t4;
}
//#endregion
//#region src/components/ui/checkbox.tsx
function Checkbox(t0) {
	const $ = c(10);
	if ($[0] !== "f845040a9f77347733927ad6b4a50e6c4a7a31ac6323a7d3ea01534b1992fc41") {
		for (let $i = 0; $i < 10; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f845040a9f77347733927ad6b4a50e6c4a7a31ac6323a7d3ea01534b1992fc41";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("peer relative flex size-4 shrink-0 items-center justify-center rounded-[4px] border border-input transition-colors outline-none group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary data-indeterminate:border-primary data-indeterminate:bg-primary data-indeterminate:text-primary-foreground dark:data-indeterminate:bg-primary", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = /* @__PURE__ */ jsxs(Checkbox$1.Indicator, {
			"data-slot": "checkbox-indicator",
			className: "group/checkbox-indicator grid place-content-center text-current transition-none [&>svg]:size-3.5",
			children: [/* @__PURE__ */ jsx(CheckIcon, { className: "group-data-indeterminate/checkbox-indicator:hidden" }), /* @__PURE__ */ jsx(MinusIcon, { className: "hidden group-data-indeterminate/checkbox-indicator:block" })]
		});
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] !== props || $[8] !== t1) {
		t3 = /* @__PURE__ */ jsx(Checkbox$1.Root, {
			"data-slot": "checkbox",
			className: t1,
			...props,
			children: t2
		});
		$[7] = props;
		$[8] = t1;
		$[9] = t3;
	} else t3 = $[9];
	return t3;
}
//#endregion
//#region src/components/ui/label.tsx
function Label(t0) {
	const $ = c(9);
	if ($[0] !== "030a17ec4220eb0e53fcb3a022267c9d709e5ee22a3a4b51c8dfa8bc68e64739") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "030a17ec4220eb0e53fcb3a022267c9d709e5ee22a3a4b51c8dfa8bc68e64739";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("label", {
			"data-slot": "label",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/ui/field.tsx
function FieldSet(t0) {
	const $ = c(9);
	if ($[0] !== "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex flex-col gap-4 has-[>[data-slot=checkbox-group]]:gap-3 has-[>[data-slot=radio-group]]:gap-3", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("fieldset", {
			"data-slot": "field-set",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function FieldLegend(t0) {
	const $ = c(11);
	if ($[0] !== "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263") {
		for (let $i = 0; $i < 11; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263";
	}
	let className;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, variant: t1, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
	}
	const variant = t1 === void 0 ? "legend" : t1;
	let t2;
	if ($[5] !== className) {
		t2 = cn("mb-1.5 font-medium data-[variant=label]:text-sm data-[variant=legend]:text-base", className);
		$[5] = className;
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] !== props || $[8] !== t2 || $[9] !== variant) {
		t3 = /* @__PURE__ */ jsx("legend", {
			"data-slot": "field-legend",
			"data-variant": variant,
			className: t2,
			...props
		});
		$[7] = props;
		$[8] = t2;
		$[9] = variant;
		$[10] = t3;
	} else t3 = $[10];
	return t3;
}
function FieldGroup(t0) {
	const $ = c(9);
	if ($[0] !== "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("group/field-group @container/field-group flex w-full flex-col gap-5 data-[slot=checkbox-group]:gap-3 *:data-[slot=field-group]:gap-4", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "field-group",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
const fieldVariants = cva("group/field flex w-full gap-2 data-[invalid=true]:text-destructive", {
	variants: { orientation: {
		vertical: "flex-col *:w-full [&>.sr-only]:w-auto",
		horizontal: "flex-row items-center has-[>[data-slot=field-content]]:items-start *:data-[slot=field-label]:flex-auto has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px",
		responsive: "flex-col *:w-full @md/field-group:flex-row @md/field-group:items-center @md/field-group:*:w-auto @md/field-group:has-[>[data-slot=field-content]]:items-start @md/field-group:*:data-[slot=field-label]:flex-auto [&>.sr-only]:w-auto @md/field-group:has-[>[data-slot=field-content]]:[&>[role=checkbox],[role=radio]]:mt-px"
	} },
	defaultVariants: { orientation: "vertical" }
});
function Field(t0) {
	const $ = c(12);
	if ($[0] !== "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263") {
		for (let $i = 0; $i < 12; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263";
	}
	let className;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, orientation: t1, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
	}
	const orientation = t1 === void 0 ? "vertical" : t1;
	let t2;
	if ($[5] !== className || $[6] !== orientation) {
		t2 = cn(fieldVariants({ orientation }), className);
		$[5] = className;
		$[6] = orientation;
		$[7] = t2;
	} else t2 = $[7];
	let t3;
	if ($[8] !== orientation || $[9] !== props || $[10] !== t2) {
		t3 = /* @__PURE__ */ jsx("div", {
			role: "group",
			"data-slot": "field",
			"data-orientation": orientation,
			className: t2,
			...props
		});
		$[8] = orientation;
		$[9] = props;
		$[10] = t2;
		$[11] = t3;
	} else t3 = $[11];
	return t3;
}
function FieldContent(t0) {
	const $ = c(9);
	if ($[0] !== "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("group/field-content flex flex-1 flex-col gap-0.5 leading-snug", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "field-content",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function FieldLabel(t0) {
	const $ = c(9);
	if ($[0] !== "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("group/field-label peer/field-label flex w-fit gap-2 leading-snug group-data-[disabled=true]/field:opacity-50 has-data-checked:border-primary/30 has-data-checked:bg-primary/5 has-[>[data-slot=field]]:rounded-lg has-[>[data-slot=field]]:border *:data-[slot=field]:p-2.5 dark:has-data-checked:border-primary/20 dark:has-data-checked:bg-primary/10", "has-[>[data-slot=field]]:w-full has-[>[data-slot=field]]:flex-col", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Label, {
			"data-slot": "field-label",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function FieldTitle(t0) {
	const $ = c(9);
	if ($[0] !== "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex w-fit items-center gap-2 text-sm font-medium group-data-[disabled=true]/field:opacity-50", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "field-label",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function FieldDescription(t0) {
	const $ = c(9);
	if ($[0] !== "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("text-left text-sm leading-normal font-normal text-muted-foreground group-has-data-horizontal/field:text-balance [[data-variant=legend]+&]:-mt-1.5", "last:mt-0 nth-last-2:-mt-1", "[&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:text-primary", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("p", {
			"data-slot": "field-description",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function FieldSeparator(t0) {
	const $ = c(15);
	if ($[0] !== "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263") {
		for (let $i = 0; $i < 15; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263";
	}
	let children;
	let className;
	let props;
	if ($[1] !== t0) {
		({children, className, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
	}
	const t1 = !!children;
	let t2;
	if ($[5] !== className) {
		t2 = cn("relative -my-2 h-5 text-sm group-data-[variant=outline]/field-group:-mb-2", className);
		$[5] = className;
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
		t3 = /* @__PURE__ */ jsx(Separator, { className: "absolute inset-0 top-1/2" });
		$[7] = t3;
	} else t3 = $[7];
	let t4;
	if ($[8] !== children) {
		t4 = children && /* @__PURE__ */ jsx("span", {
			className: "relative mx-auto block w-fit bg-background px-2 text-muted-foreground",
			"data-slot": "field-separator-content",
			children
		});
		$[8] = children;
		$[9] = t4;
	} else t4 = $[9];
	let t5;
	if ($[10] !== props || $[11] !== t1 || $[12] !== t2 || $[13] !== t4) {
		t5 = /* @__PURE__ */ jsxs("div", {
			"data-slot": "field-separator",
			"data-content": t1,
			className: t2,
			...props,
			children: [t3, t4]
		});
		$[10] = props;
		$[11] = t1;
		$[12] = t2;
		$[13] = t4;
		$[14] = t5;
	} else t5 = $[14];
	return t5;
}
function FieldError(t0) {
	const $ = c(16);
	if ($[0] !== "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263") {
		for (let $i = 0; $i < 16; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "1a46ce9f0b412b0418ee847f04d0602b96bdb873e79220e0878892c31e42f263";
	}
	let children;
	let className;
	let errors;
	let props;
	if ($[1] !== t0) {
		({className, children, errors, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = errors;
		$[5] = props;
	} else {
		children = $[2];
		className = $[3];
		errors = $[4];
		props = $[5];
	}
	let t1;
	bb0: {
		if (children) {
			t1 = children;
			break bb0;
		}
		if (!errors?.length) {
			t1 = null;
			break bb0;
		}
		let t2;
		if ($[6] !== errors) {
			t2 = [...new Map(errors.map(_temp$15)).values()];
			$[6] = errors;
			$[7] = t2;
		} else t2 = $[7];
		const uniqueErrors = t2;
		if (uniqueErrors?.length === 1) {
			t1 = uniqueErrors[0]?.message;
			break bb0;
		}
		let t3;
		if ($[8] !== uniqueErrors) {
			t3 = /* @__PURE__ */ jsx("ul", {
				className: "ml-4 flex list-disc flex-col gap-1",
				children: uniqueErrors.map(_temp2$5)
			});
			$[8] = uniqueErrors;
			$[9] = t3;
		} else t3 = $[9];
		t1 = t3;
	}
	const content = t1;
	if (!content) return null;
	let t2;
	if ($[10] !== className) {
		t2 = cn("text-sm font-normal text-destructive", className);
		$[10] = className;
		$[11] = t2;
	} else t2 = $[11];
	let t3;
	if ($[12] !== content || $[13] !== props || $[14] !== t2) {
		t3 = /* @__PURE__ */ jsx("div", {
			role: "alert",
			"data-slot": "field-error",
			className: t2,
			...props,
			children: content
		});
		$[12] = content;
		$[13] = props;
		$[14] = t2;
		$[15] = t3;
	} else t3 = $[15];
	return t3;
}
function _temp2$5(error_0, index) {
	return error_0?.message && /* @__PURE__ */ jsx("li", { children: error_0.message }, index);
}
function _temp$15(error) {
	return [error?.message, error];
}
//#endregion
//#region src/components/ui/popover.tsx
function Popover(t0) {
	const $ = c(5);
	if ($[0] !== "6325972e2ec8c03deb4a7943edec0fdf4bf389e3c1b8a16ae504d28ae82b1915") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6325972e2ec8c03deb4a7943edec0fdf4bf389e3c1b8a16ae504d28ae82b1915";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Popover$1.Root, {
			"data-slot": "popover",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function PopoverTrigger(t0) {
	const $ = c(5);
	if ($[0] !== "6325972e2ec8c03deb4a7943edec0fdf4bf389e3c1b8a16ae504d28ae82b1915") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6325972e2ec8c03deb4a7943edec0fdf4bf389e3c1b8a16ae504d28ae82b1915";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Popover$1.Trigger, {
			"data-slot": "popover-trigger",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function PopoverContent(t0) {
	const $ = c(19);
	if ($[0] !== "6325972e2ec8c03deb4a7943edec0fdf4bf389e3c1b8a16ae504d28ae82b1915") {
		for (let $i = 0; $i < 19; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6325972e2ec8c03deb4a7943edec0fdf4bf389e3c1b8a16ae504d28ae82b1915";
	}
	let className;
	let props;
	let t1;
	let t2;
	let t3;
	let t4;
	if ($[1] !== t0) {
		({className, align: t1, alignOffset: t2, side: t3, sideOffset: t4, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
		$[5] = t2;
		$[6] = t3;
		$[7] = t4;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
		t2 = $[5];
		t3 = $[6];
		t4 = $[7];
	}
	const align = t1 === void 0 ? "center" : t1;
	const alignOffset = t2 === void 0 ? 0 : t2;
	const side = t3 === void 0 ? "bottom" : t3;
	const sideOffset = t4 === void 0 ? 4 : t4;
	let t5;
	if ($[8] !== className) {
		t5 = cn("z-50 flex w-72 origin-(--transform-origin) flex-col gap-2.5 rounded-lg bg-popover p-2.5 text-sm text-popover-foreground shadow-md ring-1 ring-foreground/10 outline-hidden duration-100 data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 motion-reduce:animate-none motion-reduce:transition-none", className);
		$[8] = className;
		$[9] = t5;
	} else t5 = $[9];
	let t6;
	if ($[10] !== props || $[11] !== t5) {
		t6 = /* @__PURE__ */ jsx(Popover$1.Popup, {
			"data-slot": "popover-content",
			className: t5,
			...props
		});
		$[10] = props;
		$[11] = t5;
		$[12] = t6;
	} else t6 = $[12];
	let t7;
	if ($[13] !== align || $[14] !== alignOffset || $[15] !== side || $[16] !== sideOffset || $[17] !== t6) {
		t7 = /* @__PURE__ */ jsx(Popover$1.Portal, { children: /* @__PURE__ */ jsx(Popover$1.Positioner, {
			align,
			alignOffset,
			side,
			sideOffset,
			className: "isolate z-50",
			children: t6
		}) });
		$[13] = align;
		$[14] = alignOffset;
		$[15] = side;
		$[16] = sideOffset;
		$[17] = t6;
		$[18] = t7;
	} else t7 = $[18];
	return t7;
}
function PopoverHeader(t0) {
	const $ = c(9);
	if ($[0] !== "6325972e2ec8c03deb4a7943edec0fdf4bf389e3c1b8a16ae504d28ae82b1915") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6325972e2ec8c03deb4a7943edec0fdf4bf389e3c1b8a16ae504d28ae82b1915";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex flex-col gap-0.5 text-sm", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "popover-header",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function PopoverTitle(t0) {
	const $ = c(9);
	if ($[0] !== "6325972e2ec8c03deb4a7943edec0fdf4bf389e3c1b8a16ae504d28ae82b1915") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6325972e2ec8c03deb4a7943edec0fdf4bf389e3c1b8a16ae504d28ae82b1915";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("font-medium", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Popover$1.Title, {
			"data-slot": "popover-title",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function PopoverDescription(t0) {
	const $ = c(9);
	if ($[0] !== "6325972e2ec8c03deb4a7943edec0fdf4bf389e3c1b8a16ae504d28ae82b1915") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6325972e2ec8c03deb4a7943edec0fdf4bf389e3c1b8a16ae504d28ae82b1915";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("text-muted-foreground", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Popover$1.Description, {
			"data-slot": "popover-description",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/data-table/data-table-filter-menu.tsx
/**
* The custom filtering menu: a popover of grouped checkbox lists (via
* `FieldSet`/`FieldLegend`, per the repo's form-grouping convention) — not a
* searchable command palette. Selected values are collected into an array
* and applied through `column.setFilterValue`, matched against row data with
* the `arrHas` filter fn registered on `useDataTable`'s feature set.
*
* Import path: `@design-system/components/data-table/data-table-filter-menu`.
*/
function DataTableFilterMenu(t0) {
	const $ = c(39);
	if ($[0] !== "aa8a6c5c1634e2d01df0490674a0afc68ff30fe08529638e9d0b2e255acafeb4") {
		for (let $i = 0; $i < 39; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "aa8a6c5c1634e2d01df0490674a0afc68ff30fe08529638e9d0b2e255acafeb4";
	}
	const { column, table, title, groups, hideEmptyOptions: t1 } = t0;
	const hideEmptyOptions = t1 === void 0 ? false : t1;
	let t2;
	if ($[1] !== column.id || $[2] !== table.state.columnFilters) {
		const filterValue = table.state.columnFilters.find((filter) => filter.id === column.id)?.value;
		t2 = new Set(Array.isArray(filterValue) ? filterValue.filter(_temp$14) : []);
		$[1] = column.id;
		$[2] = table.state.columnFilters;
		$[3] = t2;
	} else t2 = $[3];
	const selected = t2;
	let T0;
	let T1;
	let t3;
	let t4;
	let t5;
	let t6;
	let t7;
	if ($[4] !== column || $[5] !== groups || $[6] !== hideEmptyOptions || $[7] !== selected || $[8] !== title) {
		const facetedUniqueValues = column.getFacetedUniqueValues();
		T1 = Popover;
		let t8;
		let t9;
		if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
			t8 = /* @__PURE__ */ jsx(Button, {
				size: "sm",
				variant: "outline"
			});
			t9 = /* @__PURE__ */ jsx(FilterIcon, {});
			$[16] = t8;
			$[17] = t9;
		} else {
			t8 = $[16];
			t9 = $[17];
		}
		let t10;
		if ($[18] !== selected.size) {
			t10 = selected.size > 0 && /* @__PURE__ */ jsx(Badge, {
				variant: "muted",
				children: selected.size
			});
			$[18] = selected.size;
			$[19] = t10;
		} else t10 = $[19];
		if ($[20] !== t10 || $[21] !== title) {
			t7 = /* @__PURE__ */ jsxs(PopoverTrigger, {
				render: t8,
				children: [
					t9,
					title,
					t10
				]
			});
			$[20] = t10;
			$[21] = title;
			$[22] = t7;
		} else t7 = $[22];
		T0 = PopoverContent;
		t5 = "start";
		t6 = "w-64";
		t3 = "flex flex-col gap-4";
		t4 = groups.map((group) => /* @__PURE__ */ jsxs(FieldSet, { children: [
			/* @__PURE__ */ jsx(FieldLegend, {
				variant: "label",
				children: group.label
			}),
			group.description && /* @__PURE__ */ jsx(FieldDescription, { children: group.description }),
			/* @__PURE__ */ jsx(FieldGroup, {
				className: "gap-2",
				children: group.options.map((option, index) => {
					const isChecked = selected.has(option.value);
					if (hideEmptyOptions) {
						if ((option.count ?? facetedUniqueValues.get(option.value) ?? 0) === 0 && !isChecked) return null;
					}
					const id = `${column.id}-${index}`;
					return /* @__PURE__ */ jsxs(Field, {
						orientation: "horizontal",
						children: [/* @__PURE__ */ jsx(Checkbox, {
							checked: isChecked,
							id,
							onCheckedChange: (checked) => toggleArrayFilterValue(column, option.value, checked)
						}), /* @__PURE__ */ jsx(FieldLabel, {
							className: "font-normal",
							htmlFor: id,
							children: option.label
						})]
					}, option.value);
				})
			})
		] }, group.label));
		$[4] = column;
		$[5] = groups;
		$[6] = hideEmptyOptions;
		$[7] = selected;
		$[8] = title;
		$[9] = T0;
		$[10] = T1;
		$[11] = t3;
		$[12] = t4;
		$[13] = t5;
		$[14] = t6;
		$[15] = t7;
	} else {
		T0 = $[9];
		T1 = $[10];
		t3 = $[11];
		t4 = $[12];
		t5 = $[13];
		t6 = $[14];
		t7 = $[15];
	}
	let t8;
	if ($[23] !== column || $[24] !== selected.size) {
		t8 = selected.size > 0 && /* @__PURE__ */ jsx(Button, {
			className: "self-start",
			size: "sm",
			variant: "ghost",
			onClick: () => column.setFilterValue(void 0),
			children: "Clear filters"
		});
		$[23] = column;
		$[24] = selected.size;
		$[25] = t8;
	} else t8 = $[25];
	let t9;
	if ($[26] !== t3 || $[27] !== t4 || $[28] !== t8) {
		t9 = /* @__PURE__ */ jsxs("div", {
			className: t3,
			children: [t4, t8]
		});
		$[26] = t3;
		$[27] = t4;
		$[28] = t8;
		$[29] = t9;
	} else t9 = $[29];
	let t10;
	if ($[30] !== T0 || $[31] !== t5 || $[32] !== t6 || $[33] !== t9) {
		t10 = /* @__PURE__ */ jsx(T0, {
			align: t5,
			className: t6,
			children: t9
		});
		$[30] = T0;
		$[31] = t5;
		$[32] = t6;
		$[33] = t9;
		$[34] = t10;
	} else t10 = $[34];
	let t11;
	if ($[35] !== T1 || $[36] !== t10 || $[37] !== t7) {
		t11 = /* @__PURE__ */ jsxs(T1, { children: [t7, t10] });
		$[35] = T1;
		$[36] = t10;
		$[37] = t7;
		$[38] = t11;
	} else t11 = $[38];
	return t11;
}
function _temp$14(value) {
	return typeof value === "string";
}
//#endregion
//#region src/components/data-table/data-table-filter-panel.tsx
/**
* An always-present filter panel, not a popover — styled after ecommerce
* facet sidebars. Each filterable column is its own collapsible section
* (`Collapsible`, open by default) with checkbox options showing live facet
* counts from `column.getFacetedUniqueValues()`. Pair it with
* `DataTableSurface.Sidebar` for responsive open/close sizing and with
* `DataTableFilterToggle` for the control. Compose optional pre-facet content
* through `children` and actions that stay outside the scrolling region
* through `footer`.
*
* Import path: `@design-system/components/data-table/data-table-filter-panel`.
*/
function DataTableFilterPanel(t0) {
	const $ = c(35);
	if ($[0] !== "8f6e14a46e91b45d37143a38b21fec6608cadd9949adb1a4f5478fc248de08da") {
		for (let $i = 0; $i < 35; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "8f6e14a46e91b45d37143a38b21fec6608cadd9949adb1a4f5478fc248de08da";
	}
	const { open, groups, table, onClearAll, className, children, footer, hideEmptyOptions: t1 } = t0;
	const hideEmptyOptions = t1 === void 0 ? false : t1;
	let t2;
	if ($[1] !== groups) {
		t2 = new Set(groups.map(_temp$13));
		$[1] = groups;
		$[2] = t2;
	} else t2 = $[2];
	const groupColumnIds = t2;
	let t3;
	if ($[3] !== groupColumnIds || $[4] !== table.state.columnFilters) {
		let t4;
		if ($[6] !== groupColumnIds) {
			t4 = (filter) => groupColumnIds.has(filter.id);
			$[6] = groupColumnIds;
			$[7] = t4;
		} else t4 = $[7];
		t3 = table.state.columnFilters.some(t4);
		$[3] = groupColumnIds;
		$[4] = table.state.columnFilters;
		$[5] = t3;
	} else t3 = $[5];
	const hasActiveFilters = t3;
	const t4 = !open;
	let t5;
	if ($[8] !== className) {
		t5 = cn("flex h-full w-64 shrink-0 flex-col overflow-hidden rounded-lg border max-md:h-64 max-md:w-full", className);
		$[8] = className;
		$[9] = t5;
	} else t5 = $[9];
	const t6 = !open;
	let t7;
	if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
		t7 = /* @__PURE__ */ jsx("span", {
			className: "text-sm font-medium",
			children: "Filters"
		});
		$[10] = t7;
	} else t7 = $[10];
	let t8;
	if ($[11] !== hasActiveFilters || $[12] !== onClearAll) {
		t8 = hasActiveFilters && /* @__PURE__ */ jsx(Button, {
			size: "sm",
			variant: "ghost",
			onClick: onClearAll,
			children: "Clear all"
		});
		$[11] = hasActiveFilters;
		$[12] = onClearAll;
		$[13] = t8;
	} else t8 = $[13];
	let t9;
	if ($[14] !== t8) {
		t9 = /* @__PURE__ */ jsxs("div", {
			className: "flex w-full shrink-0 items-center justify-between border-b bg-gx-tile-dark px-3 py-2",
			children: [t7, t8]
		});
		$[14] = t8;
		$[15] = t9;
	} else t9 = $[15];
	let t10;
	if ($[16] !== groups || $[17] !== hideEmptyOptions || $[18] !== table.state.columnFilters) {
		let t11;
		if ($[20] !== hideEmptyOptions || $[21] !== table.state.columnFilters) {
			t11 = (group_0) => {
				const filterValue = table.state.columnFilters.find((filter_0) => filter_0.id === group_0.column.id)?.value;
				const selected = new Set(Array.isArray(filterValue) ? filterValue.filter(_temp2$4) : []);
				const counts = group_0.column.getFacetedUniqueValues();
				return /* @__PURE__ */ jsxs(Collapsible, {
					defaultOpen: true,
					className: "border-b last:border-0",
					children: [/* @__PURE__ */ jsxs(CollapsibleTrigger, {
						render: /* @__PURE__ */ jsx("button", {
							className: "group/filter-trigger flex w-full items-center justify-between bg-gx-tile-dark px-3 py-2 text-left text-sm font-medium text-muted-foreground",
							type: "button"
						}),
						children: [group_0.label, /* @__PURE__ */ jsx(ChevronDownIcon, { className: "transition-transform group-data-panel-open/filter-trigger:rotate-180" })]
					}), /* @__PURE__ */ jsx(CollapsibleContent, {
						className: "flex flex-col gap-2 px-3 py-2",
						children: group_0.options.map((option, index) => {
							const id = `${group_0.column.id}-${index}`;
							const count = option.count ?? counts.get(option.value) ?? 0;
							const isChecked = selected.has(option.value);
							const isEmpty = count === 0 && !isChecked;
							if (hideEmptyOptions && isEmpty) return null;
							return /* @__PURE__ */ jsxs(Field, {
								orientation: "horizontal",
								children: [/* @__PURE__ */ jsx(Checkbox, {
									checked: isChecked,
									disabled: isEmpty,
									id,
									onCheckedChange: (checked) => toggleArrayFilterValue(group_0.column, option.value, checked)
								}), /* @__PURE__ */ jsx(FieldLabel, {
									className: cn("font-normal", isEmpty && "opacity-50"),
									htmlFor: id,
									children: /* @__PURE__ */ jsxs("span", {
										className: "flex w-full items-center justify-between gap-2",
										children: [/* @__PURE__ */ jsx("span", { children: option.label }), /* @__PURE__ */ jsx("span", {
											className: "text-xs text-muted-foreground",
											children: count
										})]
									})
								})]
							}, option.value);
						})
					})]
				}, group_0.column.id);
			};
			$[20] = hideEmptyOptions;
			$[21] = table.state.columnFilters;
			$[22] = t11;
		} else t11 = $[22];
		t10 = groups.map(t11);
		$[16] = groups;
		$[17] = hideEmptyOptions;
		$[18] = table.state.columnFilters;
		$[19] = t10;
	} else t10 = $[19];
	let t11;
	if ($[23] !== children || $[24] !== t10) {
		t11 = /* @__PURE__ */ jsxs("div", {
			className: "flex min-h-0 w-full flex-1 shrink-0 flex-col overflow-y-auto",
			children: [children, t10]
		});
		$[23] = children;
		$[24] = t10;
		$[25] = t11;
	} else t11 = $[25];
	let t12;
	if ($[26] !== footer) {
		t12 = footer != null && /* @__PURE__ */ jsx("div", {
			className: "w-full shrink-0 border-t bg-background p-2 empty:hidden",
			children: footer
		});
		$[26] = footer;
		$[27] = t12;
	} else t12 = $[27];
	let t13;
	if ($[28] !== t11 || $[29] !== t12 || $[30] !== t4 || $[31] !== t5 || $[32] !== t6 || $[33] !== t9) {
		t13 = /* @__PURE__ */ jsxs("div", {
			"aria-hidden": t4,
			className: t5,
			inert: t6,
			children: [
				t9,
				t11,
				t12
			]
		});
		$[28] = t11;
		$[29] = t12;
		$[30] = t4;
		$[31] = t5;
		$[32] = t6;
		$[33] = t9;
		$[34] = t13;
	} else t13 = $[34];
	return t13;
}
/**
* The button that opens/closes a `DataTableFilterPanel`, with a badge
* showing how many groups currently have an active filter.
*
* Import path: `@design-system/components/data-table/data-table-filter-panel`.
*/
function _temp2$4(value) {
	return typeof value === "string";
}
function _temp$13(group) {
	return group.column.id;
}
function DataTableFilterToggle(t0) {
	const $ = c(18);
	if ($[0] !== "8f6e14a46e91b45d37143a38b21fec6608cadd9949adb1a4f5478fc248de08da") {
		for (let $i = 0; $i < 18; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "8f6e14a46e91b45d37143a38b21fec6608cadd9949adb1a4f5478fc248de08da";
	}
	const { open, onOpenChange, groups, table } = t0;
	let t1;
	if ($[1] !== table.state.columnFilters) {
		t1 = new Set(table.state.columnFilters.map(_temp3$1));
		$[1] = table.state.columnFilters;
		$[2] = t1;
	} else t1 = $[2];
	const activeColumnIds = t1;
	let t2;
	if ($[3] !== activeColumnIds || $[4] !== groups) {
		let t3;
		if ($[6] !== activeColumnIds) {
			t3 = (group) => activeColumnIds.has(group.column.id);
			$[6] = activeColumnIds;
			$[7] = t3;
		} else t3 = $[7];
		t2 = groups.filter(t3);
		$[3] = activeColumnIds;
		$[4] = groups;
		$[5] = t2;
	} else t2 = $[5];
	const activeCount = t2.length;
	let t3;
	if ($[8] !== onOpenChange || $[9] !== open) {
		t3 = () => onOpenChange(!open);
		$[8] = onOpenChange;
		$[9] = open;
		$[10] = t3;
	} else t3 = $[10];
	let t4;
	if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
		t4 = /* @__PURE__ */ jsx(FilterIcon, {});
		$[11] = t4;
	} else t4 = $[11];
	let t5;
	if ($[12] !== activeCount) {
		t5 = activeCount > 0 && /* @__PURE__ */ jsx(Badge, {
			size: "sm",
			variant: "muted",
			children: activeCount
		});
		$[12] = activeCount;
		$[13] = t5;
	} else t5 = $[13];
	let t6;
	if ($[14] !== open || $[15] !== t3 || $[16] !== t5) {
		t6 = /* @__PURE__ */ jsxs(Button, {
			"aria-pressed": open,
			size: "default",
			variant: "outline",
			onClick: t3,
			children: [
				t4,
				"Filters",
				t5
			]
		});
		$[14] = open;
		$[15] = t3;
		$[16] = t5;
		$[17] = t6;
	} else t6 = $[17];
	return t6;
}
function _temp3$1(filter) {
	return filter.id;
}
//#endregion
//#region src/components/data-table/data-table-save-filter-form.tsx
/**
* The "Save current filters" affordance paired with
* `DataTableSavedFiltersList`: collapsed to a single button until clicked,
* then a name field with Save/Cancel. Save is disabled for an empty or
* duplicate name (case-insensitive, checked against `existingNames`).
*
* Doesn't persist anything itself — call `onSave` into your own
* saved-filter mutation, extracting `criteria` from the table's current
* filter state on your side.
*
* Import path: `@design-system/components/data-table/data-table-save-filter-form`.
*/
function DataTableSaveFilterForm(t0) {
	const $ = c(30);
	if ($[0] !== "d26114eb74475ca3d11849816a5451ae6e3c3e141b1e066008b7251b2a5bbd63") {
		for (let $i = 0; $i < 30; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d26114eb74475ca3d11849816a5451ae6e3c3e141b1e066008b7251b2a5bbd63";
	}
	const { canSave, existingNames, onSave } = t0;
	const [isAdding, setIsAdding] = useState(false);
	const [name, setName] = useState("");
	if (!canSave && !isAdding) return null;
	let t1;
	if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = () => {
			setIsAdding(false);
			setName("");
		};
		$[1] = t1;
	} else t1 = $[1];
	const cancel = t1;
	let t2;
	let trimmedName;
	if ($[2] !== existingNames || $[3] !== name) {
		trimmedName = name.trim();
		t2 = existingNames.some((existingName) => existingName.toLowerCase() === trimmedName.toLowerCase());
		$[2] = existingNames;
		$[3] = name;
		$[4] = t2;
		$[5] = trimmedName;
	} else {
		t2 = $[4];
		trimmedName = $[5];
	}
	const isDuplicate = t2;
	const canSubmit = trimmedName.length > 0 && !isDuplicate;
	let t3;
	if ($[6] !== canSubmit || $[7] !== onSave || $[8] !== trimmedName) {
		t3 = () => {
			if (!canSubmit) return;
			onSave(trimmedName);
			cancel();
		};
		$[6] = canSubmit;
		$[7] = onSave;
		$[8] = trimmedName;
		$[9] = t3;
	} else t3 = $[9];
	const submit = t3;
	if (!isAdding) {
		let t4;
		if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
			t4 = /* @__PURE__ */ jsxs(Button, {
				size: "sm",
				variant: "ghost",
				onClick: () => setIsAdding(true),
				children: [/* @__PURE__ */ jsx(PlusIcon, {}), "Save current filters"]
			});
			$[10] = t4;
		} else t4 = $[10];
		return t4;
	}
	let t4;
	if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
		t4 = (event) => setName(event.target.value);
		$[11] = t4;
	} else t4 = $[11];
	let t5;
	if ($[12] !== submit) {
		t5 = (event_0) => {
			if (event_0.key === "Enter") submit();
		};
		$[12] = submit;
		$[13] = t5;
	} else t5 = $[13];
	let t6;
	if ($[14] !== isDuplicate || $[15] !== name || $[16] !== t5) {
		t6 = /* @__PURE__ */ jsx(Input, {
			"aria-invalid": isDuplicate,
			"aria-label": "Filter name",
			placeholder: "Name this filter...",
			value: name,
			onChange: t4,
			onKeyDown: t5
		});
		$[14] = isDuplicate;
		$[15] = name;
		$[16] = t5;
		$[17] = t6;
	} else t6 = $[17];
	let t7;
	if ($[18] !== isDuplicate) {
		t7 = isDuplicate && /* @__PURE__ */ jsx("span", {
			className: "text-xs text-destructive",
			children: "A saved filter with this name already exists."
		});
		$[18] = isDuplicate;
		$[19] = t7;
	} else t7 = $[19];
	const t8 = !canSubmit;
	let t9;
	if ($[20] !== submit || $[21] !== t8) {
		t9 = /* @__PURE__ */ jsx(Button, {
			disabled: t8,
			size: "sm",
			onClick: submit,
			children: "Save"
		});
		$[20] = submit;
		$[21] = t8;
		$[22] = t9;
	} else t9 = $[22];
	let t10;
	if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
		t10 = /* @__PURE__ */ jsx(Button, {
			size: "sm",
			variant: "outline",
			onClick: cancel,
			children: "Cancel"
		});
		$[23] = t10;
	} else t10 = $[23];
	let t11;
	if ($[24] !== t9) {
		t11 = /* @__PURE__ */ jsxs("div", {
			className: "flex gap-2",
			children: [t9, t10]
		});
		$[24] = t9;
		$[25] = t11;
	} else t11 = $[25];
	let t12;
	if ($[26] !== t11 || $[27] !== t6 || $[28] !== t7) {
		t12 = /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col gap-2",
			children: [
				t6,
				t7,
				t11
			]
		});
		$[26] = t11;
		$[27] = t6;
		$[28] = t7;
		$[29] = t12;
	} else t12 = $[29];
	return t12;
}
//#endregion
//#region src/components/data-table/data-table-saved-filters-list.tsx
function DataTableSavedFilterRow(t0) {
	const $ = c(34);
	if ($[0] !== "a5cc14a57a7bc5a195fe779f10a805c41d7b6b7463a085f85f96fdd5c6ffe456") {
		for (let $i = 0; $i < 34; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a5cc14a57a7bc5a195fe779f10a805c41d7b6b7463a085f85f96fdd5c6ffe456";
	}
	const { filter, formatCreatedAt, onApply, onDelete } = t0;
	const [isConfirmingDelete, setIsConfirmingDelete] = useState(false);
	if (isConfirmingDelete) {
		let t1;
		if ($[1] !== filter.name) {
			t1 = /* @__PURE__ */ jsxs("span", {
				className: "text-muted-foreground",
				children: [
					"Delete \"",
					filter.name,
					"\"?"
				]
			});
			$[1] = filter.name;
			$[2] = t1;
		} else t1 = $[2];
		let t2;
		if ($[3] !== filter.id || $[4] !== onDelete) {
			t2 = /* @__PURE__ */ jsx(Button, {
				size: "xs",
				variant: "destructive",
				onClick: () => onDelete(filter.id),
				children: "Delete"
			});
			$[3] = filter.id;
			$[4] = onDelete;
			$[5] = t2;
		} else t2 = $[5];
		let t3;
		if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
			t3 = /* @__PURE__ */ jsx(Button, {
				size: "xs",
				variant: "ghost",
				onClick: () => setIsConfirmingDelete(false),
				children: "Cancel"
			});
			$[6] = t3;
		} else t3 = $[6];
		let t4;
		if ($[7] !== t2) {
			t4 = /* @__PURE__ */ jsxs("div", {
				className: "flex shrink-0 gap-1",
				children: [t2, t3]
			});
			$[7] = t2;
			$[8] = t4;
		} else t4 = $[8];
		let t5;
		if ($[9] !== t1 || $[10] !== t4) {
			t5 = /* @__PURE__ */ jsxs("div", {
				className: "flex items-center justify-between gap-2 border-b px-3 py-1.5 text-sm last:border-0",
				children: [t1, t4]
			});
			$[9] = t1;
			$[10] = t4;
			$[11] = t5;
		} else t5 = $[11];
		return t5;
	}
	const t1 = `Apply saved filter ${filter.name}`;
	let t2;
	if ($[12] !== filter.criteria || $[13] !== onApply) {
		t2 = () => onApply(filter.criteria);
		$[12] = filter.criteria;
		$[13] = onApply;
		$[14] = t2;
	} else t2 = $[14];
	let t3;
	if ($[15] !== filter.name) {
		t3 = /* @__PURE__ */ jsx("span", {
			className: "truncate",
			children: filter.name
		});
		$[15] = filter.name;
		$[16] = t3;
	} else t3 = $[16];
	let t4;
	if ($[17] !== filter.createdAt || $[18] !== formatCreatedAt) {
		t4 = formatCreatedAt(filter.createdAt);
		$[17] = filter.createdAt;
		$[18] = formatCreatedAt;
		$[19] = t4;
	} else t4 = $[19];
	let t5;
	if ($[20] !== t4) {
		t5 = /* @__PURE__ */ jsx("span", {
			className: "shrink-0 text-xs text-muted-foreground",
			children: t4
		});
		$[20] = t4;
		$[21] = t5;
	} else t5 = $[21];
	let t6;
	if ($[22] !== t1 || $[23] !== t2 || $[24] !== t3 || $[25] !== t5) {
		t6 = /* @__PURE__ */ jsxs("button", {
			"aria-label": t1,
			className: "flex min-w-0 flex-1 items-center justify-between gap-2 text-left text-sm",
			type: "button",
			onClick: t2,
			children: [t3, t5]
		});
		$[22] = t1;
		$[23] = t2;
		$[24] = t3;
		$[25] = t5;
		$[26] = t6;
	} else t6 = $[26];
	const t7 = `Delete saved filter ${filter.name}`;
	let t8;
	let t9;
	if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
		t8 = () => setIsConfirmingDelete(true);
		t9 = /* @__PURE__ */ jsx(XIcon, {});
		$[27] = t8;
		$[28] = t9;
	} else {
		t8 = $[27];
		t9 = $[28];
	}
	let t10;
	if ($[29] !== t7) {
		t10 = /* @__PURE__ */ jsx(Button, {
			"aria-label": t7,
			className: "shrink-0 opacity-0 group-hover/saved-filter:opacity-100 focus-visible:opacity-100",
			size: "icon-xs",
			variant: "ghost",
			onClick: t8,
			children: t9
		});
		$[29] = t7;
		$[30] = t10;
	} else t10 = $[30];
	let t11;
	if ($[31] !== t10 || $[32] !== t6) {
		t11 = /* @__PURE__ */ jsxs("div", {
			className: "group/saved-filter flex items-center gap-1 border-b px-3 py-1.5 last:border-0",
			children: [t6, t10]
		});
		$[31] = t10;
		$[32] = t6;
		$[33] = t11;
	} else t11 = $[33];
	return t11;
}
const formatCreatedAtAsDate = (createdAt) => new Date(createdAt).toLocaleDateString();
/**
* A list of saved filter presets, newest first: clicking a row applies its
* `criteria`, and deleting one requires a second confirming click. Renders
* nothing when `savedFilters` is empty.
*
* The toolkit doesn't own persistence — `savedFilters` comes from your own
* query, and `onApply`/`onDelete` wire into your own mutations. Pair with
* `DataTableSaveFilterForm` to create new entries.
*
* Import path: `@design-system/components/data-table/data-table-saved-filters-list`.
*/
function DataTableSavedFiltersList(t0) {
	const $ = c(15);
	if ($[0] !== "a5cc14a57a7bc5a195fe779f10a805c41d7b6b7463a085f85f96fdd5c6ffe456") {
		for (let $i = 0; $i < 15; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "a5cc14a57a7bc5a195fe779f10a805c41d7b6b7463a085f85f96fdd5c6ffe456";
	}
	const { savedFilters, formatCreatedAt: t1, onApply, onDelete } = t0;
	const formatCreatedAt = t1 === void 0 ? formatCreatedAtAsDate : t1;
	let t2;
	if ($[1] !== savedFilters) {
		t2 = [...savedFilters].toSorted(_temp$12);
		$[1] = savedFilters;
		$[2] = t2;
	} else t2 = $[2];
	const sortedByNewest = t2;
	if (savedFilters.length === 0) return null;
	let t3;
	if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
		t3 = /* @__PURE__ */ jsx("div", {
			className: "border-b px-3 py-1.5 text-xs font-semibold text-muted-foreground",
			children: "Saved filters"
		});
		$[3] = t3;
	} else t3 = $[3];
	let t4;
	if ($[4] !== formatCreatedAt || $[5] !== onApply || $[6] !== onDelete || $[7] !== sortedByNewest) {
		let t5;
		if ($[9] !== formatCreatedAt || $[10] !== onApply || $[11] !== onDelete) {
			t5 = (filter) => /* @__PURE__ */ jsx(DataTableSavedFilterRow, {
				filter,
				formatCreatedAt,
				onApply,
				onDelete
			}, filter.id);
			$[9] = formatCreatedAt;
			$[10] = onApply;
			$[11] = onDelete;
			$[12] = t5;
		} else t5 = $[12];
		t4 = sortedByNewest.map(t5);
		$[4] = formatCreatedAt;
		$[5] = onApply;
		$[6] = onDelete;
		$[7] = sortedByNewest;
		$[8] = t4;
	} else t4 = $[8];
	let t5;
	if ($[13] !== t4) {
		t5 = /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col",
			children: [t3, t4]
		});
		$[13] = t4;
		$[14] = t5;
	} else t5 = $[14];
	return t5;
}
function _temp$12(a, b) {
	return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
}
//#endregion
//#region src/components/ui/textarea.tsx
function Textarea(t0) {
	const $ = c(9);
	if ($[0] !== "3886e66bba5b7399de82730c9909c2362c46074f008ad5e385df0a920e237ec6") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "3886e66bba5b7399de82730c9909c2362c46074f008ad5e385df0a920e237ec6";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex field-sizing-content min-h-16 w-full rounded-lg border border-input bg-transparent px-2.5 py-2 text-base transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("textarea", {
			"data-slot": "textarea",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/ui/input-group.tsx
function InputGroup(t0) {
	const $ = c(9);
	if ($[0] !== "ce12c802e7383220435311f000fa632dea6f02e824a03d45fe6a939d7409811f") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "ce12c802e7383220435311f000fa632dea6f02e824a03d45fe6a939d7409811f";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("group/input-group relative flex h-8 w-full min-w-0 items-center rounded-lg border border-input transition-colors outline-none in-data-[slot=combobox-content]:focus-within:border-inherit in-data-[slot=combobox-content]:focus-within:ring-0 has-disabled:bg-input/50 has-disabled:opacity-50 has-[[data-slot=input-group-control]:focus-visible]:border-ring has-[[data-slot=input-group-control]:focus-visible]:ring-3 has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 has-[[data-slot][aria-invalid=true]]:border-destructive has-[[data-slot][aria-invalid=true]]:ring-3 has-[[data-slot][aria-invalid=true]]:ring-destructive/20 has-[>[data-align=block-end]]:h-auto has-[>[data-align=block-end]]:flex-col has-[>[data-align=block-start]]:h-auto has-[>[data-align=block-start]]:flex-col has-[>textarea]:h-auto dark:bg-input/30 dark:has-disabled:bg-input/80 dark:has-[[data-slot][aria-invalid=true]]:ring-destructive/40 has-[>[data-align=block-end]]:[&>input]:pt-3 has-[>[data-align=block-start]]:[&>input]:pb-3 has-[>[data-align=inline-end]]:[&>input]:pr-1.5 has-[>[data-align=inline-start]]:[&>input]:pl-1.5", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "input-group",
			role: "group",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
const inputGroupAddonVariants = cva("flex h-auto cursor-text items-center justify-center gap-2 py-1.5 text-sm font-medium text-muted-foreground select-none group-data-[disabled=true]/input-group:opacity-50 [&>kbd]:rounded-[calc(var(--radius)-5px)] [&>svg:not([class*='size-'])]:size-4", {
	variants: { align: {
		"inline-start": "order-first pl-2 has-[>button]:ml-[-0.3rem] has-[>kbd]:ml-[-0.15rem]",
		"inline-end": "order-last pr-2 has-[>button]:mr-[-0.3rem] has-[>kbd]:mr-[-0.15rem]",
		"block-start": "order-first w-full justify-start px-2.5 pt-2 group-has-[>input]/input-group:pt-2 [.border-b]:pb-2",
		"block-end": "order-last w-full justify-start px-2.5 pb-2 group-has-[>input]/input-group:pb-2 [.border-t]:pt-2"
	} },
	defaultVariants: { align: "inline-start" }
});
function InputGroupAddon(t0) {
	const $ = c(12);
	if ($[0] !== "ce12c802e7383220435311f000fa632dea6f02e824a03d45fe6a939d7409811f") {
		for (let $i = 0; $i < 12; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "ce12c802e7383220435311f000fa632dea6f02e824a03d45fe6a939d7409811f";
	}
	let className;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, align: t1, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
	}
	const align = t1 === void 0 ? "inline-start" : t1;
	let t2;
	if ($[5] !== align || $[6] !== className) {
		t2 = cn(inputGroupAddonVariants({ align }), className);
		$[5] = align;
		$[6] = className;
		$[7] = t2;
	} else t2 = $[7];
	let t3;
	if ($[8] !== align || $[9] !== props || $[10] !== t2) {
		t3 = /* @__PURE__ */ jsx("div", {
			role: "group",
			"data-slot": "input-group-addon",
			"data-align": align,
			className: t2,
			onClick: _temp$11,
			...props
		});
		$[8] = align;
		$[9] = props;
		$[10] = t2;
		$[11] = t3;
	} else t3 = $[11];
	return t3;
}
function _temp$11(e) {
	if (e.target.closest("button")) return;
	e.currentTarget.parentElement?.querySelector("input")?.focus();
}
const inputGroupButtonVariants = cva("flex items-center gap-2 text-sm shadow-none", {
	variants: { size: {
		xs: "h-6 gap-1 rounded-[calc(var(--radius)-3px)] px-1.5 [&>svg:not([class*='size-'])]:size-3.5",
		sm: "",
		"icon-xs": "size-6 rounded-[calc(var(--radius)-3px)] p-0 has-[>svg]:p-0",
		"icon-sm": "size-8 p-0 has-[>svg]:p-0"
	} },
	defaultVariants: { size: "xs" }
});
function InputGroupButton(t0) {
	const $ = c(16);
	if ($[0] !== "ce12c802e7383220435311f000fa632dea6f02e824a03d45fe6a939d7409811f") {
		for (let $i = 0; $i < 16; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "ce12c802e7383220435311f000fa632dea6f02e824a03d45fe6a939d7409811f";
	}
	let className;
	let props;
	let t1;
	let t2;
	let t3;
	if ($[1] !== t0) {
		({className, type: t1, variant: t2, size: t3, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
		$[5] = t2;
		$[6] = t3;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
		t2 = $[5];
		t3 = $[6];
	}
	const type = t1 === void 0 ? "button" : t1;
	const variant = t2 === void 0 ? "ghost" : t2;
	const size = t3 === void 0 ? "xs" : t3;
	let t4;
	if ($[7] !== className || $[8] !== size) {
		t4 = cn(inputGroupButtonVariants({ size }), className);
		$[7] = className;
		$[8] = size;
		$[9] = t4;
	} else t4 = $[9];
	let t5;
	if ($[10] !== props || $[11] !== size || $[12] !== t4 || $[13] !== type || $[14] !== variant) {
		t5 = /* @__PURE__ */ jsx(Button, {
			type,
			"data-size": size,
			variant,
			className: t4,
			...props
		});
		$[10] = props;
		$[11] = size;
		$[12] = t4;
		$[13] = type;
		$[14] = variant;
		$[15] = t5;
	} else t5 = $[15];
	return t5;
}
function InputGroupText(t0) {
	const $ = c(9);
	if ($[0] !== "ce12c802e7383220435311f000fa632dea6f02e824a03d45fe6a939d7409811f") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "ce12c802e7383220435311f000fa632dea6f02e824a03d45fe6a939d7409811f";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex items-center gap-2 text-sm text-muted-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("span", {
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function InputGroupInput(t0) {
	const $ = c(9);
	if ($[0] !== "ce12c802e7383220435311f000fa632dea6f02e824a03d45fe6a939d7409811f") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "ce12c802e7383220435311f000fa632dea6f02e824a03d45fe6a939d7409811f";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex-1 rounded-none border-0 bg-transparent shadow-none ring-0 focus-visible:ring-0 disabled:bg-transparent aria-invalid:ring-0 dark:bg-transparent dark:disabled:bg-transparent", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Input, {
			"data-slot": "input-group-control",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function InputGroupTextarea(t0) {
	const $ = c(9);
	if ($[0] !== "ce12c802e7383220435311f000fa632dea6f02e824a03d45fe6a939d7409811f") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "ce12c802e7383220435311f000fa632dea6f02e824a03d45fe6a939d7409811f";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex-1 resize-none rounded-none border-0 bg-transparent py-2 shadow-none ring-0 focus-visible:ring-0 disabled:bg-transparent aria-invalid:ring-0 dark:bg-transparent dark:disabled:bg-transparent", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Textarea, {
			"data-slot": "input-group-control",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/data-table/data-table-search-input.tsx
const DEFAULT_COMMIT_EVENTS = ["blur", "enter"];
/**
* A free-text table search with immediate input feedback and debounced owner
* updates. Column mode writes to a TanStack column (and optionally runs fuzzy
* matching); controlled mode delegates the string to an external owner such
* as URL or feature state. Empty values always clear synchronously.
*
* Pass `fuzzy` to match approximately (typo-tolerant) across the whole
* dataset instead of an exact substring on one column — see the `fuzzy`
* prop doc for the matching column-def requirement.
*
* Import path: `@design-system/components/data-table/data-table-search-input`.
*/
function DataTableSearchInput({ mode = "column", column, table, value: controlledValue, onValueChange, wait = 300, fuzzy, onCommit, commitOn = DEFAULT_COMMIT_EVENTS, onBlur, onClick, onKeyDown, ...props }) {
	const columnFilterValue = mode === "column" && column ? table.state.columnFilters.find((filter) => filter.id === column.id)?.value : void 0;
	let synchronizedValue;
	if (mode === "controlled") synchronizedValue = controlledValue ?? "";
	else if (typeof columnFilterValue === "string" || columnFilterValue === void 0) synchronizedValue = columnFilterValue ?? "";
	else synchronizedValue = null;
	const [inputValue, setInputValue] = useState(() => synchronizedValue ?? "");
	const flatRows = mode === "column" && column ? table.getCoreRowModel().flatRows : void 0;
	const fuzzyKeys = fuzzy?.keys.join("\0");
	const fuse = useMemo(() => fuzzy && flatRows ? new Fuse(flatRows.map((row) => row.original), {
		keys: fuzzy.keys,
		threshold: fuzzy.threshold
	}) : null, [
		flatRows,
		fuzzyKeys,
		fuzzy?.threshold
	]);
	useEffect(() => {
		if (synchronizedValue !== null) setInputValue(synchronizedValue);
	}, [synchronizedValue]);
	const applySearch = useDebouncedCallback((next) => {
		if (!next) return;
		if (mode === "controlled") {
			onValueChange?.(next);
			return;
		}
		if (fuse && flatRows) {
			const matchedIds = new Set(fuse.search(next).map((result) => flatRows[result.refIndex].id));
			column?.setFilterValue(matchedIds);
			return;
		}
		column?.setFilterValue(next);
	}, { wait });
	const commitForAnalytics = useDebouncedCallback((next_0) => onCommit?.(next_0), { wait: 2e3 });
	return /* @__PURE__ */ jsxs(InputGroup, {
		className: "w-full sm:w-72",
		children: [/* @__PURE__ */ jsx(InputGroupAddon, { children: /* @__PURE__ */ jsx(SearchIcon, {}) }), /* @__PURE__ */ jsx(InputGroupInput, {
			value: inputValue,
			onBlur: (event) => {
				if (onCommit && commitOn.includes("blur")) commitForAnalytics(event.currentTarget.value);
				onBlur?.(event);
			},
			onClick: (event_0) => {
				if (onCommit && commitOn.includes("click")) commitForAnalytics(event_0.currentTarget.value);
				onClick?.(event_0);
			},
			onChange: (event_1) => {
				const next_1 = event_1.currentTarget.value;
				setInputValue(next_1);
				applySearch(next_1);
				if (!next_1) if (mode === "controlled") onValueChange?.("");
				else column?.setFilterValue(void 0);
			},
			onKeyDown: (event_2) => {
				const shouldCommit = commitOn.includes("keydown") || event_2.key === "Enter" && commitOn.includes("enter");
				if (onCommit && shouldCommit) commitForAnalytics(event_2.currentTarget.value);
				onKeyDown?.(event_2);
			},
			...props
		})]
	});
}
//#endregion
//#region src/components/data-table/data-table-show-selected-toggle.tsx
/**
* The paired toggle for `useFrozenSelectionSnapshot`. Pressing it freezes
* the currently selected rows so scrolling, re-selecting, or clearing the
* live selection doesn't shift what's shown until it's pressed again.
*
* Import path: `@design-system/components/data-table/data-table-show-selected-toggle`.
*/
function DataTableShowSelectedToggle(t0) {
	const $ = c(11);
	if ($[0] !== "59aaaf7805d5b87e64dfd892a0712fd48fe3750c5ff2d19d1a19b2bbd49b62a6") {
		for (let $i = 0; $i < 11; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "59aaaf7805d5b87e64dfd892a0712fd48fe3750c5ff2d19d1a19b2bbd49b62a6";
	}
	const { pressed, onPressedChange, hasSelection } = t0;
	const t1 = pressed && "text-primary";
	let t2;
	if ($[1] !== t1) {
		t2 = cn(t1);
		$[1] = t1;
		$[2] = t2;
	} else t2 = $[2];
	const t3 = !hasSelection && !pressed;
	let t4;
	if ($[3] !== onPressedChange || $[4] !== pressed) {
		t4 = () => onPressedChange(!pressed);
		$[3] = onPressedChange;
		$[4] = pressed;
		$[5] = t4;
	} else t4 = $[5];
	let t5;
	if ($[6] !== pressed || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
		t5 = /* @__PURE__ */ jsx(Button, {
			"aria-pressed": pressed,
			className: t2,
			disabled: t3,
			size: "sm",
			variant: "outline",
			onClick: t4,
			children: "Show selected only"
		});
		$[6] = pressed;
		$[7] = t2;
		$[8] = t3;
		$[9] = t4;
		$[10] = t5;
	} else t5 = $[10];
	return t5;
}
//#endregion
//#region src/components/data-table/data-table-surface.tsx
function Root$1(t0) {
	const $ = c(9);
	if ($[0] !== "6b2c1f8fdf00d98e6f7b574ea52758134b974931e76f7b3ef53807c43d148a1d") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6b2c1f8fdf00d98e6f7b574ea52758134b974931e76f7b3ef53807c43d148a1d";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex min-h-0 flex-1 flex-col gap-0", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("section", {
			"data-slot": "data-table-surface",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function Controls(t0) {
	const $ = c(9);
	if ($[0] !== "6b2c1f8fdf00d98e6f7b574ea52758134b974931e76f7b3ef53807c43d148a1d") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6b2c1f8fdf00d98e6f7b574ea52758134b974931e76f7b3ef53807c43d148a1d";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex shrink-0 flex-col gap-3", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "data-table-surface-controls",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function Body(t0) {
	const $ = c(9);
	if ($[0] !== "6b2c1f8fdf00d98e6f7b574ea52758134b974931e76f7b3ef53807c43d148a1d") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6b2c1f8fdf00d98e6f7b574ea52758134b974931e76f7b3ef53807c43d148a1d";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex min-h-0 flex-1 gap-0 has-[>[data-open]]:gap-2 max-md:flex-col", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "data-table-surface-body",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function Sidebar(t0) {
	const $ = c(14);
	if ($[0] !== "6b2c1f8fdf00d98e6f7b574ea52758134b974931e76f7b3ef53807c43d148a1d") {
		for (let $i = 0; $i < 14; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6b2c1f8fdf00d98e6f7b574ea52758134b974931e76f7b3ef53807c43d148a1d";
	}
	let className;
	let open;
	let props;
	if ($[1] !== t0) {
		({open, className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = open;
		$[4] = props;
	} else {
		className = $[2];
		open = $[3];
		props = $[4];
	}
	const t1 = !open;
	const t2 = open ? "" : void 0;
	const t3 = !open;
	const t4 = open ? "w-64 max-md:h-64 max-md:w-full" : "w-0 max-md:h-0 max-md:w-full";
	let t5;
	if ($[5] !== className || $[6] !== t4) {
		t5 = cn("min-h-0 shrink-0 overflow-hidden transition-[width] duration-300 max-md:transition-[height]", t4, className);
		$[5] = className;
		$[6] = t4;
		$[7] = t5;
	} else t5 = $[7];
	let t6;
	if ($[8] !== props || $[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t5) {
		t6 = /* @__PURE__ */ jsx("aside", {
			"aria-hidden": t1,
			"data-open": t2,
			"data-slot": "data-table-surface-sidebar",
			inert: t3,
			className: t5,
			...props
		});
		$[8] = props;
		$[9] = t1;
		$[10] = t2;
		$[11] = t3;
		$[12] = t5;
		$[13] = t6;
	} else t6 = $[13];
	return t6;
}
/**
* Structural layout for DataTable controls, an optional filter sidebar, and
* scrollable table content. It owns responsive sizing and overflow only; table
* state and feature controls remain explicitly composed by the consumer.
*/
const DataTableSurface = {
	Root: Root$1,
	Controls,
	Body,
	Sidebar,
	Content: forwardRef(function Content(t0, ref) {
		const $ = c(10);
		if ($[0] !== "6b2c1f8fdf00d98e6f7b574ea52758134b974931e76f7b3ef53807c43d148a1d") {
			for (let $i = 0; $i < 10; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
			$[0] = "6b2c1f8fdf00d98e6f7b574ea52758134b974931e76f7b3ef53807c43d148a1d";
		}
		let className;
		let props;
		if ($[1] !== t0) {
			({className, ...props} = t0);
			$[1] = t0;
			$[2] = className;
			$[3] = props;
		} else {
			className = $[2];
			props = $[3];
		}
		let t1;
		if ($[4] !== className) {
			t1 = cn("relative flex min-h-0 min-w-0 flex-1 overflow-hidden", className);
			$[4] = className;
			$[5] = t1;
		} else t1 = $[5];
		let t2;
		if ($[6] !== props || $[7] !== ref || $[8] !== t1) {
			t2 = /* @__PURE__ */ jsx("div", {
				ref,
				"data-slot": "data-table-surface-content",
				className: t1,
				...props
			});
			$[6] = props;
			$[7] = ref;
			$[8] = t1;
			$[9] = t2;
		} else t2 = $[9];
		return t2;
	})
};
//#endregion
//#region src/components/data-table/data-table-view-options-panel.tsx
/**
* A column's display label: its string `header` when set, falling back to
* the column id for function/element headers.
*
* Import path: `@design-system/components/data-table/data-table-view-options-panel`.
*/
function columnLabel(column) {
	return typeof column.columnDef.header === "string" ? column.columnDef.header : column.id;
}
function ViewOptionsTile(t0) {
	const $ = c(9);
	if ($[0] !== "d1a8658edd708f0bc9f0c69f4b1e3e360adde6bf29eedaf7b6277fcd56548c95") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d1a8658edd708f0bc9f0c69f4b1e3e360adde6bf29eedaf7b6277fcd56548c95";
	}
	const { checked, column } = t0;
	const t1 = checked ? "" : void 0;
	let t2;
	let t3;
	if ($[1] !== column) {
		t2 = () => column.toggleVisibility();
		t3 = columnLabel(column);
		$[1] = column;
		$[2] = t2;
		$[3] = t3;
	} else {
		t2 = $[2];
		t3 = $[3];
	}
	let t4;
	if ($[4] !== checked || $[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
		t4 = /* @__PURE__ */ jsx("button", {
			"aria-pressed": checked,
			className: "h-6 rounded-md border border-input px-2 text-xs font-medium whitespace-nowrap text-muted-foreground transition-colors data-checked:border-primary data-checked:bg-primary/10 data-checked:text-foreground",
			"data-checked": t1,
			type: "button",
			onClick: t2,
			children: t3
		});
		$[4] = checked;
		$[5] = t1;
		$[6] = t2;
		$[7] = t3;
		$[8] = t4;
	} else t4 = $[8];
	return t4;
}
/**
* An always-visible alternative to `DataTableViewOptions`: one section per
* `groups` entry, each a "Select all"/"Clear all" action above a responsive
* grid of clickable column-visibility tiles (`data-checked` styled, not
* literal checkboxes) reflecting the selected column-visibility state. Columns not found
* on the table (a typo'd id, or hidden behind another feature flag) are
* skipped.
*
* Import path: `@design-system/components/data-table/data-table-view-options-panel`.
*/
function DataTableViewOptionsPanel(t0) {
	const $ = c(11);
	if ($[0] !== "d1a8658edd708f0bc9f0c69f4b1e3e360adde6bf29eedaf7b6277fcd56548c95") {
		for (let $i = 0; $i < 11; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d1a8658edd708f0bc9f0c69f4b1e3e360adde6bf29eedaf7b6277fcd56548c95";
	}
	const { table, groups, children } = t0;
	const columnVisibility = table.state.columnVisibility;
	let t1;
	if ($[1] !== columnVisibility || $[2] !== groups || $[3] !== table) {
		let t2;
		if ($[5] !== columnVisibility || $[6] !== table) {
			t2 = (group) => {
				const columns = group.columnIds.map((id) => table.getColumn(id)).filter(_temp$10);
				const allVisible = columns.length > 0 && columns.every((column_0) => columnVisibility[column_0.id] ?? true);
				return /* @__PURE__ */ jsxs("div", {
					"aria-label": group.label,
					className: "flex min-w-40 flex-col gap-1.5",
					role: "group",
					children: [/* @__PURE__ */ jsxs("div", {
						className: "flex items-center justify-between gap-2",
						children: [/* @__PURE__ */ jsx("span", {
							className: "text-xs font-semibold tracking-wide text-muted-foreground uppercase",
							children: group.label
						}), /* @__PURE__ */ jsx(Button, {
							size: "xs",
							variant: "link",
							onClick: () => {
								for (const column_1 of columns) column_1.toggleVisibility(!allVisible);
							},
							children: allVisible ? "Clear all" : "Select all"
						})]
					}), /* @__PURE__ */ jsx("div", {
						className: "grid gap-1.5",
						style: { gridTemplateColumns: "repeat(auto-fill, minmax(7.5rem, 1fr))" },
						children: columns.map((column_2) => /* @__PURE__ */ jsx(ViewOptionsTile, {
							checked: columnVisibility[column_2.id] ?? true,
							column: column_2
						}, column_2.id))
					})]
				}, group.label);
			};
			$[5] = columnVisibility;
			$[6] = table;
			$[7] = t2;
		} else t2 = $[7];
		t1 = groups.map(t2);
		$[1] = columnVisibility;
		$[2] = groups;
		$[3] = table;
		$[4] = t1;
	} else t1 = $[4];
	let t2;
	if ($[8] !== children || $[9] !== t1) {
		t2 = /* @__PURE__ */ jsxs("div", {
			className: "flex flex-wrap gap-4 rounded-lg border bg-gx-tile-dark p-3",
			children: [t1, children]
		});
		$[8] = children;
		$[9] = t1;
		$[10] = t2;
	} else t2 = $[10];
	return t2;
}
function _temp$10(column) {
	return Boolean(column);
}
//#endregion
//#region src/components/data-table/data-table-view-options.tsx
/**
* Counts leaf columns that can hide (`getCanHide()`) and are currently not
* visible. Feeds the active-count badge on `DataTableViewOptions`' trigger;
* export it for any custom trigger paired with `DataTableViewOptionsPanel`.
*
* Import path: `@design-system/components/data-table/data-table-view-options`.
*/
function getHiddenColumnCount(table) {
	return table.getAllLeafColumns().filter((column) => column.getCanHide() && !column.getIsVisible()).length;
}
/**
* Column show/hide control: a dropdown with one checkbox item per column
* that has `enableHiding` (the default), reflecting and toggling
* `column.getIsVisible()`. Renders nothing when no column can hide. Shows a
* badge with the hidden-column count once any column is turned off.
*
* Import path: `@design-system/components/data-table/data-table-view-options`.
*/
function DataTableViewOptions(t0) {
	const $ = c(32);
	if ($[0] !== "1f2da9026c1bdf8f209b03a3c5744d96c75e9bb8ae5158f97c0b33259dfe6b91") {
		for (let $i = 0; $i < 32; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "1f2da9026c1bdf8f209b03a3c5744d96c75e9bb8ae5158f97c0b33259dfe6b91";
	}
	const { table } = t0;
	let T0;
	let T1;
	let T2;
	let t1;
	let t2;
	let t3;
	let t4;
	let t5;
	let t6;
	if ($[1] !== table) {
		t6 = Symbol.for("react.early_return_sentinel");
		bb0: {
			const hideableColumns = table.getAllLeafColumns().filter(_temp$9);
			if (!hideableColumns.length) {
				t6 = null;
				break bb0;
			}
			const hiddenCount = getHiddenColumnCount(table);
			T2 = DropdownMenu;
			let t7;
			let t8;
			if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
				t7 = /* @__PURE__ */ jsx(Button, {
					size: "sm",
					variant: "outline"
				});
				t8 = /* @__PURE__ */ jsx(SlidersHorizontalIcon, {});
				$[11] = t7;
				$[12] = t8;
			} else {
				t7 = $[11];
				t8 = $[12];
			}
			let t9;
			if ($[13] !== hiddenCount) {
				t9 = hiddenCount > 0 && /* @__PURE__ */ jsx(Badge, {
					variant: "muted",
					children: hiddenCount
				});
				$[13] = hiddenCount;
				$[14] = t9;
			} else t9 = $[14];
			if ($[15] !== t9) {
				t5 = /* @__PURE__ */ jsxs(DropdownMenuTrigger, {
					render: t7,
					children: [
						t8,
						"View",
						t9
					]
				});
				$[15] = t9;
				$[16] = t5;
			} else t5 = $[16];
			T1 = DropdownMenuContent;
			t4 = "end";
			T0 = DropdownMenuGroup;
			if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
				t1 = /* @__PURE__ */ jsx(DropdownMenuLabel, { children: "Toggle columns" });
				t2 = /* @__PURE__ */ jsx(DropdownMenuSeparator, {});
				$[17] = t1;
				$[18] = t2;
			} else {
				t1 = $[17];
				t2 = $[18];
			}
			t3 = hideableColumns.map(_temp2$3);
		}
		$[1] = table;
		$[2] = T0;
		$[3] = T1;
		$[4] = T2;
		$[5] = t1;
		$[6] = t2;
		$[7] = t3;
		$[8] = t4;
		$[9] = t5;
		$[10] = t6;
	} else {
		T0 = $[2];
		T1 = $[3];
		T2 = $[4];
		t1 = $[5];
		t2 = $[6];
		t3 = $[7];
		t4 = $[8];
		t5 = $[9];
		t6 = $[10];
	}
	if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
	let t7;
	if ($[19] !== T0 || $[20] !== t1 || $[21] !== t2 || $[22] !== t3) {
		t7 = /* @__PURE__ */ jsxs(T0, { children: [
			t1,
			t2,
			t3
		] });
		$[19] = T0;
		$[20] = t1;
		$[21] = t2;
		$[22] = t3;
		$[23] = t7;
	} else t7 = $[23];
	let t8;
	if ($[24] !== T1 || $[25] !== t4 || $[26] !== t7) {
		t8 = /* @__PURE__ */ jsx(T1, {
			align: t4,
			children: t7
		});
		$[24] = T1;
		$[25] = t4;
		$[26] = t7;
		$[27] = t8;
	} else t8 = $[27];
	let t9;
	if ($[28] !== T2 || $[29] !== t5 || $[30] !== t8) {
		t9 = /* @__PURE__ */ jsxs(T2, { children: [t5, t8] });
		$[28] = T2;
		$[29] = t5;
		$[30] = t8;
		$[31] = t9;
	} else t9 = $[31];
	return t9;
}
function _temp2$3(column_0) {
	return /* @__PURE__ */ jsx(DropdownMenuCheckboxItem, {
		checked: column_0.getIsVisible(),
		onCheckedChange: (checked) => column_0.toggleVisibility(checked),
		children: columnLabel(column_0)
	}, column_0.id);
}
function _temp$9(column) {
	return column.getCanHide();
}
//#endregion
//#region src/components/data-table/data-table-toolbar.tsx
const DataTableToolbarContext = createContext(null);
function useToolbarTable() {
	const $ = c(1);
	if ($[0] !== "213174a619f1433180d07eb5293f20ff4bcd1ebc62d9b7380e7f15fe7f16b2e6") {
		for (let $i = 0; $i < 1; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "213174a619f1433180d07eb5293f20ff4bcd1ebc62d9b7380e7f15fe7f16b2e6";
	}
	const table = useContext(DataTableToolbarContext);
	if (!table) throw new Error("DataTableToolbar controls must be rendered inside DataTableToolbar.Root");
	return table;
}
function Root(t0) {
	const $ = c(13);
	if ($[0] !== "213174a619f1433180d07eb5293f20ff4bcd1ebc62d9b7380e7f15fe7f16b2e6") {
		for (let $i = 0; $i < 13; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "213174a619f1433180d07eb5293f20ff4bcd1ebc62d9b7380e7f15fe7f16b2e6";
	}
	let className;
	let props;
	let table;
	if ($[1] !== t0) {
		({table, className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = table;
	} else {
		className = $[2];
		props = $[3];
		table = $[4];
	}
	const t1 = table;
	let t2;
	if ($[5] !== className) {
		t2 = cn("flex min-h-12 flex-wrap items-center justify-between gap-2 px-2 py-2", className);
		$[5] = className;
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] !== props || $[8] !== t2) {
		t3 = /* @__PURE__ */ jsx("div", {
			"data-slot": "data-table-toolbar",
			className: t2,
			...props
		});
		$[7] = props;
		$[8] = t2;
		$[9] = t3;
	} else t3 = $[9];
	let t4;
	if ($[10] !== t1 || $[11] !== t3) {
		t4 = /* @__PURE__ */ jsx(DataTableToolbarContext.Provider, {
			value: t1,
			children: t3
		});
		$[10] = t1;
		$[11] = t3;
		$[12] = t4;
	} else t4 = $[12];
	return t4;
}
function Start(t0) {
	const $ = c(9);
	if ($[0] !== "213174a619f1433180d07eb5293f20ff4bcd1ebc62d9b7380e7f15fe7f16b2e6") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "213174a619f1433180d07eb5293f20ff4bcd1ebc62d9b7380e7f15fe7f16b2e6";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex flex-1 flex-wrap items-center gap-2", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "data-table-toolbar-start",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function End(t0) {
	const $ = c(9);
	if ($[0] !== "213174a619f1433180d07eb5293f20ff4bcd1ebc62d9b7380e7f15fe7f16b2e6") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "213174a619f1433180d07eb5293f20ff4bcd1ebc62d9b7380e7f15fe7f16b2e6";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex min-w-0 flex-wrap items-center justify-end gap-2", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "data-table-toolbar-end",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function ResetFilters() {
	const $ = c(6);
	if ($[0] !== "213174a619f1433180d07eb5293f20ff4bcd1ebc62d9b7380e7f15fe7f16b2e6") {
		for (let $i = 0; $i < 6; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "213174a619f1433180d07eb5293f20ff4bcd1ebc62d9b7380e7f15fe7f16b2e6";
	}
	const table = useToolbarTable();
	if (table.state.columnFilters.length === 0) return null;
	let t0;
	if ($[1] !== table) {
		t0 = () => table.resetColumnFilters();
		$[1] = table;
		$[2] = t0;
	} else t0 = $[2];
	let t1;
	if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = /* @__PURE__ */ jsx(XIcon, {});
		$[3] = t1;
	} else t1 = $[3];
	let t2;
	if ($[4] !== t0) {
		t2 = /* @__PURE__ */ jsxs(Button, {
			size: "sm",
			variant: "ghost",
			onClick: t0,
			children: ["Reset filters", t1]
		});
		$[4] = t0;
		$[5] = t2;
	} else t2 = $[5];
	return t2;
}
function ViewOptions() {
	const $ = c(3);
	if ($[0] !== "213174a619f1433180d07eb5293f20ff4bcd1ebc62d9b7380e7f15fe7f16b2e6") {
		for (let $i = 0; $i < 3; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "213174a619f1433180d07eb5293f20ff4bcd1ebc62d9b7380e7f15fe7f16b2e6";
	}
	const t0 = useToolbarTable();
	let t1;
	if ($[1] !== t0) {
		t1 = /* @__PURE__ */ jsx(DataTableViewOptions, { table: t0 });
		$[1] = t0;
		$[2] = t1;
	} else t1 = $[2];
	return t1;
}
/**
* Table-scoped compound toolbar. Consumers explicitly compose start/end
* content and opt into reset or view controls, so feature toolbars never gain
* hidden controls.
*
* Import path: `@design-system/components/data-table/data-table-toolbar`.
*/
const DataTableToolbar = {
	Root,
	Start,
	End,
	ResetFilters,
	ViewOptions
};
//#endregion
//#region src/lib/motion.ts
function getPreferredScrollBehavior() {
	if (typeof window === "undefined") return "auto";
	return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
}
//#endregion
//#region src/components/data-table/fit-column-sizes.ts
function fitColumnSizes(baseSizes, availableWidth) {
	const totalSize = baseSizes.reduce((total, size) => total + size, 0);
	if (!availableWidth || availableWidth <= 0 || totalSize <= 0) return [...baseSizes];
	const scale = availableWidth / totalSize;
	let allocatedWidth = 0;
	return baseSizes.map((size, index) => {
		if (index === baseSizes.length - 1) return availableWidth - allocatedWidth;
		const fittedSize = size * scale;
		allocatedWidth += fittedSize;
		return fittedSize;
	});
}
//#endregion
//#region src/components/data-table/data-table-virtualized-body.tsx
const ROW_TONE_CLASSES = {
	default: void 0,
	"selected-primary": "bg-primary/10",
	"selected-secondary": "bg-accent/20",
	restricted: "bg-muted/40 text-muted-foreground",
	expanded: "bg-gx-tile-dark"
};
const ALIGNMENT_CLASSES = {
	start: "justify-start text-left",
	center: "justify-center text-center",
	end: "justify-end text-right"
};
const ROW_ACTION_SELECTOR = "button, a, input, select, textarea, [role=\"checkbox\"], [data-row-action]";
const HORIZONTAL_SCROLL_TOLERANCE = 1;
function isNestedRowAction(target) {
	return target instanceof Element && target.closest(ROW_ACTION_SELECTOR) !== null;
}
function getRowZebraClass(tone, index) {
	if (tone !== "default") return void 0;
	return index % 2 === 0 ? "bg-gx-tile-light" : "bg-gx-tile-dark";
}
function getRowDataState(row, tone) {
	return row.getIsSelected() || tone.startsWith("selected-") ? "selected" : void 0;
}
function DataTableColumnSpacer(t0) {
	const $ = c(7);
	if ($[0] !== "5cd96d9019b54225d71e637f0daffe61d0894ee6cd43907d770123fae99b862e") {
		for (let $i = 0; $i < 7; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "5cd96d9019b54225d71e637f0daffe61d0894ee6cd43907d770123fae99b862e";
	}
	const { side, size } = t0;
	const t1 = `data-table-column-spacer-${side}`;
	let t2;
	if ($[1] !== size) {
		t2 = { width: size };
		$[1] = size;
		$[2] = t2;
	} else t2 = $[2];
	let t3;
	if ($[3] !== size || $[4] !== t1 || $[5] !== t2) {
		t3 = /* @__PURE__ */ jsx("div", {
			"aria-hidden": "true",
			className: "shrink-0",
			"data-size": size,
			"data-slot": t1,
			style: t2
		});
		$[3] = size;
		$[4] = t1;
		$[5] = t2;
		$[6] = t3;
	} else t3 = $[6];
	return t3;
}
function getHeaderLeafIndexes(header, columnIndexById) {
	if (header.subHeaders.length === 0) {
		const index = columnIndexById.get(header.column.id);
		return index === void 0 ? [] : [index];
	}
	return header.subHeaders.flatMap((subHeader) => getHeaderLeafIndexes(subHeader, columnIndexById));
}
function getHeaderLayouts(headers, columnIndexById, columnOffsets) {
	return headers.flatMap((header) => {
		const leafIndexes = getHeaderLeafIndexes(header, columnIndexById);
		if (leafIndexes.length === 0) return [];
		const startIndex = Math.min(...leafIndexes);
		const endIndex = Math.max(...leafIndexes);
		return [{
			header,
			startIndex,
			endIndex,
			start: columnOffsets[startIndex] ?? 0,
			end: columnOffsets[endIndex + 1] ?? 0
		}];
	});
}
function getRenderedHeaderLayouts({ headerLayouts, virtualizeColumns, firstVirtualColumnIndex, lastVirtualColumnIndex }) {
	if (!virtualizeColumns) return headerLayouts;
	return headerLayouts.filter((layout) => layout.endIndex >= firstVirtualColumnIndex && layout.startIndex <= lastVirtualColumnIndex);
}
function renderDataTableHeaderCells({ layouts, renderHeader, table }) {
	return layouts.map(({ end, endIndex, header, start, startIndex }) => {
		const size = end - start;
		const align = header.column.columnDef.meta?.align ?? "start";
		let headerContent = null;
		if (!header.isPlaceholder) headerContent = renderHeader ? renderHeader(header) : /* @__PURE__ */ jsx(table.FlexRender, { header });
		return /* @__PURE__ */ jsx("div", {
			"aria-colindex": startIndex + 1,
			"aria-colspan": endIndex - startIndex + 1,
			className: cn("flex h-10 min-w-0 shrink-0 items-center overflow-hidden px-2 text-sm font-medium whitespace-nowrap text-foreground", ALIGNMENT_CLASSES[align]),
			"data-align": align,
			"data-size": size,
			role: "columnheader",
			style: { width: size },
			children: headerContent
		}, header.id);
	});
}
function DataTableVirtualizedCells(t0) {
	const $ = c(19);
	if ($[0] !== "5cd96d9019b54225d71e637f0daffe61d0894ee6cd43907d770123fae99b862e") {
		for (let $i = 0; $i < 19; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "5cd96d9019b54225d71e637f0daffe61d0894ee6cd43907d770123fae99b862e";
	}
	const { columnIndexes, columnSizes, columnSpacerLeft, columnSpacerRight, table, row, virtualizeColumns } = t0;
	let t1;
	let t2;
	if ($[1] !== columnIndexes || $[2] !== columnSizes || $[3] !== columnSpacerLeft || $[4] !== row || $[5] !== table || $[6] !== virtualizeColumns) {
		const cells = row.getVisibleCells();
		if ($[9] !== columnSpacerLeft || $[10] !== virtualizeColumns) {
			t1 = virtualizeColumns ? /* @__PURE__ */ jsx(DataTableColumnSpacer, {
				side: "left",
				size: columnSpacerLeft
			}) : null;
			$[9] = columnSpacerLeft;
			$[10] = virtualizeColumns;
			$[11] = t1;
		} else t1 = $[11];
		t2 = columnIndexes.map((columnIndex) => {
			const cell = cells[columnIndex];
			if (!cell) return null;
			const align = cell.column.columnDef.meta?.align ?? "start";
			const columnSize = columnSizes[columnIndex] ?? cell.column.getSize();
			return /* @__PURE__ */ jsx("div", {
				"aria-colindex": columnIndex + 1,
				className: cn("flex h-6 min-w-0 shrink-0 items-center overflow-hidden px-2 py-0 text-sm whitespace-nowrap", ALIGNMENT_CLASSES[align]),
				"data-align": align,
				"data-size": columnSize,
				role: "cell",
				style: { width: columnSize },
				children: /* @__PURE__ */ jsx(table.FlexRender, { cell })
			}, cell.id);
		});
		$[1] = columnIndexes;
		$[2] = columnSizes;
		$[3] = columnSpacerLeft;
		$[4] = row;
		$[5] = table;
		$[6] = virtualizeColumns;
		$[7] = t1;
		$[8] = t2;
	} else {
		t1 = $[7];
		t2 = $[8];
	}
	let t3;
	if ($[12] !== columnSpacerRight || $[13] !== virtualizeColumns) {
		t3 = virtualizeColumns ? /* @__PURE__ */ jsx(DataTableColumnSpacer, {
			side: "right",
			size: columnSpacerRight
		}) : null;
		$[12] = columnSpacerRight;
		$[13] = virtualizeColumns;
		$[14] = t3;
	} else t3 = $[14];
	let t4;
	if ($[15] !== t1 || $[16] !== t2 || $[17] !== t3) {
		t4 = /* @__PURE__ */ jsxs(Fragment, { children: [
			t1,
			t2,
			t3
		] });
		$[15] = t1;
		$[16] = t2;
		$[17] = t3;
		$[18] = t4;
	} else t4 = $[18];
	return t4;
}
function DataTableVirtualizedDefaultRow(t0) {
	const $ = c(43);
	if ($[0] !== "5cd96d9019b54225d71e637f0daffe61d0894ee6cd43907d770123fae99b862e") {
		for (let $i = 0; $i < 43; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "5cd96d9019b54225d71e637f0daffe61d0894ee6cd43907d770123fae99b862e";
	}
	const { columnIndexes, columnSizes, columnSpacerLeft, columnSpacerRight, table, row, index, presentation, activateRow, canActivate, isExpanded, rowIndex, expandedRowIndex, footerRowIndex, hasExpandedContent, hasRowFooter, expandedContent, footerContent, virtualizeColumns } = t0;
	const t1 = presentation.disabled || void 0;
	const t2 = row.getCanExpand() ? isExpanded : void 0;
	let t3;
	if ($[1] !== index || $[2] !== presentation.tone) {
		t3 = cn("flex h-6 w-full border-b transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring hover:bg-muted/50", getRowZebraClass(presentation.tone, index), ROW_TONE_CLASSES[presentation.tone]);
		$[1] = index;
		$[2] = presentation.tone;
		$[3] = t3;
	} else t3 = $[3];
	let t4;
	if ($[4] !== presentation.tone || $[5] !== row) {
		t4 = getRowDataState(row, presentation.tone);
		$[4] = presentation.tone;
		$[5] = row;
		$[6] = t4;
	} else t4 = $[6];
	const t5 = canActivate ? 0 : -1;
	let t6;
	let t7;
	if ($[7] !== activateRow) {
		t6 = (event) => {
			if (!isNestedRowAction(event.target)) activateRow();
		};
		t7 = (event_0) => {
			if (!isNestedRowAction(event_0.target) && (event_0.key === "Enter" || event_0.key === " ")) {
				event_0.preventDefault();
				activateRow();
			}
		};
		$[7] = activateRow;
		$[8] = t6;
		$[9] = t7;
	} else {
		t6 = $[8];
		t7 = $[9];
	}
	let t8;
	if ($[10] !== columnIndexes || $[11] !== columnSizes || $[12] !== columnSpacerLeft || $[13] !== columnSpacerRight || $[14] !== row || $[15] !== table || $[16] !== virtualizeColumns) {
		t8 = /* @__PURE__ */ jsx(DataTableVirtualizedCells, {
			columnIndexes,
			columnSizes,
			columnSpacerLeft,
			columnSpacerRight,
			table,
			row,
			virtualizeColumns
		});
		$[10] = columnIndexes;
		$[11] = columnSizes;
		$[12] = columnSpacerLeft;
		$[13] = columnSpacerRight;
		$[14] = row;
		$[15] = table;
		$[16] = virtualizeColumns;
		$[17] = t8;
	} else t8 = $[17];
	let t9;
	if ($[18] !== presentation.tone || $[19] !== rowIndex || $[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8) {
		t9 = /* @__PURE__ */ jsx("div", {
			"aria-disabled": t1,
			"aria-expanded": t2,
			"aria-rowindex": rowIndex,
			className: t3,
			"data-state": t4,
			"data-tone": presentation.tone,
			role: "row",
			tabIndex: t5,
			onClick: t6,
			onKeyDown: t7,
			children: t8
		});
		$[18] = presentation.tone;
		$[19] = rowIndex;
		$[20] = t1;
		$[21] = t2;
		$[22] = t3;
		$[23] = t4;
		$[24] = t5;
		$[25] = t6;
		$[26] = t7;
		$[27] = t8;
		$[28] = t9;
	} else t9 = $[28];
	let t10;
	if ($[29] !== expandedContent || $[30] !== expandedRowIndex || $[31] !== hasExpandedContent || $[32] !== row) {
		t10 = hasExpandedContent && /* @__PURE__ */ jsx("div", {
			"aria-rowindex": expandedRowIndex,
			className: "border-b bg-gx-tile-dark",
			"data-slot": "data-table-expanded-row",
			role: "row",
			children: /* @__PURE__ */ jsx("div", {
				"aria-colspan": row.getVisibleCells().length,
				className: "w-full",
				role: "cell",
				children: expandedContent
			})
		});
		$[29] = expandedContent;
		$[30] = expandedRowIndex;
		$[31] = hasExpandedContent;
		$[32] = row;
		$[33] = t10;
	} else t10 = $[33];
	let t11;
	if ($[34] !== footerContent || $[35] !== footerRowIndex || $[36] !== hasRowFooter || $[37] !== row) {
		t11 = hasRowFooter && /* @__PURE__ */ jsx("div", {
			"aria-rowindex": footerRowIndex,
			className: "border-b bg-background",
			"data-slot": "data-table-row-footer",
			role: "row",
			children: /* @__PURE__ */ jsx("div", {
				"aria-colspan": row.getVisibleCells().length,
				className: "w-full",
				role: "cell",
				children: footerContent
			})
		});
		$[34] = footerContent;
		$[35] = footerRowIndex;
		$[36] = hasRowFooter;
		$[37] = row;
		$[38] = t11;
	} else t11 = $[38];
	let t12;
	if ($[39] !== t10 || $[40] !== t11 || $[41] !== t9) {
		t12 = /* @__PURE__ */ jsxs(Fragment, { children: [
			t9,
			t10,
			t11
		] });
		$[39] = t10;
		$[40] = t11;
		$[41] = t9;
		$[42] = t12;
	} else t12 = $[42];
	return t12;
}
function DataTableVirtualizedRow(t0) {
	const $ = c(50);
	if ($[0] !== "5cd96d9019b54225d71e637f0daffe61d0894ee6cd43907d770123fae99b862e") {
		for (let $i = 0; $i < 50; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "5cd96d9019b54225d71e637f0daffe61d0894ee6cd43907d770123fae99b862e";
	}
	const { columnIndexes, columnSizes, columnSpacerLeft, columnSpacerRight, table, row, index, start, isExpanded, rowIndex, expandedRowIndex, footerRowIndex, hasExpandedContent, hasRowFooter, measureElementRef, renderExpandedContent, getRowPresentation, onRowActivate, renderRowFooter, renderRow, virtualizeColumns } = t0;
	let t1;
	if ($[1] !== hasExpandedContent || $[2] !== renderExpandedContent || $[3] !== renderRow || $[4] !== row) {
		t1 = !renderRow && hasExpandedContent ? renderExpandedContent?.(row) : void 0;
		$[1] = hasExpandedContent;
		$[2] = renderExpandedContent;
		$[3] = renderRow;
		$[4] = row;
		$[5] = t1;
	} else t1 = $[5];
	const expandedContent = t1;
	let t2;
	if ($[6] !== hasRowFooter || $[7] !== renderRow || $[8] !== renderRowFooter || $[9] !== row) {
		t2 = !renderRow && hasRowFooter ? renderRowFooter?.(row) : void 0;
		$[6] = hasRowFooter;
		$[7] = renderRow;
		$[8] = renderRowFooter;
		$[9] = row;
		$[10] = t2;
	} else t2 = $[10];
	const footerContent = t2;
	let defaultTone = "default";
	if (isExpanded) defaultTone = "expanded";
	else if (row.getIsSelected()) defaultTone = "selected-primary";
	let t3;
	if ($[11] !== defaultTone || $[12] !== getRowPresentation || $[13] !== onRowActivate || $[14] !== row) {
		t3 = getRowPresentation?.(row) ?? {
			tone: defaultTone,
			disabled: false,
			interactive: Boolean(onRowActivate)
		};
		$[11] = defaultTone;
		$[12] = getRowPresentation;
		$[13] = onRowActivate;
		$[14] = row;
		$[15] = t3;
	} else t3 = $[15];
	const presentation = t3;
	const canActivate = Boolean(onRowActivate) && presentation.interactive && !presentation.disabled;
	let t4;
	if ($[16] !== canActivate || $[17] !== onRowActivate || $[18] !== row) {
		t4 = () => {
			if (canActivate) onRowActivate?.(row);
		};
		$[16] = canActivate;
		$[17] = onRowActivate;
		$[18] = row;
		$[19] = t4;
	} else t4 = $[19];
	const activateRow = t4;
	const t5 = renderRow ? rowIndex : void 0;
	const t6 = renderRow ? "row" : void 0;
	const t7 = `translateY(${start}px)`;
	let t8;
	if ($[20] !== t7) {
		t8 = { transform: t7 };
		$[20] = t7;
		$[21] = t8;
	} else t8 = $[21];
	let t9;
	if ($[22] !== activateRow || $[23] !== canActivate || $[24] !== columnIndexes || $[25] !== columnSizes || $[26] !== columnSpacerLeft || $[27] !== columnSpacerRight || $[28] !== expandedContent || $[29] !== expandedRowIndex || $[30] !== footerContent || $[31] !== footerRowIndex || $[32] !== hasExpandedContent || $[33] !== hasRowFooter || $[34] !== index || $[35] !== isExpanded || $[36] !== presentation || $[37] !== renderRow || $[38] !== row || $[39] !== rowIndex || $[40] !== table || $[41] !== virtualizeColumns) {
		t9 = renderRow ? renderRow(row, index) : /* @__PURE__ */ jsx(DataTableVirtualizedDefaultRow, {
			columnIndexes,
			columnSizes,
			columnSpacerLeft,
			columnSpacerRight,
			table,
			row,
			index,
			presentation,
			activateRow,
			canActivate,
			isExpanded,
			rowIndex,
			expandedRowIndex,
			footerRowIndex,
			hasExpandedContent,
			hasRowFooter,
			expandedContent,
			footerContent,
			virtualizeColumns
		});
		$[22] = activateRow;
		$[23] = canActivate;
		$[24] = columnIndexes;
		$[25] = columnSizes;
		$[26] = columnSpacerLeft;
		$[27] = columnSpacerRight;
		$[28] = expandedContent;
		$[29] = expandedRowIndex;
		$[30] = footerContent;
		$[31] = footerRowIndex;
		$[32] = hasExpandedContent;
		$[33] = hasRowFooter;
		$[34] = index;
		$[35] = isExpanded;
		$[36] = presentation;
		$[37] = renderRow;
		$[38] = row;
		$[39] = rowIndex;
		$[40] = table;
		$[41] = virtualizeColumns;
		$[42] = t9;
	} else t9 = $[42];
	let t10;
	if ($[43] !== index || $[44] !== measureElementRef || $[45] !== t5 || $[46] !== t6 || $[47] !== t8 || $[48] !== t9) {
		t10 = /* @__PURE__ */ jsx("div", {
			"aria-rowindex": t5,
			ref: measureElementRef,
			className: "absolute top-0 left-0 w-full",
			"data-index": index,
			role: t6,
			style: t8,
			children: t9
		});
		$[43] = index;
		$[44] = measureElementRef;
		$[45] = t5;
		$[46] = t6;
		$[47] = t8;
		$[48] = t9;
		$[49] = t10;
	} else t10 = $[49];
	return t10;
}
function getSemanticRowLayouts({ rows, expanded, firstRowIndex, canRenderExpandedContent, canRenderRowFooter, hasExpandedContent, hasRowFooter }) {
	let nextRowIndex = firstRowIndex;
	return rows.map((row) => {
		const isExpanded = expanded === true || expanded[row.id];
		const rowHasExpandedContent = canRenderExpandedContent && isExpanded && (hasExpandedContent?.(row) ?? true);
		const rowHasFooter = canRenderRowFooter && (hasRowFooter?.(row) ?? true);
		return {
			isExpanded,
			rowIndex: nextRowIndex++,
			expandedRowIndex: rowHasExpandedContent ? nextRowIndex++ : void 0,
			footerRowIndex: rowHasFooter ? nextRowIndex++ : void 0,
			hasExpandedContent: rowHasExpandedContent,
			hasRowFooter: rowHasFooter
		};
	});
}
function DataTableSemanticLayout(t0) {
	const $ = c(14);
	if ($[0] !== "5cd96d9019b54225d71e637f0daffe61d0894ee6cd43907d770123fae99b862e") {
		for (let $i = 0; $i < 14; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "5cd96d9019b54225d71e637f0daffe61d0894ee6cd43907d770123fae99b862e";
	}
	const { rows, expanded, firstRowIndex, canRenderExpandedContent, canRenderRowFooter, hasExpandedContent, hasRowFooter, children } = t0;
	let t1;
	if ($[1] !== canRenderExpandedContent || $[2] !== canRenderRowFooter || $[3] !== expanded || $[4] !== firstRowIndex || $[5] !== hasExpandedContent || $[6] !== hasRowFooter || $[7] !== rows) {
		t1 = getSemanticRowLayouts({
			rows,
			expanded,
			firstRowIndex,
			canRenderExpandedContent,
			canRenderRowFooter,
			hasExpandedContent,
			hasRowFooter
		});
		$[1] = canRenderExpandedContent;
		$[2] = canRenderRowFooter;
		$[3] = expanded;
		$[4] = firstRowIndex;
		$[5] = hasExpandedContent;
		$[6] = hasRowFooter;
		$[7] = rows;
		$[8] = t1;
	} else t1 = $[8];
	const layouts = t1;
	let t2;
	if ($[9] !== children || $[10] !== firstRowIndex || $[11] !== layouts || $[12] !== rows.length) {
		const lastLayout = layouts.at(-1);
		t2 = children(layouts, rows.length === 0 ? firstRowIndex : lastLayout?.footerRowIndex ?? lastLayout?.expandedRowIndex ?? lastLayout?.rowIndex ?? firstRowIndex - 1);
		$[9] = children;
		$[10] = firstRowIndex;
		$[11] = layouts;
		$[12] = rows.length;
		$[13] = t2;
	} else t2 = $[13];
	return t2;
}
/**
* A virtualized alternative to composing `Table`/`TableHeader`/`TableBody`
* directly: windows `table.getRowModel().rows` with `@tanstack/react-virtual`
* for large datasets. Absolutely-positioned rows can't participate in a
* native `<table>`'s row/column layout, so this renders a div-based grid
* (`role="table"`/`role="row"`/`role="cell"` for equivalent semantics)
* instead of the `table.tsx` primitives — the same approach
* `apps/client-ui`'s `CatalogTableGrid` uses for its own large virtualized
* catalog table. Use the plain `Table` primitives for small/medium tables;
* reach for this only once row count makes unwindowed rendering slow.
*
* Import path: `@design-system/components/data-table/data-table-virtualized-body`.
*/
function DataTableVirtualized({ table, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, rows: providedRows, renderHeader, renderHeaderFooter, renderExpandedContent, hasExpandedContent, getRowPresentation, onRowActivate, renderRowFooter, hasRowFooter, renderRow, emptyContent, estimateSize = 24, overscan = 5, virtualizeColumns = false, fitColumnsToViewport = false, columnOverscan, className }) {
	const scrollRef = useRef(null);
	const rows = providedRows ?? table.getRowModel().rows;
	const columns = table.getVisibleLeafColumns();
	const headerGroups = table.getHeaderGroups();
	const [viewportWidth, setViewportWidth] = useState(0);
	const columnSizes = fitColumnSizes(columns.map((column) => column.getSize()), fitColumnsToViewport ? viewportWidth : void 0);
	const tableWidth = columnSizes.reduce((total, size) => total + size, 0);
	const columnSizeKey = columns.map((column_0, index) => `${column_0.id}:${columnSizes[index] ?? 0}`).join("|");
	const columnIndexById = new Map(columns.map((column_1, index_0) => [column_1.id, index_0]));
	const columnOffsets = [0];
	for (const size_0 of columnSizes) columnOffsets.push((columnOffsets.at(-1) ?? 0) + size_0);
	const [horizontalScroll, setHorizontalScroll] = useState({
		hasOverflow: false,
		canScrollLeft: false,
		canScrollRight: false
	});
	const updateHorizontalScroll = useCallback(() => {
		const element = scrollRef.current;
		if (!element) return;
		const clientWidth = element.clientWidth;
		if (fitColumnsToViewport && clientWidth > 0) setViewportWidth((currentWidth) => currentWidth === clientWidth ? currentWidth : clientWidth);
		const scrollWidth = Math.max(element.scrollWidth, tableWidth);
		const hasOverflow = scrollWidth > clientWidth + HORIZONTAL_SCROLL_TOLERANCE;
		const canScrollLeft = element.scrollLeft > HORIZONTAL_SCROLL_TOLERANCE;
		const canScrollRight = element.scrollLeft + clientWidth < scrollWidth - HORIZONTAL_SCROLL_TOLERANCE;
		setHorizontalScroll((current) => current.hasOverflow === hasOverflow && current.canScrollLeft === canScrollLeft && current.canScrollRight === canScrollRight ? current : {
			hasOverflow,
			canScrollLeft,
			canScrollRight
		});
	}, [fitColumnsToViewport, tableWidth]);
	useLayoutEffect(() => {
		updateHorizontalScroll();
	}, [
		rows.length,
		tableWidth,
		updateHorizontalScroll
	]);
	useEffect(() => {
		const element_0 = scrollRef.current;
		if (!element_0) return void 0;
		let pendingFrame = null;
		const scheduleUpdate = () => {
			if (pendingFrame !== null) return;
			pendingFrame = requestAnimationFrame(() => {
				pendingFrame = null;
				updateHorizontalScroll();
			});
		};
		const resizeObserver = new ResizeObserver(scheduleUpdate);
		resizeObserver.observe(element_0);
		element_0.addEventListener("scroll", scheduleUpdate, { passive: true });
		return () => {
			if (pendingFrame !== null) cancelAnimationFrame(pendingFrame);
			resizeObserver.disconnect();
			element_0.removeEventListener("scroll", scheduleUpdate);
		};
	}, [updateHorizontalScroll]);
	const scrollHorizontally = (direction) => {
		const element_1 = scrollRef.current;
		if (!element_1) return;
		element_1.scrollBy({
			left: direction * element_1.clientWidth * .75,
			behavior: getPreferredScrollBehavior()
		});
	};
	const columnVirtualizer = useVirtualizer({
		horizontal: true,
		count: virtualizeColumns ? columns.length : 0,
		getScrollElement: () => scrollRef.current,
		estimateSize: (index_1) => columnSizes[index_1] ?? 0,
		overscan: columnOverscan
	});
	const rowVirtualizer = useVirtualizer({
		count: rows.length,
		estimateSize: () => estimateSize,
		getScrollElement: () => scrollRef.current,
		getItemKey: (index_2) => rows[index_2]?.id ?? index_2,
		overscan
	});
	const measureColumns = columnVirtualizer.measure;
	useLayoutEffect(() => {
		if (virtualizeColumns) measureColumns();
	}, [
		columnSizeKey,
		measureColumns,
		virtualizeColumns
	]);
	const virtualColumns = virtualizeColumns ? columnVirtualizer.getVirtualItems() : [];
	const columnIndexes = virtualizeColumns ? virtualColumns.map((column_2) => column_2.index) : columns.map((_, index_3) => index_3);
	const columnSpacerLeft = virtualColumns[0]?.start ?? 0;
	const lastVirtualColumn = virtualColumns.at(-1);
	const columnSpacerRight = lastVirtualColumn ? Math.max(0, columnVirtualizer.getTotalSize() - lastVirtualColumn.end) : 0;
	const firstVirtualColumnIndex = virtualColumns[0]?.index ?? 0;
	const lastVirtualColumnIndex = lastVirtualColumn?.index ?? columns.length - 1;
	const headerRowCount = headerGroups.length + (renderHeaderFooter ? 1 : 0);
	return /* @__PURE__ */ jsx(table.Subscribe, {
		selector: (state) => state.expanded,
		children: (expanded) => /* @__PURE__ */ jsx(DataTableSemanticLayout, {
			rows,
			expanded,
			firstRowIndex: headerRowCount + 1,
			canRenderExpandedContent: Boolean(renderExpandedContent) && !renderRow,
			canRenderRowFooter: Boolean(renderRowFooter) && !renderRow,
			hasExpandedContent,
			hasRowFooter,
			children: (semanticRowLayouts, ariaRowCount) => /* @__PURE__ */ jsxs("div", {
				className: cn("relative h-full w-full min-w-0 rounded-lg border", className),
				children: [/* @__PURE__ */ jsxs("div", {
					"aria-label": ariaLabel,
					"aria-labelledby": ariaLabelledby,
					"aria-colcount": columns.length,
					"aria-rowcount": ariaRowCount,
					ref: scrollRef,
					className: "relative h-full rounded-[inherit]",
					"data-total-column-size": tableWidth,
					role: "table",
					style: { overflow: "auto" },
					children: [/* @__PURE__ */ jsxs("div", {
						className: "sticky top-0 z-10",
						role: "rowgroup",
						children: [headerGroups.map((headerGroup, headerGroupIndex) => {
							const renderedHeaderLayouts = getRenderedHeaderLayouts({
								headerLayouts: getHeaderLayouts(headerGroup.headers, columnIndexById, columnOffsets),
								virtualizeColumns,
								firstVirtualColumnIndex,
								lastVirtualColumnIndex
							});
							const firstHeaderLayout = renderedHeaderLayouts[0];
							const lastHeaderLayout = renderedHeaderLayouts.at(-1);
							const headerSpacerLeft = firstHeaderLayout?.start ?? 0;
							const headerSpacerRight = lastHeaderLayout ? Math.max(0, tableWidth - lastHeaderLayout.end) : tableWidth;
							const renderedHeaders = renderDataTableHeaderCells({
								layouts: renderedHeaderLayouts,
								renderHeader,
								table
							});
							return /* @__PURE__ */ jsxs("div", {
								"aria-rowindex": headerGroupIndex + 1,
								className: "flex border-b bg-background",
								role: "row",
								style: { minWidth: tableWidth },
								children: [
									virtualizeColumns ? /* @__PURE__ */ jsx(DataTableColumnSpacer, {
										side: "left",
										size: headerSpacerLeft
									}) : null,
									renderedHeaders,
									virtualizeColumns ? /* @__PURE__ */ jsx(DataTableColumnSpacer, {
										side: "right",
										size: headerSpacerRight
									}) : null
								]
							}, headerGroup.id);
						}), renderHeaderFooter ? /* @__PURE__ */ jsx("div", {
							"aria-rowindex": headerGroups.length + 1,
							className: "flex border-b bg-background",
							role: "row",
							style: { minWidth: tableWidth },
							children: /* @__PURE__ */ jsx("div", {
								"aria-colspan": columns.length,
								className: "w-full",
								role: "cell",
								children: renderHeaderFooter(table)
							})
						}) : null]
					}), rows.length === 0 ? /* @__PURE__ */ jsx("div", {
						role: "rowgroup",
						children: /* @__PURE__ */ jsx("div", {
							"aria-rowindex": headerRowCount + 1,
							role: "row",
							children: /* @__PURE__ */ jsx("div", {
								"aria-colspan": table.getVisibleLeafColumns().length,
								className: "flex h-24 items-center justify-center text-sm text-muted-foreground",
								role: "cell",
								children: emptyContent
							})
						})
					}) : /* @__PURE__ */ jsx("div", {
						className: "relative",
						role: "rowgroup",
						style: {
							height: rowVirtualizer.getTotalSize(),
							minWidth: tableWidth
						},
						children: rowVirtualizer.getVirtualItems().map((virtualRow) => {
							const row = rows[virtualRow.index];
							const semanticLayout = semanticRowLayouts[virtualRow.index];
							if (!row || !semanticLayout) return null;
							return /* @__PURE__ */ jsx(DataTableVirtualizedRow, {
								columnIndexes,
								columnSizes,
								columnSpacerLeft,
								columnSpacerRight,
								table,
								row,
								index: virtualRow.index,
								start: virtualRow.start,
								isExpanded: semanticLayout.isExpanded,
								rowIndex: semanticLayout.rowIndex,
								expandedRowIndex: semanticLayout.expandedRowIndex,
								footerRowIndex: semanticLayout.footerRowIndex,
								hasExpandedContent: semanticLayout.hasExpandedContent,
								hasRowFooter: semanticLayout.hasRowFooter,
								measureElementRef: rowVirtualizer.measureElement,
								renderExpandedContent,
								getRowPresentation,
								onRowActivate,
								renderRowFooter,
								renderRow,
								virtualizeColumns
							}, virtualRow.key);
						})
					})]
				}), horizontalScroll.hasOverflow && /* @__PURE__ */ jsxs("div", {
					className: "absolute right-24 bottom-3 z-20 flex gap-1 rounded-md border bg-background/90 p-1 shadow-sm backdrop-blur-sm",
					"data-slot": "data-table-horizontal-scroll-controls",
					children: [/* @__PURE__ */ jsx("button", {
						"aria-label": "Scroll table left",
						className: "flex size-7 items-center justify-center rounded-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none disabled:pointer-events-none disabled:opacity-30",
						disabled: !horizontalScroll.canScrollLeft,
						type: "button",
						onClick: () => scrollHorizontally(-1),
						children: /* @__PURE__ */ jsx(ChevronLeft, {
							"aria-hidden": "true",
							className: "size-4"
						})
					}), /* @__PURE__ */ jsx("button", {
						"aria-label": "Scroll table right",
						className: "flex size-7 items-center justify-center rounded-sm text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none disabled:pointer-events-none disabled:opacity-30",
						disabled: !horizontalScroll.canScrollRight,
						type: "button",
						onClick: () => scrollHorizontally(1),
						children: /* @__PURE__ */ jsx(ChevronRight, {
							"aria-hidden": "true",
							className: "size-4"
						})
					})]
				})]
			})
		})
	});
}
//#endregion
//#region src/components/data-table/selection-column.tsx
function resolveSelectionModel(options) {
	return options.selection ?? {
		type: "table",
		isRowSelectable: options.isRowSelectable,
		isLocked: options.isLocked,
		onLockedClick: options.onLockedClick
	};
}
/**
* Canonical table-selection control for checked, mixed, disabled, and locked
* states. Locked controls remain focusable so consumers can explain or change
* a mutually exclusive selection mode.
*/
function DataTableSelectionCheckbox(t0) {
	const $ = c(25);
	if ($[0] !== "6ac4e1d8222ae3a0477738081e4db6ba70a8354c5df6ee12099d3e21e96cbf9a") {
		for (let $i = 0; $i < 25; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6ac4e1d8222ae3a0477738081e4db6ba70a8354c5df6ee12099d3e21e96cbf9a";
	}
	const { snapshot, "aria-label": ariaLabel, onToggle } = t0;
	const lockedDescriptionId = useId();
	if (snapshot.locked && !snapshot.disabled) {
		const nextChecked = snapshot.checked ? false : true;
		let t1;
		if ($[1] !== nextChecked || $[2] !== onToggle) {
			t1 = () => onToggle(nextChecked);
			$[1] = nextChecked;
			$[2] = onToggle;
			$[3] = t1;
		} else t1 = $[3];
		const activate = t1;
		const t2 = snapshot.indeterminate ? "mixed" : snapshot.checked;
		let t3;
		if ($[4] !== activate) {
			t3 = (event) => {
				if (event.key === "Enter" || event.key === " ") {
					event.preventDefault();
					activate();
				}
			};
			$[4] = activate;
			$[5] = t3;
		} else t3 = $[5];
		let t4;
		if ($[6] !== snapshot.checked || $[7] !== snapshot.indeterminate) {
			t4 = /* @__PURE__ */ jsx(Checkbox, {
				"aria-hidden": "true",
				checked: snapshot.checked,
				disabled: true,
				indeterminate: snapshot.indeterminate,
				tabIndex: -1
			});
			$[6] = snapshot.checked;
			$[7] = snapshot.indeterminate;
			$[8] = t4;
		} else t4 = $[8];
		let t5;
		if ($[9] !== lockedDescriptionId) {
			t5 = /* @__PURE__ */ jsx("span", {
				id: lockedDescriptionId,
				className: "sr-only",
				children: "Selection mode locked"
			});
			$[9] = lockedDescriptionId;
			$[10] = t5;
		} else t5 = $[10];
		let t6;
		if ($[11] !== activate || $[12] !== ariaLabel || $[13] !== lockedDescriptionId || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
			t6 = /* @__PURE__ */ jsxs("span", {
				"aria-checked": t2,
				"aria-describedby": lockedDescriptionId,
				"aria-disabled": "true",
				"aria-label": ariaLabel,
				className: "inline-flex size-4 cursor-pointer rounded-[4px] outline-none focus-visible:ring-3 focus-visible:ring-ring/50",
				"data-locked": "",
				role: "checkbox",
				tabIndex: 0,
				onClick: activate,
				onKeyDown: t3,
				children: [t4, t5]
			});
			$[11] = activate;
			$[12] = ariaLabel;
			$[13] = lockedDescriptionId;
			$[14] = t2;
			$[15] = t3;
			$[16] = t4;
			$[17] = t5;
			$[18] = t6;
		} else t6 = $[18];
		return t6;
	}
	let t1;
	if ($[19] !== ariaLabel || $[20] !== onToggle || $[21] !== snapshot.checked || $[22] !== snapshot.disabled || $[23] !== snapshot.indeterminate) {
		t1 = /* @__PURE__ */ jsx(Checkbox, {
			"aria-label": ariaLabel,
			checked: snapshot.checked,
			disabled: snapshot.disabled,
			indeterminate: snapshot.indeterminate,
			onCheckedChange: onToggle
		});
		$[19] = ariaLabel;
		$[20] = onToggle;
		$[21] = snapshot.checked;
		$[22] = snapshot.disabled;
		$[23] = snapshot.indeterminate;
		$[24] = t1;
	} else t1 = $[24];
	return t1;
}
function resolveIsSelectable(row, isRowSelectable) {
	return isRowSelectable ? isRowSelectable(row) : row.getCanSelect();
}
function getSelectableRows(rows, isRowSelectable) {
	return rows.flatMap((row) => [...isRowSelectable(row) ? [row] : [], ...getSelectableRows(row.subRows, isRowSelectable)]);
}
function getFirstSelectableRow(rows, isRowSelectable) {
	for (const row of rows) {
		if (isRowSelectable(row)) return row;
		const descendant = getFirstSelectableRow(row.subRows, isRowSelectable);
		if (descendant) return descendant;
	}
}
function toggleRows(rows, checked) {
	for (const row of rows) row.toggleSelected(checked === true, { selectChildren: false });
}
function handleRowCheckedChange(row, { isLocked, onLockedClick }, checked, selectChildren = true) {
	if (isLocked?.(row) && onLockedClick) onLockedClick(row);
	else row.toggleSelected(checked === true, { selectChildren });
}
function getHeaderCheckboxProps(table, isRowSelectable) {
	if (!isRowSelectable) return {
		checked: table.getIsAllRowsSelected(),
		indeterminate: table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected(),
		onCheckedChange: (checked) => table.toggleAllRowsSelected(checked === true)
	};
	const rows = getSelectableRows(table.getRowModel().rows, isRowSelectable);
	const selectedCount = rows.filter((row) => row.getIsSelected()).length;
	const allSelected = rows.length > 0 && selectedCount === rows.length;
	return {
		checked: allSelected,
		indeterminate: selectedCount > 0 && !allSelected,
		onCheckedChange: (checked) => toggleRows(rows, checked)
	};
}
/**
* A `select` display column: header checkbox toggles every row on the page,
* cell checkbox toggles that row. Use on flat (non-grouped) tables.
*
* Import path: `@design-system/components/data-table/selection-column`.
*/
function getSelectionColumn(options = {}) {
	const helper = createAppColumnHelper();
	const selection = resolveSelectionModel(options);
	return helper.display({
		id: "select",
		size: options.size,
		header: ({ table }) => {
			if (selection.type === "external") {
				const rows = table.getRowModel().rows;
				return /* @__PURE__ */ jsx(DataTableSelectionCheckbox, {
					"aria-label": "Select all rows",
					snapshot: selection.adapter.getHeaderState(rows),
					onToggle: () => selection.adapter.toggleRows(rows)
				});
			}
			const { checked, indeterminate, onCheckedChange } = getHeaderCheckboxProps(table, selection.isRowSelectable);
			return /* @__PURE__ */ jsx(DataTableSelectionCheckbox, {
				"aria-label": "Select all rows",
				snapshot: {
					checked,
					indeterminate,
					disabled: false,
					locked: false
				},
				onToggle: onCheckedChange
			});
		},
		cell: ({ row }) => {
			if (selection.type === "external") return /* @__PURE__ */ jsx(DataTableSelectionCheckbox, {
				"aria-label": "Select row",
				snapshot: selection.adapter.getRowState(row),
				onToggle: () => selection.adapter.toggleRow(row)
			});
			return /* @__PURE__ */ jsx(DataTableSelectionCheckbox, {
				"aria-label": "Select row",
				snapshot: {
					checked: row.getIsSelected(),
					indeterminate: false,
					disabled: !resolveIsSelectable(row, selection.isRowSelectable),
					locked: Boolean(selection.isLocked?.(row))
				},
				onToggle: (checked) => handleRowCheckedChange(row, selection, checked)
			});
		},
		enableSorting: false,
		enableHiding: false
	});
}
/**
* A `select` display column for grouped/nested rows: a group's header
* checkbox reflects "some vs. all vs. none of its sub-rows selected"
* (indeterminate when partially selected), and toggling it selects/clears
* every sub-row in that group. Leaf rows behave like a plain selection
* checkbox.
*
* Import path: `@design-system/components/data-table/selection-column`.
*/
function getGroupSelectionColumn(options = {}) {
	const helper = createAppColumnHelper();
	const { groupSelectionVariant = "all-descendants" } = options;
	const selection = resolveSelectionModel(options);
	return helper.display({
		id: "select",
		size: options.size,
		header: ({ table }) => {
			if (selection.type === "external") {
				const rows = table.getRowModel().rows;
				return /* @__PURE__ */ jsx(DataTableSelectionCheckbox, {
					"aria-label": "Select all rows",
					snapshot: selection.adapter.getHeaderState(rows),
					onToggle: () => selection.adapter.toggleRows(rows)
				});
			}
			const { checked, indeterminate, onCheckedChange } = getHeaderCheckboxProps(table, selection.isRowSelectable);
			return /* @__PURE__ */ jsx(DataTableSelectionCheckbox, {
				"aria-label": "Select all rows",
				snapshot: {
					checked,
					indeterminate,
					disabled: false,
					locked: false
				},
				onToggle: onCheckedChange
			});
		},
		cell: ({ row }) => {
			const isGroup = row.subRows.length > 0;
			if (selection.type === "external") return /* @__PURE__ */ jsx(DataTableSelectionCheckbox, {
				"aria-label": isGroup ? "Select all rows in group" : "Select row",
				snapshot: selection.adapter.getRowState(row),
				onToggle: () => selection.adapter.toggleRow(row)
			});
			const disabled = !resolveIsSelectable(row, selection.isRowSelectable);
			if (isGroup && groupSelectionVariant === "first-child") {
				const firstSelectableRow = getFirstSelectableRow(row.subRows, (subRow) => resolveIsSelectable(subRow, selection.isRowSelectable));
				return /* @__PURE__ */ jsx(DataTableSelectionCheckbox, {
					"aria-label": "Select first row in group",
					snapshot: {
						checked: firstSelectableRow?.getIsSelected() ?? false,
						indeterminate: false,
						disabled: disabled || !firstSelectableRow,
						locked: Boolean(firstSelectableRow && selection.isLocked?.(firstSelectableRow))
					},
					onToggle: (checked) => {
						if (firstSelectableRow) handleRowCheckedChange(firstSelectableRow, selection, checked, false);
					}
				});
			}
			if (isGroup && selection.isRowSelectable) {
				const subRows = getSelectableRows(row.subRows, selection.isRowSelectable);
				const selectedCount = subRows.filter((subRow) => subRow.getIsSelected()).length;
				const allSelected = subRows.length > 0 && selectedCount === subRows.length;
				return /* @__PURE__ */ jsx(DataTableSelectionCheckbox, {
					"aria-label": "Select all rows in group",
					snapshot: {
						checked: allSelected,
						disabled,
						indeterminate: selectedCount > 0 && !allSelected,
						locked: false
					},
					onToggle: (checked) => toggleRows(subRows, checked)
				});
			}
			return /* @__PURE__ */ jsx(DataTableSelectionCheckbox, {
				"aria-label": isGroup ? "Select all rows in group" : "Select row",
				snapshot: {
					checked: row.getIsSelected(),
					disabled,
					indeterminate: isGroup ? row.getIsSomeSelected() && !row.getIsAllSubRowsSelected() : false,
					locked: Boolean(selection.isLocked?.(row))
				},
				onToggle: (checked) => handleRowCheckedChange(row, selection, checked)
			});
		},
		enableSorting: false,
		enableHiding: false
	});
}
//#endregion
//#region src/components/ui/dialog.tsx
function Dialog(t0) {
	const $ = c(5);
	if ($[0] !== "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Dialog$1.Root, {
			"data-slot": "dialog",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function DialogTrigger(t0) {
	const $ = c(5);
	if ($[0] !== "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Dialog$1.Trigger, {
			"data-slot": "dialog-trigger",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function DialogPortal(t0) {
	const $ = c(5);
	if ($[0] !== "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Dialog$1.Portal, {
			"data-slot": "dialog-portal",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function DialogClose(t0) {
	const $ = c(5);
	if ($[0] !== "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Dialog$1.Close, {
			"data-slot": "dialog-close",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function DialogOverlay(t0) {
	const $ = c(9);
	if ($[0] !== "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("fixed inset-0 isolate z-[var(--z-dialog)] bg-black/10 duration-100 supports-backdrop-filter:backdrop-blur-xs data-open:animate-in data-open:fade-in-0 data-closed:animate-out data-closed:fade-out-0 motion-reduce:animate-none motion-reduce:transition-none", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Dialog$1.Backdrop, {
			"data-slot": "dialog-overlay",
			"data-testid": "dialog-overlay",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function DialogContent(t0) {
	const $ = c(23);
	if ($[0] !== "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f") {
		for (let $i = 0; $i < 23; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f";
	}
	let children;
	let className;
	let container;
	let props;
	let t1;
	let t2;
	if ($[1] !== t0) {
		({className, children, showCloseButton: t1, container, hideOverlay: t2, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = container;
		$[5] = props;
		$[6] = t1;
		$[7] = t2;
	} else {
		children = $[2];
		className = $[3];
		container = $[4];
		props = $[5];
		t1 = $[6];
		t2 = $[7];
	}
	const showCloseButton = t1 === void 0 ? true : t1;
	const hideOverlay = t2 === void 0 ? false : t2;
	let t3;
	if ($[8] !== hideOverlay) {
		t3 = !hideOverlay && /* @__PURE__ */ jsx(DialogOverlay, {});
		$[8] = hideOverlay;
		$[9] = t3;
	} else t3 = $[9];
	let t4;
	if ($[10] !== className) {
		t4 = cn("fixed top-1/2 left-1/2 z-[var(--z-dialog)] grid w-full max-w-[calc(100%-2rem)] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl bg-popover p-4 text-sm text-popover-foreground ring-1 ring-foreground/10 duration-100 outline-none sm:max-w-sm data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95 motion-reduce:animate-none motion-reduce:transition-none", className);
		$[10] = className;
		$[11] = t4;
	} else t4 = $[11];
	let t5;
	if ($[12] !== showCloseButton) {
		t5 = showCloseButton && /* @__PURE__ */ jsxs(Dialog$1.Close, {
			"data-slot": "dialog-close",
			render: /* @__PURE__ */ jsx(Button, {
				variant: "ghost",
				className: "absolute top-2 right-2",
				size: "icon-sm"
			}),
			children: [/* @__PURE__ */ jsx(XIcon, {}), /* @__PURE__ */ jsx("span", {
				className: "sr-only",
				children: "Close"
			})]
		});
		$[12] = showCloseButton;
		$[13] = t5;
	} else t5 = $[13];
	let t6;
	if ($[14] !== children || $[15] !== props || $[16] !== t4 || $[17] !== t5) {
		t6 = /* @__PURE__ */ jsxs(Dialog$1.Popup, {
			"data-slot": "dialog-content",
			className: t4,
			...props,
			children: [children, t5]
		});
		$[14] = children;
		$[15] = props;
		$[16] = t4;
		$[17] = t5;
		$[18] = t6;
	} else t6 = $[18];
	let t7;
	if ($[19] !== container || $[20] !== t3 || $[21] !== t6) {
		t7 = /* @__PURE__ */ jsxs(DialogPortal, {
			container,
			children: [t3, t6]
		});
		$[19] = container;
		$[20] = t3;
		$[21] = t6;
		$[22] = t7;
	} else t7 = $[22];
	return t7;
}
function DialogHeader(t0) {
	const $ = c(9);
	if ($[0] !== "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex flex-col gap-2", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "dialog-header",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function DialogFooter(t0) {
	const $ = c(15);
	if ($[0] !== "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f") {
		for (let $i = 0; $i < 15; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f";
	}
	let children;
	let className;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, showCloseButton: t1, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
		$[5] = t1;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
		t1 = $[5];
	}
	const showCloseButton = t1 === void 0 ? false : t1;
	let t2;
	if ($[6] !== className) {
		t2 = cn("-mx-4 -mb-4 flex flex-col-reverse gap-2 rounded-b-xl border-t bg-muted/50 p-4 sm:flex-row sm:justify-end", className);
		$[6] = className;
		$[7] = t2;
	} else t2 = $[7];
	let t3;
	if ($[8] !== showCloseButton) {
		t3 = showCloseButton && /* @__PURE__ */ jsx(Dialog$1.Close, {
			render: /* @__PURE__ */ jsx(Button, { variant: "outline" }),
			children: "Close"
		});
		$[8] = showCloseButton;
		$[9] = t3;
	} else t3 = $[9];
	let t4;
	if ($[10] !== children || $[11] !== props || $[12] !== t2 || $[13] !== t3) {
		t4 = /* @__PURE__ */ jsxs("div", {
			"data-slot": "dialog-footer",
			className: t2,
			...props,
			children: [children, t3]
		});
		$[10] = children;
		$[11] = props;
		$[12] = t2;
		$[13] = t3;
		$[14] = t4;
	} else t4 = $[14];
	return t4;
}
function DialogTitle(t0) {
	const $ = c(9);
	if ($[0] !== "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("font-heading text-base leading-none font-medium", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Dialog$1.Title, {
			"data-slot": "dialog-title",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function DialogDescription(t0) {
	const $ = c(9);
	if ($[0] !== "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c3c503865fb98e2f9e56109392d041646e0ea36eb5d449a207c17766d2c24a9f";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("text-sm text-muted-foreground *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Dialog$1.Description, {
			"data-slot": "dialog-description",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/ui/drawer.tsx
/**
* A GX modal side-panel ("drawer"), built on the same base-ui Dialog base as
* `Sheet` (NOT vaul). Composable slots: `Drawer` (root) + `DrawerTrigger` +
* `DrawerContent`, with `DrawerHeader`/`DrawerTitle`/`DrawerDescription`,
* `DrawerBody`, `DrawerFooter`, and the edge-flush `DrawerHeaderButton`
* (close/history/back). Renders in a portal with role `dialog`; `DrawerTitle`
* and `DrawerDescription` label it, and base-ui provides focus trap + escape.
*
* Import path: `@design-system/components/ui/drawer`.
*/
const Drawer = Sheet;
const DrawerTrigger = SheetTrigger;
const DrawerClose = SheetClose;
/**
* The drawer panel: a portalled, GX-navy backdrop plus an edge-anchored popup.
* Owns the ~845px width (`w-full max-w-[53rem]`, overridable) and slides in
* from `side` (`"right"` default). No built-in close button — close lives in
* the header via `DrawerHeaderButton`.
*/
function DrawerContent(t0) {
	const $ = c(14);
	if ($[0] !== "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645") {
		for (let $i = 0; $i < 14; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645";
	}
	let children;
	let className;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, children, side: t1, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
		$[5] = t1;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
		t1 = $[5];
	}
	const side = t1 === void 0 ? "right" : t1;
	let t2;
	if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = /* @__PURE__ */ jsx(Dialog$1.Backdrop, {
			"data-slot": "drawer-overlay",
			className: "fixed inset-0 z-[var(--z-panel)] bg-gx-additional-paper/80 transition-opacity duration-200 data-ending-style:opacity-0 data-starting-style:opacity-0"
		});
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] !== className) {
		t3 = cn("fixed inset-y-0 z-[var(--z-panel)] flex h-full w-full max-w-[53rem] flex-col border-gx-border bg-gx-main-background shadow-lg transition duration-200 ease-in-out data-ending-style:opacity-0 data-starting-style:opacity-0", "data-[side=right]:right-0 data-[side=right]:border-l data-[side=right]:data-ending-style:translate-x-[2.5rem] data-[side=right]:data-starting-style:translate-x-[2.5rem]", "data-[side=left]:left-0 data-[side=left]:border-r data-[side=left]:data-ending-style:-translate-x-[2.5rem] data-[side=left]:data-starting-style:-translate-x-[2.5rem]", className);
		$[7] = className;
		$[8] = t3;
	} else t3 = $[8];
	let t4;
	if ($[9] !== children || $[10] !== props || $[11] !== side || $[12] !== t3) {
		t4 = /* @__PURE__ */ jsxs(Dialog$1.Portal, { children: [t2, /* @__PURE__ */ jsx(Dialog$1.Popup, {
			"data-slot": "drawer-content",
			"data-side": side,
			className: t3,
			...props,
			children
		})] });
		$[9] = children;
		$[10] = props;
		$[11] = side;
		$[12] = t3;
		$[13] = t4;
	} else t4 = $[13];
	return t4;
}
/**
* The 108px chrome bar; lays children edge-to-edge at full height with a 16px
* gap between them (so an edge-flush back button clears the title group).
*/
function DrawerHeader(t0) {
	const $ = c(9);
	if ($[0] !== "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex min-h-27 shrink-0 items-stretch justify-between gap-4 border-b border-gx-text-disabled", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "drawer-header",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
/**
* The drawer title: a 60px-tall row of a 32px inline icon plus 24px bold text.
* The fixed row height keeps a following `DrawerDescription` clear of the icon.
*/
function DrawerTitle(t0) {
	const $ = c(9);
	if ($[0] !== "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex h-15 items-center gap-4 text-h3 text-foreground [&_svg]:size-8", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Dialog$1.Title, {
			"data-slot": "drawer-title",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
/** The 12px muted subtitle under the title. */
function DrawerDescription(t0) {
	const $ = c(9);
	if ($[0] !== "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("text-xs font-medium text-gx-text-disabled", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Dialog$1.Description, {
			"data-slot": "drawer-description",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
/** The scrolling body region between header and footer. */
function DrawerBody(t0) {
	const $ = c(9);
	if ($[0] !== "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex min-h-0 flex-1 flex-col overflow-auto p-6", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "drawer-body",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
/** The 96px pinned footer action bar; direct children stretch equally. */
function DrawerFooter(t0) {
	const $ = c(9);
	if ($[0] !== "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex min-h-24 shrink-0 items-center justify-between gap-6 border-t border-gx-text-disabled bg-gx-main-background p-6 [&>*]:flex-1", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "drawer-footer",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
/**
* The edge-flush 48-wide, full-header-height icon button used for close /
* history / back. `label` is the accessible name for the icon-only control.
* When `active` is defined, a bottom indicator bar renders (highlighted when
* `true`). Spreads button props so it composes under `DrawerClose`'s `render`.
*/
function DrawerHeaderButton(t0) {
	const $ = c(18);
	if ($[0] !== "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645") {
		for (let $i = 0; $i < 18; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f96486724dedc931b93335fd77b950dd8d0710d332df9cca2229a4c5d0441645";
	}
	let active;
	let children;
	let className;
	let label;
	let props;
	if ($[1] !== t0) {
		({className, label, active, children, ...props} = t0);
		$[1] = t0;
		$[2] = active;
		$[3] = children;
		$[4] = className;
		$[5] = label;
		$[6] = props;
	} else {
		active = $[2];
		children = $[3];
		className = $[4];
		label = $[5];
		props = $[6];
	}
	let t1;
	if ($[7] !== className) {
		t1 = cn("relative flex w-12 shrink-0 items-center justify-center self-stretch bg-gx-tile-dark text-foreground outline-none transition-colors focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:size-6", className);
		$[7] = className;
		$[8] = t1;
	} else t1 = $[8];
	let t2;
	if ($[9] !== active) {
		t2 = active !== void 0 && /* @__PURE__ */ jsx("span", {
			"aria-hidden": true,
			className: cn("absolute inset-x-0 bottom-0 h-[0.1875rem]", active ? "bg-gx-highlight" : "bg-transparent")
		});
		$[9] = active;
		$[10] = t2;
	} else t2 = $[10];
	let t3;
	if ($[11] !== active || $[12] !== children || $[13] !== label || $[14] !== props || $[15] !== t1 || $[16] !== t2) {
		t3 = /* @__PURE__ */ jsxs("button", {
			type: "button",
			"aria-label": label,
			"aria-pressed": active,
			"data-slot": "drawer-header-button",
			className: t1,
			...props,
			children: [children, t2]
		});
		$[11] = active;
		$[12] = children;
		$[13] = label;
		$[14] = props;
		$[15] = t1;
		$[16] = t2;
		$[17] = t3;
	} else t3 = $[17];
	return t3;
}
//#endregion
//#region src/components/ui/alert.tsx
const alertVariants = cva("group/alert relative grid w-full gap-0.5 rounded-lg border px-2.5 py-2 text-left text-sm has-data-[slot=alert-action]:relative has-data-[slot=alert-action]:pr-18 has-[>svg]:grid-cols-[auto_1fr] has-[>svg]:gap-x-2 *:[svg]:row-span-2 *:[svg]:translate-y-0.5 *:[svg]:text-current *:[svg:not([class*='size-'])]:size-4", {
	variants: { variant: {
		default: "bg-card text-card-foreground",
		destructive: "bg-card text-destructive *:data-[slot=alert-description]:text-destructive/90 *:[svg]:text-current"
	} },
	defaultVariants: { variant: "default" }
});
function Alert(t0) {
	const $ = c(11);
	if ($[0] !== "9b8adb499203e8ebeb1eb9c632da39d52f7f2c56f37a56c4298fe60f28e58760") {
		for (let $i = 0; $i < 11; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "9b8adb499203e8ebeb1eb9c632da39d52f7f2c56f37a56c4298fe60f28e58760";
	}
	let className;
	let props;
	let variant;
	if ($[1] !== t0) {
		({className, variant, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = variant;
	} else {
		className = $[2];
		props = $[3];
		variant = $[4];
	}
	let t1;
	if ($[5] !== className || $[6] !== variant) {
		t1 = cn(alertVariants({ variant }), className);
		$[5] = className;
		$[6] = variant;
		$[7] = t1;
	} else t1 = $[7];
	let t2;
	if ($[8] !== props || $[9] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "alert",
			role: "alert",
			className: t1,
			...props
		});
		$[8] = props;
		$[9] = t1;
		$[10] = t2;
	} else t2 = $[10];
	return t2;
}
function AlertTitle(t0) {
	const $ = c(9);
	if ($[0] !== "9b8adb499203e8ebeb1eb9c632da39d52f7f2c56f37a56c4298fe60f28e58760") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "9b8adb499203e8ebeb1eb9c632da39d52f7f2c56f37a56c4298fe60f28e58760";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("font-medium group-has-[>svg]/alert:col-start-2 [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "alert-title",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function AlertDescription(t0) {
	const $ = c(9);
	if ($[0] !== "9b8adb499203e8ebeb1eb9c632da39d52f7f2c56f37a56c4298fe60f28e58760") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "9b8adb499203e8ebeb1eb9c632da39d52f7f2c56f37a56c4298fe60f28e58760";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("text-sm text-balance text-muted-foreground md:text-pretty [&_a]:underline [&_a]:underline-offset-3 [&_a]:hover:text-foreground [&_p:not(:last-child)]:mb-4", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "alert-description",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function AlertAction(t0) {
	const $ = c(9);
	if ($[0] !== "9b8adb499203e8ebeb1eb9c632da39d52f7f2c56f37a56c4298fe60f28e58760") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "9b8adb499203e8ebeb1eb9c632da39d52f7f2c56f37a56c4298fe60f28e58760";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("absolute top-2 right-2", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "alert-action",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/ui/radio-group.tsx
function RadioGroup(t0) {
	const $ = c(9);
	if ($[0] !== "186cb8e381e1b253228045429ecdbf3f78ecd9eb37e117a80d3d3c4dfe35f0d0") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "186cb8e381e1b253228045429ecdbf3f78ecd9eb37e117a80d3d3c4dfe35f0d0";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("grid w-full gap-2", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(RadioGroup$1, {
			"data-slot": "radio-group",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function RadioGroupItem(t0) {
	const $ = c(10);
	if ($[0] !== "186cb8e381e1b253228045429ecdbf3f78ecd9eb37e117a80d3d3c4dfe35f0d0") {
		for (let $i = 0; $i < 10; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "186cb8e381e1b253228045429ecdbf3f78ecd9eb37e117a80d3d3c4dfe35f0d0";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("group/radio-group-item peer relative flex aspect-square size-4 shrink-0 rounded-full border border-input outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = /* @__PURE__ */ jsx(Radio.Indicator, {
			"data-slot": "radio-group-indicator",
			className: "flex size-4 items-center justify-center",
			children: /* @__PURE__ */ jsx("span", { className: "absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary-foreground" })
		});
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] !== props || $[8] !== t1) {
		t3 = /* @__PURE__ */ jsx(Radio.Root, {
			"data-slot": "radio-group-item",
			className: t1,
			...props,
			children: t2
		});
		$[7] = props;
		$[8] = t1;
		$[9] = t3;
	} else t3 = $[9];
	return t3;
}
//#endregion
//#region src/components/ui/calendar.tsx
function Calendar({ className, classNames, showOutsideDays = true, captionLayout = "label", buttonVariant = "ghost", locale, formatters, components, ...props }) {
	const defaultClassNames = getDefaultClassNames();
	return /* @__PURE__ */ jsx(DayPicker, {
		showOutsideDays,
		className: cn("group/calendar bg-background p-2 [--cell-radius:var(--radius-md)] [--cell-size:--spacing(7)] in-data-[slot=card-content]:bg-transparent in-data-[slot=popover-content]:bg-transparent", String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`, String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`, className),
		captionLayout,
		locale,
		formatters: {
			formatMonthDropdown: (date) => date.toLocaleString(locale?.code, { month: "short" }),
			...formatters
		},
		classNames: {
			root: cn("w-fit", defaultClassNames.root),
			months: cn("relative flex flex-col gap-4 md:flex-row", defaultClassNames.months),
			month: cn("flex w-full flex-col gap-4", defaultClassNames.month),
			nav: cn("absolute inset-x-0 top-0 flex w-full items-center justify-between gap-1", defaultClassNames.nav),
			button_previous: cn(buttonVariants({ variant: buttonVariant }), "size-(--cell-size) p-0 select-none aria-disabled:opacity-50", defaultClassNames.button_previous),
			button_next: cn(buttonVariants({ variant: buttonVariant }), "size-(--cell-size) p-0 select-none aria-disabled:opacity-50", defaultClassNames.button_next),
			month_caption: cn("flex h-(--cell-size) w-full items-center justify-center px-(--cell-size)", defaultClassNames.month_caption),
			dropdowns: cn("flex h-(--cell-size) w-full items-center justify-center gap-1.5 text-sm font-medium", defaultClassNames.dropdowns),
			dropdown_root: cn("relative rounded-(--cell-radius)", defaultClassNames.dropdown_root),
			dropdown: cn("absolute inset-0 bg-popover opacity-0", defaultClassNames.dropdown),
			caption_label: cn("font-medium select-none", captionLayout === "label" ? "text-sm" : "flex items-center gap-1 rounded-(--cell-radius) text-sm [&>svg]:size-3.5 [&>svg]:text-muted-foreground", defaultClassNames.caption_label),
			month_grid: cn("w-full border-collapse", defaultClassNames.month_grid),
			weekdays: cn("flex", defaultClassNames.weekdays),
			weekday: cn("flex-1 rounded-(--cell-radius) text-[0.8rem] font-normal text-muted-foreground select-none", defaultClassNames.weekday),
			week: cn("mt-2 flex w-full", defaultClassNames.week),
			week_number_header: cn("w-(--cell-size) select-none", defaultClassNames.week_number_header),
			week_number: cn("text-[0.8rem] text-muted-foreground select-none", defaultClassNames.week_number),
			day: cn("group/day relative aspect-square h-full w-full rounded-(--cell-radius) p-0 text-center select-none [&:last-child[data-selected=true]_button]:rounded-r-(--cell-radius)", props.showWeekNumber ? "[&:nth-child(2)[data-selected=true]_button]:rounded-l-(--cell-radius)" : "[&:first-child[data-selected=true]_button]:rounded-l-(--cell-radius)", defaultClassNames.day),
			range_start: cn("relative isolate z-0 rounded-l-(--cell-radius) bg-muted after:absolute after:inset-y-0 after:right-0 after:w-4 after:bg-muted", defaultClassNames.range_start),
			range_middle: cn("rounded-none", defaultClassNames.range_middle),
			range_end: cn("relative isolate z-0 rounded-r-(--cell-radius) bg-muted after:absolute after:inset-y-0 after:left-0 after:w-4 after:bg-muted", defaultClassNames.range_end),
			today: cn("rounded-(--cell-radius) bg-muted text-foreground data-[selected=true]:rounded-none", defaultClassNames.today),
			outside: cn("text-muted-foreground aria-selected:text-muted-foreground", defaultClassNames.outside),
			disabled: cn("text-muted-foreground opacity-50", defaultClassNames.disabled),
			hidden: cn("invisible", defaultClassNames.hidden),
			...classNames
		},
		components: {
			Root: ({ className: className_0, rootRef, ...rootProps }) => /* @__PURE__ */ jsx("div", {
				"data-slot": "calendar",
				ref: rootRef,
				className: cn(className_0),
				...rootProps
			}),
			Chevron: ({ className: className_1, orientation, ...chevronProps }) => {
				if (orientation === "left") return /* @__PURE__ */ jsx(ChevronLeftIcon, {
					className: cn("size-4", className_1),
					...chevronProps
				});
				if (orientation === "right") return /* @__PURE__ */ jsx(ChevronRightIcon, {
					className: cn("size-4", className_1),
					...chevronProps
				});
				return /* @__PURE__ */ jsx(ChevronDownIcon, {
					className: cn("size-4", className_1),
					...chevronProps
				});
			},
			DayButton: ({ ...dayButtonProps }) => /* @__PURE__ */ jsx(CalendarDayButton, {
				locale,
				...dayButtonProps
			}),
			WeekNumber: ({ children, ...weekNumberProps }) => /* @__PURE__ */ jsx("td", {
				...weekNumberProps,
				children: /* @__PURE__ */ jsx("div", {
					className: "flex size-(--cell-size) items-center justify-center text-center",
					children
				})
			}),
			...components
		},
		...props
	});
}
function CalendarDayButton(t0) {
	const $ = c(22);
	if ($[0] !== "34ffd83236a597e71a0b90f940204b31836edeafe3a066071a468ba39cf3c037") {
		for (let $i = 0; $i < 22; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "34ffd83236a597e71a0b90f940204b31836edeafe3a066071a468ba39cf3c037";
	}
	let className;
	let day;
	let locale;
	let modifiers;
	let props;
	if ($[1] !== t0) {
		({className, day, modifiers, locale, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = day;
		$[4] = locale;
		$[5] = modifiers;
		$[6] = props;
	} else {
		className = $[2];
		day = $[3];
		locale = $[4];
		modifiers = $[5];
		props = $[6];
	}
	const defaultClassNames = getDefaultClassNames();
	const ref = React.useRef(null);
	let t1;
	let t2;
	if ($[7] !== modifiers.focused) {
		t1 = () => {
			if (modifiers.focused) ref.current?.focus();
		};
		t2 = [modifiers.focused];
		$[7] = modifiers.focused;
		$[8] = t1;
		$[9] = t2;
	} else {
		t1 = $[8];
		t2 = $[9];
	}
	React.useEffect(t1, t2);
	const T0 = Button;
	const t3 = "ghost";
	const t4 = "icon";
	let t5;
	if ($[10] !== day.date || $[11] !== locale?.code) {
		t5 = day.date.toLocaleDateString(locale?.code);
		$[10] = day.date;
		$[11] = locale?.code;
		$[12] = t5;
	} else t5 = $[12];
	const t6 = modifiers.selected && !modifiers.range_start && !modifiers.range_end && !modifiers.range_middle;
	const t7 = modifiers.range_start;
	const t8 = modifiers.range_end;
	const t9 = modifiers.range_middle;
	const t10 = cn("relative isolate z-10 flex aspect-square size-auto w-full min-w-(--cell-size) flex-col gap-1 border-0 leading-none font-normal group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-[3px] group-data-[focused=true]/day:ring-ring/50 data-[range-end=true]:rounded-(--cell-radius) data-[range-end=true]:rounded-r-(--cell-radius) data-[range-end=true]:bg-primary data-[range-end=true]:text-primary-foreground data-[range-middle=true]:rounded-none data-[range-middle=true]:bg-muted data-[range-middle=true]:text-foreground data-[range-start=true]:rounded-(--cell-radius) data-[range-start=true]:rounded-l-(--cell-radius) data-[range-start=true]:bg-primary data-[range-start=true]:text-primary-foreground data-[selected-single=true]:bg-primary data-[selected-single=true]:text-primary-foreground dark:hover:text-foreground [&>span]:text-xs [&>span]:opacity-70", defaultClassNames.day, className);
	let t11;
	if ($[13] !== T0 || $[14] !== modifiers.range_end || $[15] !== modifiers.range_middle || $[16] !== modifiers.range_start || $[17] !== props || $[18] !== t10 || $[19] !== t5 || $[20] !== t6) {
		t11 = /* @__PURE__ */ jsx(T0, {
			ref,
			variant: t3,
			size: t4,
			"data-day": t5,
			"data-selected-single": t6,
			"data-range-start": t7,
			"data-range-end": t8,
			"data-range-middle": t9,
			className: t10,
			...props
		});
		$[13] = T0;
		$[14] = modifiers.range_end;
		$[15] = modifiers.range_middle;
		$[16] = modifiers.range_start;
		$[17] = props;
		$[18] = t10;
		$[19] = t5;
		$[20] = t6;
		$[21] = t11;
	} else t11 = $[21];
	return t11;
}
//#endregion
//#region src/components/ui/date-input.tsx
/**
* A single-date picker: a trigger button showing the selected date, opening a
* `Popover` with a `Calendar` in single-select mode. Closes automatically once
* a date is picked.
*
* Import path: `@design-system/components/ui/date-input`.
*/
function DateInput({ value, onValueChange, placeholder = "Pick a date", formatDate = (date) => format(date, "PPP"), disabledDates, defaultMonth, disabled, open, onOpenChange, id, className, ...props }) {
	const [internalOpen, setInternalOpen] = React.useState(false);
	const isOpen = open ?? internalOpen;
	function setOpen(next) {
		setInternalOpen(next);
		onOpenChange?.(next);
	}
	return /* @__PURE__ */ jsxs(Popover, {
		open: isOpen,
		onOpenChange: setOpen,
		children: [/* @__PURE__ */ jsxs(PopoverTrigger, {
			render: /* @__PURE__ */ jsx(Button, {
				variant: "outline",
				id,
				disabled,
				className: cn("justify-start px-2.5 font-normal", className),
				...props
			}),
			children: [/* @__PURE__ */ jsx(CalendarIcon, { "data-icon": "inline-start" }), value ? formatDate(value) : /* @__PURE__ */ jsx("span", {
				className: "text-muted-foreground",
				children: placeholder
			})]
		}), /* @__PURE__ */ jsx(PopoverContent, {
			className: "w-auto p-0",
			align: "start",
			children: /* @__PURE__ */ jsx(Calendar, {
				mode: "single",
				selected: value,
				defaultMonth: value ?? defaultMonth,
				disabled: disabledDates,
				onSelect: (date_0) => {
					onValueChange?.(date_0);
					setOpen(false);
				}
			})
		})]
	});
}
//#endregion
//#region src/components/ui/date-range-input.tsx
function renderRangeLabel(from, to, formatDate) {
	if (!to) return formatDate(from);
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		formatDate(from),
		" - ",
		formatDate(to)
	] });
}
/**
* A date-range picker: a trigger button showing the selected `from`–`to`
* range, opening a `Popover` with a `Calendar` in range-select mode. Closes
* automatically once both ends of the range are picked.
*
* Import path: `@design-system/components/ui/date-range-input`.
*/
function DateRangeInput({ value, onValueChange, placeholder = "Pick a date range", formatDate = (date) => format(date, "LLL dd, y"), disabledDates, disabled, numberOfMonths = 2, defaultMonth, open, onOpenChange, id, className, ...props }) {
	const [internalOpen, setInternalOpen] = React.useState(false);
	const isOpen = open ?? internalOpen;
	function setOpen(next) {
		setInternalOpen(next);
		onOpenChange?.(next);
	}
	return /* @__PURE__ */ jsxs(Popover, {
		open: isOpen,
		onOpenChange: setOpen,
		children: [/* @__PURE__ */ jsxs(PopoverTrigger, {
			render: /* @__PURE__ */ jsx(Button, {
				variant: "outline",
				id,
				disabled,
				className: cn("justify-start px-2.5 font-normal", className),
				...props
			}),
			children: [/* @__PURE__ */ jsx(CalendarIcon, { "data-icon": "inline-start" }), value?.from ? renderRangeLabel(value.from, value.to, formatDate) : /* @__PURE__ */ jsx("span", {
				className: "text-muted-foreground",
				children: placeholder
			})]
		}), /* @__PURE__ */ jsx(PopoverContent, {
			className: "w-auto p-0",
			align: "start",
			children: /* @__PURE__ */ jsx(Calendar, {
				mode: "range",
				min: 1,
				resetOnSelect: true,
				selected: value,
				defaultMonth: value?.from ?? defaultMonth,
				numberOfMonths,
				disabled: disabledDates,
				onSelect: (range) => {
					onValueChange?.(range);
					if (range?.from && range?.to) setOpen(false);
				}
			})
		})]
	});
}
//#endregion
//#region src/components/ui/card.tsx
/**
* A surface container that groups related content. Compose it from the slot
* parts: `CardHeader` (with `CardTitle` / `CardDescription` / `CardAction`),
* `CardContent`, and `CardFooter`. Neutral by design — it has no variants.
*
* Import path: `@design-system/components/ui/card`.
*/
function Card(t0) {
	const $ = c(9);
	if ($[0] !== "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex flex-col gap-6 rounded-xl border bg-card py-6 text-card-foreground shadow-sm", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "card",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function CardHeader(t0) {
	const $ = c(9);
	if ($[0] !== "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto]", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "card-header",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function CardTitle(t0) {
	const $ = c(9);
	if ($[0] !== "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("font-semibold leading-none", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "card-title",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function CardDescription(t0) {
	const $ = c(9);
	if ($[0] !== "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("text-sm text-muted-foreground", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "card-description",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function CardAction(t0) {
	const $ = c(9);
	if ($[0] !== "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("col-start-2 row-span-2 row-start-1 self-start justify-self-end", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "card-action",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function CardContent(t0) {
	const $ = c(9);
	if ($[0] !== "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("px-6", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "card-content",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function CardFooter(t0) {
	const $ = c(9);
	if ($[0] !== "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "e27ca9188f2dbb0ebd8ed28ecfb88ed82ecb673f446715900d69aeeebad6c812";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex items-center px-6", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "card-footer",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/ui/settings-card.tsx
/**
* A Settings section surface with a named header and divided rows.
* Compose it with SettingsCardRow and SettingsCardFooter.
*/
function SettingsCard(t0) {
	const $ = c(24);
	if ($[0] !== "45dc9a38fad36b7432808848266c36df8f5374ec8add5cba843167aaa3b60c08") {
		for (let $i = 0; $i < 24; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "45dc9a38fad36b7432808848266c36df8f5374ec8add5cba843167aaa3b60c08";
	}
	let action;
	let ariaLabelledBy;
	let children;
	let className;
	let props;
	let title;
	if ($[1] !== t0) {
		({title, action, className, children, "aria-labelledby": ariaLabelledBy, ...props} = t0);
		$[1] = t0;
		$[2] = action;
		$[3] = ariaLabelledBy;
		$[4] = children;
		$[5] = className;
		$[6] = props;
		$[7] = title;
	} else {
		action = $[2];
		ariaLabelledBy = $[3];
		children = $[4];
		className = $[5];
		props = $[6];
		title = $[7];
	}
	const titleId = useId();
	const t1 = ariaLabelledBy ?? titleId;
	let t2;
	if ($[8] !== className) {
		t2 = cn("gap-0 overflow-hidden rounded-xl border-border bg-card py-0 text-card-foreground shadow-none", className);
		$[8] = className;
		$[9] = t2;
	} else t2 = $[9];
	let t3;
	if ($[10] !== title || $[11] !== titleId) {
		t3 = /* @__PURE__ */ jsx("h2", {
			id: titleId,
			"data-slot": "settings-card-title",
			className: "text-sm font-bold tracking-[0.12em] text-gx-muted uppercase",
			children: title
		});
		$[10] = title;
		$[11] = titleId;
		$[12] = t3;
	} else t3 = $[12];
	let t4;
	if ($[13] !== action) {
		t4 = action ? /* @__PURE__ */ jsx("div", {
			"data-slot": "settings-card-action",
			className: "ml-auto shrink-0",
			children: action
		}) : null;
		$[13] = action;
		$[14] = t4;
	} else t4 = $[14];
	let t5;
	if ($[15] !== t3 || $[16] !== t4) {
		t5 = /* @__PURE__ */ jsxs("div", {
			"data-slot": "settings-card-header",
			className: "flex min-h-16 flex-wrap items-center justify-between gap-3 px-6 py-4",
			children: [t3, t4]
		});
		$[15] = t3;
		$[16] = t4;
		$[17] = t5;
	} else t5 = $[17];
	let t6;
	if ($[18] !== children || $[19] !== props || $[20] !== t1 || $[21] !== t2 || $[22] !== t5) {
		t6 = /* @__PURE__ */ jsxs(Card, {
			...props,
			role: "region",
			"aria-labelledby": t1,
			"data-slot": "settings-card",
			className: t2,
			children: [t5, children]
		});
		$[18] = children;
		$[19] = props;
		$[20] = t1;
		$[21] = t2;
		$[22] = t5;
		$[23] = t6;
	} else t6 = $[23];
	return t6;
}
function SettingsCardRow(t0) {
	const $ = c(22);
	if ($[0] !== "45dc9a38fad36b7432808848266c36df8f5374ec8add5cba843167aaa3b60c08") {
		for (let $i = 0; $i < 22; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "45dc9a38fad36b7432808848266c36df8f5374ec8add5cba843167aaa3b60c08";
	}
	let children;
	let className;
	let label;
	let labelFor;
	let props;
	if ($[1] !== t0) {
		({label, labelFor, className, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = label;
		$[5] = labelFor;
		$[6] = props;
	} else {
		children = $[2];
		className = $[3];
		label = $[4];
		labelFor = $[5];
		props = $[6];
	}
	let labelNode = null;
	if (label && labelFor) {
		let t1;
		if ($[7] !== label || $[8] !== labelFor) {
			t1 = /* @__PURE__ */ jsx("label", {
				htmlFor: labelFor,
				"data-slot": "settings-card-row-label",
				className: "text-sm font-semibold tracking-[0.04em] text-gx-muted uppercase",
				children: label
			});
			$[7] = label;
			$[8] = labelFor;
			$[9] = t1;
		} else t1 = $[9];
		labelNode = t1;
	} else if (label) {
		let t1;
		if ($[10] !== label) {
			t1 = /* @__PURE__ */ jsx("div", {
				"data-slot": "settings-card-row-label",
				className: "text-sm font-semibold tracking-[0.04em] text-gx-muted uppercase",
				children: label
			});
			$[10] = label;
			$[11] = t1;
		} else t1 = $[11];
		labelNode = t1;
	}
	const t1 = label ? "md:grid-cols-[11rem_minmax(0,1fr)] md:items-center" : void 0;
	let t2;
	if ($[12] !== className || $[13] !== t1) {
		t2 = cn("grid min-h-16 gap-3 border-t border-border px-6 py-4", t1, className);
		$[12] = className;
		$[13] = t1;
		$[14] = t2;
	} else t2 = $[14];
	let t3;
	if ($[15] !== children) {
		t3 = /* @__PURE__ */ jsx("div", {
			"data-slot": "settings-card-row-content",
			className: "min-w-0 text-sm text-foreground",
			children
		});
		$[15] = children;
		$[16] = t3;
	} else t3 = $[16];
	let t4;
	if ($[17] !== labelNode || $[18] !== props || $[19] !== t2 || $[20] !== t3) {
		t4 = /* @__PURE__ */ jsxs("div", {
			...props,
			"data-slot": "settings-card-row",
			className: t2,
			children: [labelNode, t3]
		});
		$[17] = labelNode;
		$[18] = props;
		$[19] = t2;
		$[20] = t3;
		$[21] = t4;
	} else t4 = $[21];
	return t4;
}
function SettingsCardFooter(t0) {
	const $ = c(13);
	if ($[0] !== "45dc9a38fad36b7432808848266c36df8f5374ec8add5cba843167aaa3b60c08") {
		for (let $i = 0; $i < 13; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "45dc9a38fad36b7432808848266c36df8f5374ec8add5cba843167aaa3b60c08";
	}
	let children;
	let className;
	let props;
	if ($[1] !== t0) {
		({className, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
	}
	let t1;
	if ($[5] !== className) {
		t1 = cn("grid min-h-16 gap-3 border-t border-border px-6 py-4 md:grid-cols-[11rem_minmax(0,1fr)] md:items-center", className);
		$[5] = className;
		$[6] = t1;
	} else t1 = $[6];
	let t2;
	if ($[7] !== children) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "settings-card-footer-content",
			className: "min-w-0 md:col-start-2",
			children
		});
		$[7] = children;
		$[8] = t2;
	} else t2 = $[8];
	let t3;
	if ($[9] !== props || $[10] !== t1 || $[11] !== t2) {
		t3 = /* @__PURE__ */ jsx("div", {
			...props,
			"data-slot": "settings-card-footer",
			className: t1,
			children: t2
		});
		$[9] = props;
		$[10] = t1;
		$[11] = t2;
		$[12] = t3;
	} else t3 = $[12];
	return t3;
}
//#endregion
//#region src/hooks/use-filter-options-with-counts.ts
function tallyValues(rows, columnId, splitValue) {
	const counts = /* @__PURE__ */ new Map();
	for (const row of rows) {
		const raw = row.getValue(columnId);
		if (raw === void 0 || raw === null || raw === "") continue;
		if (typeof raw !== "string" && typeof raw !== "number" && typeof raw !== "boolean") continue;
		const stringValue = typeof raw === "string" ? raw : String(raw);
		const values = splitValue ? splitValue(stringValue) : [stringValue];
		for (const value of values) counts.set(value, (counts.get(value) ?? 0) + 1);
	}
	return counts;
}
/**
* Derives `{ label, value, count }[]` filter options per column, ready to
* feed `DataTableFilterPanel`/`DataTableFilterMenu`'s `groups` prop.
*
* The option set and its order come from the table's *pre-filtered* rows
* (`table.getPreFilteredRowModel()`), never the live-filtered rows, so
* options never appear, disappear, or reorder as filters (in this column or
* any other) are toggled. Only each option's `count` reacts to filtering,
* sourced from that column's faceted rows (`column.getFacetedRowModel()`)
* rather than `getFacetedUniqueValues()`, which can't split multi-value
* strings.
*
* Import path: `@design-system/hooks/use-filter-options-with-counts`.
*/
function useFilterOptionsWithCounts(table, columns) {
	const $ = c(7);
	if ($[0] !== "8b559f31bb21d90e76444ba0f802772f9f7be1e31443c739aefcf16e892fdb62") {
		for (let $i = 0; $i < 7; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "8b559f31bb21d90e76444ba0f802772f9f7be1e31443c739aefcf16e892fdb62";
	}
	let t0;
	if ($[1] !== table) {
		t0 = table.getPreFilteredRowModel();
		$[1] = table;
		$[2] = t0;
	} else t0 = $[2];
	const allRows = t0.rows;
	let result;
	if ($[3] !== allRows || $[4] !== columns || $[5] !== table) {
		result = {};
		for (const { columnId, splitValue } of columns) {
			const column = table.getColumn(columnId);
			const globalCounts = tallyValues(allRows, columnId, splitValue);
			const facetCounts = tallyValues(column?.getFacetedRowModel().rows ?? allRows, columnId, splitValue);
			result[columnId] = Array.from(globalCounts.keys()).map((value) => ({
				label: value,
				value,
				count: facetCounts.get(value) ?? 0
			}));
		}
		$[3] = allRows;
		$[4] = columns;
		$[5] = table;
		$[6] = result;
	} else result = $[6];
	return result;
}
//#endregion
//#region src/hooks/use-frozen-selection-snapshot.ts
/**
* Freezes `selectedIds` into a stable snapshot the instant `showSelectedOnly`
* flips on, and holds that snapshot steady — ignoring further selection
* changes — until it's toggled back off, at which point the next "on" takes
* a fresh snapshot. Pair with `DataTableShowSelectedToggle`. This hook only
* tracks which ids are frozen; it never touches the table's row model
* directly. Consumers resolve `frozenIds` to rows themselves — filter
* `table.getRowModel().flatRows` (not `.rows`), so a frozen row stays
* resolvable even if it's a sub-row whose parent group later collapses.
*
* Import path: `@design-system/hooks/use-frozen-selection-snapshot`.
*/
function useFrozenSelectionSnapshot(selectedIds) {
	const [showSelectedOnly, setShowSelectedOnly] = useState(false);
	const frozenIdsRef = useRef([]);
	const wasShowingSelectedOnlyRef = useRef(false);
	if (showSelectedOnly && !wasShowingSelectedOnlyRef.current) frozenIdsRef.current = selectedIds;
	wasShowingSelectedOnlyRef.current = showSelectedOnly;
	return {
		showSelectedOnly,
		setShowSelectedOnly,
		frozenIds: frozenIdsRef.current
	};
}
//#endregion
//#region src/hooks/use-managed-timeout.ts
/** Manages one replaceable timeout and cancels it automatically on unmount. */
function useManagedTimeout() {
	const $ = c(6);
	if ($[0] !== "b3611f0a40d8fea35ee79eb9d031eb9f296c0286aa98174c236301e98e5ff988") {
		for (let $i = 0; $i < 6; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "b3611f0a40d8fea35ee79eb9d031eb9f296c0286aa98174c236301e98e5ff988";
	}
	const timeoutRef = useRef(null);
	let t0;
	if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
		t0 = () => {
			if (timeoutRef.current === null) return;
			clearTimeout(timeoutRef.current);
			timeoutRef.current = null;
		};
		$[1] = t0;
	} else t0 = $[1];
	const cancel = t0;
	let t1;
	if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = (callback, delay) => {
			cancel();
			timeoutRef.current = setTimeout(() => {
				timeoutRef.current = null;
				callback();
			}, delay);
		};
		$[2] = t1;
	} else t1 = $[2];
	const schedule = t1;
	let t2;
	let t3;
	if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = () => cancel;
		t3 = [cancel];
		$[3] = t2;
		$[4] = t3;
	} else {
		t2 = $[3];
		t3 = $[4];
	}
	useEffect(t2, t3);
	let t4;
	if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
		t4 = {
			cancel,
			schedule
		};
		$[5] = t4;
	} else t4 = $[5];
	return t4;
}
//#endregion
//#region src/hooks/use-progressive-reveal.ts
/**
* Slice-and-reveal for a side-loaded list (e.g. a `DataTableDetailPanel`'s
* children) that's too long to show in full up front: only `initialCount`
* items render until `revealAll` is called, then every item stays visible —
* there's no "show less" back path, matching the "+N more" pattern this
* mirrors.
*
* Import path: `@design-system/hooks/use-progressive-reveal`.
*/
function useProgressiveReveal(items, t0) {
	const $ = c(10);
	if ($[0] !== "c75712bdee3926ff8aa3f8ab5e5b4ff58fb5756e74572f21ee6c7f3cc101e9c8") {
		for (let $i = 0; $i < 10; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c75712bdee3926ff8aa3f8ab5e5b4ff58fb5756e74572f21ee6c7f3cc101e9c8";
	}
	const { initialCount } = t0;
	const [showAll, setShowAll] = useState(false);
	let t1;
	if ($[1] !== initialCount || $[2] !== items || $[3] !== showAll) {
		t1 = showAll ? items : items.slice(0, initialCount);
		$[1] = initialCount;
		$[2] = items;
		$[3] = showAll;
		$[4] = t1;
	} else t1 = $[4];
	const visibleItems = t1;
	const remaining = Math.max(0, items.length - visibleItems.length);
	let t2;
	if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = () => setShowAll(true);
		$[5] = t2;
	} else t2 = $[5];
	let t3;
	if ($[6] !== remaining || $[7] !== showAll || $[8] !== visibleItems) {
		t3 = {
			visibleItems,
			remaining,
			showAll,
			revealAll: t2
		};
		$[6] = remaining;
		$[7] = showAll;
		$[8] = visibleItems;
		$[9] = t3;
	} else t3 = $[9];
	return t3;
}
//#endregion
//#region src/hooks/use-url-synced-table-state.ts
const SORT_SEARCH_PARAM = "sort";
function parseSorting(searchParams) {
	const raw = searchParams.get(SORT_SEARCH_PARAM);
	if (!raw) return [];
	const separatorIndex = raw.lastIndexOf(":");
	if (separatorIndex === -1) return [];
	return [{
		id: raw.slice(0, separatorIndex),
		desc: raw.slice(separatorIndex + 1) === "desc"
	}];
}
function applySortingToParams(params, sorting) {
	const next = new URLSearchParams(params);
	const [sort] = sorting;
	if (sort) next.set(SORT_SEARCH_PARAM, `${sort.id}:${sort.desc ? "desc" : "asc"}`);
	else next.delete(SORT_SEARCH_PARAM);
	return next;
}
function parseColumnFilters(searchParams, filterableColumnIds) {
	return filterableColumnIds.map((id) => ({
		id,
		value: searchParams.getAll(id)
	})).filter((filter) => filter.value.length > 0);
}
function applyColumnFiltersToParams(params, columnFilters, filterableColumnIds) {
	const next = new URLSearchParams(params);
	for (const id of filterableColumnIds) next.delete(id);
	for (const filter of columnFilters) {
		const values = Array.isArray(filter.value) ? filter.value : [String(filter.value)];
		for (const value of values) next.append(filter.id, value);
	}
	return next;
}
/**
* Router-agnostic replacement for the two `useState` pairs `useDataTable`
* owns internally for `sorting`/`columnFilters`. Takes the current
* `URLSearchParams` and a setter as props — wire those to `react-router`'s
* `useSearchParams`, another router, or plain `window.history`/
* `URLSearchParams` — rather than importing a router hook here, since
* `packages/design-system` has no router dependency.
*
* Serializes `SortingState` as a single `?sort=columnId:asc|desc` param (only
* the first sort entry is persisted) and `ColumnFiltersState` as one
* multi-value param per filtered column id, always restored as a `string[]`.
* That's compatible with every filter fn in this toolkit, including
* `fuzzyIds` (`filterFn_fuzzyIds` accepts a plain array as well as the
* `Set<string>` `DataTableSearchInput` normally produces) — restoring a
* fuzzy-search column's filter from a URL re-filters by that literal id list
* rather than re-running the fuzzy search itself.
*
* Import path: `@design-system/hooks/use-url-synced-table-state`.
*/
function useUrlSyncedTableState(t0) {
	const $ = c(24);
	if ($[0] !== "b77ada37e366736bdc4fa2aeb64438437aff5e2751c5b3e020eb9b10719cc36b") {
		for (let $i = 0; $i < 24; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "b77ada37e366736bdc4fa2aeb64438437aff5e2751c5b3e020eb9b10719cc36b";
	}
	const { searchParams, setSearchParams, filterableColumnIds, disableSearchParams: t1 } = t0;
	const disableSearchParams = t1 === void 0 ? false : t1;
	let t2;
	if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = [];
		$[1] = t2;
	} else t2 = $[1];
	const [localSorting, setLocalSorting] = useState(t2);
	let t3;
	if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
		t3 = [];
		$[2] = t3;
	} else t3 = $[2];
	const [localColumnFilters, setLocalColumnFilters] = useState(t3);
	let t4;
	if ($[3] !== disableSearchParams || $[4] !== localSorting || $[5] !== searchParams) {
		t4 = disableSearchParams ? localSorting : parseSorting(searchParams);
		$[3] = disableSearchParams;
		$[4] = localSorting;
		$[5] = searchParams;
		$[6] = t4;
	} else t4 = $[6];
	const sorting = t4;
	let t5;
	if ($[7] !== disableSearchParams || $[8] !== filterableColumnIds || $[9] !== localColumnFilters || $[10] !== searchParams) {
		t5 = disableSearchParams ? localColumnFilters : parseColumnFilters(searchParams, filterableColumnIds);
		$[7] = disableSearchParams;
		$[8] = filterableColumnIds;
		$[9] = localColumnFilters;
		$[10] = searchParams;
		$[11] = t5;
	} else t5 = $[11];
	const columnFilters = t5;
	let t6;
	if ($[12] !== disableSearchParams || $[13] !== setSearchParams) {
		t6 = (updater) => {
			if (disableSearchParams) {
				setLocalSorting((prev) => functionalUpdate(updater, prev));
				return;
			}
			setSearchParams((prev_0) => applySortingToParams(prev_0, functionalUpdate(updater, parseSorting(prev_0))));
		};
		$[12] = disableSearchParams;
		$[13] = setSearchParams;
		$[14] = t6;
	} else t6 = $[14];
	const onSortingChange = t6;
	let t7;
	if ($[15] !== disableSearchParams || $[16] !== filterableColumnIds || $[17] !== setSearchParams) {
		t7 = (updater_0) => {
			if (disableSearchParams) {
				setLocalColumnFilters((prev_1) => functionalUpdate(updater_0, prev_1));
				return;
			}
			setSearchParams((prev_2) => {
				return applyColumnFiltersToParams(prev_2, functionalUpdate(updater_0, parseColumnFilters(prev_2, filterableColumnIds)), filterableColumnIds);
			});
		};
		$[15] = disableSearchParams;
		$[16] = filterableColumnIds;
		$[17] = setSearchParams;
		$[18] = t7;
	} else t7 = $[18];
	const onColumnFiltersChange = t7;
	let t8;
	if ($[19] !== columnFilters || $[20] !== onColumnFiltersChange || $[21] !== onSortingChange || $[22] !== sorting) {
		t8 = {
			sorting,
			onSortingChange,
			columnFilters,
			onColumnFiltersChange
		};
		$[19] = columnFilters;
		$[20] = onColumnFiltersChange;
		$[21] = onSortingChange;
		$[22] = sorting;
		$[23] = t8;
	} else t8 = $[23];
	return t8;
}
//#endregion
//#region src/components/ui/button-group.tsx
const buttonGroupVariants = cva("flex w-fit items-stretch *:focus-visible:relative *:focus-visible:z-10 has-[>[data-slot=button-group]]:gap-2 has-[select[aria-hidden=true]:last-child]:[&>[data-slot=select-trigger]:last-of-type]:rounded-r-lg [&>[data-slot=select-trigger]:not([class*='w-'])]:w-fit [&>input]:flex-1", {
	variants: { orientation: {
		horizontal: "*:data-slot:rounded-r-none [&>[data-slot]:not(:has(~[data-slot]))]:rounded-r-lg! [&>[data-slot]~[data-slot]]:rounded-l-none [&>[data-slot]~[data-slot]]:border-l-0",
		vertical: "flex-col *:data-slot:rounded-b-none [&>[data-slot]:not(:has(~[data-slot]))]:rounded-b-lg! [&>[data-slot]~[data-slot]]:rounded-t-none [&>[data-slot]~[data-slot]]:border-t-0"
	} },
	defaultVariants: { orientation: "horizontal" }
});
function ButtonGroup(t0) {
	const $ = c(12);
	if ($[0] !== "9ee104a365f71d3c987c7b48cbb4b4b3c05d8fc66b2cf7baa186e34daf10ec42") {
		for (let $i = 0; $i < 12; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "9ee104a365f71d3c987c7b48cbb4b4b3c05d8fc66b2cf7baa186e34daf10ec42";
	}
	let className;
	let orientation;
	let props;
	if ($[1] !== t0) {
		({className, orientation, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = orientation;
		$[4] = props;
	} else {
		className = $[2];
		orientation = $[3];
		props = $[4];
	}
	let t1;
	if ($[5] !== className || $[6] !== orientation) {
		t1 = cn(buttonGroupVariants({ orientation }), className);
		$[5] = className;
		$[6] = orientation;
		$[7] = t1;
	} else t1 = $[7];
	let t2;
	if ($[8] !== orientation || $[9] !== props || $[10] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			role: "group",
			"data-slot": "button-group",
			"data-orientation": orientation,
			className: t1,
			...props
		});
		$[8] = orientation;
		$[9] = props;
		$[10] = t1;
		$[11] = t2;
	} else t2 = $[11];
	return t2;
}
//#endregion
//#region src/components/ui/highlighted-price.tsx
const deltaVariants = cva("flex items-center gap-1 text-xs font-bold leading-none tabular-nums", {
	variants: { trend: {
		up: "text-gx-success",
		down: "text-gx-failure-light",
		neutral: "text-gx-text-secondary"
	} },
	defaultVariants: { trend: "neutral" }
});
/**
* A compact, presentational price tile: instrument code + title, a large price,
* a colored up/down delta, and an optional sparkline. Purely presentational —
* it renders exactly what it is given and contains no formatting or direction
* logic; the caller decides the values, the trend, and the chart element.
*
* Import path: `@design-system/components/ui/highlighted-price`.
*/
function HighlightedPrice(t0) {
	const $ = c(40);
	if ($[0] !== "3e391ff9603f10bc49600db6a4abc0c55169f72b81c1cb601100f644a8569826") {
		for (let $i = 0; $i < 40; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "3e391ff9603f10bc49600db6a4abc0c55169f72b81c1cb601100f644a8569826";
	}
	let chart;
	let className;
	let code;
	let delta;
	let price;
	let props;
	let t1;
	let title;
	if ($[1] !== t0) {
		({className, code, title, price, delta, trend: t1, chart, ...props} = t0);
		$[1] = t0;
		$[2] = chart;
		$[3] = className;
		$[4] = code;
		$[5] = delta;
		$[6] = price;
		$[7] = props;
		$[8] = t1;
		$[9] = title;
	} else {
		chart = $[2];
		className = $[3];
		code = $[4];
		delta = $[5];
		price = $[6];
		props = $[7];
		t1 = $[8];
		title = $[9];
	}
	const trend = t1 === void 0 ? "neutral" : t1;
	let t2;
	if ($[10] !== className) {
		t2 = cn("relative gap-0 rounded-[10px] border-white/10 bg-gx-tile-dark px-3.5 py-3 text-gx-text shadow-none", className);
		$[10] = className;
		$[11] = t2;
	} else t2 = $[11];
	let t3;
	if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
		t3 = cn("text-[11px] tracking-[0.06em] text-gx-text-disabled");
		$[12] = t3;
	} else t3 = $[12];
	let t4;
	if ($[13] !== code) {
		t4 = /* @__PURE__ */ jsx("span", {
			"data-slot": "highlighted-price-code",
			className: t3,
			children: code
		});
		$[13] = code;
		$[14] = t4;
	} else t4 = $[14];
	let t5;
	if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
		t5 = cn("mt-0.5 mb-2 min-h-[34px] text-[13px] font-bold leading-[1.3]");
		$[15] = t5;
	} else t5 = $[15];
	let t6;
	if ($[16] !== title) {
		t6 = /* @__PURE__ */ jsx("span", {
			"data-slot": "highlighted-price-title",
			className: t5,
			children: title
		});
		$[16] = title;
		$[17] = t6;
	} else t6 = $[17];
	let t7;
	if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
		t7 = cn("text-[19px] font-extrabold leading-tight tabular-nums");
		$[18] = t7;
	} else t7 = $[18];
	let t8;
	if ($[19] !== price) {
		t8 = /* @__PURE__ */ jsx("span", {
			"data-slot": "highlighted-price-value",
			className: t7,
			children: price
		});
		$[19] = price;
		$[20] = t8;
	} else t8 = $[20];
	let t9;
	if ($[21] !== trend) {
		t9 = cn(deltaVariants({ trend }));
		$[21] = trend;
		$[22] = t9;
	} else t9 = $[22];
	let t10;
	if ($[23] !== trend) {
		t10 = trend !== "neutral" ? /* @__PURE__ */ jsx(TriangleIcon, {
			className: cn("size-2.5 fill-current", trend === "down" && "rotate-180"),
			"aria-hidden": true
		}) : null;
		$[23] = trend;
		$[24] = t10;
	} else t10 = $[24];
	let t11;
	if ($[25] !== delta || $[26] !== t10 || $[27] !== t9) {
		t11 = /* @__PURE__ */ jsxs("span", {
			"data-slot": "highlighted-price-delta",
			className: t9,
			children: [t10, delta]
		});
		$[25] = delta;
		$[26] = t10;
		$[27] = t9;
		$[28] = t11;
	} else t11 = $[28];
	let t12;
	if ($[29] !== chart) {
		t12 = chart ? /* @__PURE__ */ jsx("div", {
			"data-slot": "highlighted-price-chart",
			className: "absolute right-3 bottom-3 opacity-60",
			children: chart
		}) : null;
		$[29] = chart;
		$[30] = t12;
	} else t12 = $[30];
	let t13;
	if ($[31] !== props || $[32] !== t11 || $[33] !== t12 || $[34] !== t2 || $[35] !== t4 || $[36] !== t6 || $[37] !== t8 || $[38] !== trend) {
		t13 = /* @__PURE__ */ jsxs(Card, {
			"data-slot": "highlighted-price",
			"data-trend": trend,
			className: t2,
			...props,
			children: [
				t4,
				t6,
				t8,
				t11,
				t12
			]
		});
		$[31] = props;
		$[32] = t11;
		$[33] = t12;
		$[34] = t2;
		$[35] = t4;
		$[36] = t6;
		$[37] = t8;
		$[38] = trend;
		$[39] = t13;
	} else t13 = $[39];
	return t13;
}
//#endregion
//#region src/components/ui/accent-card.tsx
const SIDE_STYLE = {
	top: (width, color) => ({
		borderTopWidth: width,
		borderTopColor: color
	}),
	right: (width, color) => ({
		borderRightWidth: width,
		borderRightColor: color
	}),
	bottom: (width, color) => ({
		borderBottomWidth: width,
		borderBottomColor: color
	}),
	left: (width, color) => ({
		borderLeftWidth: width,
		borderLeftColor: color
	})
};
/**
* A generic bordered surface shell: a rounded, shadowless hairline card that
* draws a colored accent along any specified edges and holds no content of its
* own. Built on `Card`, stripped of its decorative defaults and of internal
* padding — consumers own the spacing. Purely presentational.
*
* Import path: `@design-system/components/ui/accent-card`.
*/
function AccentCard(t0) {
	const $ = c(28);
	if ($[0] !== "ec4f650c171eb2166df5896e5ffac796bd2303a8e840c25825df0b43ff13a549") {
		for (let $i = 0; $i < 28; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "ec4f650c171eb2166df5896e5ffac796bd2303a8e840c25825df0b43ff13a549";
	}
	let className;
	let props;
	let style;
	let t1;
	let t2;
	let t3;
	if ($[1] !== t0) {
		({className, style, sides: t1, color: t2, accentWidth: t3, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = style;
		$[5] = t1;
		$[6] = t2;
		$[7] = t3;
	} else {
		className = $[2];
		props = $[3];
		style = $[4];
		t1 = $[5];
		t2 = $[6];
		t3 = $[7];
	}
	let sides;
	let t4;
	if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
		sides = t1 === void 0 ? ["left"] : t1;
		const color = t2 === void 0 ? "var(--gx-highlight)" : t2;
		const accentWidth = t3 === void 0 ? 4 : t3;
		let t5;
		if ($[13] !== accentWidth || $[14] !== color) {
			t5 = (acc, side) => ({
				...acc,
				...SIDE_STYLE[side](accentWidth, color)
			});
			$[13] = accentWidth;
			$[14] = color;
			$[15] = t5;
		} else t5 = $[15];
		t4 = sides.reduce(t5, {});
		$[8] = t1;
		$[9] = t2;
		$[10] = t3;
		$[11] = sides;
		$[12] = t4;
	} else {
		sides = $[11];
		t4 = $[12];
	}
	const accentStyle = t4;
	let t5;
	if ($[16] !== sides) {
		t5 = sides.join(" ");
		$[16] = sides;
		$[17] = t5;
	} else t5 = $[17];
	let t6;
	if ($[18] !== className) {
		t6 = cn("gap-0 overflow-hidden rounded-[10px] border-white/10 bg-gx-tile-dark py-0 text-gx-text shadow-none", className);
		$[18] = className;
		$[19] = t6;
	} else t6 = $[19];
	let t7;
	if ($[20] !== accentStyle || $[21] !== style) {
		t7 = {
			...accentStyle,
			...style
		};
		$[20] = accentStyle;
		$[21] = style;
		$[22] = t7;
	} else t7 = $[22];
	let t8;
	if ($[23] !== props || $[24] !== t5 || $[25] !== t6 || $[26] !== t7) {
		t8 = /* @__PURE__ */ jsx(Card, {
			"data-slot": "accent-card",
			"data-sides": t5,
			className: t6,
			style: t7,
			...props
		});
		$[23] = props;
		$[24] = t5;
		$[25] = t6;
		$[26] = t7;
		$[27] = t8;
	} else t8 = $[27];
	return t8;
}
//#endregion
//#region src/components/ui/intel-signal-card.tsx
/**
* The full intel signal layout: a 5px accent (a left spine by default; the GX
* Analyst window passes `sides={['top']}` for a top accent), a title row with
* an optional badge and right-aligned tag, a blurb, and a footer row with an
* optional timestamp and action. `selected` adds a violet outline. Purely
* presentational — it composes `AccentCard` and lays out the nodes it is given.
* For interactive use, the consumer must supply keyboard and role semantics
* (e.g. `role="button"`, `tabIndex`, an `onKeyDown` handler, and
* `aria-selected`/`aria-current` for selection) via props.
*
* Import path: `@design-system/components/ui/intel-signal-card`.
*/
function IntelSignalCard(t0) {
	const $ = c(40);
	if ($[0] !== "96a4b95219ccf95d5360e60d508a731e1826b7563917763fddc8daf05468e5a2") {
		for (let $i = 0; $i < 40; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "96a4b95219ccf95d5360e60d508a731e1826b7563917763fddc8daf05468e5a2";
	}
	let action;
	let badge;
	let children;
	let className;
	let color;
	let props;
	let selected;
	let sides;
	let tag;
	let timestamp;
	let title;
	if ($[1] !== t0) {
		({className, title, badge, tag, children, timestamp, action, selected, color, sides, ...props} = t0);
		$[1] = t0;
		$[2] = action;
		$[3] = badge;
		$[4] = children;
		$[5] = className;
		$[6] = color;
		$[7] = props;
		$[8] = selected;
		$[9] = sides;
		$[10] = tag;
		$[11] = timestamp;
		$[12] = title;
	} else {
		action = $[2];
		badge = $[3];
		children = $[4];
		className = $[5];
		color = $[6];
		props = $[7];
		selected = $[8];
		sides = $[9];
		tag = $[10];
		timestamp = $[11];
		title = $[12];
	}
	const t1 = selected ? "true" : void 0;
	const t2 = selected ? "border-[#8b7cf6]" : "hover:border-white/20";
	let t3;
	if ($[13] !== className || $[14] !== t2) {
		t3 = cn("cursor-pointer", t2, className);
		$[13] = className;
		$[14] = t2;
		$[15] = t3;
	} else t3 = $[15];
	let t4;
	if ($[16] !== title) {
		t4 = /* @__PURE__ */ jsx("span", {
			className: "text-[14.5px] font-extrabold",
			children: title
		});
		$[16] = title;
		$[17] = t4;
	} else t4 = $[17];
	let t5;
	if ($[18] !== tag) {
		t5 = tag ? /* @__PURE__ */ jsx("span", {
			className: "ml-auto",
			children: tag
		}) : null;
		$[18] = tag;
		$[19] = t5;
	} else t5 = $[19];
	let t6;
	if ($[20] !== badge || $[21] !== t4 || $[22] !== t5) {
		t6 = /* @__PURE__ */ jsxs("div", {
			className: "mb-[5px] flex flex-wrap items-center gap-x-1 gap-y-2.5",
			children: [
				t4,
				badge,
				t5
			]
		});
		$[20] = badge;
		$[21] = t4;
		$[22] = t5;
		$[23] = t6;
	} else t6 = $[23];
	let t7;
	if ($[24] !== children) {
		t7 = /* @__PURE__ */ jsx("div", {
			className: "mb-2.5 text-[13px] leading-[1.55] text-gx-text-secondary",
			children
		});
		$[24] = children;
		$[25] = t7;
	} else t7 = $[25];
	let t8;
	if ($[26] !== action || $[27] !== timestamp) {
		t8 = timestamp || action ? /* @__PURE__ */ jsxs("div", {
			className: "flex items-center gap-3.5",
			children: [timestamp ? /* @__PURE__ */ jsx("span", {
				className: "text-[11px] text-gx-text-secondary",
				children: timestamp
			}) : null, action ? /* @__PURE__ */ jsx("span", {
				className: "ml-auto",
				children: action
			}) : null]
		}) : null;
		$[26] = action;
		$[27] = timestamp;
		$[28] = t8;
	} else t8 = $[28];
	let t9;
	if ($[29] !== t6 || $[30] !== t7 || $[31] !== t8) {
		t9 = /* @__PURE__ */ jsxs("div", {
			className: "min-w-0 flex-1 py-3.5 pr-[18px] pl-[18px]",
			children: [
				t6,
				t7,
				t8
			]
		});
		$[29] = t6;
		$[30] = t7;
		$[31] = t8;
		$[32] = t9;
	} else t9 = $[32];
	let t10;
	if ($[33] !== color || $[34] !== props || $[35] !== sides || $[36] !== t1 || $[37] !== t3 || $[38] !== t9) {
		t10 = /* @__PURE__ */ jsx(AccentCard, {
			"data-slot": "intel-signal-card",
			"data-selected": t1,
			color,
			sides,
			accentWidth: 5,
			className: t3,
			...props,
			children: t9
		});
		$[33] = color;
		$[34] = props;
		$[35] = sides;
		$[36] = t1;
		$[37] = t3;
		$[38] = t9;
		$[39] = t10;
	} else t10 = $[39];
	return t10;
}
//#endregion
//#region src/components/ui/intel-signal-card-compact.tsx
/**
* The compact analyst-window intel layout: a left spine and a title, nothing
* else. `selected` adds a violet outline. Purely presentational — it composes
* `AccentCard`. For interactive use, the consumer must supply keyboard and
* role semantics (e.g. `role="button"`, `tabIndex`, an `onKeyDown` handler,
* and `aria-selected`/`aria-current` for selection) via props.
*
* Import path: `@design-system/components/ui/intel-signal-card-compact`.
*/
function IntelSignalCardCompact(t0) {
	const $ = c(18);
	if ($[0] !== "72988e304e97082b6a0ccca89437023caefbefcdd7090fcffb0051765510d738") {
		for (let $i = 0; $i < 18; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "72988e304e97082b6a0ccca89437023caefbefcdd7090fcffb0051765510d738";
	}
	let className;
	let color;
	let props;
	let selected;
	let title;
	if ($[1] !== t0) {
		({className, title, selected, color, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = color;
		$[4] = props;
		$[5] = selected;
		$[6] = title;
	} else {
		className = $[2];
		color = $[3];
		props = $[4];
		selected = $[5];
		title = $[6];
	}
	const t1 = selected ? "true" : void 0;
	const t2 = selected ? "border-[#8b7cf6]" : "hover:border-white/20";
	let t3;
	if ($[7] !== className || $[8] !== t2) {
		t3 = cn("cursor-pointer", t2, className);
		$[7] = className;
		$[8] = t2;
		$[9] = t3;
	} else t3 = $[9];
	let t4;
	if ($[10] !== title) {
		t4 = /* @__PURE__ */ jsx("div", {
			className: "min-w-0 flex-1 px-2.5 py-[9px]",
			children: /* @__PURE__ */ jsx("span", {
				className: "text-[12px] font-extrabold",
				children: title
			})
		});
		$[10] = title;
		$[11] = t4;
	} else t4 = $[11];
	let t5;
	if ($[12] !== color || $[13] !== props || $[14] !== t1 || $[15] !== t3 || $[16] !== t4) {
		t5 = /* @__PURE__ */ jsx(AccentCard, {
			"data-slot": "intel-signal-card-compact",
			"data-selected": t1,
			color,
			accentWidth: 5,
			className: t3,
			...props,
			children: t4
		});
		$[12] = color;
		$[13] = props;
		$[14] = t1;
		$[15] = t3;
		$[16] = t4;
		$[17] = t5;
	} else t5 = $[17];
	return t5;
}
//#endregion
//#region src/components/ui/markdown.tsx
const headingClassName = "mt-6 mb-3 font-bold first:mt-0";
function MarkdownH1(t0) {
	const $ = c(8);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 8; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let children;
	let props;
	if ($[1] !== t0) {
		const { node: _node, children: t1, ...t2 } = t0;
		children = t1;
		props = t2;
		$[1] = t0;
		$[2] = children;
		$[3] = props;
	} else {
		children = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = cn("text-h1", headingClassName);
		$[4] = t1;
	} else t1 = $[4];
	let t2;
	if ($[5] !== children || $[6] !== props) {
		t2 = /* @__PURE__ */ jsx("h1", {
			className: t1,
			...props,
			children
		});
		$[5] = children;
		$[6] = props;
		$[7] = t2;
	} else t2 = $[7];
	return t2;
}
function MarkdownH2(t0) {
	const $ = c(8);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 8; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let children;
	let props;
	if ($[1] !== t0) {
		const { node: _node, children: t1, ...t2 } = t0;
		children = t1;
		props = t2;
		$[1] = t0;
		$[2] = children;
		$[3] = props;
	} else {
		children = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = cn("text-h2", headingClassName);
		$[4] = t1;
	} else t1 = $[4];
	let t2;
	if ($[5] !== children || $[6] !== props) {
		t2 = /* @__PURE__ */ jsx("h2", {
			className: t1,
			...props,
			children
		});
		$[5] = children;
		$[6] = props;
		$[7] = t2;
	} else t2 = $[7];
	return t2;
}
function MarkdownH3(t0) {
	const $ = c(8);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 8; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let children;
	let props;
	if ($[1] !== t0) {
		const { node: _node, children: t1, ...t2 } = t0;
		children = t1;
		props = t2;
		$[1] = t0;
		$[2] = children;
		$[3] = props;
	} else {
		children = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = cn("text-h3", headingClassName);
		$[4] = t1;
	} else t1 = $[4];
	let t2;
	if ($[5] !== children || $[6] !== props) {
		t2 = /* @__PURE__ */ jsx("h3", {
			className: t1,
			...props,
			children
		});
		$[5] = children;
		$[6] = props;
		$[7] = t2;
	} else t2 = $[7];
	return t2;
}
function MarkdownH4(t0) {
	const $ = c(8);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 8; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let children;
	let props;
	if ($[1] !== t0) {
		const { node: _node, children: t1, ...t2 } = t0;
		children = t1;
		props = t2;
		$[1] = t0;
		$[2] = children;
		$[3] = props;
	} else {
		children = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = cn("text-h4", headingClassName);
		$[4] = t1;
	} else t1 = $[4];
	let t2;
	if ($[5] !== children || $[6] !== props) {
		t2 = /* @__PURE__ */ jsx("h4", {
			className: t1,
			...props,
			children
		});
		$[5] = children;
		$[6] = props;
		$[7] = t2;
	} else t2 = $[7];
	return t2;
}
function MarkdownH5(t0) {
	const $ = c(8);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 8; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let children;
	let props;
	if ($[1] !== t0) {
		const { node: _node, children: t1, ...t2 } = t0;
		children = t1;
		props = t2;
		$[1] = t0;
		$[2] = children;
		$[3] = props;
	} else {
		children = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = cn("text-h5", headingClassName);
		$[4] = t1;
	} else t1 = $[4];
	let t2;
	if ($[5] !== children || $[6] !== props) {
		t2 = /* @__PURE__ */ jsx("h5", {
			className: t1,
			...props,
			children
		});
		$[5] = children;
		$[6] = props;
		$[7] = t2;
	} else t2 = $[7];
	return t2;
}
function MarkdownH6(t0) {
	const $ = c(8);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 8; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let children;
	let props;
	if ($[1] !== t0) {
		const { node: _node, children: t1, ...t2 } = t0;
		children = t1;
		props = t2;
		$[1] = t0;
		$[2] = children;
		$[3] = props;
	} else {
		children = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = cn("text-h6", headingClassName);
		$[4] = t1;
	} else t1 = $[4];
	let t2;
	if ($[5] !== children || $[6] !== props) {
		t2 = /* @__PURE__ */ jsx("h6", {
			className: t1,
			...props,
			children
		});
		$[5] = children;
		$[6] = props;
		$[7] = t2;
	} else t2 = $[7];
	return t2;
}
function MarkdownP(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx("p", {
			className: "my-3 text-body leading-relaxed first:mt-0 last:mb-0",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownStrong(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx("strong", {
			className: "font-bold",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownEm(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx("em", {
			className: "italic",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownDel(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx("del", {
			className: "line-through",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownLink(t0) {
	const $ = c(8);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 8; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let children;
	let props;
	if ($[1] !== t0) {
		const { node: _node, children: t1, ...t2 } = t0;
		children = t1;
		props = t2;
		$[1] = t0;
		$[2] = children;
		$[3] = props;
	} else {
		children = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = /* @__PURE__ */ jsx(ChevronRightIcon, { className: "size-3.5" });
		$[4] = t1;
	} else t1 = $[4];
	let t2;
	if ($[5] !== children || $[6] !== props) {
		t2 = /* @__PURE__ */ jsxs("a", {
			className: "inline-flex items-center gap-0.5 text-primary underline underline-offset-2 hover:text-primary/80",
			rel: "noopener noreferrer",
			target: "_blank",
			...props,
			children: [children, t1]
		});
		$[5] = children;
		$[6] = props;
		$[7] = t2;
	} else t2 = $[7];
	return t2;
}
function MarkdownBlockquote(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx("blockquote", {
			className: "my-3 border-l-4 border-border pl-4 text-muted-foreground",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownCode(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx("code", {
			className: "rounded bg-muted px-1 py-0.5 font-mono text-xs",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownPre(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx("pre", {
			className: "my-3 overflow-auto rounded-md bg-muted p-4 font-mono text-xs",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownHr(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx("hr", {
			className: "my-6 border-border",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownImg(t0) {
	const $ = c(7);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 7; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	let t1;
	if ($[1] !== t0) {
		const { node: _node, alt: t2, ...t3 } = t0;
		t1 = t2;
		props = t3;
		$[1] = t0;
		$[2] = props;
		$[3] = t1;
	} else {
		props = $[2];
		t1 = $[3];
	}
	const alt = t1 === void 0 ? "" : t1;
	let t2;
	if ($[4] !== alt || $[5] !== props) {
		t2 = /* @__PURE__ */ jsx("img", {
			alt,
			className: "my-3 block h-auto max-w-full rounded-md",
			...props
		});
		$[4] = alt;
		$[5] = props;
		$[6] = t2;
	} else t2 = $[6];
	return t2;
}
function MarkdownUl(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx("ul", {
			className: "my-3 list-disc pl-6",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownOl(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx("ol", {
			className: "my-3 list-decimal pl-6",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownLi(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx("li", {
			className: "mb-1 text-body",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownTable(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Table, { ...props });
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownThead(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(TableHeader, { ...props });
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownTbody(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(TableBody, { ...props });
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownTr(t0) {
	const $ = c(5);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let props;
	if ($[1] !== t0) {
		const { node: _node, ...t1 } = t0;
		props = t1;
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(TableRow, { ...props });
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function MarkdownTableCell(t0) {
	const $ = c(7);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 7; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let node;
	let props;
	if ($[1] !== t0) {
		({node, ...props} = t0);
		$[1] = t0;
		$[2] = node;
		$[3] = props;
	} else {
		node = $[2];
		props = $[3];
	}
	const isHeader = node?.tagName === "th";
	let t1;
	if ($[4] !== isHeader || $[5] !== props) {
		t1 = isHeader ? /* @__PURE__ */ jsx(TableHead, { ...props }) : /* @__PURE__ */ jsx(TableCell, { ...props });
		$[4] = isHeader;
		$[5] = props;
		$[6] = t1;
	} else t1 = $[6];
	return t1;
}
const spanClassNameByVariant = {
	muted: "text-gx-text-disabled",
	secondary: "text-gx-text-secondary",
	primary: "text-primary",
	error: "text-destructive"
};
function MarkdownSpan(t0) {
	const $ = c(9);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		const { node: _node, className: t1, ...t2 } = t0;
		className = t1;
		props = t2;
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	const variantClassName = className ? spanClassNameByVariant[className] : void 0;
	let t1;
	if ($[4] !== variantClassName) {
		t1 = cn(variantClassName);
		$[4] = variantClassName;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("span", {
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
const defaultComponents = {
	a: MarkdownLink,
	p: MarkdownP,
	strong: MarkdownStrong,
	em: MarkdownEm,
	del: MarkdownDel,
	h1: MarkdownH1,
	h2: MarkdownH2,
	h3: MarkdownH3,
	h4: MarkdownH4,
	h5: MarkdownH5,
	h6: MarkdownH6,
	img: MarkdownImg,
	blockquote: MarkdownBlockquote,
	code: MarkdownCode,
	pre: MarkdownPre,
	hr: MarkdownHr,
	ul: MarkdownUl,
	ol: MarkdownOl,
	li: MarkdownLi,
	table: MarkdownTable,
	thead: MarkdownThead,
	tbody: MarkdownTbody,
	tr: MarkdownTr,
	th: MarkdownTableCell,
	td: MarkdownTableCell,
	span: MarkdownSpan
};
/**
* Renders a Markdown string (GFM + inline HTML) with GX's typography and
* color tokens. Headings map to the `text-h1`…`text-h6` scale, links open in
* a new tab with an external-link affordance, and `<span class="muted | secondary | primary | error">`
* maps to the matching GX text color token — the one piece of inline HTML
* this renderer gives special meaning to.
*
* Pass `components` to override individual element renderers (merged over
* the defaults) — for example to change link behavior in a host app.
*
* Import path: `@design-system/components/ui/markdown`.
*/
function Markdown(t0) {
	const $ = c(13);
	if ($[0] !== "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f") {
		for (let $i = 0; $i < 13; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "50b7cebadc5fdc3e501b454a84190ce8eae7c18a2c87527776ca82996793af6f";
	}
	const { children, className, components } = t0;
	let t1;
	if ($[1] !== components) {
		t1 = {
			...defaultComponents,
			...components
		};
		$[1] = components;
		$[2] = t1;
	} else t1 = $[2];
	const resolvedComponents = t1;
	let t2;
	if ($[3] !== className) {
		t2 = cn("text-body text-foreground", className);
		$[3] = className;
		$[4] = t2;
	} else t2 = $[4];
	let t3;
	let t4;
	if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
		t3 = [rehypeRaw];
		t4 = [remarkGfm];
		$[5] = t3;
		$[6] = t4;
	} else {
		t3 = $[5];
		t4 = $[6];
	}
	let t5;
	if ($[7] !== children || $[8] !== resolvedComponents) {
		t5 = /* @__PURE__ */ jsx(ReactMarkdown, {
			components: resolvedComponents,
			rehypePlugins: t3,
			remarkPlugins: t4,
			children
		});
		$[7] = children;
		$[8] = resolvedComponents;
		$[9] = t5;
	} else t5 = $[9];
	let t6;
	if ($[10] !== t2 || $[11] !== t5) {
		t6 = /* @__PURE__ */ jsx("div", {
			"data-slot": "markdown",
			className: t2,
			children: t5
		});
		$[10] = t2;
		$[11] = t5;
		$[12] = t6;
	} else t6 = $[12];
	return t6;
}
//#endregion
//#region src/components/ui/marker.tsx
const markerVariants = cva("group/marker relative flex min-h-4 w-full items-center gap-2 text-left text-sm text-muted-foreground [&_svg:not([class*='size-'])]:size-4 [a]:underline [a]:underline-offset-3 [a]:hover:text-foreground", { variants: { variant: {
	default: "",
	separator: "before:mr-1 before:h-px before:min-w-0 before:flex-1 before:bg-border after:ml-1 after:h-px after:min-w-0 after:flex-1 after:bg-border",
	border: "border-b border-border pb-2"
} } });
/**
* A labeled inline row for status text and separators: a plain row
* (`default`), a bordered row (`border`), or a centered label flanked by
* hairlines (`separator`) — e.g. an "or" divider between two alternative
* actions. Compose with `MarkerIcon`/`MarkerContent`, and pass `render` to
* render the root as a link or button when the marker itself is
* interactive. Since `Marker` is a plain styled element, ARIA props (e.g.
* `role="separator"`, `aria-label`) pass straight through to the root when a
* variant needs semantic meaning beyond its visual styling.
*
* Import path: `@design-system/components/ui/marker`.
*/
function Marker(t0) {
	const $ = c(14);
	if ($[0] !== "49654edd177292747e028b27a5df20049262130e3d085ccc12b38b2cbde1319c") {
		for (let $i = 0; $i < 14; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "49654edd177292747e028b27a5df20049262130e3d085ccc12b38b2cbde1319c";
	}
	let render;
	let t1;
	let t2;
	let t3;
	let variant;
	if ($[1] !== t0) {
		const { className, variant: t4, render: t5, ...props } = t0;
		render = t5;
		variant = t4 === void 0 ? "default" : t4;
		t3 = useRender;
		t1 = "div";
		t2 = mergeProps({ className: cn(markerVariants({
			variant,
			className
		})) }, props);
		$[1] = t0;
		$[2] = render;
		$[3] = t1;
		$[4] = t2;
		$[5] = t3;
		$[6] = variant;
	} else {
		render = $[2];
		t1 = $[3];
		t2 = $[4];
		t3 = $[5];
		variant = $[6];
	}
	let t4;
	if ($[7] !== variant) {
		t4 = {
			slot: "marker",
			variant
		};
		$[7] = variant;
		$[8] = t4;
	} else t4 = $[8];
	let t5;
	if ($[9] !== render || $[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
		t5 = {
			defaultTagName: t1,
			props: t2,
			render,
			state: t4
		};
		$[9] = render;
		$[10] = t1;
		$[11] = t2;
		$[12] = t4;
		$[13] = t5;
	} else t5 = $[13];
	return t3(t5);
}
function MarkerIcon(t0) {
	const $ = c(9);
	if ($[0] !== "49654edd177292747e028b27a5df20049262130e3d085ccc12b38b2cbde1319c") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "49654edd177292747e028b27a5df20049262130e3d085ccc12b38b2cbde1319c";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("size-4 shrink-0 [&_svg:not([class*='size-'])]:size-4", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("span", {
			"data-slot": "marker-icon",
			"aria-hidden": "true",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function MarkerContent(t0) {
	const $ = c(9);
	if ($[0] !== "49654edd177292747e028b27a5df20049262130e3d085ccc12b38b2cbde1319c") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "49654edd177292747e028b27a5df20049262130e3d085ccc12b38b2cbde1319c";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("min-w-0 wrap-break-word group-data-[variant=separator]/marker:flex-none group-data-[variant=separator]/marker:text-center *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("span", {
			"data-slot": "marker-content",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/ui/message-scroller.tsx
function MessageScrollerProvider(props) {
	const $ = c(3);
	if ($[0] !== "46c085de32b36877c9ba386a9e8fe191b0629c1747856433ab3fbd36989969fb") {
		for (let $i = 0; $i < 3; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "46c085de32b36877c9ba386a9e8fe191b0629c1747856433ab3fbd36989969fb";
	}
	let t0;
	if ($[1] !== props) {
		t0 = /* @__PURE__ */ jsx(MessageScroller$1.Provider, { ...props });
		$[1] = props;
		$[2] = t0;
	} else t0 = $[2];
	return t0;
}
function MessageScroller(t0) {
	const $ = c(9);
	if ($[0] !== "46c085de32b36877c9ba386a9e8fe191b0629c1747856433ab3fbd36989969fb") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "46c085de32b36877c9ba386a9e8fe191b0629c1747856433ab3fbd36989969fb";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("group/message-scroller relative flex size-full min-h-0 flex-col overflow-hidden", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(MessageScroller$1.Root, {
			"data-slot": "message-scroller",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function MessageScrollerViewport(t0) {
	const $ = c(9);
	if ($[0] !== "46c085de32b36877c9ba386a9e8fe191b0629c1747856433ab3fbd36989969fb") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "46c085de32b36877c9ba386a9e8fe191b0629c1747856433ab3fbd36989969fb";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("size-full min-h-0 min-w-0 scroll-fade-b scrollbar-thin scrollbar-gutter-stable overflow-y-auto overscroll-contain contain-content data-autoscrolling:scrollbar-thumb-transparent data-autoscrolling:scrollbar-track-transparent", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(MessageScroller$1.Viewport, {
			"data-slot": "message-scroller-viewport",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function MessageScrollerContent(t0) {
	const $ = c(9);
	if ($[0] !== "46c085de32b36877c9ba386a9e8fe191b0629c1747856433ab3fbd36989969fb") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "46c085de32b36877c9ba386a9e8fe191b0629c1747856433ab3fbd36989969fb";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex h-max min-h-full flex-col gap-6", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(MessageScroller$1.Content, {
			"data-slot": "message-scroller-content",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function MessageScrollerItem(t0) {
	const $ = c(11);
	if ($[0] !== "46c085de32b36877c9ba386a9e8fe191b0629c1747856433ab3fbd36989969fb") {
		for (let $i = 0; $i < 11; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "46c085de32b36877c9ba386a9e8fe191b0629c1747856433ab3fbd36989969fb";
	}
	let className;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, scrollAnchor: t1, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
	}
	const scrollAnchor = t1 === void 0 ? false : t1;
	let t2;
	if ($[5] !== className) {
		t2 = cn("min-w-0 shrink-0 [contain-intrinsic-size:auto_10rem] [content-visibility:auto]", className);
		$[5] = className;
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] !== props || $[8] !== scrollAnchor || $[9] !== t2) {
		t3 = /* @__PURE__ */ jsx(MessageScroller$1.Item, {
			"data-slot": "message-scroller-item",
			scrollAnchor,
			className: t2,
			...props
		});
		$[7] = props;
		$[8] = scrollAnchor;
		$[9] = t2;
		$[10] = t3;
	} else t3 = $[10];
	return t3;
}
function MessageScrollerButton(t0) {
	const $ = c(26);
	if ($[0] !== "46c085de32b36877c9ba386a9e8fe191b0629c1747856433ab3fbd36989969fb") {
		for (let $i = 0; $i < 26; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "46c085de32b36877c9ba386a9e8fe191b0629c1747856433ab3fbd36989969fb";
	}
	let children;
	let className;
	let props;
	let render;
	let t1;
	let t2;
	let t3;
	if ($[1] !== t0) {
		({direction: t1, className, children, render, variant: t2, size: t3, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
		$[5] = render;
		$[6] = t1;
		$[7] = t2;
		$[8] = t3;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
		render = $[5];
		t1 = $[6];
		t2 = $[7];
		t3 = $[8];
	}
	const direction = t1 === void 0 ? "end" : t1;
	const variant = t2 === void 0 ? "secondary" : t2;
	const size = t3 === void 0 ? "icon-sm" : t3;
	let t4;
	if ($[9] !== className) {
		t4 = cn("absolute inset-s-1/2 -translate-x-1/2 border-border bg-background text-foreground transition-[translate,scale,opacity] duration-200 hover:bg-muted hover:text-foreground data-[active=false]:pointer-events-none data-[active=false]:scale-95 data-[active=false]:opacity-0 data-[active=false]:duration-400 data-[active=false]:ease-[cubic-bezier(0.7,0,0.84,0)] data-[active=true]:translate-y-0 data-[active=true]:scale-100 data-[active=true]:opacity-100 data-[active=true]:ease-[cubic-bezier(0.23,1,0.32,1)] data-[direction=end]:bottom-4 data-[direction=end]:data-[active=false]:translate-y-full data-[direction=start]:top-4 data-[direction=start]:data-[active=false]:-translate-y-full rtl:translate-x-1/2 data-[direction=start]:[&_svg]:rotate-180", className);
		$[9] = className;
		$[10] = t4;
	} else t4 = $[10];
	let t5;
	if ($[11] !== render || $[12] !== size || $[13] !== variant) {
		t5 = render ?? /* @__PURE__ */ jsx(Button, {
			variant,
			size
		});
		$[11] = render;
		$[12] = size;
		$[13] = variant;
		$[14] = t5;
	} else t5 = $[14];
	let t6;
	if ($[15] !== children || $[16] !== direction) {
		t6 = children ?? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx(ArrowDownIcon, { "data-icon": "inline-start" }), /* @__PURE__ */ jsx("span", {
			className: "sr-only",
			children: direction === "end" ? "Scroll to end" : "Scroll to start"
		})] });
		$[15] = children;
		$[16] = direction;
		$[17] = t6;
	} else t6 = $[17];
	let t7;
	if ($[18] !== direction || $[19] !== props || $[20] !== size || $[21] !== t4 || $[22] !== t5 || $[23] !== t6 || $[24] !== variant) {
		t7 = /* @__PURE__ */ jsx(MessageScroller$1.Button, {
			"data-slot": "message-scroller-button",
			"data-direction": direction,
			"data-variant": variant,
			"data-size": size,
			direction,
			className: t4,
			render: t5,
			...props,
			children: t6
		});
		$[18] = direction;
		$[19] = props;
		$[20] = size;
		$[21] = t4;
		$[22] = t5;
		$[23] = t6;
		$[24] = variant;
		$[25] = t7;
	} else t7 = $[25];
	return t7;
}
//#endregion
//#region src/components/ui/slider.tsx
function Slider(t0) {
	const $ = c(53);
	if ($[0] !== "cb6a2aaa698e3c9bd624333cccb3631736f6fb003fa1d45ffeb52eb8aa2b2372") {
		for (let $i = 0; $i < 53; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "cb6a2aaa698e3c9bd624333cccb3631736f6fb003fa1d45ffeb52eb8aa2b2372";
	}
	let className;
	let defaultValue;
	let getAriaLabel;
	let getAriaValueText;
	let props;
	let t1;
	let t2;
	let value;
	if ($[1] !== t0) {
		({className, defaultValue, value, min: t1, max: t2, getAriaLabel, getAriaValueText, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = defaultValue;
		$[4] = getAriaLabel;
		$[5] = getAriaValueText;
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
		$[9] = value;
	} else {
		className = $[2];
		defaultValue = $[3];
		getAriaLabel = $[4];
		getAriaValueText = $[5];
		props = $[6];
		t1 = $[7];
		t2 = $[8];
		value = $[9];
	}
	const min = t1 === void 0 ? 0 : t1;
	const max = t2 === void 0 ? 100 : t2;
	let T0;
	let T1;
	let t10;
	let t11;
	let t12;
	let t13;
	let t3;
	let t4;
	let t5;
	let t6;
	let t7;
	let t8;
	let t9;
	if ($[10] !== className || $[11] !== defaultValue || $[12] !== getAriaLabel || $[13] !== getAriaValueText || $[14] !== max || $[15] !== min || $[16] !== props || $[17] !== value) {
		let _values = [min, max];
		if (Array.isArray(value)) _values = value;
		else if (Array.isArray(defaultValue)) _values = defaultValue;
		T1 = Slider$1.Root;
		if ($[31] !== className) {
			t6 = cn("data-horizontal:w-full data-vertical:h-full", className);
			$[31] = className;
			$[32] = t6;
		} else t6 = $[32];
		t7 = "slider";
		t8 = defaultValue;
		t9 = value;
		t10 = min;
		t11 = max;
		t12 = "edge";
		t13 = props;
		T0 = Slider$1.Control;
		t3 = "relative flex w-full touch-none items-center select-none data-disabled:opacity-50 data-vertical:h-full data-vertical:min-h-40 data-vertical:w-auto data-vertical:flex-col";
		if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
			t4 = /* @__PURE__ */ jsx(Slider$1.Track, {
				"data-slot": "slider-track",
				className: "relative grow overflow-hidden rounded-full bg-muted select-none data-horizontal:h-1 data-horizontal:w-full data-vertical:h-full data-vertical:w-1",
				children: /* @__PURE__ */ jsx(Slider$1.Indicator, {
					"data-slot": "slider-range",
					className: "bg-primary select-none data-horizontal:h-full data-vertical:w-full"
				})
			});
			$[33] = t4;
		} else t4 = $[33];
		let t14;
		if ($[34] !== getAriaLabel || $[35] !== getAriaValueText) {
			t14 = (_, index) => /* @__PURE__ */ jsx(Slider$1.Thumb, {
				"data-slot": "slider-thumb",
				getAriaLabel,
				getAriaValueText,
				className: "relative block size-3 shrink-0 rounded-full border border-ring bg-white ring-ring/50 transition-[color,box-shadow] select-none after:absolute after:-inset-2 hover:ring-3 focus-visible:ring-3 focus-visible:outline-hidden active:ring-3 disabled:pointer-events-none disabled:opacity-50"
			}, index);
			$[34] = getAriaLabel;
			$[35] = getAriaValueText;
			$[36] = t14;
		} else t14 = $[36];
		t5 = Array.from({ length: _values.length }, t14);
		$[10] = className;
		$[11] = defaultValue;
		$[12] = getAriaLabel;
		$[13] = getAriaValueText;
		$[14] = max;
		$[15] = min;
		$[16] = props;
		$[17] = value;
		$[18] = T0;
		$[19] = T1;
		$[20] = t10;
		$[21] = t11;
		$[22] = t12;
		$[23] = t13;
		$[24] = t3;
		$[25] = t4;
		$[26] = t5;
		$[27] = t6;
		$[28] = t7;
		$[29] = t8;
		$[30] = t9;
	} else {
		T0 = $[18];
		T1 = $[19];
		t10 = $[20];
		t11 = $[21];
		t12 = $[22];
		t13 = $[23];
		t3 = $[24];
		t4 = $[25];
		t5 = $[26];
		t6 = $[27];
		t7 = $[28];
		t8 = $[29];
		t9 = $[30];
	}
	let t14;
	if ($[37] !== T0 || $[38] !== t3 || $[39] !== t4 || $[40] !== t5) {
		t14 = /* @__PURE__ */ jsxs(T0, {
			className: t3,
			children: [t4, t5]
		});
		$[37] = T0;
		$[38] = t3;
		$[39] = t4;
		$[40] = t5;
		$[41] = t14;
	} else t14 = $[41];
	let t15;
	if ($[42] !== T1 || $[43] !== t10 || $[44] !== t11 || $[45] !== t12 || $[46] !== t13 || $[47] !== t14 || $[48] !== t6 || $[49] !== t7 || $[50] !== t8 || $[51] !== t9) {
		t15 = /* @__PURE__ */ jsx(T1, {
			className: t6,
			"data-slot": t7,
			defaultValue: t8,
			value: t9,
			min: t10,
			max: t11,
			thumbAlignment: t12,
			...t13,
			children: t14
		});
		$[42] = T1;
		$[43] = t10;
		$[44] = t11;
		$[45] = t12;
		$[46] = t13;
		$[47] = t14;
		$[48] = t6;
		$[49] = t7;
		$[50] = t8;
		$[51] = t9;
		$[52] = t15;
	} else t15 = $[52];
	return t15;
}
//#endregion
//#region src/components/ui/sparkline.tsx
const TREND_CLASS = {
	up: "text-gx-success",
	down: "text-gx-failure-light",
	neutral: "text-gx-text-secondary"
};
/**
* Min/max-normalizes `points` to the unit interval [0, 1] on both axes: `t` is
* the point's left→right position, `v` is its scaled value. Shared by every
* sparkline-shaped chart so the scaling math has one owner.
*/
function normalizeSparklinePoints(points) {
	const min = Math.min(...points);
	const range = Math.max(...points) - min || 1;
	return points.map((value, index) => ({
		t: index / (points.length - 1),
		v: (value - min) / range
	}));
}
/**
* A minimal, presentational sparkline: a single polyline scaled to a fixed
* 56×20 viewbox, colored by `trend`. Purely presentational — no data, no
* formatting. Renders nothing for fewer than two points.
*
* Import path: `@design-system/components/ui/sparkline`.
*/
function Sparkline(t0) {
	const $ = c(18);
	if ($[0] !== "fd1d89c2e592697688d6c6a80443a54088786269de3cd726107810650d8f42fe") {
		for (let $i = 0; $i < 18; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "fd1d89c2e592697688d6c6a80443a54088786269de3cd726107810650d8f42fe";
	}
	let className;
	let points;
	let props;
	let t1;
	if ($[1] !== t0) {
		({points, trend: t1, className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = points;
		$[4] = props;
		$[5] = t1;
	} else {
		className = $[2];
		points = $[3];
		props = $[4];
		t1 = $[5];
	}
	const trend = t1 === void 0 ? "neutral" : t1;
	if (points.length < 2) return null;
	let t2;
	if ($[6] !== points) {
		t2 = normalizeSparklinePoints(points).map(_temp$8).join(" ");
		$[6] = points;
		$[7] = t2;
	} else t2 = $[7];
	const coords = t2;
	const t3 = TREND_CLASS[trend];
	let t4;
	if ($[8] !== className || $[9] !== t3) {
		t4 = cn(t3, className);
		$[8] = className;
		$[9] = t3;
		$[10] = t4;
	} else t4 = $[10];
	let t5;
	if ($[11] !== coords) {
		t5 = /* @__PURE__ */ jsx("polyline", {
			points: coords,
			stroke: "currentColor",
			strokeWidth: "1.5"
		});
		$[11] = coords;
		$[12] = t5;
	} else t5 = $[12];
	let t6;
	if ($[13] !== props || $[14] !== t4 || $[15] !== t5 || $[16] !== trend) {
		t6 = /* @__PURE__ */ jsx("svg", {
			"data-slot": "sparkline",
			"data-trend": trend,
			width: "56",
			height: "20",
			viewBox: "0 0 56 20",
			fill: "none",
			"aria-hidden": true,
			className: t4,
			...props,
			children: t5
		});
		$[13] = props;
		$[14] = t4;
		$[15] = t5;
		$[16] = trend;
		$[17] = t6;
	} else t6 = $[17];
	return t6;
}
function _temp$8(t0) {
	const { t, v } = t0;
	return `${(t * 54).toFixed(1)},${(18 - v * 16).toFixed(1)}`;
}
//#endregion
//#region src/components/ui/stat-tile.tsx
/**
* A single KPI tile: a large value over a small caps label. Purely
* presentational and unstyled at the edges — compose several inside a
* `divide-x` row for a bordered stat strip (see `MorningIntelFeed`), or use
* standalone.
*
* Import path: `@design-system/components/ui/stat-tile`.
*/
function StatTile(t0) {
	const $ = c(22);
	if ($[0] !== "37edf5513726cdf5dccfb054186d632c8ff07f4d0b5d4e0f6ac8dd977124c1c6") {
		for (let $i = 0; $i < 22; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "37edf5513726cdf5dccfb054186d632c8ff07f4d0b5d4e0f6ac8dd977124c1c6";
	}
	let accent;
	let className;
	let label;
	let props;
	let value;
	if ($[1] !== t0) {
		({value, label, accent, className, ...props} = t0);
		$[1] = t0;
		$[2] = accent;
		$[3] = className;
		$[4] = label;
		$[5] = props;
		$[6] = value;
	} else {
		accent = $[2];
		className = $[3];
		label = $[4];
		props = $[5];
		value = $[6];
	}
	let t1;
	if ($[7] !== className) {
		t1 = cn("flex flex-1 flex-col gap-1 px-5 py-4", className);
		$[7] = className;
		$[8] = t1;
	} else t1 = $[8];
	const t2 = accent === "accent" && "text-gx-highlight";
	const t3 = accent === "warning" && "text-gx-warning";
	let t4;
	if ($[9] !== t2 || $[10] !== t3) {
		t4 = cn("text-[28px] font-extrabold leading-none text-gx-text", t2, t3);
		$[9] = t2;
		$[10] = t3;
		$[11] = t4;
	} else t4 = $[11];
	let t5;
	if ($[12] !== t4 || $[13] !== value) {
		t5 = /* @__PURE__ */ jsx("span", {
			className: t4,
			children: value
		});
		$[12] = t4;
		$[13] = value;
		$[14] = t5;
	} else t5 = $[14];
	let t6;
	if ($[15] !== label) {
		t6 = /* @__PURE__ */ jsx("span", {
			className: "text-[11px] font-bold tracking-[0.08em] text-gx-text-secondary uppercase",
			children: label
		});
		$[15] = label;
		$[16] = t6;
	} else t6 = $[16];
	let t7;
	if ($[17] !== props || $[18] !== t1 || $[19] !== t5 || $[20] !== t6) {
		t7 = /* @__PURE__ */ jsxs("div", {
			"data-slot": "stat-tile",
			className: t1,
			...props,
			children: [t5, t6]
		});
		$[17] = props;
		$[18] = t1;
		$[19] = t5;
		$[20] = t6;
		$[21] = t7;
	} else t7 = $[21];
	return t7;
}
//#endregion
//#region src/components/icon-button.tsx
function IconButton(t0) {
	const $ = c(17);
	if ($[0] !== "3463e374315d00134c740eff737d33871d01c3acba11e1d56fecf589766c64a7") {
		for (let $i = 0; $i < 17; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "3463e374315d00134c740eff737d33871d01c3acba11e1d56fecf589766c64a7";
	}
	let label;
	let props;
	let t1;
	let t2;
	let tooltipContent;
	if ($[1] !== t0) {
		({label, tooltipContent, size: t1, side: t2, ...props} = t0);
		$[1] = t0;
		$[2] = label;
		$[3] = props;
		$[4] = t1;
		$[5] = t2;
		$[6] = tooltipContent;
	} else {
		label = $[2];
		props = $[3];
		t1 = $[4];
		t2 = $[5];
		tooltipContent = $[6];
	}
	const size = t1 === void 0 ? "icon" : t1;
	const side = t2 === void 0 ? "top" : t2;
	let t3;
	if ($[7] !== label || $[8] !== props || $[9] !== size) {
		t3 = /* @__PURE__ */ jsx(TooltipTrigger, { render: /* @__PURE__ */ jsx(Button, {
			size,
			"aria-label": label,
			...props
		}) });
		$[7] = label;
		$[8] = props;
		$[9] = size;
		$[10] = t3;
	} else t3 = $[10];
	const t4 = tooltipContent ?? label;
	let t5;
	if ($[11] !== side || $[12] !== t4) {
		t5 = /* @__PURE__ */ jsx(TooltipContent, {
			side,
			children: t4
		});
		$[11] = side;
		$[12] = t4;
		$[13] = t5;
	} else t5 = $[13];
	let t6;
	if ($[14] !== t3 || $[15] !== t5) {
		t6 = /* @__PURE__ */ jsxs(Tooltip, { children: [t3, t5] });
		$[14] = t3;
		$[15] = t5;
		$[16] = t6;
	} else t6 = $[16];
	return t6;
}
//#endregion
//#region src/components/ui/tabs.tsx
function Tabs(t0) {
	const $ = c(11);
	if ($[0] !== "5382e5de8182d3a7e6bc48cdebb98006fad2a090d42eba65747537437eba8abf") {
		for (let $i = 0; $i < 11; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "5382e5de8182d3a7e6bc48cdebb98006fad2a090d42eba65747537437eba8abf";
	}
	let className;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, orientation: t1, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
	}
	const orientation = t1 === void 0 ? "horizontal" : t1;
	let t2;
	if ($[5] !== className) {
		t2 = cn("group/tabs flex gap-2 data-horizontal:flex-col", className);
		$[5] = className;
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] !== orientation || $[8] !== props || $[9] !== t2) {
		t3 = /* @__PURE__ */ jsx(Tabs$1.Root, {
			"data-slot": "tabs",
			"data-orientation": orientation,
			className: t2,
			...props
		});
		$[7] = orientation;
		$[8] = props;
		$[9] = t2;
		$[10] = t3;
	} else t3 = $[10];
	return t3;
}
const tabsListVariants = cva("group/tabs-list inline-flex w-fit items-center justify-center p-[3px] text-muted-foreground group-data-horizontal/tabs:h-8 group-data-vertical/tabs:h-fit group-data-vertical/tabs:flex-col", {
	variants: { variant: {
		pill: "rounded-lg bg-muted",
		underline: "gap-0.5 rounded-none bg-secondary px-0 pt-0 pb-[3px]",
		line: "gap-0.5 rounded-lg border border-border/50 bg-secondary px-0 pt-0 pb-[3px]"
	} },
	defaultVariants: { variant: "pill" }
});
function TabsList(t0) {
	const $ = c(37);
	if ($[0] !== "5382e5de8182d3a7e6bc48cdebb98006fad2a090d42eba65747537437eba8abf") {
		for (let $i = 0; $i < 37; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "5382e5de8182d3a7e6bc48cdebb98006fad2a090d42eba65747537437eba8abf";
	}
	let children;
	let className;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, variant: t1, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
		$[5] = t1;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
		t1 = $[5];
	}
	const variant = t1 === void 0 ? "pill" : t1;
	const scrollRef = React.useRef(null);
	let t2;
	if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = {
			start: false,
			end: false
		};
		$[6] = t2;
	} else t2 = $[6];
	const [canScroll, setCanScroll] = React.useState(t2);
	const [hasOverflow, setHasOverflow] = React.useState(false);
	let t3;
	if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
		t3 = () => {
			const el = scrollRef.current;
			if (!el) return;
			setHasOverflow(el.scrollWidth > el.clientWidth);
			setCanScroll({
				start: el.scrollLeft > 0,
				end: Math.ceil(el.scrollLeft + el.clientWidth) < el.scrollWidth
			});
		};
		$[7] = t3;
	} else t3 = $[7];
	const updateCanScroll = t3;
	let t4;
	let t5;
	if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
		t4 = () => {
			updateCanScroll();
		};
		t5 = [updateCanScroll];
		$[8] = t4;
		$[9] = t5;
	} else {
		t4 = $[8];
		t5 = $[9];
	}
	React.useLayoutEffect(t4, t5);
	let t6;
	let t7;
	if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
		t6 = () => {
			const el_0 = scrollRef.current;
			if (!el_0) return;
			const resizeObserver = new ResizeObserver(updateCanScroll);
			resizeObserver.observe(el_0);
			el_0.addEventListener("scroll", updateCanScroll, { passive: true });
			const frameId = window.requestAnimationFrame(updateCanScroll);
			return () => {
				window.cancelAnimationFrame(frameId);
				resizeObserver.disconnect();
				el_0.removeEventListener("scroll", updateCanScroll);
			};
		};
		t7 = [updateCanScroll];
		$[10] = t6;
		$[11] = t7;
	} else {
		t6 = $[10];
		t7 = $[11];
	}
	React.useEffect(t6, t7);
	let t8;
	let t9;
	if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
		t8 = () => {
			const el_1 = scrollRef.current;
			if (!el_1) return;
			const revealActiveTab = () => {
				const activeTab = el_1.querySelector("[data-slot=\"tabs-trigger\"][data-active]");
				if (!activeTab) return;
				const areaRect = el_1.getBoundingClientRect();
				const tabRect = activeTab.getBoundingClientRect();
				let left = 0;
				if (tabRect.left < areaRect.left) left = tabRect.left - areaRect.left;
				else if (tabRect.right > areaRect.right) left = tabRect.right - areaRect.right;
				if (left === 0) return;
				el_1.scrollBy({
					left,
					behavior: getPreferredScrollBehavior()
				});
			};
			const observer = new MutationObserver(revealActiveTab);
			observer.observe(el_1, {
				attributes: true,
				attributeFilter: ["data-active"],
				subtree: true
			});
			return () => observer.disconnect();
		};
		t9 = [];
		$[12] = t8;
		$[13] = t9;
	} else {
		t8 = $[12];
		t9 = $[13];
	}
	React.useEffect(t8, t9);
	const autoScrollRef = React.useRef(null);
	let t10;
	if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
		t10 = () => {
			if (autoScrollRef.current !== null) {
				window.clearInterval(autoScrollRef.current);
				autoScrollRef.current = null;
			}
		};
		$[14] = t10;
	} else t10 = $[14];
	const stopAutoScroll = t10;
	let t11;
	let t12;
	if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
		t11 = () => stopAutoScroll;
		t12 = [];
		$[15] = t11;
		$[16] = t12;
	} else {
		t11 = $[15];
		t12 = $[16];
	}
	React.useEffect(t11, t12);
	let scrollByPage;
	let startAutoScroll;
	if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
		startAutoScroll = (direction) => {
			stopAutoScroll();
			if (getPreferredScrollBehavior() === "auto") {
				scrollByPage(direction);
				return;
			}
			autoScrollRef.current = window.setInterval(() => {
				scrollRef.current?.scrollBy({
					left: direction * 12,
					behavior: getPreferredScrollBehavior()
				});
			}, 16);
		};
		scrollByPage = (direction_0) => {
			const el_2 = scrollRef.current;
			if (!el_2) return;
			el_2.scrollBy({
				left: direction_0 * el_2.clientWidth * .75,
				behavior: getPreferredScrollBehavior()
			});
		};
		$[17] = scrollByPage;
		$[18] = startAutoScroll;
	} else {
		scrollByPage = $[17];
		startAutoScroll = $[18];
	}
	let t13;
	if ($[19] !== canScroll || $[20] !== hasOverflow) {
		t13 = hasOverflow && /* @__PURE__ */ jsx("button", {
			type: "button",
			"data-slot": "tabs-list-scroll-button",
			"aria-label": "Scroll tabs backward",
			"aria-hidden": !canScroll.start,
			tabIndex: canScroll.start ? 0 : -1,
			onClick: () => scrollByPage(-1),
			onMouseEnter: () => startAutoScroll(-1),
			onMouseLeave: stopAutoScroll,
			className: cn("flex size-6 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-accent-foreground", !canScroll.start && "invisible pointer-events-none"),
			children: /* @__PURE__ */ jsx(ChevronLeft, { className: "size-4" })
		});
		$[19] = canScroll;
		$[20] = hasOverflow;
		$[21] = t13;
	} else t13 = $[21];
	let t14;
	if ($[22] !== className || $[23] !== variant) {
		t14 = cn(tabsListVariants({ variant }), className);
		$[22] = className;
		$[23] = variant;
		$[24] = t14;
	} else t14 = $[24];
	let t15;
	if ($[25] !== children || $[26] !== props || $[27] !== t14 || $[28] !== variant) {
		t15 = /* @__PURE__ */ jsx("div", {
			ref: scrollRef,
			"data-slot": "tabs-list-scroll-area",
			className: "min-w-0 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
			children: /* @__PURE__ */ jsx(Tabs$1.List, {
				"data-slot": "tabs-list",
				"data-variant": variant,
				className: t14,
				...props,
				children
			})
		});
		$[25] = children;
		$[26] = props;
		$[27] = t14;
		$[28] = variant;
		$[29] = t15;
	} else t15 = $[29];
	let t16;
	if ($[30] !== canScroll || $[31] !== hasOverflow) {
		t16 = hasOverflow && /* @__PURE__ */ jsx("button", {
			type: "button",
			"data-slot": "tabs-list-scroll-button",
			"aria-label": "Scroll tabs forward",
			"aria-hidden": !canScroll.end,
			tabIndex: canScroll.end ? 0 : -1,
			onClick: () => scrollByPage(1),
			onMouseEnter: () => startAutoScroll(1),
			onMouseLeave: stopAutoScroll,
			className: cn("flex size-6 shrink-0 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-accent-foreground", !canScroll.end && "invisible pointer-events-none"),
			children: /* @__PURE__ */ jsx(ChevronRight, { className: "size-4" })
		});
		$[30] = canScroll;
		$[31] = hasOverflow;
		$[32] = t16;
	} else t16 = $[32];
	let t17;
	if ($[33] !== t13 || $[34] !== t15 || $[35] !== t16) {
		t17 = /* @__PURE__ */ jsxs("div", {
			className: "flex min-w-0 items-center gap-0.5",
			children: [
				t13,
				t15,
				t16
			]
		});
		$[33] = t13;
		$[34] = t15;
		$[35] = t16;
		$[36] = t17;
	} else t17 = $[36];
	return t17;
}
function TabsTrigger(t0) {
	const $ = c(27);
	if ($[0] !== "5382e5de8182d3a7e6bc48cdebb98006fad2a090d42eba65747537437eba8abf") {
		for (let $i = 0; $i < 27; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "5382e5de8182d3a7e6bc48cdebb98006fad2a090d42eba65747537437eba8abf";
	}
	let children;
	let className;
	let onClose;
	let props;
	if ($[1] !== t0) {
		({className, onClose, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = onClose;
		$[5] = props;
	} else {
		children = $[2];
		className = $[3];
		onClose = $[4];
		props = $[5];
	}
	const t1 = onClose && "pr-6";
	let t2;
	if ($[6] !== className || $[7] !== t1) {
		t2 = cn("relative inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-1.5 py-0.5 text-sm font-medium whitespace-nowrap text-foreground/60 transition-all group-data-vertical/tabs:w-full group-data-vertical/tabs:justify-start hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1 focus-visible:outline-ring disabled:pointer-events-none disabled:opacity-50 has-data-[icon=inline-end]:pr-1 has-data-[icon=inline-start]:pl-1 aria-disabled:pointer-events-none aria-disabled:opacity-50 dark:text-muted-foreground dark:hover:text-foreground group-data-[variant=pill]/tabs-list:data-active:shadow-sm group-data-[variant=underline]/tabs-list:rounded-none group-data-[variant=underline]/tabs-list:data-active:shadow-none group-data-[variant=line]/tabs-list:data-active:shadow-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", "group-data-[variant=underline]/tabs-list:bg-transparent group-data-[variant=underline]/tabs-list:data-active:bg-accent group-data-[variant=line]/tabs-list:bg-transparent group-data-[variant=line]/tabs-list:data-active:bg-accent dark:group-data-[variant=underline]/tabs-list:data-active:border-transparent dark:group-data-[variant=underline]/tabs-list:data-active:bg-accent dark:group-data-[variant=line]/tabs-list:data-active:border-transparent dark:group-data-[variant=line]/tabs-list:data-active:bg-accent", "data-active:bg-background data-active:text-foreground dark:data-active:border-input dark:data-active:bg-input/30 dark:data-active:text-foreground", "after:pointer-events-none after:absolute after:rounded-full after:bg-primary after:opacity-0 after:transition-opacity group-data-horizontal/tabs:after:inset-x-0 group-data-horizontal/tabs:after:-bottom-[3.5px] group-data-horizontal/tabs:after:h-[3px] group-data-vertical/tabs:after:inset-y-0 group-data-vertical/tabs:after:-right-1 group-data-vertical/tabs:after:w-0.5 group-data-[variant=underline]/tabs-list:data-active:after:opacity-100 group-data-[variant=line]/tabs-list:data-active:after:opacity-100", t1, className);
		$[6] = className;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	const tabClassName = t2;
	if (!onClose) {
		let t3;
		if ($[9] !== children || $[10] !== props || $[11] !== tabClassName) {
			t3 = /* @__PURE__ */ jsx(Tabs$1.Tab, {
				"data-slot": "tabs-trigger",
				className: tabClassName,
				...props,
				children
			});
			$[9] = children;
			$[10] = props;
			$[11] = tabClassName;
			$[12] = t3;
		} else t3 = $[12];
		return t3;
	}
	let t3;
	if ($[13] !== children) {
		t3 = /* @__PURE__ */ jsx("span", {
			className: "truncate",
			children
		});
		$[13] = children;
		$[14] = t3;
	} else t3 = $[14];
	let t4;
	if ($[15] !== props || $[16] !== t3 || $[17] !== tabClassName) {
		t4 = /* @__PURE__ */ jsx(Tabs$1.Tab, {
			"data-slot": "tabs-trigger",
			className: tabClassName,
			...props,
			children: t3
		});
		$[15] = props;
		$[16] = t3;
		$[17] = tabClassName;
		$[18] = t4;
	} else t4 = $[18];
	let t5;
	if ($[19] !== onClose) {
		t5 = (event_0) => {
			event_0.stopPropagation();
			onClose();
		};
		$[19] = onClose;
		$[20] = t5;
	} else t5 = $[20];
	let t6;
	if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
		t6 = /* @__PURE__ */ jsx(XIcon, { className: "size-3" });
		$[21] = t6;
	} else t6 = $[21];
	let t7;
	if ($[22] !== t5) {
		t7 = /* @__PURE__ */ jsx("button", {
			type: "button",
			"aria-label": "Close tab",
			"data-slot": "tabs-trigger-close",
			className: "absolute top-1/2 right-1 flex size-4 -translate-y-1/2 items-center justify-center rounded-sm text-foreground/60 hover:bg-accent hover:text-accent-foreground",
			onPointerDown: _temp$7,
			onClick: t5,
			children: t6
		});
		$[22] = t5;
		$[23] = t7;
	} else t7 = $[23];
	let t8;
	if ($[24] !== t4 || $[25] !== t7) {
		t8 = /* @__PURE__ */ jsxs("span", {
			className: "relative inline-flex shrink-0",
			children: [t4, t7]
		});
		$[24] = t4;
		$[25] = t7;
		$[26] = t8;
	} else t8 = $[26];
	return t8;
}
function _temp$7(event) {
	return event.stopPropagation();
}
function TabsContent(t0) {
	const $ = c(9);
	if ($[0] !== "5382e5de8182d3a7e6bc48cdebb98006fad2a090d42eba65747537437eba8abf") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "5382e5de8182d3a7e6bc48cdebb98006fad2a090d42eba65747537437eba8abf";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex-1 text-sm outline-none", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Tabs$1.Panel, {
			"data-slot": "tabs-content",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/ui/marketing-bar.tsx
/**
* A compact promotional chip — an orange-outlined anchor for a single marketing
* link (e.g. a blog post), matching the redesign prototype's `.marketing-bar`.
* Purely presentational: it renders the message node it is given and links to
* `href`. Any inline `span` inside the message is styled in the accent color, so
* sanitized-HTML copy that wraps its call-to-action in a `span` is highlighted
* automatically; alternatively pass a structured `cta` node.
*
* Import path: `@design-system/components/ui/marketing-bar`.
*/
function MarketingBar(t0) {
	const $ = c(15);
	if ($[0] !== "d414a546cb44ad0118123916b24bfa256da6c54185eb73e0b903a761ebbc2a35") {
		for (let $i = 0; $i < 15; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d414a546cb44ad0118123916b24bfa256da6c54185eb73e0b903a761ebbc2a35";
	}
	let children;
	let className;
	let cta;
	let props;
	if ($[1] !== t0) {
		({className, children, cta, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = cta;
		$[5] = props;
	} else {
		children = $[2];
		className = $[3];
		cta = $[4];
		props = $[5];
	}
	let t1;
	if ($[6] !== className) {
		t1 = cn("inline-flex items-center gap-2 whitespace-nowrap rounded-sm border border-gx-highlight bg-gx-highlight/10 px-3.5 py-1.5 text-[12.5px] font-semibold text-gx-text-secondary no-underline transition-colors hover:bg-gx-highlight/20 [&_span]:font-extrabold [&_span]:text-gx-highlight", className);
		$[6] = className;
		$[7] = t1;
	} else t1 = $[7];
	let t2;
	if ($[8] !== cta) {
		t2 = cta ? /* @__PURE__ */ jsx("span", {
			className: "font-extrabold text-gx-highlight",
			children: cta
		}) : null;
		$[8] = cta;
		$[9] = t2;
	} else t2 = $[9];
	let t3;
	if ($[10] !== children || $[11] !== props || $[12] !== t1 || $[13] !== t2) {
		t3 = /* @__PURE__ */ jsxs("a", {
			"data-slot": "marketing-bar",
			className: t1,
			...props,
			children: [children, t2]
		});
		$[10] = children;
		$[11] = props;
		$[12] = t1;
		$[13] = t2;
		$[14] = t3;
	} else t3 = $[14];
	return t3;
}
//#endregion
//#region src/components/ui/page-header.tsx
/**
* The fixed application topbar: a 52px, non-scrolling bar with a bottom hairline.
* Left side is a `Section / Title` breadcrumb (title only when `section` is
* omitted); the right side holds an optional `action` slot. Purely
* presentational — the consumer supplies the resolved title/section nodes and
* any action. Owns its 24px horizontal gutter, matching page content.
*
* Import path: `@design-system/components/ui/page-header`.
*/
function PageHeader(t0) {
	const $ = c(23);
	if ($[0] !== "c08005b26cc6770a37e4d7454ee68d20a4a03549314f851dd702dd47bb3346fa") {
		for (let $i = 0; $i < 23; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "c08005b26cc6770a37e4d7454ee68d20a4a03549314f851dd702dd47bb3346fa";
	}
	let action;
	let className;
	let props;
	let section;
	let title;
	if ($[1] !== t0) {
		({className, title, section, action, ...props} = t0);
		$[1] = t0;
		$[2] = action;
		$[3] = className;
		$[4] = props;
		$[5] = section;
		$[6] = title;
	} else {
		action = $[2];
		className = $[3];
		props = $[4];
		section = $[5];
		title = $[6];
	}
	let t1;
	if ($[7] !== className) {
		t1 = cn("flex h-[52px] flex-none items-center gap-3.5 border-b border-white/10 px-6", className);
		$[7] = className;
		$[8] = t1;
	} else t1 = $[8];
	let t2;
	if ($[9] !== section) {
		t2 = section ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("span", {
			className: "truncate text-[13px] text-gx-text-disabled",
			children: section
		}), /* @__PURE__ */ jsx("span", {
			className: "text-[13px] text-gx-text-disabled",
			"aria-hidden": "true",
			children: "/"
		})] }) : null;
		$[9] = section;
		$[10] = t2;
	} else t2 = $[10];
	let t3;
	if ($[11] !== title) {
		t3 = /* @__PURE__ */ jsx("h1", {
			className: "truncate text-[15px] font-bold tracking-[0.02em] text-gx-text",
			children: title
		});
		$[11] = title;
		$[12] = t3;
	} else t3 = $[12];
	let t4;
	if ($[13] !== t2 || $[14] !== t3) {
		t4 = /* @__PURE__ */ jsxs("div", {
			className: "flex min-w-0 items-center gap-2",
			children: [t2, t3]
		});
		$[13] = t2;
		$[14] = t3;
		$[15] = t4;
	} else t4 = $[15];
	let t5;
	if ($[16] !== action) {
		t5 = action ? /* @__PURE__ */ jsx("div", {
			className: "ml-auto flex flex-none items-center",
			children: action
		}) : null;
		$[16] = action;
		$[17] = t5;
	} else t5 = $[17];
	let t6;
	if ($[18] !== props || $[19] !== t1 || $[20] !== t4 || $[21] !== t5) {
		t6 = /* @__PURE__ */ jsxs("header", {
			"data-slot": "page-header",
			className: t1,
			...props,
			children: [t4, t5]
		});
		$[18] = props;
		$[19] = t1;
		$[20] = t4;
		$[21] = t5;
		$[22] = t6;
	} else t6 = $[22];
	return t6;
}
//#endregion
//#region src/components/ui/empty.tsx
function Empty(t0) {
	const $ = c(9);
	if ($[0] !== "507dbeb60c2eb1725f4efa1def40fe6a6c066b546d27c7d100d5860023f48107") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "507dbeb60c2eb1725f4efa1def40fe6a6c066b546d27c7d100d5860023f48107";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex w-full min-w-0 flex-1 flex-col items-center justify-center gap-4 rounded-xl border-dashed p-6 text-center text-balance", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "empty",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function EmptyHeader(t0) {
	const $ = c(9);
	if ($[0] !== "507dbeb60c2eb1725f4efa1def40fe6a6c066b546d27c7d100d5860023f48107") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "507dbeb60c2eb1725f4efa1def40fe6a6c066b546d27c7d100d5860023f48107";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex max-w-sm flex-col items-center gap-2", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "empty-header",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
const emptyMediaVariants = cva("mb-2 flex shrink-0 items-center justify-center [&_svg]:pointer-events-none [&_svg]:shrink-0", {
	variants: { variant: {
		default: "bg-transparent",
		icon: "flex size-8 shrink-0 items-center justify-center rounded-lg bg-muted text-foreground [&_svg:not([class*='size-'])]:size-4"
	} },
	defaultVariants: { variant: "default" }
});
function EmptyMedia(t0) {
	const $ = c(12);
	if ($[0] !== "507dbeb60c2eb1725f4efa1def40fe6a6c066b546d27c7d100d5860023f48107") {
		for (let $i = 0; $i < 12; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "507dbeb60c2eb1725f4efa1def40fe6a6c066b546d27c7d100d5860023f48107";
	}
	let className;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, variant: t1, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
	}
	const variant = t1 === void 0 ? "default" : t1;
	let t2;
	if ($[5] !== className || $[6] !== variant) {
		t2 = cn(emptyMediaVariants({
			variant,
			className
		}));
		$[5] = className;
		$[6] = variant;
		$[7] = t2;
	} else t2 = $[7];
	let t3;
	if ($[8] !== props || $[9] !== t2 || $[10] !== variant) {
		t3 = /* @__PURE__ */ jsx("div", {
			"data-slot": "empty-icon",
			"data-variant": variant,
			className: t2,
			...props
		});
		$[8] = props;
		$[9] = t2;
		$[10] = variant;
		$[11] = t3;
	} else t3 = $[11];
	return t3;
}
function EmptyTitle(t0) {
	const $ = c(9);
	if ($[0] !== "507dbeb60c2eb1725f4efa1def40fe6a6c066b546d27c7d100d5860023f48107") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "507dbeb60c2eb1725f4efa1def40fe6a6c066b546d27c7d100d5860023f48107";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("font-heading text-sm font-medium tracking-tight", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "empty-title",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function EmptyDescription(t0) {
	const $ = c(9);
	if ($[0] !== "507dbeb60c2eb1725f4efa1def40fe6a6c066b546d27c7d100d5860023f48107") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "507dbeb60c2eb1725f4efa1def40fe6a6c066b546d27c7d100d5860023f48107";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("text-sm/relaxed text-muted-foreground [&>a]:underline [&>a]:underline-offset-4 [&>a:hover]:text-primary", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "empty-description",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function EmptyContent(t0) {
	const $ = c(9);
	if ($[0] !== "507dbeb60c2eb1725f4efa1def40fe6a6c066b546d27c7d100d5860023f48107") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "507dbeb60c2eb1725f4efa1def40fe6a6c066b546d27c7d100d5860023f48107";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex w-full max-w-sm min-w-0 flex-col items-center gap-2.5 text-sm text-balance", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx("div", {
			"data-slot": "empty-content",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/ui/combobox.tsx
const Combobox = Combobox$1.Root;
const PREVIEW_PANEL_WIDTH$1 = 192;
function usePreviewSide$1(preview, panelWidth) {
	const $ = c(7);
	if ($[0] !== "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b") {
		for (let $i = 0; $i < 7; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b";
	}
	const containerRef = React.useRef(null);
	const [side, setSide] = React.useState("right");
	let t0;
	let t1;
	if ($[1] !== panelWidth || $[2] !== preview) {
		t0 = () => {
			if (!preview) return;
			const el = containerRef.current;
			if (!el) return;
			const updateSide = () => {
				const rect = el.getBoundingClientRect();
				const spaceRight = window.innerWidth - rect.right;
				const spaceLeft = rect.left;
				setSide(spaceRight >= panelWidth || spaceRight >= spaceLeft ? "right" : "left");
			};
			updateSide();
			const raf = requestAnimationFrame(updateSide);
			window.addEventListener("resize", updateSide);
			return () => {
				cancelAnimationFrame(raf);
				window.removeEventListener("resize", updateSide);
			};
		};
		t1 = [preview, panelWidth];
		$[1] = panelWidth;
		$[2] = preview;
		$[3] = t0;
		$[4] = t1;
	} else {
		t0 = $[3];
		t1 = $[4];
	}
	React.useLayoutEffect(t0, t1);
	let t2;
	if ($[5] !== side) {
		t2 = {
			containerRef,
			side
		};
		$[5] = side;
		$[6] = t2;
	} else t2 = $[6];
	return t2;
}
function ComboboxTrigger(t0) {
	const $ = c(12);
	if ($[0] !== "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b") {
		for (let $i = 0; $i < 12; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b";
	}
	let children;
	let className;
	let props;
	if ($[1] !== t0) {
		({className, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
	}
	let t1;
	if ($[5] !== className) {
		t1 = cn("[&_svg:not([class*='size-'])]:size-4", className);
		$[5] = className;
		$[6] = t1;
	} else t1 = $[6];
	let t2;
	if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = /* @__PURE__ */ jsx(ChevronDownIcon, { className: "pointer-events-none size-4 text-muted-foreground" });
		$[7] = t2;
	} else t2 = $[7];
	let t3;
	if ($[8] !== children || $[9] !== props || $[10] !== t1) {
		t3 = /* @__PURE__ */ jsxs(Combobox$1.Trigger, {
			"data-slot": "combobox-trigger",
			className: t1,
			...props,
			children: [children, t2]
		});
		$[8] = children;
		$[9] = props;
		$[10] = t1;
		$[11] = t3;
	} else t3 = $[11];
	return t3;
}
function ComboboxClear(t0) {
	const $ = c(11);
	if ($[0] !== "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b") {
		for (let $i = 0; $i < 11; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = /* @__PURE__ */ jsx(InputGroupButton, {
			variant: "ghost",
			size: "icon-xs"
		});
		$[4] = t1;
	} else t1 = $[4];
	let t2;
	if ($[5] !== className) {
		t2 = cn(className);
		$[5] = className;
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
		t3 = /* @__PURE__ */ jsx(XIcon, { className: "pointer-events-none" });
		$[7] = t3;
	} else t3 = $[7];
	let t4;
	if ($[8] !== props || $[9] !== t2) {
		t4 = /* @__PURE__ */ jsx(Combobox$1.Clear, {
			"data-slot": "combobox-clear",
			render: t1,
			className: t2,
			...props,
			children: t3
		});
		$[8] = props;
		$[9] = t2;
		$[10] = t4;
	} else t4 = $[10];
	return t4;
}
function ComboboxInput(t0) {
	const $ = c(29);
	if ($[0] !== "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b") {
		for (let $i = 0; $i < 29; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b";
	}
	let children;
	let className;
	let props;
	let t1;
	let t2;
	let t3;
	if ($[1] !== t0) {
		({className, children, disabled: t1, showTrigger: t2, showClear: t3, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
		$[5] = t1;
		$[6] = t2;
		$[7] = t3;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
		t1 = $[5];
		t2 = $[6];
		t3 = $[7];
	}
	const disabled = t1 === void 0 ? false : t1;
	const showTrigger = t2 === void 0 ? true : t2;
	const showClear = t3 === void 0 ? false : t3;
	let t4;
	if ($[8] !== className) {
		t4 = cn("w-auto", className);
		$[8] = className;
		$[9] = t4;
	} else t4 = $[9];
	let t5;
	if ($[10] !== disabled) {
		t5 = /* @__PURE__ */ jsx(InputGroupInput, { disabled });
		$[10] = disabled;
		$[11] = t5;
	} else t5 = $[11];
	let t6;
	if ($[12] !== props || $[13] !== t5) {
		t6 = /* @__PURE__ */ jsx(Combobox$1.Input, {
			render: t5,
			...props
		});
		$[12] = props;
		$[13] = t5;
		$[14] = t6;
	} else t6 = $[14];
	let t7;
	if ($[15] !== disabled || $[16] !== showTrigger) {
		t7 = showTrigger && /* @__PURE__ */ jsx(InputGroupButton, {
			size: "icon-xs",
			variant: "ghost",
			render: /* @__PURE__ */ jsx(ComboboxTrigger, {}),
			"data-slot": "input-group-button",
			className: "group-has-data-[slot=combobox-clear]/input-group:hidden data-pressed:bg-transparent",
			disabled
		});
		$[15] = disabled;
		$[16] = showTrigger;
		$[17] = t7;
	} else t7 = $[17];
	let t8;
	if ($[18] !== disabled || $[19] !== showClear) {
		t8 = showClear && /* @__PURE__ */ jsx(ComboboxClear, { disabled });
		$[18] = disabled;
		$[19] = showClear;
		$[20] = t8;
	} else t8 = $[20];
	let t9;
	if ($[21] !== t7 || $[22] !== t8) {
		t9 = /* @__PURE__ */ jsxs(InputGroupAddon, {
			align: "inline-end",
			children: [t7, t8]
		});
		$[21] = t7;
		$[22] = t8;
		$[23] = t9;
	} else t9 = $[23];
	let t10;
	if ($[24] !== children || $[25] !== t4 || $[26] !== t6 || $[27] !== t9) {
		t10 = /* @__PURE__ */ jsxs(InputGroup, {
			className: t4,
			children: [
				t6,
				t9,
				children
			]
		});
		$[24] = children;
		$[25] = t4;
		$[26] = t6;
		$[27] = t9;
		$[28] = t10;
	} else t10 = $[28];
	return t10;
}
function ComboboxContent(t0) {
	const $ = c(32);
	if ($[0] !== "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b") {
		for (let $i = 0; $i < 32; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b";
	}
	let anchor;
	let children;
	let className;
	let preview;
	let props;
	let t1;
	let t2;
	let t3;
	let t4;
	if ($[1] !== t0) {
		({className, children, preview, side: t1, sideOffset: t2, align: t3, alignOffset: t4, anchor, ...props} = t0);
		$[1] = t0;
		$[2] = anchor;
		$[3] = children;
		$[4] = className;
		$[5] = preview;
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
		$[9] = t3;
		$[10] = t4;
	} else {
		anchor = $[2];
		children = $[3];
		className = $[4];
		preview = $[5];
		props = $[6];
		t1 = $[7];
		t2 = $[8];
		t3 = $[9];
		t4 = $[10];
	}
	const side = t1 === void 0 ? "bottom" : t1;
	const sideOffset = t2 === void 0 ? 6 : t2;
	const align = t3 === void 0 ? "start" : t3;
	const alignOffset = t4 === void 0 ? 0 : t4;
	const { containerRef, side: previewSide } = usePreviewSide$1(preview, PREVIEW_PANEL_WIDTH$1);
	const t5 = !!anchor;
	let t6;
	if ($[11] !== className) {
		t6 = cn("group/combobox-content relative w-(--anchor-width) max-w-(--available-width) min-w-[calc(var(--anchor-width)+--spacing(7))] origin-(--transform-origin) rounded-lg bg-popover text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[chips=true]:min-w-(--anchor-width) data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", className);
		$[11] = className;
		$[12] = t6;
	} else t6 = $[12];
	let t7;
	if ($[13] !== children) {
		t7 = /* @__PURE__ */ jsx("div", {
			className: "max-h-(--available-height) overflow-hidden rounded-lg [&_[data-slot=input-group]]:m-1 [&_[data-slot=input-group]]:mb-0 [&_[data-slot=input-group]]:h-8 [&_[data-slot=input-group]]:border-input/30 [&_[data-slot=input-group]]:bg-input/30 [&_[data-slot=input-group]]:shadow-none",
			children
		});
		$[13] = children;
		$[14] = t7;
	} else t7 = $[14];
	let t8;
	if ($[15] !== preview || $[16] !== previewSide) {
		t8 = preview && /* @__PURE__ */ jsx("div", {
			"data-slot": "combobox-preview",
			"data-side": previewSide,
			className: cn("absolute top-0 z-10 max-h-(--available-height) w-48 overflow-y-auto rounded-lg bg-popover p-3 text-sm text-foreground shadow-md ring-1 ring-foreground/10", previewSide === "right" ? "left-full ml-1" : "right-full mr-1"),
			children: preview
		});
		$[15] = preview;
		$[16] = previewSide;
		$[17] = t8;
	} else t8 = $[17];
	let t9;
	if ($[18] !== containerRef || $[19] !== props || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
		t9 = /* @__PURE__ */ jsxs(Combobox$1.Popup, {
			ref: containerRef,
			"data-slot": "combobox-content",
			"data-chips": t5,
			className: t6,
			...props,
			children: [t7, t8]
		});
		$[18] = containerRef;
		$[19] = props;
		$[20] = t5;
		$[21] = t6;
		$[22] = t7;
		$[23] = t8;
		$[24] = t9;
	} else t9 = $[24];
	let t10;
	if ($[25] !== align || $[26] !== alignOffset || $[27] !== anchor || $[28] !== side || $[29] !== sideOffset || $[30] !== t9) {
		t10 = /* @__PURE__ */ jsx(Combobox$1.Portal, { children: /* @__PURE__ */ jsx(Combobox$1.Positioner, {
			side,
			sideOffset,
			align,
			alignOffset,
			anchor,
			className: "isolate z-[var(--z-panel-floating)]",
			children: t9
		}) });
		$[25] = align;
		$[26] = alignOffset;
		$[27] = anchor;
		$[28] = side;
		$[29] = sideOffset;
		$[30] = t9;
		$[31] = t10;
	} else t10 = $[31];
	return t10;
}
function ComboboxList(t0) {
	const $ = c(9);
	if ($[0] !== "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("no-scrollbar max-h-[min(calc(--spacing(72)---spacing(9)),calc(var(--available-height)---spacing(9)))] scroll-py-1 overflow-y-auto overscroll-contain p-1 data-empty:p-0", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Combobox$1.List, {
			"data-slot": "combobox-list",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function ComboboxItem(t0) {
	const $ = c(12);
	if ($[0] !== "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b") {
		for (let $i = 0; $i < 12; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b";
	}
	let children;
	let className;
	let props;
	if ($[1] !== t0) {
		({className, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
	}
	let t1;
	if ($[5] !== className) {
		t1 = cn("relative flex w-full cursor-default items-center gap-2 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none data-highlighted:bg-accent data-highlighted:text-accent-foreground not-data-[variant=destructive]:data-highlighted:**:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className);
		$[5] = className;
		$[6] = t1;
	} else t1 = $[6];
	let t2;
	if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = /* @__PURE__ */ jsx(Combobox$1.ItemIndicator, {
			render: /* @__PURE__ */ jsx("span", { className: "pointer-events-none absolute right-2 flex size-4 items-center justify-center" }),
			children: /* @__PURE__ */ jsx(CheckIcon, { className: "pointer-events-none" })
		});
		$[7] = t2;
	} else t2 = $[7];
	let t3;
	if ($[8] !== children || $[9] !== props || $[10] !== t1) {
		t3 = /* @__PURE__ */ jsxs(Combobox$1.Item, {
			"data-slot": "combobox-item",
			className: t1,
			...props,
			children: [children, t2]
		});
		$[8] = children;
		$[9] = props;
		$[10] = t1;
		$[11] = t3;
	} else t3 = $[11];
	return t3;
}
function ComboboxGroup(t0) {
	const $ = c(9);
	if ($[0] !== "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn(className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Combobox$1.Group, {
			"data-slot": "combobox-group",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function ComboboxLabel(t0) {
	const $ = c(9);
	if ($[0] !== "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("px-2 py-1.5 text-xs text-muted-foreground", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Combobox$1.GroupLabel, {
			"data-slot": "combobox-label",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function ComboboxCollection(t0) {
	const $ = c(5);
	if ($[0] !== "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Combobox$1.Collection, {
			"data-slot": "combobox-collection",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function ComboboxEmpty(t0) {
	const $ = c(9);
	if ($[0] !== "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "bb95efa3365d6c4c001e160dd436772b308ed0adcf0e59c47d5d32e0c8f1bb9b";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("hidden w-full justify-center py-2 text-center text-sm text-muted-foreground group-data-empty/combobox-content:flex", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Combobox$1.Empty, {
			"data-slot": "combobox-empty",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/ui/select.tsx
const Select = Select$1.Root;
const PREVIEW_PANEL_WIDTH = 192;
function usePreviewSide(preview, panelWidth) {
	const $ = c(7);
	if ($[0] !== "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3") {
		for (let $i = 0; $i < 7; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3";
	}
	const containerRef = React.useRef(null);
	const [side, setSide] = React.useState("right");
	let t0;
	let t1;
	if ($[1] !== panelWidth || $[2] !== preview) {
		t0 = () => {
			if (!preview) return;
			const el = containerRef.current;
			if (!el) return;
			const updateSide = () => {
				const rect = el.getBoundingClientRect();
				const spaceRight = window.innerWidth - rect.right;
				const spaceLeft = rect.left;
				setSide(spaceRight >= panelWidth || spaceRight >= spaceLeft ? "right" : "left");
			};
			updateSide();
			const raf = requestAnimationFrame(updateSide);
			window.addEventListener("resize", updateSide);
			return () => {
				cancelAnimationFrame(raf);
				window.removeEventListener("resize", updateSide);
			};
		};
		t1 = [preview, panelWidth];
		$[1] = panelWidth;
		$[2] = preview;
		$[3] = t0;
		$[4] = t1;
	} else {
		t0 = $[3];
		t1 = $[4];
	}
	React.useLayoutEffect(t0, t1);
	let t2;
	if ($[5] !== side) {
		t2 = {
			containerRef,
			side
		};
		$[5] = side;
		$[6] = t2;
	} else t2 = $[6];
	return t2;
}
function SelectGroup(t0) {
	const $ = c(9);
	if ($[0] !== "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("scroll-my-1 p-1", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Select$1.Group, {
			"data-slot": "select-group",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SelectValue(t0) {
	const $ = c(9);
	if ($[0] !== "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex flex-1 text-left", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Select$1.Value, {
			"data-slot": "select-value",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SelectTrigger(t0) {
	const $ = c(14);
	if ($[0] !== "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3") {
		for (let $i = 0; $i < 14; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3";
	}
	let children;
	let className;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, size: t1, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
		$[5] = t1;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
		t1 = $[5];
	}
	const size = t1 === void 0 ? "default" : t1;
	let t2;
	if ($[6] !== className) {
		t2 = cn("flex w-fit items-center justify-between gap-1.5 rounded-lg border border-input bg-transparent py-2 pr-2 pl-2.5 text-sm whitespace-nowrap transition-colors outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-placeholder:text-muted-foreground data-[size=default]:h-8 data-[size=sm]:h-7 data-[size=sm]:rounded-[min(var(--radius-md),10px)] *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-1.5 dark:bg-input/30 dark:hover:bg-input/50 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className);
		$[6] = className;
		$[7] = t2;
	} else t2 = $[7];
	let t3;
	if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
		t3 = /* @__PURE__ */ jsx(Select$1.Icon, { render: /* @__PURE__ */ jsx(ChevronDownIcon, { className: "pointer-events-none size-4 text-muted-foreground" }) });
		$[8] = t3;
	} else t3 = $[8];
	let t4;
	if ($[9] !== children || $[10] !== props || $[11] !== size || $[12] !== t2) {
		t4 = /* @__PURE__ */ jsxs(Select$1.Trigger, {
			"data-slot": "select-trigger",
			"data-size": size,
			className: t2,
			...props,
			children: [children, t3]
		});
		$[9] = children;
		$[10] = props;
		$[11] = size;
		$[12] = t2;
		$[13] = t4;
	} else t4 = $[13];
	return t4;
}
function SelectContent(t0) {
	const $ = c(36);
	if ($[0] !== "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3") {
		for (let $i = 0; $i < 36; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3";
	}
	let children;
	let className;
	let preview;
	let props;
	let t1;
	let t2;
	let t3;
	let t4;
	let t5;
	if ($[1] !== t0) {
		({className, children, preview, side: t1, sideOffset: t2, align: t3, alignOffset: t4, alignItemWithTrigger: t5, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = preview;
		$[5] = props;
		$[6] = t1;
		$[7] = t2;
		$[8] = t3;
		$[9] = t4;
		$[10] = t5;
	} else {
		children = $[2];
		className = $[3];
		preview = $[4];
		props = $[5];
		t1 = $[6];
		t2 = $[7];
		t3 = $[8];
		t4 = $[9];
		t5 = $[10];
	}
	const side = t1 === void 0 ? "bottom" : t1;
	const sideOffset = t2 === void 0 ? 4 : t2;
	const align = t3 === void 0 ? "center" : t3;
	const alignOffset = t4 === void 0 ? 0 : t4;
	const alignItemWithTrigger = t5 === void 0 ? true : t5;
	const { containerRef, side: previewSide } = usePreviewSide(preview, PREVIEW_PANEL_WIDTH);
	let t6;
	if ($[11] !== className) {
		t6 = cn("relative isolate z-50 w-(--anchor-width) min-w-36 origin-(--transform-origin) rounded-lg bg-popover text-popover-foreground shadow-md ring-1 ring-foreground/10 duration-100 data-[align-trigger=true]:animate-none data-[side=bottom]:slide-in-from-top-2 data-[side=inline-end]:slide-in-from-left-2 data-[side=inline-start]:slide-in-from-right-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-open:animate-in data-open:fade-in-0 data-open:zoom-in-95 data-closed:animate-out data-closed:fade-out-0 data-closed:zoom-out-95", className);
		$[11] = className;
		$[12] = t6;
	} else t6 = $[12];
	let t7;
	if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
		t7 = /* @__PURE__ */ jsx(SelectScrollUpButton, {});
		$[13] = t7;
	} else t7 = $[13];
	let t8;
	if ($[14] !== children) {
		t8 = /* @__PURE__ */ jsx(Select$1.List, { children });
		$[14] = children;
		$[15] = t8;
	} else t8 = $[15];
	let t9;
	if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
		t9 = /* @__PURE__ */ jsx(SelectScrollDownButton, {});
		$[16] = t9;
	} else t9 = $[16];
	let t10;
	if ($[17] !== t8) {
		t10 = /* @__PURE__ */ jsxs("div", {
			className: "max-h-(--available-height) overflow-x-hidden overflow-y-auto rounded-lg",
			children: [
				t7,
				t8,
				t9
			]
		});
		$[17] = t8;
		$[18] = t10;
	} else t10 = $[18];
	let t11;
	if ($[19] !== preview || $[20] !== previewSide) {
		t11 = preview && /* @__PURE__ */ jsx("div", {
			"data-slot": "select-preview",
			"data-side": previewSide,
			className: cn("absolute top-0 z-10 max-h-(--available-height) w-48 overflow-y-auto rounded-lg bg-popover p-3 text-sm text-foreground shadow-md ring-1 ring-foreground/10", previewSide === "right" ? "left-full ml-1" : "right-full mr-1"),
			children: preview
		});
		$[19] = preview;
		$[20] = previewSide;
		$[21] = t11;
	} else t11 = $[21];
	let t12;
	if ($[22] !== alignItemWithTrigger || $[23] !== containerRef || $[24] !== props || $[25] !== t10 || $[26] !== t11 || $[27] !== t6) {
		t12 = /* @__PURE__ */ jsxs(Select$1.Popup, {
			ref: containerRef,
			"data-slot": "select-content",
			"data-align-trigger": alignItemWithTrigger,
			className: t6,
			...props,
			children: [t10, t11]
		});
		$[22] = alignItemWithTrigger;
		$[23] = containerRef;
		$[24] = props;
		$[25] = t10;
		$[26] = t11;
		$[27] = t6;
		$[28] = t12;
	} else t12 = $[28];
	let t13;
	if ($[29] !== align || $[30] !== alignItemWithTrigger || $[31] !== alignOffset || $[32] !== side || $[33] !== sideOffset || $[34] !== t12) {
		t13 = /* @__PURE__ */ jsx(Select$1.Portal, { children: /* @__PURE__ */ jsx(Select$1.Positioner, {
			side,
			sideOffset,
			align,
			alignOffset,
			alignItemWithTrigger,
			className: "isolate z-50",
			children: t12
		}) });
		$[29] = align;
		$[30] = alignItemWithTrigger;
		$[31] = alignOffset;
		$[32] = side;
		$[33] = sideOffset;
		$[34] = t12;
		$[35] = t13;
	} else t13 = $[35];
	return t13;
}
function SelectLabel(t0) {
	const $ = c(9);
	if ($[0] !== "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("px-1.5 py-1 text-xs text-muted-foreground", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Select$1.GroupLabel, {
			"data-slot": "select-label",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SelectItem(t0) {
	const $ = c(14);
	if ($[0] !== "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3") {
		for (let $i = 0; $i < 14; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3";
	}
	let children;
	let className;
	let props;
	if ($[1] !== t0) {
		({className, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
	}
	let t1;
	if ($[5] !== className) {
		t1 = cn("relative flex w-full cursor-default items-center gap-1.5 rounded-md py-1 pr-8 pl-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground not-data-[variant=destructive]:focus:**:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", className);
		$[5] = className;
		$[6] = t1;
	} else t1 = $[6];
	let t2;
	if ($[7] !== children) {
		t2 = /* @__PURE__ */ jsx(Select$1.ItemText, {
			className: "flex flex-1 shrink-0 gap-2 whitespace-nowrap",
			children
		});
		$[7] = children;
		$[8] = t2;
	} else t2 = $[8];
	let t3;
	if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
		t3 = /* @__PURE__ */ jsx(Select$1.ItemIndicator, {
			render: /* @__PURE__ */ jsx("span", { className: "pointer-events-none absolute right-2 flex size-4 items-center justify-center" }),
			children: /* @__PURE__ */ jsx(CheckIcon, { className: "pointer-events-none" })
		});
		$[9] = t3;
	} else t3 = $[9];
	let t4;
	if ($[10] !== props || $[11] !== t1 || $[12] !== t2) {
		t4 = /* @__PURE__ */ jsxs(Select$1.Item, {
			"data-slot": "select-item",
			className: t1,
			...props,
			children: [t2, t3]
		});
		$[10] = props;
		$[11] = t1;
		$[12] = t2;
		$[13] = t4;
	} else t4 = $[13];
	return t4;
}
function SelectSeparator(t0) {
	const $ = c(9);
	if ($[0] !== "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("pointer-events-none -mx-1 my-1 h-px bg-border", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Select$1.Separator, {
			"data-slot": "select-separator",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function SelectScrollUpButton(t0) {
	const $ = c(10);
	if ($[0] !== "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3") {
		for (let $i = 0; $i < 10; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("top-0 z-10 flex w-full cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-4", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = /* @__PURE__ */ jsx(ChevronUpIcon, {});
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] !== props || $[8] !== t1) {
		t3 = /* @__PURE__ */ jsx(Select$1.ScrollUpArrow, {
			"data-slot": "select-scroll-up-button",
			className: t1,
			...props,
			children: t2
		});
		$[7] = props;
		$[8] = t1;
		$[9] = t3;
	} else t3 = $[9];
	return t3;
}
function SelectScrollDownButton(t0) {
	const $ = c(10);
	if ($[0] !== "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3") {
		for (let $i = 0; $i < 10; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "696fd18c1ede53b6058b5b1a149d358c1c379afc8681d5ae6767fe4d780159c3";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("bottom-0 z-10 flex w-full cursor-default items-center justify-center bg-popover py-1 [&_svg:not([class*='size-'])]:size-4", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = /* @__PURE__ */ jsx(ChevronDownIcon, {});
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] !== props || $[8] !== t1) {
		t3 = /* @__PURE__ */ jsx(Select$1.ScrollDownArrow, {
			"data-slot": "select-scroll-down-button",
			className: t1,
			...props,
			children: t2
		});
		$[7] = props;
		$[8] = t1;
		$[9] = t3;
	} else t3 = $[9];
	return t3;
}
//#endregion
//#region src/components/ui/spinner.tsx
function Spinner(t0) {
	const $ = c(9);
	if ($[0] !== "f7ef778dbd7db06255d379293597b4e35435d9011b57a7e242aa7cdd6e2d40e2") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f7ef778dbd7db06255d379293597b4e35435d9011b57a7e242aa7cdd6e2d40e2";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("size-4 animate-spin motion-reduce:animate-none motion-reduce:transition-none", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Loader2Icon, {
			"data-slot": "spinner",
			role: "status",
			"aria-label": "Loading",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
//#endregion
//#region src/components/ui/switch.tsx
function Switch(t0) {
	const $ = c(12);
	if ($[0] !== "960167e56d6ada6fde674a42663f0c5e4e2a93e7dbdf9d772f30cf8228ab033f") {
		for (let $i = 0; $i < 12; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "960167e56d6ada6fde674a42663f0c5e4e2a93e7dbdf9d772f30cf8228ab033f";
	}
	let className;
	let props;
	let t1;
	if ($[1] !== t0) {
		({className, size: t1, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
	}
	const size = t1 === void 0 ? "default" : t1;
	let t2;
	if ($[5] !== className) {
		t2 = cn("peer group/switch relative inline-flex shrink-0 items-center rounded-full border border-transparent transition-all outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-[size=default]:h-[18.4px] data-[size=default]:w-[32px] data-[size=sm]:h-[14px] data-[size=sm]:w-[24px] dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:bg-primary data-unchecked:bg-input dark:data-unchecked:bg-input/80 data-disabled:cursor-not-allowed data-disabled:opacity-50", className);
		$[5] = className;
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
		t3 = /* @__PURE__ */ jsx(Switch$1.Thumb, {
			"data-slot": "switch-thumb",
			className: "pointer-events-none block rounded-full bg-background ring-0 transition-transform group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-3 group-data-[size=default]/switch:data-checked:translate-x-[calc(100%-2px)] group-data-[size=sm]/switch:data-checked:translate-x-[calc(100%-2px)] dark:data-checked:bg-primary-foreground group-data-[size=default]/switch:data-unchecked:translate-x-0 group-data-[size=sm]/switch:data-unchecked:translate-x-0 dark:data-unchecked:bg-foreground"
		});
		$[7] = t3;
	} else t3 = $[7];
	let t4;
	if ($[8] !== props || $[9] !== size || $[10] !== t2) {
		t4 = /* @__PURE__ */ jsx(Switch$1.Root, {
			"data-slot": "switch",
			"data-size": size,
			className: t2,
			...props,
			children: t3
		});
		$[8] = props;
		$[9] = size;
		$[10] = t2;
		$[11] = t4;
	} else t4 = $[11];
	return t4;
}
//#endregion
//#region src/components/ui/toast.tsx
const toast = Toast$1.createToastManager();
function ToastProvider(t0) {
	const $ = c(5);
	if ($[0] !== "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Toast$1.Provider, {
			toastManager: toast,
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function ToastPortal(t0) {
	const $ = c(5);
	if ($[0] !== "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c") {
		for (let $i = 0; $i < 5; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c";
	}
	let props;
	if ($[1] !== t0) {
		({...props} = t0);
		$[1] = t0;
		$[2] = props;
	} else props = $[2];
	let t1;
	if ($[3] !== props) {
		t1 = /* @__PURE__ */ jsx(Toast$1.Portal, {
			"data-slot": "toast-portal",
			...props
		});
		$[3] = props;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
}
function ToastViewport(t0) {
	const $ = c(9);
	if ($[0] !== "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("pointer-events-none fixed inset-x-4 bottom-4 z-[var(--z-snackbar)] mx-auto w-auto max-w-sm outline-none sm:right-auto sm:left-4 sm:mx-0 sm:w-full", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Toast$1.Viewport, {
			"data-slot": "toast-viewport",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function Toast(t0) {
	const $ = c(9);
	if ($[0] !== "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("group/toast pointer-events-auto absolute bottom-0 left-0 z-[calc(1000-var(--toast-index))] w-full origin-bottom rounded-2xl border bg-popover text-popover-foreground shadow-lg will-change-transform outline-none select-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50", "[--gap:0.75rem] [--height:var(--toast-frontmost-height,var(--toast-height))] [--offset-y:calc(var(--toast-offset-y)*-1+calc(var(--toast-index)*var(--gap)*-1)+var(--toast-swipe-movement-y))] [--peek:0.75rem] [--scale:calc(max(0,1-(var(--toast-index)*0.1)))] [--shrink:calc(1-var(--scale))]", "h-(--height) [transform:translateX(var(--toast-swipe-movement-x))_translateY(calc(var(--toast-swipe-movement-y)-(var(--toast-index)*var(--peek))-(var(--shrink)*var(--height))))_scale(var(--scale))] [transition:transform_500ms_cubic-bezier(0.22,1,0.36,1),opacity_500ms,height_150ms]", "after:absolute after:top-full after:left-0 after:h-[calc(var(--gap)+1px)] after:w-full after:content-['']", "data-expanded:h-(--toast-height) data-expanded:[transform:translateX(var(--toast-swipe-movement-x))_translateY(var(--offset-y))]", "data-limited:opacity-0 data-starting-style:[transform:translateY(150%)]", "[&[data-ending-style]:not([data-limited]):not([data-swipe-direction])]:[transform:translateY(150%)]", "data-ending-style:data-[swipe-direction=down]:[transform:translateY(calc(var(--toast-swipe-movement-y)+150%))]", "data-ending-style:data-[swipe-direction=left]:[transform:translateX(calc(var(--toast-swipe-movement-x)-150%))_translateY(var(--offset-y))]", "data-ending-style:data-[swipe-direction=right]:[transform:translateX(calc(var(--toast-swipe-movement-x)+150%))_translateY(var(--offset-y))]", "data-ending-style:data-[swipe-direction=up]:[transform:translateY(calc(var(--toast-swipe-movement-y)-150%))]", "data-expanded:data-ending-style:data-[swipe-direction=down]:[transform:translateY(calc(var(--toast-swipe-movement-y)+150%))]", "data-expanded:data-ending-style:data-[swipe-direction=left]:[transform:translateX(calc(var(--toast-swipe-movement-x)-150%))_translateY(var(--offset-y))]", "data-expanded:data-ending-style:data-[swipe-direction=right]:[transform:translateX(calc(var(--toast-swipe-movement-x)+150%))_translateY(var(--offset-y))]", "data-expanded:data-ending-style:data-[swipe-direction=up]:[transform:translateY(calc(var(--toast-swipe-movement-y)-150%))]", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Toast$1.Root, {
			"data-slot": "toast",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function ToastContent(t0) {
	const $ = c(9);
	if ($[0] !== "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("flex h-full items-center gap-3 overflow-hidden p-4 transition-opacity duration-250 ease-[cubic-bezier(0.22,1,0.36,1)] data-behind:opacity-0 data-expanded:opacity-100", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Toast$1.Content, {
			"data-slot": "toast-content",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function ToastTitle(t0) {
	const $ = c(9);
	if ($[0] !== "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("text-sm font-medium", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Toast$1.Title, {
			"data-slot": "toast-title",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function ToastDescription(t0) {
	const $ = c(9);
	if ($[0] !== "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c") {
		for (let $i = 0; $i < 9; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("text-sm text-muted-foreground", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== props || $[7] !== t1) {
		t2 = /* @__PURE__ */ jsx(Toast$1.Description, {
			"data-slot": "toast-description",
			className: t1,
			...props
		});
		$[6] = props;
		$[7] = t1;
		$[8] = t2;
	} else t2 = $[8];
	return t2;
}
function ToastAction({ className, render = /* @__PURE__ */ jsx(Button, {
	variant: "outline",
	size: "sm"
}), ...props }) {
	return /* @__PURE__ */ jsx(Toast$1.Action, {
		"data-slot": "toast-action",
		render,
		className: cn("shrink-0", className),
		...props
	});
}
function ToastClose({ className, children, render = /* @__PURE__ */ jsx(Button, {
	variant: "ghost",
	size: "icon-sm"
}), ...props }) {
	return /* @__PURE__ */ jsx(Toast$1.Close, {
		"data-slot": "toast-close",
		"aria-label": "Close toast",
		render,
		className: cn("relative shrink-0 text-muted-foreground after:absolute after:-inset-2 after:content-[''] hover:text-foreground", className),
		...props,
		children: children ?? /* @__PURE__ */ jsx(XIcon, {
			"aria-hidden": "true",
			className: "size-4"
		})
	});
}
function ToastIcon(t0) {
	const $ = c(8);
	if ($[0] !== "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c") {
		for (let $i = 0; $i < 8; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c";
	}
	const { type } = t0;
	let icon = null;
	if (type === "success") {
		let t1;
		if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
			t1 = /* @__PURE__ */ jsx(CircleCheckIcon, {
				"aria-hidden": "true",
				className: "size-4 text-gx-success"
			});
			$[1] = t1;
		} else t1 = $[1];
		icon = t1;
	}
	if (type === "info") {
		let t1;
		if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
			t1 = /* @__PURE__ */ jsx(InfoIcon, {
				"aria-hidden": "true",
				className: "size-4 text-gx-neutral"
			});
			$[2] = t1;
		} else t1 = $[2];
		icon = t1;
	}
	if (type === "warning") {
		let t1;
		if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
			t1 = /* @__PURE__ */ jsx(TriangleAlertIcon, {
				"aria-hidden": "true",
				className: "size-4 text-gx-warning"
			});
			$[3] = t1;
		} else t1 = $[3];
		icon = t1;
	}
	if (type === "error") {
		let t1;
		if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
			t1 = /* @__PURE__ */ jsx(CircleXIcon, {
				"aria-hidden": "true",
				className: "size-4 text-gx-failure"
			});
			$[4] = t1;
		} else t1 = $[4];
		icon = t1;
	}
	if (type === "loading") {
		let t1;
		if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
			t1 = /* @__PURE__ */ jsx(Spinner, { className: "size-4" });
			$[5] = t1;
		} else t1 = $[5];
		icon = t1;
	}
	if (!icon) return null;
	let t1;
	if ($[6] !== icon) {
		t1 = /* @__PURE__ */ jsx("span", {
			"data-slot": "toast-icon",
			className: "shrink-0",
			children: icon
		});
		$[6] = icon;
		$[7] = t1;
	} else t1 = $[7];
	return t1;
}
function ToastList() {
	const $ = c(3);
	if ($[0] !== "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c") {
		for (let $i = 0; $i < 3; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c";
	}
	const { toasts } = Toast$1.useToastManager();
	let t0;
	if ($[1] !== toasts) {
		t0 = toasts.map(_temp$6);
		$[1] = toasts;
		$[2] = t0;
	} else t0 = $[2];
	return t0;
}
function _temp$6(toastItem) {
	return /* @__PURE__ */ jsx(Toast, {
		toast: toastItem,
		children: /* @__PURE__ */ jsxs(ToastContent, { children: [
			/* @__PURE__ */ jsx(ToastIcon, { type: toastItem.type }),
			/* @__PURE__ */ jsxs("div", {
				className: "flex min-w-0 flex-1 flex-col gap-1",
				children: [/* @__PURE__ */ jsx(ToastTitle, {}), /* @__PURE__ */ jsx(ToastDescription, {})]
			}),
			/* @__PURE__ */ jsx(ToastAction, {}),
			/* @__PURE__ */ jsx(ToastClose, {})
		] })
	}, toastItem.id);
}
function Toaster(t0) {
	const $ = c(10);
	if ($[0] !== "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c") {
		for (let $i = 0; $i < 10; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6d23871d310da45a6feb2b3f28a403cfccdcb2409b7452bbfe096ce5e801bc4c";
	}
	let children;
	let props;
	let t1;
	if ($[1] !== t0) {
		({children, toastManager: t1, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = props;
		$[4] = t1;
	} else {
		children = $[2];
		props = $[3];
		t1 = $[4];
	}
	const toastManager = t1 === void 0 ? toast : t1;
	let t2;
	if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = /* @__PURE__ */ jsx(ToastPortal, { children: /* @__PURE__ */ jsx(ToastViewport, { children: /* @__PURE__ */ jsx(ToastList, {}) }) });
		$[5] = t2;
	} else t2 = $[5];
	let t3;
	if ($[6] !== children || $[7] !== props || $[8] !== toastManager) {
		t3 = /* @__PURE__ */ jsxs(ToastProvider, {
			toastManager,
			...props,
			children: [children, t2]
		});
		$[6] = children;
		$[7] = props;
		$[8] = toastManager;
		$[9] = t3;
	} else t3 = $[9];
	return t3;
}
const createToastManager = Toast$1.createToastManager;
const useToastManager = Toast$1.useToastManager;
//#endregion
//#region src/components/ui/toggle.tsx
const toggleVariants = cva("group/toggle inline-flex items-center justify-center gap-1 rounded-lg text-sm font-medium whitespace-nowrap transition-all outline-none hover:bg-muted hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 aria-pressed:bg-muted data-[state=on]:bg-muted dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", {
	variants: {
		variant: {
			default: "bg-transparent",
			outline: "border border-input bg-transparent hover:bg-muted"
		},
		size: {
			default: "h-8 min-w-8 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2",
			sm: "h-7 min-w-7 rounded-[min(var(--radius-md),12px)] px-2.5 text-[0.8rem] has-data-[icon=inline-end]:pr-1.5 has-data-[icon=inline-start]:pl-1.5 [&_svg:not([class*='size-'])]:size-3.5",
			lg: "h-9 min-w-9 px-2.5 has-data-[icon=inline-end]:pr-2 has-data-[icon=inline-start]:pl-2"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
//#endregion
//#region src/components/ui/toggle-group.tsx
const ToggleGroupContext = React.createContext({
	size: "default",
	variant: "default",
	spacing: 2,
	orientation: "horizontal"
});
function ToggleGroup(t0) {
	const $ = c(30);
	if ($[0] !== "e0286237cc0e5e2a9420534c0a580635faf64e34720f4ca17c86b63466d40ad3") {
		for (let $i = 0; $i < 30; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "e0286237cc0e5e2a9420534c0a580635faf64e34720f4ca17c86b63466d40ad3";
	}
	let children;
	let className;
	let props;
	let size;
	let t1;
	let t2;
	let variant;
	if ($[1] !== t0) {
		({className, variant, size, spacing: t1, orientation: t2, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
		$[5] = size;
		$[6] = t1;
		$[7] = t2;
		$[8] = variant;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
		size = $[5];
		t1 = $[6];
		t2 = $[7];
		variant = $[8];
	}
	const spacing = t1 === void 0 ? 2 : t1;
	const orientation = t2 === void 0 ? "horizontal" : t2;
	let t3;
	if ($[9] !== spacing) {
		t3 = { "--gap": spacing };
		$[9] = spacing;
		$[10] = t3;
	} else t3 = $[10];
	const t4 = t3;
	let t5;
	if ($[11] !== className) {
		t5 = cn("group/toggle-group flex w-fit flex-row items-center gap-[--spacing(var(--gap))] rounded-lg data-[size=sm]:rounded-[min(var(--radius-md),10px)] data-vertical:flex-col data-vertical:items-stretch", className);
		$[11] = className;
		$[12] = t5;
	} else t5 = $[12];
	let t6;
	if ($[13] !== orientation || $[14] !== size || $[15] !== spacing || $[16] !== variant) {
		t6 = {
			variant,
			size,
			spacing,
			orientation
		};
		$[13] = orientation;
		$[14] = size;
		$[15] = spacing;
		$[16] = variant;
		$[17] = t6;
	} else t6 = $[17];
	let t7;
	if ($[18] !== children || $[19] !== t6) {
		t7 = /* @__PURE__ */ jsx(ToggleGroupContext.Provider, {
			value: t6,
			children
		});
		$[18] = children;
		$[19] = t6;
		$[20] = t7;
	} else t7 = $[20];
	let t8;
	if ($[21] !== orientation || $[22] !== props || $[23] !== size || $[24] !== spacing || $[25] !== t4 || $[26] !== t5 || $[27] !== t7 || $[28] !== variant) {
		t8 = /* @__PURE__ */ jsx(ToggleGroup$1, {
			"data-slot": "toggle-group",
			"data-variant": variant,
			"data-size": size,
			"data-spacing": spacing,
			"data-orientation": orientation,
			style: t4,
			className: t5,
			...props,
			children: t7
		});
		$[21] = orientation;
		$[22] = props;
		$[23] = size;
		$[24] = spacing;
		$[25] = t4;
		$[26] = t5;
		$[27] = t7;
		$[28] = variant;
		$[29] = t8;
	} else t8 = $[29];
	return t8;
}
function ToggleGroupItem(t0) {
	const $ = c(20);
	if ($[0] !== "e0286237cc0e5e2a9420534c0a580635faf64e34720f4ca17c86b63466d40ad3") {
		for (let $i = 0; $i < 20; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "e0286237cc0e5e2a9420534c0a580635faf64e34720f4ca17c86b63466d40ad3";
	}
	let children;
	let className;
	let props;
	let t1;
	let t2;
	if ($[1] !== t0) {
		({className, children, variant: t1, size: t2, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = props;
		$[5] = t1;
		$[6] = t2;
	} else {
		children = $[2];
		className = $[3];
		props = $[4];
		t1 = $[5];
		t2 = $[6];
	}
	const variant = t1 === void 0 ? "default" : t1;
	const size = t2 === void 0 ? "default" : t2;
	const context = React.useContext(ToggleGroupContext);
	const t3 = context.variant || variant;
	const t4 = context.size || size;
	const t5 = context.spacing;
	let t6;
	if ($[7] !== className || $[8] !== context.size || $[9] !== context.variant || $[10] !== size || $[11] !== variant) {
		t6 = cn("shrink-0 group-data-[spacing=0]/toggle-group:rounded-none group-data-[spacing=0]/toggle-group:px-2 focus:z-10 focus-visible:z-10 group-data-[spacing=0]/toggle-group:has-data-[icon=inline-end]:pr-1.5 group-data-[spacing=0]/toggle-group:has-data-[icon=inline-start]:pl-1.5 group-data-horizontal/toggle-group:data-[spacing=0]:first:rounded-l-lg group-data-vertical/toggle-group:data-[spacing=0]:first:rounded-t-lg group-data-horizontal/toggle-group:data-[spacing=0]:last:rounded-r-lg group-data-vertical/toggle-group:data-[spacing=0]:last:rounded-b-lg group-data-horizontal/toggle-group:data-[spacing=0]:data-[variant=outline]:border-l-0 group-data-vertical/toggle-group:data-[spacing=0]:data-[variant=outline]:border-t-0 group-data-horizontal/toggle-group:data-[spacing=0]:data-[variant=outline]:first:border-l group-data-vertical/toggle-group:data-[spacing=0]:data-[variant=outline]:first:border-t", toggleVariants({
			variant: context.variant || variant,
			size: context.size || size
		}), className);
		$[7] = className;
		$[8] = context.size;
		$[9] = context.variant;
		$[10] = size;
		$[11] = variant;
		$[12] = t6;
	} else t6 = $[12];
	let t7;
	if ($[13] !== children || $[14] !== context.spacing || $[15] !== props || $[16] !== t3 || $[17] !== t4 || $[18] !== t6) {
		t7 = /* @__PURE__ */ jsx(Toggle, {
			"data-slot": "toggle-group-item",
			"data-variant": t3,
			"data-size": t4,
			"data-spacing": t5,
			className: t6,
			...props,
			children
		});
		$[13] = children;
		$[14] = context.spacing;
		$[15] = props;
		$[16] = t3;
		$[17] = t4;
		$[18] = t6;
		$[19] = t7;
	} else t7 = $[19];
	return t7;
}
//#endregion
//#region src/lib/interactive.ts
/**
* Keyboard activation for an element made clickable via `onClick` (e.g. a `div`
* given `role="button"`): fires a native click on Enter/Space so the element's
* own `onClick` runs, matching native button semantics. Any consumer-supplied
* `onKeyDown` runs first and can cancel activation via `preventDefault()`.
*/
function activateOnEnterSpace(onKeyDown) {
	return (event) => {
		onKeyDown?.(event);
		if (event.defaultPrevented) return;
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			event.currentTarget.click();
		}
	};
}
//#endregion
//#region src/components/home/home-greeting.tsx
/**
* The homepage greeting banner: a bold greeting line over a muted date.
* Purely presentational — the consumer computes the greeting and date strings.
*
* Import path: `@design-system/components/home/home-greeting`.
*/
function HomeGreeting(t0) {
	const $ = c(17);
	if ($[0] !== "d0e40a5ee158557108ab4d90340304bdd41b990e519775bc70f332a91e0e4a21") {
		for (let $i = 0; $i < 17; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "d0e40a5ee158557108ab4d90340304bdd41b990e519775bc70f332a91e0e4a21";
	}
	let className;
	let date;
	let props;
	let title;
	if ($[1] !== t0) {
		({title, date, className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = date;
		$[4] = props;
		$[5] = title;
	} else {
		className = $[2];
		date = $[3];
		props = $[4];
		title = $[5];
	}
	let t1;
	if ($[6] !== className) {
		t1 = cn("mb-5", className);
		$[6] = className;
		$[7] = t1;
	} else t1 = $[7];
	let t2;
	if ($[8] !== title) {
		t2 = /* @__PURE__ */ jsx("h2", {
			className: "text-[22px] font-extrabold leading-[1.2] text-[#f3f2ed]",
			children: title
		});
		$[8] = title;
		$[9] = t2;
	} else t2 = $[9];
	let t3;
	if ($[10] !== date) {
		t3 = /* @__PURE__ */ jsx("p", {
			className: "text-[13px] text-[#66677a]",
			children: date
		});
		$[10] = date;
		$[11] = t3;
	} else t3 = $[11];
	let t4;
	if ($[12] !== props || $[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
		t4 = /* @__PURE__ */ jsxs("div", {
			"data-slot": "home-greeting",
			className: t1,
			...props,
			children: [t2, t3]
		});
		$[12] = props;
		$[13] = t1;
		$[14] = t2;
		$[15] = t3;
		$[16] = t4;
	} else t4 = $[16];
	return t4;
}
//#endregion
//#region src/components/home/home-section-header.tsx
const sectionTitleVariants = cva("text-[12px] uppercase", {
	variants: { variant: {
		primary: "font-extrabold tracking-[0.12em] text-[#9fa0ad]",
		secondary: "font-semibold tracking-[0.08em] text-[#66677a]"
	} },
	defaultVariants: { variant: "primary" }
});
/**
* A homepage section header: an uppercase overline title, a hairline rule, and
* an optional right-aligned action node. Presentational — the consumer supplies
* the action element (link/button); the header renders no navigation itself.
*
* Two `variant`s control the title's weight/tracking/color: `primary` (the
* default — bolder, wider tracking, brighter text; e.g. Morning Intel) and
* `secondary` (lighter weight, tighter tracking, dimmer text; e.g. Watchlist,
* My Dashboards, Catalog, Export).
*
* Import path: `@design-system/components/home/home-section-header`.
*/
function HomeSectionHeader(t0) {
	const $ = c(20);
	if ($[0] !== "1631783677024479193f1bf04ba336617d71e5382834e1ecb7bad1cde5a67908") {
		for (let $i = 0; $i < 20; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "1631783677024479193f1bf04ba336617d71e5382834e1ecb7bad1cde5a67908";
	}
	let action;
	let className;
	let props;
	let title;
	let variant;
	if ($[1] !== t0) {
		({title, action, variant, className, ...props} = t0);
		$[1] = t0;
		$[2] = action;
		$[3] = className;
		$[4] = props;
		$[5] = title;
		$[6] = variant;
	} else {
		action = $[2];
		className = $[3];
		props = $[4];
		title = $[5];
		variant = $[6];
	}
	let t1;
	if ($[7] !== className) {
		t1 = cn("mb-3 flex items-center gap-3", className);
		$[7] = className;
		$[8] = t1;
	} else t1 = $[8];
	let t2;
	if ($[9] !== variant) {
		t2 = sectionTitleVariants({ variant });
		$[9] = variant;
		$[10] = t2;
	} else t2 = $[10];
	let t3;
	if ($[11] !== t2 || $[12] !== title) {
		t3 = /* @__PURE__ */ jsx("h3", {
			className: t2,
			children: title
		});
		$[11] = t2;
		$[12] = title;
		$[13] = t3;
	} else t3 = $[13];
	let t4;
	if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
		t4 = /* @__PURE__ */ jsx("span", {
			className: "h-px flex-1 bg-[#26272f]",
			"aria-hidden": true
		});
		$[14] = t4;
	} else t4 = $[14];
	let t5;
	if ($[15] !== action || $[16] !== props || $[17] !== t1 || $[18] !== t3) {
		t5 = /* @__PURE__ */ jsxs("div", {
			"data-slot": "home-section-header",
			className: t1,
			...props,
			children: [
				t3,
				t4,
				action
			]
		});
		$[15] = action;
		$[16] = props;
		$[17] = t1;
		$[18] = t3;
		$[19] = t5;
	} else t5 = $[19];
	return t5;
}
//#endregion
//#region src/components/home/section-states.tsx
/**
* Shared empty/error state for the homepage sections: a DS `Empty` (icon +
* title + optional description). By default it is wrapped in a `Card` so the
* empty and error states share the framed look of the loading skeleton and the
* populated list (My Dashboards, Catalog, Export). Pass `framed={false}` for
* sections whose populated state is not a single bordered card (Morning Intel),
* which renders the same content without the Card. Presentational.
*
* Import path: `@design-system/components/home/section-states`.
*/
function SectionState(t0) {
	const $ = c(32);
	if ($[0] !== "9c96f2a3d92e09cc90be4e9d197c18ba030070bca074ce1f7b82cab9c8b42262") {
		for (let $i = 0; $i < 32; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "9c96f2a3d92e09cc90be4e9d197c18ba030070bca074ce1f7b82cab9c8b42262";
	}
	let className;
	let description;
	let icon;
	let props;
	let t1;
	let title;
	if ($[1] !== t0) {
		({icon, title, description, framed: t1, className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = description;
		$[4] = icon;
		$[5] = props;
		$[6] = t1;
		$[7] = title;
	} else {
		className = $[2];
		description = $[3];
		icon = $[4];
		props = $[5];
		t1 = $[6];
		title = $[7];
	}
	const framed = t1 === void 0 ? true : t1;
	let t2;
	if ($[8] !== icon) {
		t2 = /* @__PURE__ */ jsx(EmptyMedia, {
			variant: "icon",
			children: icon
		});
		$[8] = icon;
		$[9] = t2;
	} else t2 = $[9];
	let t3;
	if ($[10] !== title) {
		t3 = /* @__PURE__ */ jsx(EmptyTitle, { children: title });
		$[10] = title;
		$[11] = t3;
	} else t3 = $[11];
	let t4;
	if ($[12] !== description) {
		t4 = description ? /* @__PURE__ */ jsx(EmptyDescription, { children: description }) : null;
		$[12] = description;
		$[13] = t4;
	} else t4 = $[13];
	let t5;
	if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
		t5 = /* @__PURE__ */ jsxs(EmptyHeader, { children: [
			t2,
			t3,
			t4
		] });
		$[14] = t2;
		$[15] = t3;
		$[16] = t4;
		$[17] = t5;
	} else t5 = $[17];
	const header = t5;
	if (!framed) {
		let t6;
		if ($[18] !== className) {
			t6 = cn("border-0", className);
			$[18] = className;
			$[19] = t6;
		} else t6 = $[19];
		let t7;
		if ($[20] !== header || $[21] !== props || $[22] !== t6) {
			t7 = /* @__PURE__ */ jsx(Empty, {
				className: t6,
				...props,
				children: header
			});
			$[20] = header;
			$[21] = props;
			$[22] = t6;
			$[23] = t7;
		} else t7 = $[23];
		return t7;
	}
	let t6;
	if ($[24] !== className) {
		t6 = cn("border-white/10 py-0", className);
		$[24] = className;
		$[25] = t6;
	} else t6 = $[25];
	let t7;
	if ($[26] !== header) {
		t7 = /* @__PURE__ */ jsx(Empty, {
			className: "border-0",
			children: header
		});
		$[26] = header;
		$[27] = t7;
	} else t7 = $[27];
	let t8;
	if ($[28] !== props || $[29] !== t6 || $[30] !== t7) {
		t8 = /* @__PURE__ */ jsx(Card, {
			className: t6,
			...props,
			children: t7
		});
		$[28] = props;
		$[29] = t6;
		$[30] = t7;
		$[31] = t8;
	} else t8 = $[31];
	return t8;
}
/**
* Shared error state for the data-backed homepage sections: a card-framed
* `SectionState` with an alert icon. Non-interactive (no retry) — the consumer's
* query refetches on focus/navigation. Presentational.
*
* Import path: `@design-system/components/home/section-states`.
*/
function SectionError(t0) {
	const $ = c(10);
	if ($[0] !== "9c96f2a3d92e09cc90be4e9d197c18ba030070bca074ce1f7b82cab9c8b42262") {
		for (let $i = 0; $i < 10; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "9c96f2a3d92e09cc90be4e9d197c18ba030070bca074ce1f7b82cab9c8b42262";
	}
	let description;
	let props;
	let title;
	if ($[1] !== t0) {
		({title, description, ...props} = t0);
		$[1] = t0;
		$[2] = description;
		$[3] = props;
		$[4] = title;
	} else {
		description = $[2];
		props = $[3];
		title = $[4];
	}
	let t1;
	if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = /* @__PURE__ */ jsx(TriangleAlertIcon, {});
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	if ($[6] !== description || $[7] !== props || $[8] !== title) {
		t2 = /* @__PURE__ */ jsx(SectionState, {
			icon: t1,
			title,
			description,
			...props
		});
		$[6] = description;
		$[7] = props;
		$[8] = title;
		$[9] = t2;
	} else t2 = $[9];
	return t2;
}
//#endregion
//#region src/components/intel-importance.ts
const IMPORTANCE = {
	high: {
		label: "High importance",
		badge: "accentOutline",
		color: "var(--gx-highlight)",
		glow: "0 14px 30px -16px rgba(232, 78, 15, 0.18)"
	},
	medium: {
		label: "Medium importance",
		badge: "warningOutline",
		color: "var(--gx-warning)",
		glow: "0 14px 30px -16px rgba(240, 180, 41, 0.22)"
	},
	low: {
		label: "Low importance",
		badge: "neutralOutline",
		glow: "0 14px 30px -16px rgba(0, 0, 0, 0.5)"
	}
};
//#endregion
//#region src/components/ui/intel-summary-card.tsx
/**
* Compact intel card for the homepage summary feed: a serif title with an
* optional badge, the full blurb, and a footer row for a tag, timestamp, and
* action. No spine — matches the approved Home prototype's signal-card
* language. Purely presentational — it lays out the nodes it is given. For
* interactive use, the consumer must supply keyboard and role semantics (e.g.
* `role="button"`, `tabIndex`, an `onKeyDown` handler, and
* `aria-selected`/`aria-current` for selection) via props.
*
* Import path: `@design-system/components/ui/intel-summary-card`.
*/
function IntelSummaryCard(t0) {
	const $ = c(35);
	if ($[0] !== "e26181fe13263c61eea3be2f9cb6fa4b151609400abfc3b01146dcfe4fd238a1") {
		for (let $i = 0; $i < 35; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "e26181fe13263c61eea3be2f9cb6fa4b151609400abfc3b01146dcfe4fd238a1";
	}
	let action;
	let badge;
	let children;
	let className;
	let glow;
	let props;
	let style;
	let tag;
	let timestamp;
	let title;
	if ($[1] !== t0) {
		({className, style, title, badge, children, tag, timestamp, action, glow, ...props} = t0);
		$[1] = t0;
		$[2] = action;
		$[3] = badge;
		$[4] = children;
		$[5] = className;
		$[6] = glow;
		$[7] = props;
		$[8] = style;
		$[9] = tag;
		$[10] = timestamp;
		$[11] = title;
	} else {
		action = $[2];
		badge = $[3];
		children = $[4];
		className = $[5];
		glow = $[6];
		props = $[7];
		style = $[8];
		tag = $[9];
		timestamp = $[10];
		title = $[11];
	}
	let t1;
	if ($[12] !== glow || $[13] !== style) {
		t1 = glow ? {
			...style,
			"--intel-summary-glow": glow
		} : style;
		$[12] = glow;
		$[13] = style;
		$[14] = t1;
	} else t1 = $[14];
	let t2;
	if ($[15] !== className) {
		t2 = cn("gap-0 rounded-[6px] border-[#26272f] bg-[#111116] px-4.5 py-4 text-[#f3f2ed] shadow-none transition-[border-color,transform,box-shadow] hover:-translate-y-0.5 hover:border-[#3d3f4c] hover:shadow-[var(--intel-summary-glow)]", className);
		$[15] = className;
		$[16] = t2;
	} else t2 = $[16];
	let t3;
	if ($[17] !== title) {
		t3 = /* @__PURE__ */ jsx("span", {
			className: "min-w-0 flex-1 font-serif text-[18px] leading-[1.25] font-bold tracking-[-0.005em]",
			children: title
		});
		$[17] = title;
		$[18] = t3;
	} else t3 = $[18];
	let t4;
	if ($[19] !== badge || $[20] !== t3) {
		t4 = /* @__PURE__ */ jsxs("div", {
			className: "mb-1.5 flex items-start gap-3",
			children: [t3, badge]
		});
		$[19] = badge;
		$[20] = t3;
		$[21] = t4;
	} else t4 = $[21];
	let t5;
	if ($[22] !== children) {
		t5 = /* @__PURE__ */ jsx("p", {
			className: "mb-3 flex-1 text-[13px] leading-[1.6] text-[#9fa0ad]",
			children
		});
		$[22] = children;
		$[23] = t5;
	} else t5 = $[23];
	let t6;
	if ($[24] !== action || $[25] !== tag || $[26] !== timestamp) {
		t6 = tag || timestamp || action ? /* @__PURE__ */ jsxs("div", {
			className: "flex flex-wrap items-center gap-3.5",
			children: [
				tag,
				timestamp,
				action ? /* @__PURE__ */ jsx("span", {
					className: "ml-auto",
					children: action
				}) : null
			]
		}) : null;
		$[24] = action;
		$[25] = tag;
		$[26] = timestamp;
		$[27] = t6;
	} else t6 = $[27];
	let t7;
	if ($[28] !== props || $[29] !== t1 || $[30] !== t2 || $[31] !== t4 || $[32] !== t5 || $[33] !== t6) {
		t7 = /* @__PURE__ */ jsxs(Card, {
			"data-slot": "intel-summary-card",
			style: t1,
			className: t2,
			...props,
			children: [
				t4,
				t5,
				t6
			]
		});
		$[28] = props;
		$[29] = t1;
		$[30] = t2;
		$[31] = t4;
		$[32] = t5;
		$[33] = t6;
		$[34] = t7;
	} else t7 = $[34];
	return t7;
}
//#endregion
//#region src/components/ui/carousel.tsx
const CarouselContext = React.createContext(null);
function useCarousel() {
	const $ = c(1);
	if ($[0] !== "f61626e031995f84613fc5b68de58ff56dc5112a477d135cf9de6194a0bf2571") {
		for (let $i = 0; $i < 1; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f61626e031995f84613fc5b68de58ff56dc5112a477d135cf9de6194a0bf2571";
	}
	const context = React.useContext(CarouselContext);
	if (!context) throw new Error("useCarousel must be used within a <Carousel />");
	return context;
}
function Carousel(t0) {
	const $ = c(46);
	if ($[0] !== "f61626e031995f84613fc5b68de58ff56dc5112a477d135cf9de6194a0bf2571") {
		for (let $i = 0; $i < 46; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f61626e031995f84613fc5b68de58ff56dc5112a477d135cf9de6194a0bf2571";
	}
	let children;
	let className;
	let opts;
	let plugins;
	let props;
	let setApi;
	let t1;
	if ($[1] !== t0) {
		({orientation: t1, opts, setApi, plugins, className, children, ...props} = t0);
		$[1] = t0;
		$[2] = children;
		$[3] = className;
		$[4] = opts;
		$[5] = plugins;
		$[6] = props;
		$[7] = setApi;
		$[8] = t1;
	} else {
		children = $[2];
		className = $[3];
		opts = $[4];
		plugins = $[5];
		props = $[6];
		setApi = $[7];
		t1 = $[8];
	}
	const orientation = t1 === void 0 ? "horizontal" : t1;
	const t2 = orientation === "horizontal" ? "x" : "y";
	let t3;
	if ($[9] !== opts || $[10] !== t2) {
		t3 = {
			...opts,
			axis: t2
		};
		$[9] = opts;
		$[10] = t2;
		$[11] = t3;
	} else t3 = $[11];
	const [carouselRef, api] = useEmblaCarousel(t3, plugins);
	const [canScrollPrev, setCanScrollPrev] = React.useState(false);
	const [canScrollNext, setCanScrollNext] = React.useState(false);
	let t4;
	if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
		t4 = (carouselApi) => {
			if (!carouselApi) return;
			setCanScrollPrev(carouselApi.canScrollPrev());
			setCanScrollNext(carouselApi.canScrollNext());
		};
		$[12] = t4;
	} else t4 = $[12];
	const onSelect = t4;
	let t5;
	if ($[13] !== api) {
		t5 = () => {
			api?.scrollPrev();
		};
		$[13] = api;
		$[14] = t5;
	} else t5 = $[14];
	const scrollPrev = t5;
	let t6;
	if ($[15] !== api) {
		t6 = () => {
			api?.scrollNext();
		};
		$[15] = api;
		$[16] = t6;
	} else t6 = $[16];
	const scrollNext = t6;
	let t7;
	if ($[17] !== scrollNext || $[18] !== scrollPrev) {
		t7 = (event) => {
			if (event.key === "ArrowLeft") {
				event.preventDefault();
				scrollPrev();
			} else if (event.key === "ArrowRight") {
				event.preventDefault();
				scrollNext();
			}
		};
		$[17] = scrollNext;
		$[18] = scrollPrev;
		$[19] = t7;
	} else t7 = $[19];
	const handleKeyDown = t7;
	let t8;
	let t9;
	if ($[20] !== api || $[21] !== setApi) {
		t8 = () => {
			if (!api || !setApi) return;
			setApi(api);
		};
		t9 = [api, setApi];
		$[20] = api;
		$[21] = setApi;
		$[22] = t8;
		$[23] = t9;
	} else {
		t8 = $[22];
		t9 = $[23];
	}
	React.useEffect(t8, t9);
	let t10;
	let t11;
	if ($[24] !== api) {
		t10 = () => {
			if (!api) return;
			const initialSync = window.requestAnimationFrame(() => onSelect(api));
			api.on("reInit", onSelect);
			api.on("select", onSelect);
			return () => {
				window.cancelAnimationFrame(initialSync);
				api.off("select", onSelect);
				api.off("reInit", onSelect);
			};
		};
		t11 = [api, onSelect];
		$[24] = api;
		$[25] = t10;
		$[26] = t11;
	} else {
		t10 = $[25];
		t11 = $[26];
	}
	React.useEffect(t10, t11);
	const t12 = orientation || (opts?.axis === "y" ? "vertical" : "horizontal");
	let t13;
	if ($[27] !== api || $[28] !== canScrollNext || $[29] !== canScrollPrev || $[30] !== carouselRef || $[31] !== opts || $[32] !== scrollNext || $[33] !== scrollPrev || $[34] !== t12) {
		t13 = {
			carouselRef,
			api,
			opts,
			orientation: t12,
			scrollPrev,
			scrollNext,
			canScrollPrev,
			canScrollNext
		};
		$[27] = api;
		$[28] = canScrollNext;
		$[29] = canScrollPrev;
		$[30] = carouselRef;
		$[31] = opts;
		$[32] = scrollNext;
		$[33] = scrollPrev;
		$[34] = t12;
		$[35] = t13;
	} else t13 = $[35];
	let t14;
	if ($[36] !== className) {
		t14 = cn("relative", className);
		$[36] = className;
		$[37] = t14;
	} else t14 = $[37];
	let t15;
	if ($[38] !== children || $[39] !== handleKeyDown || $[40] !== props || $[41] !== t14) {
		t15 = /* @__PURE__ */ jsx("div", {
			onKeyDownCapture: handleKeyDown,
			className: t14,
			role: "region",
			"aria-roledescription": "carousel",
			"data-slot": "carousel",
			...props,
			children
		});
		$[38] = children;
		$[39] = handleKeyDown;
		$[40] = props;
		$[41] = t14;
		$[42] = t15;
	} else t15 = $[42];
	let t16;
	if ($[43] !== t13 || $[44] !== t15) {
		t16 = /* @__PURE__ */ jsx(CarouselContext.Provider, {
			value: t13,
			children: t15
		});
		$[43] = t13;
		$[44] = t15;
		$[45] = t16;
	} else t16 = $[45];
	return t16;
}
function CarouselContent(t0) {
	const $ = c(13);
	if ($[0] !== "f61626e031995f84613fc5b68de58ff56dc5112a477d135cf9de6194a0bf2571") {
		for (let $i = 0; $i < 13; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f61626e031995f84613fc5b68de58ff56dc5112a477d135cf9de6194a0bf2571";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	const { carouselRef, orientation } = useCarousel();
	const t1 = orientation === "horizontal" ? "-ml-4" : "-mt-4 flex-col";
	let t2;
	if ($[4] !== className || $[5] !== t1) {
		t2 = cn("flex", t1, className);
		$[4] = className;
		$[5] = t1;
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] !== props || $[8] !== t2) {
		t3 = /* @__PURE__ */ jsx("div", {
			className: t2,
			...props
		});
		$[7] = props;
		$[8] = t2;
		$[9] = t3;
	} else t3 = $[9];
	let t4;
	if ($[10] !== carouselRef || $[11] !== t3) {
		t4 = /* @__PURE__ */ jsx("div", {
			ref: carouselRef,
			className: "overflow-hidden",
			"data-slot": "carousel-content",
			children: t3
		});
		$[10] = carouselRef;
		$[11] = t3;
		$[12] = t4;
	} else t4 = $[12];
	return t4;
}
function CarouselItem(t0) {
	const $ = c(10);
	if ($[0] !== "f61626e031995f84613fc5b68de58ff56dc5112a477d135cf9de6194a0bf2571") {
		for (let $i = 0; $i < 10; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f61626e031995f84613fc5b68de58ff56dc5112a477d135cf9de6194a0bf2571";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	const { orientation } = useCarousel();
	const t1 = orientation === "horizontal" ? "pl-4" : "pt-4";
	let t2;
	if ($[4] !== className || $[5] !== t1) {
		t2 = cn("min-w-0 shrink-0 grow-0 basis-full", t1, className);
		$[4] = className;
		$[5] = t1;
		$[6] = t2;
	} else t2 = $[6];
	let t3;
	if ($[7] !== props || $[8] !== t2) {
		t3 = /* @__PURE__ */ jsx("div", {
			role: "group",
			"aria-roledescription": "slide",
			"data-slot": "carousel-item",
			className: t2,
			...props
		});
		$[7] = props;
		$[8] = t2;
		$[9] = t3;
	} else t3 = $[9];
	return t3;
}
function CarouselPrevious(t0) {
	const $ = c(18);
	if ($[0] !== "f61626e031995f84613fc5b68de58ff56dc5112a477d135cf9de6194a0bf2571") {
		for (let $i = 0; $i < 18; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f61626e031995f84613fc5b68de58ff56dc5112a477d135cf9de6194a0bf2571";
	}
	let className;
	let props;
	let t1;
	let t2;
	if ($[1] !== t0) {
		({className, variant: t1, size: t2, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
		$[5] = t2;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
		t2 = $[5];
	}
	const variant = t1 === void 0 ? "outline" : t1;
	const size = t2 === void 0 ? "icon-sm" : t2;
	const { orientation, scrollPrev, canScrollPrev } = useCarousel();
	const t3 = orientation === "horizontal" ? "inset-y-0 -left-12 my-auto" : "-top-12 left-1/2 -translate-x-1/2 rotate-90";
	let t4;
	if ($[6] !== className || $[7] !== t3) {
		t4 = cn("absolute touch-manipulation rounded-full", t3, className);
		$[6] = className;
		$[7] = t3;
		$[8] = t4;
	} else t4 = $[8];
	const t5 = !canScrollPrev;
	let t6;
	let t7;
	if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
		t6 = /* @__PURE__ */ jsx(ChevronLeftIcon, {});
		t7 = /* @__PURE__ */ jsx("span", {
			className: "sr-only",
			children: "Previous slide"
		});
		$[9] = t6;
		$[10] = t7;
	} else {
		t6 = $[9];
		t7 = $[10];
	}
	let t8;
	if ($[11] !== props || $[12] !== scrollPrev || $[13] !== size || $[14] !== t4 || $[15] !== t5 || $[16] !== variant) {
		t8 = /* @__PURE__ */ jsxs(Button, {
			"data-slot": "carousel-previous",
			variant,
			size,
			className: t4,
			disabled: t5,
			onClick: scrollPrev,
			...props,
			children: [t6, t7]
		});
		$[11] = props;
		$[12] = scrollPrev;
		$[13] = size;
		$[14] = t4;
		$[15] = t5;
		$[16] = variant;
		$[17] = t8;
	} else t8 = $[17];
	return t8;
}
function CarouselNext(t0) {
	const $ = c(18);
	if ($[0] !== "f61626e031995f84613fc5b68de58ff56dc5112a477d135cf9de6194a0bf2571") {
		for (let $i = 0; $i < 18; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "f61626e031995f84613fc5b68de58ff56dc5112a477d135cf9de6194a0bf2571";
	}
	let className;
	let props;
	let t1;
	let t2;
	if ($[1] !== t0) {
		({className, variant: t1, size: t2, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
		$[4] = t1;
		$[5] = t2;
	} else {
		className = $[2];
		props = $[3];
		t1 = $[4];
		t2 = $[5];
	}
	const variant = t1 === void 0 ? "outline" : t1;
	const size = t2 === void 0 ? "icon-sm" : t2;
	const { orientation, scrollNext, canScrollNext } = useCarousel();
	const t3 = orientation === "horizontal" ? "inset-y-0 -right-12 my-auto" : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90";
	let t4;
	if ($[6] !== className || $[7] !== t3) {
		t4 = cn("absolute touch-manipulation rounded-full", t3, className);
		$[6] = className;
		$[7] = t3;
		$[8] = t4;
	} else t4 = $[8];
	const t5 = !canScrollNext;
	let t6;
	let t7;
	if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
		t6 = /* @__PURE__ */ jsx(ChevronRightIcon, {});
		t7 = /* @__PURE__ */ jsx("span", {
			className: "sr-only",
			children: "Next slide"
		});
		$[9] = t6;
		$[10] = t7;
	} else {
		t6 = $[9];
		t7 = $[10];
	}
	let t8;
	if ($[11] !== props || $[12] !== scrollNext || $[13] !== size || $[14] !== t4 || $[15] !== t5 || $[16] !== variant) {
		t8 = /* @__PURE__ */ jsxs(Button, {
			"data-slot": "carousel-next",
			variant,
			size,
			className: t4,
			disabled: t5,
			onClick: scrollNext,
			...props,
			children: [t6, t7]
		});
		$[11] = props;
		$[12] = scrollNext;
		$[13] = size;
		$[14] = t4;
		$[15] = t5;
		$[16] = variant;
		$[17] = t8;
	} else t8 = $[17];
	return t8;
}
//#endregion
//#region src/components/home/home-carousel.tsx
/** Home composition of the shadcn/Embla carousel with prototype pagination. */
function HomeCarousel(t0) {
	const $ = c(48);
	if ($[0] !== "89a6ddc2bea087a0518f56e5987f65f116586dc1d55b9b41fe7f4ed7ff7da70c") {
		for (let $i = 0; $i < 48; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "89a6ddc2bea087a0518f56e5987f65f116586dc1d55b9b41fe7f4ed7ff7da70c";
	}
	let ariaLabel;
	let className;
	let itemKey;
	let items;
	let props;
	let renderItem;
	let t1;
	if ($[1] !== t0) {
		({ariaLabel, items, itemKey, renderItem, itemsPerPage: t1, className, ...props} = t0);
		$[1] = t0;
		$[2] = ariaLabel;
		$[3] = className;
		$[4] = itemKey;
		$[5] = items;
		$[6] = props;
		$[7] = renderItem;
		$[8] = t1;
	} else {
		ariaLabel = $[2];
		className = $[3];
		itemKey = $[4];
		items = $[5];
		props = $[6];
		renderItem = $[7];
		t1 = $[8];
	}
	const itemsPerPage = t1 === void 0 ? 1 : t1;
	const [api, setApi] = useState();
	const [selectedIndex, setSelectedIndex] = useState(0);
	const [snapCount, setSnapCount] = useState(0);
	let t2;
	let t3;
	if ($[9] !== api) {
		t2 = () => {
			if (!api) return;
			const updatePagination = () => {
				setSelectedIndex(api.selectedScrollSnap());
				setSnapCount(api.scrollSnapList().length);
			};
			const initialSync = window.requestAnimationFrame(updatePagination);
			api.on("select", updatePagination);
			api.on("reInit", updatePagination);
			return () => {
				window.cancelAnimationFrame(initialSync);
				api.off("select", updatePagination);
				api.off("reInit", updatePagination);
			};
		};
		t3 = [api];
		$[9] = api;
		$[10] = t2;
		$[11] = t3;
	} else {
		t2 = $[10];
		t3 = $[11];
	}
	useEffect(t2, t3);
	const showPagination = snapCount > 1;
	let t4;
	if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
		t4 = {
			align: "start",
			loop: true,
			slidesToScroll: "auto"
		};
		$[12] = t4;
	} else t4 = $[12];
	let t5;
	if ($[13] !== className) {
		t5 = cn("flex flex-col gap-3.5", className);
		$[13] = className;
		$[14] = t5;
	} else t5 = $[14];
	let t6;
	if ($[15] !== ariaLabel || $[16] !== showPagination) {
		t6 = showPagination ? /* @__PURE__ */ jsx(CarouselPrevious, {
			size: "icon",
			"aria-label": `Previous ${ariaLabel.toLowerCase()} page`,
			className: "static my-0 size-8 shrink-0 translate-none border-[#3d3f4c] bg-[#111116] text-[#9fa0ad] hover:border-[#66677a] hover:bg-[#17181f] hover:text-[#f3f2ed] disabled:opacity-40"
		}) : null;
		$[15] = ariaLabel;
		$[16] = showPagination;
		$[17] = t6;
	} else t6 = $[17];
	let t7;
	if ($[18] !== itemKey || $[19] !== items || $[20] !== itemsPerPage || $[21] !== renderItem) {
		let t8;
		if ($[23] !== itemKey || $[24] !== itemsPerPage || $[25] !== renderItem) {
			t8 = (item) => /* @__PURE__ */ jsx(CarouselItem, {
				className: cn("pl-3", itemsPerPage === 2 && "md:basis-1/2"),
				children: renderItem(item)
			}, itemKey(item));
			$[23] = itemKey;
			$[24] = itemsPerPage;
			$[25] = renderItem;
			$[26] = t8;
		} else t8 = $[26];
		t7 = items.map(t8);
		$[18] = itemKey;
		$[19] = items;
		$[20] = itemsPerPage;
		$[21] = renderItem;
		$[22] = t7;
	} else t7 = $[22];
	let t8;
	if ($[27] !== t7) {
		t8 = /* @__PURE__ */ jsx("div", {
			className: "min-w-0 flex-1",
			children: /* @__PURE__ */ jsx(CarouselContent, {
				className: "-ml-3",
				children: t7
			})
		});
		$[27] = t7;
		$[28] = t8;
	} else t8 = $[28];
	let t9;
	if ($[29] !== ariaLabel || $[30] !== showPagination) {
		t9 = showPagination ? /* @__PURE__ */ jsx(CarouselNext, {
			size: "icon",
			"aria-label": `Next ${ariaLabel.toLowerCase()} page`,
			className: "static my-0 size-8 shrink-0 translate-none border-[#3d3f4c] bg-[#111116] text-[#9fa0ad] hover:border-[#66677a] hover:bg-[#17181f] hover:text-[#f3f2ed] disabled:opacity-40"
		}) : null;
		$[29] = ariaLabel;
		$[30] = showPagination;
		$[31] = t9;
	} else t9 = $[31];
	let t10;
	if ($[32] !== t6 || $[33] !== t8 || $[34] !== t9) {
		t10 = /* @__PURE__ */ jsxs("div", {
			className: "flex items-center gap-2",
			children: [
				t6,
				t8,
				t9
			]
		});
		$[32] = t6;
		$[33] = t8;
		$[34] = t9;
		$[35] = t10;
	} else t10 = $[35];
	let t11;
	if ($[36] !== api || $[37] !== ariaLabel || $[38] !== selectedIndex || $[39] !== showPagination || $[40] !== snapCount) {
		t11 = showPagination ? /* @__PURE__ */ jsx("div", {
			"aria-label": `${ariaLabel} pagination`,
			className: "flex justify-center gap-1.5",
			children: Array.from({ length: snapCount }, (_, index) => /* @__PURE__ */ jsx("button", {
				type: "button",
				"aria-label": `Go to ${ariaLabel.toLowerCase()} page ${index + 1}`,
				"aria-current": index === selectedIndex ? "page" : void 0,
				onClick: () => api?.scrollTo(index),
				className: cn("h-1.5 w-1.5 rounded-full bg-[#3d3f4c] transition-[width,background-color]", index === selectedIndex && "w-4.5 rounded-[3px] bg-[#e84e0f]")
			}, index))
		}) : null;
		$[36] = api;
		$[37] = ariaLabel;
		$[38] = selectedIndex;
		$[39] = showPagination;
		$[40] = snapCount;
		$[41] = t11;
	} else t11 = $[41];
	let t12;
	if ($[42] !== ariaLabel || $[43] !== props || $[44] !== t10 || $[45] !== t11 || $[46] !== t5) {
		t12 = /* @__PURE__ */ jsxs(Carousel, {
			"data-slot": "home-carousel",
			"aria-label": ariaLabel,
			opts: t4,
			setApi,
			className: t5,
			...props,
			children: [t10, t11]
		});
		$[42] = ariaLabel;
		$[43] = props;
		$[44] = t10;
		$[45] = t11;
		$[46] = t5;
		$[47] = t12;
	} else t12 = $[47];
	return t12;
}
//#endregion
//#region src/components/home/morning-intel-section.tsx
/**
* The homepage Morning Intel preview: a carousel of `IntelSummaryCard`s, one
* per signal, with the importance mapped to a badge and hover glow, a region
* tag, a timestamp, and a decorative "Deep dive" action. Each card is
* clickable (`onSignalSelect`) when that prop is supplied. Renders a DS
* `Empty` state when there are no signals. Presentational — the consumer
* supplies pre-formatted values and the importance level.
*
* Import path: `@design-system/components/home/morning-intel-section`.
*/
function MorningIntelSection(t0) {
	const $ = c(19);
	if ($[0] !== "26aaf794a2ac3b033f8accad2f6241485cc7874ea4e0d963f9a67d7338c5bbb7") {
		for (let $i = 0; $i < 19; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "26aaf794a2ac3b033f8accad2f6241485cc7874ea4e0d963f9a67d7338c5bbb7";
	}
	let className;
	let onSignalSelect;
	let props;
	let signals;
	if ($[1] !== t0) {
		({signals, onSignalSelect, className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = onSignalSelect;
		$[4] = props;
		$[5] = signals;
	} else {
		className = $[2];
		onSignalSelect = $[3];
		props = $[4];
		signals = $[5];
	}
	if (signals.length === 0) {
		let t1;
		if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
			t1 = /* @__PURE__ */ jsx(SparklesIcon, {});
			$[6] = t1;
		} else t1 = $[6];
		let t2;
		if ($[7] !== className || $[8] !== props) {
			t2 = /* @__PURE__ */ jsx(SectionState, {
				className,
				framed: false,
				icon: t1,
				title: "No signals yet",
				description: "Market intelligence will appear here.",
				...props
			});
			$[7] = className;
			$[8] = props;
			$[9] = t2;
		} else t2 = $[9];
		return t2;
	}
	let t1;
	if ($[10] !== className) {
		t1 = cn(className);
		$[10] = className;
		$[11] = t1;
	} else t1 = $[11];
	let t2;
	if ($[12] !== onSignalSelect) {
		t2 = (signal_0) => {
			const cfg = IMPORTANCE[signal_0.importance];
			const interactive = onSignalSelect != null;
			return /* @__PURE__ */ jsx(IntelSummaryCard, {
				title: signal_0.title,
				badge: /* @__PURE__ */ jsx(Badge, {
					variant: cfg.badge,
					children: cfg.label
				}),
				tag: /* @__PURE__ */ jsx(Badge, {
					variant: "mutedOutline",
					children: signal_0.region
				}),
				timestamp: /* @__PURE__ */ jsxs("span", {
					className: "font-mono text-[11px] tracking-[0.06em] text-gx-text-tertiary",
					children: ["Produced ", signal_0.timestamp]
				}),
				action: /* @__PURE__ */ jsx(Button, {
					"aria-hidden": "true",
					nativeButton: false,
					render: /* @__PURE__ */ jsx("span", {}),
					variant: "outline-highlight",
					size: "sm",
					children: "Deep dive →"
				}),
				glow: cfg.glow,
				className: interactive ? "cursor-pointer" : void 0,
				role: interactive ? "button" : void 0,
				tabIndex: interactive ? 0 : void 0,
				"aria-label": interactive ? signal_0.title : void 0,
				onClick: interactive ? () => onSignalSelect(signal_0) : void 0,
				onKeyDown: interactive ? activateOnEnterSpace() : void 0,
				children: signal_0.blurb
			}, signal_0.id);
		};
		$[12] = onSignalSelect;
		$[13] = t2;
	} else t2 = $[13];
	let t3;
	if ($[14] !== props || $[15] !== signals || $[16] !== t1 || $[17] !== t2) {
		t3 = /* @__PURE__ */ jsx(HomeCarousel, {
			"data-home-section": "morning-intel",
			ariaLabel: "Morning Intel",
			items: signals,
			itemsPerPage: 2,
			itemKey: _temp$5,
			className: t1,
			renderItem: t2,
			...props
		});
		$[14] = props;
		$[15] = signals;
		$[16] = t1;
		$[17] = t2;
		$[18] = t3;
	} else t3 = $[18];
	return t3;
}
function _temp$5(signal) {
	return signal.id;
}
//#endregion
//#region src/components/home/my-dashboards-section.tsx
/**
* The homepage "My Dashboards" preview: the first available dashboard shown as
* a large chart preview with its metadata and navigation affordance. The
* section-header action links to the full collection.
*
* Import path: `@design-system/components/home/my-dashboards-section`.
*/
function MyDashboardsSection(t0) {
	const $ = c(51);
	if ($[0] !== "686ee260b026edb6047689ee153dd9df856c6f908e5607ee66bcc4da167073f2") {
		for (let $i = 0; $i < 51; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "686ee260b026edb6047689ee153dd9df856c6f908e5607ee66bcc4da167073f2";
	}
	let className;
	let dashboards;
	let props;
	let t1;
	let t2;
	if ($[1] !== t0) {
		({dashboards, isLoading: t1, isError: t2, className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = dashboards;
		$[4] = props;
		$[5] = t1;
		$[6] = t2;
	} else {
		className = $[2];
		dashboards = $[3];
		props = $[4];
		t1 = $[5];
		t2 = $[6];
	}
	const isLoading = t1 === void 0 ? false : t1;
	if (t2 === void 0 ? false : t2) {
		let t3;
		if ($[7] !== className || $[8] !== props) {
			t3 = /* @__PURE__ */ jsx(SectionError, {
				className,
				title: "Couldn't load dashboards",
				description: "Please try again shortly.",
				...props
			});
			$[7] = className;
			$[8] = props;
			$[9] = t3;
		} else t3 = $[9];
		return t3;
	}
	if (isLoading) {
		let t3;
		if ($[10] !== className) {
			t3 = cn("gap-0 overflow-hidden rounded-[6px] border-[#26272f] bg-[#111116] py-0 shadow-none", className);
			$[10] = className;
			$[11] = t3;
		} else t3 = $[11];
		let t4;
		if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
			t4 = /* @__PURE__ */ jsx(Skeleton, { className: "h-75 w-full rounded-none" });
			$[12] = t4;
		} else t4 = $[12];
		let t5;
		if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
			t5 = /* @__PURE__ */ jsxs("div", {
				className: "flex items-center gap-4 px-4.5 py-3.5",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "flex-1 space-y-1.5",
					children: [/* @__PURE__ */ jsx(Skeleton, { className: "h-4 w-1/3" }), /* @__PURE__ */ jsx(Skeleton, { className: "h-3 w-1/4" })]
				}), /* @__PURE__ */ jsx(Skeleton, { className: "size-4" })]
			});
			$[13] = t5;
		} else t5 = $[13];
		let t6;
		if ($[14] !== props || $[15] !== t3) {
			t6 = /* @__PURE__ */ jsxs(Card, {
				className: t3,
				...props,
				children: [t4, t5]
			});
			$[14] = props;
			$[15] = t3;
			$[16] = t6;
		} else t6 = $[16];
		return t6;
	}
	if (dashboards.length === 0) {
		let t3;
		if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
			t3 = /* @__PURE__ */ jsx(LayoutDashboardIcon, {});
			$[17] = t3;
		} else t3 = $[17];
		let t4;
		if ($[18] !== className || $[19] !== props) {
			t4 = /* @__PURE__ */ jsx(SectionState, {
				className,
				icon: t3,
				title: "No dashboards yet",
				description: "Create a dashboard to see it here.",
				...props
			});
			$[18] = className;
			$[19] = props;
			$[20] = t4;
		} else t4 = $[20];
		return t4;
	}
	const dashboard = dashboards[0];
	const interactive = dashboard.onClick != null;
	let t3;
	if ($[21] !== dashboard.trailing) {
		t3 = dashboard.trailing === void 0 ? /* @__PURE__ */ jsx(ChevronRight, {
			className: "size-4 text-[#66677a]",
			"aria-hidden": true
		}) : dashboard.trailing;
		$[21] = dashboard.trailing;
		$[22] = t3;
	} else t3 = $[22];
	const trailing = t3;
	const t4 = interactive && "cursor-pointer";
	let t5;
	if ($[23] !== className || $[24] !== t4) {
		t5 = cn("gap-0 overflow-hidden rounded-[6px] border-[#26272f] bg-[#111116] py-0 text-[#f3f2ed] shadow-none transition-[border-color,transform] hover:-translate-y-0.5 hover:border-[#3d3f4c]", t4, className);
		$[23] = className;
		$[24] = t4;
		$[25] = t5;
	} else t5 = $[25];
	const t6 = interactive ? "button" : void 0;
	const t7 = interactive ? 0 : void 0;
	let t8;
	if ($[26] !== interactive) {
		t8 = interactive ? activateOnEnterSpace() : void 0;
		$[26] = interactive;
		$[27] = t8;
	} else t8 = $[27];
	let t9;
	if ($[28] !== dashboard.thumbnail) {
		t9 = dashboard.thumbnail ?? /* @__PURE__ */ jsx("div", { className: "size-full bg-[#17181f]" });
		$[28] = dashboard.thumbnail;
		$[29] = t9;
	} else t9 = $[29];
	let t10;
	if ($[30] !== t9) {
		t10 = /* @__PURE__ */ jsx("div", {
			className: "h-75 overflow-hidden border-b border-[#26272f] bg-linear-to-b from-[#17181f] to-[#111116] p-3.5 [&_svg_path]:[vector-effect:non-scaling-stroke]",
			children: t9
		});
		$[30] = t9;
		$[31] = t10;
	} else t10 = $[31];
	let t11;
	if ($[32] !== dashboard.name) {
		t11 = /* @__PURE__ */ jsx("div", {
			className: "truncate text-[15px] font-extrabold",
			children: dashboard.name
		});
		$[32] = dashboard.name;
		$[33] = t11;
	} else t11 = $[33];
	let t12;
	if ($[34] !== dashboard.meta) {
		t12 = dashboard.meta ? /* @__PURE__ */ jsx("div", {
			className: "truncate text-[12.5px] text-[#66677a]",
			children: dashboard.meta
		}) : null;
		$[34] = dashboard.meta;
		$[35] = t12;
	} else t12 = $[35];
	let t13;
	if ($[36] !== t11 || $[37] !== t12) {
		t13 = /* @__PURE__ */ jsxs("div", {
			className: "min-w-0 flex-1",
			children: [t11, t12]
		});
		$[36] = t11;
		$[37] = t12;
		$[38] = t13;
	} else t13 = $[38];
	let t14;
	if ($[39] !== t13 || $[40] !== trailing) {
		t14 = /* @__PURE__ */ jsxs("div", {
			className: "flex items-center gap-4 px-4.5 py-3.5",
			children: [t13, trailing]
		});
		$[39] = t13;
		$[40] = trailing;
		$[41] = t14;
	} else t14 = $[41];
	let t15;
	if ($[42] !== dashboard.onClick || $[43] !== props || $[44] !== t10 || $[45] !== t14 || $[46] !== t5 || $[47] !== t6 || $[48] !== t7 || $[49] !== t8) {
		t15 = /* @__PURE__ */ jsxs(Card, {
			className: t5,
			onClick: dashboard.onClick,
			role: t6,
			tabIndex: t7,
			onKeyDown: t8,
			...props,
			children: [t10, t14]
		});
		$[42] = dashboard.onClick;
		$[43] = props;
		$[44] = t10;
		$[45] = t14;
		$[46] = t5;
		$[47] = t6;
		$[48] = t7;
		$[49] = t8;
		$[50] = t15;
	} else t15 = $[50];
	return t15;
}
//#endregion
//#region src/components/ui/export-card.tsx
/** Status-label color by tone — same token choices as `CatalogTable`'s
*  `deltaCellVariants`, defined locally so the status text carries no
*  table-cell classes. */
const statusVariants = cva("flex items-center gap-1 text-[11px] font-bold whitespace-nowrap", {
	variants: { tone: {
		success: "text-gx-success",
		danger: "text-gx-failure-light",
		neutral: "text-gx-text-secondary"
	} },
	defaultVariants: { tone: "neutral" }
});
/**
* A single "Export" list row for the home page: a leading download icon tile,
* the export file name, a muted subtitle, a trailing colored status label
* (with a check glyph alongside the label for the `success` tone), and —
* when `onRetry` is provided — a small Retry button. Purely presentational: it
* renders exactly what it is given (no fetching, formatting, status derivation,
* or navigation) and owns no state. Composes `Card`, stripped of its decorative
* defaults to read as a stacking row with a bottom hairline and a hover
* background; drop several into a `Card`/list container (with `overflow-hidden`)
* to build the section. The structural twin of `DashboardCard`. When `onClick`
* is provided the row becomes an accessible button automatically
* (`role="button"`, `tabIndex={0}`, Enter/Space activation); the Retry button
* stops propagation so it does not trigger that row click.
*
* Import path: `@design-system/components/ui/export-card`.
*/
function ExportCard(t0) {
	const $ = c(50);
	if ($[0] !== "6a069d56a753c40df84717ce26d4afcfd687d6b120fc30396764e9cb2fd8dc77") {
		for (let $i = 0; $i < 50; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "6a069d56a753c40df84717ce26d4afcfd687d6b120fc30396764e9cb2fd8dc77";
	}
	let className;
	let icon;
	let meta;
	let name;
	let onClick;
	let onKeyDown;
	let onRetry;
	let props;
	let role;
	let status;
	let tabIndex;
	if ($[1] !== t0) {
		({className, name, meta, status, icon, onRetry, onClick, onKeyDown, role, tabIndex, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = icon;
		$[4] = meta;
		$[5] = name;
		$[6] = onClick;
		$[7] = onKeyDown;
		$[8] = onRetry;
		$[9] = props;
		$[10] = role;
		$[11] = status;
		$[12] = tabIndex;
	} else {
		className = $[2];
		icon = $[3];
		meta = $[4];
		name = $[5];
		onClick = $[6];
		onKeyDown = $[7];
		onRetry = $[8];
		props = $[9];
		role = $[10];
		status = $[11];
		tabIndex = $[12];
	}
	const interactive = onClick != null;
	let t1;
	if ($[13] !== className) {
		t1 = cn("flex-row items-center gap-3 rounded-none border-0 border-b border-[#26272f] bg-transparent px-4 py-3 text-[#f3f2ed] shadow-none last:border-b-0 cursor-pointer hover:bg-[#17181f]", className);
		$[13] = className;
		$[14] = t1;
	} else t1 = $[14];
	const t2 = role ?? (interactive ? "button" : void 0);
	const t3 = tabIndex ?? (interactive ? 0 : void 0);
	let t4;
	if ($[15] !== interactive || $[16] !== onKeyDown) {
		t4 = interactive ? activateOnEnterSpace(onKeyDown) : onKeyDown;
		$[15] = interactive;
		$[16] = onKeyDown;
		$[17] = t4;
	} else t4 = $[17];
	let t5;
	if ($[18] !== icon) {
		t5 = icon ?? /* @__PURE__ */ jsx(Download, {
			className: "size-3.5",
			"aria-hidden": true
		});
		$[18] = icon;
		$[19] = t5;
	} else t5 = $[19];
	let t6;
	if ($[20] !== t5) {
		t6 = /* @__PURE__ */ jsx("div", {
			className: "flex size-7 shrink-0 items-center justify-center bg-[#20222c] text-[#9fa0ad]",
			children: t5
		});
		$[20] = t5;
		$[21] = t6;
	} else t6 = $[21];
	let t7;
	if ($[22] !== name) {
		t7 = /* @__PURE__ */ jsx("div", {
			className: "truncate text-[13px] font-bold",
			children: name
		});
		$[22] = name;
		$[23] = t7;
	} else t7 = $[23];
	let t8;
	if ($[24] !== meta) {
		t8 = meta ? /* @__PURE__ */ jsx("div", {
			className: "truncate text-[12px] text-[#66677a]",
			children: meta
		}) : null;
		$[24] = meta;
		$[25] = t8;
	} else t8 = $[25];
	let t9;
	if ($[26] !== t7 || $[27] !== t8) {
		t9 = /* @__PURE__ */ jsxs("div", {
			className: "min-w-0 flex-1",
			children: [t7, t8]
		});
		$[26] = t7;
		$[27] = t8;
		$[28] = t9;
	} else t9 = $[28];
	let t10;
	if ($[29] !== status.tone) {
		t10 = statusVariants({ tone: status.tone });
		$[29] = status.tone;
		$[30] = t10;
	} else t10 = $[30];
	let t11;
	if ($[31] !== status.tone) {
		t11 = status.tone === "success" ? /* @__PURE__ */ jsx(Check, {
			className: "size-3",
			"aria-hidden": true
		}) : null;
		$[31] = status.tone;
		$[32] = t11;
	} else t11 = $[32];
	let t12;
	if ($[33] !== status.label || $[34] !== t10 || $[35] !== t11) {
		t12 = /* @__PURE__ */ jsxs("span", {
			className: t10,
			children: [t11, status.label]
		});
		$[33] = status.label;
		$[34] = t10;
		$[35] = t11;
		$[36] = t12;
	} else t12 = $[36];
	let t13;
	if ($[37] !== onRetry) {
		t13 = onRetry ? /* @__PURE__ */ jsx("button", {
			type: "button",
			onClick: (event) => {
				event.stopPropagation();
				onRetry();
			},
			className: "ml-2 shrink-0 cursor-pointer rounded-[3px] border border-gx-failure-light px-2.5 py-1 text-[12px] font-bold text-gx-failure-light hover:bg-gx-failure-light/12",
			children: "Retry"
		}) : null;
		$[37] = onRetry;
		$[38] = t13;
	} else t13 = $[38];
	let t14;
	if ($[39] !== onClick || $[40] !== props || $[41] !== t1 || $[42] !== t12 || $[43] !== t13 || $[44] !== t2 || $[45] !== t3 || $[46] !== t4 || $[47] !== t6 || $[48] !== t9) {
		t14 = /* @__PURE__ */ jsxs(Card, {
			"data-slot": "export-card",
			className: t1,
			onClick,
			role: t2,
			tabIndex: t3,
			onKeyDown: t4,
			...props,
			children: [
				t6,
				t9,
				t12,
				t13
			]
		});
		$[39] = onClick;
		$[40] = props;
		$[41] = t1;
		$[42] = t12;
		$[43] = t13;
		$[44] = t2;
		$[45] = t3;
		$[46] = t4;
		$[47] = t6;
		$[48] = t9;
		$[49] = t14;
	} else t14 = $[49];
	return t14;
}
//#endregion
//#region src/components/home/recent-exports-section.tsx
/**
* The homepage Recent Exports list: `ExportCard` rows inside a `Card` list
* container (corners clipped). Renders a DS `Empty` state when there are no
* exports. Presentational — the consumer supplies status label/tone and any
* retry handler.
*
* Import path: `@design-system/components/home/recent-exports-section`.
*/
function RecentExportsSection(t0) {
	const $ = c(28);
	if ($[0] !== "68c9d031992294c95e4ab15f902484d53df8f8517d4a7b9cc987eaebf63e8c48") {
		for (let $i = 0; $i < 28; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "68c9d031992294c95e4ab15f902484d53df8f8517d4a7b9cc987eaebf63e8c48";
	}
	let className;
	let exports;
	let props;
	let t1;
	let t2;
	if ($[1] !== t0) {
		({exports, isLoading: t1, isError: t2, className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = exports;
		$[4] = props;
		$[5] = t1;
		$[6] = t2;
	} else {
		className = $[2];
		exports = $[3];
		props = $[4];
		t1 = $[5];
		t2 = $[6];
	}
	const isLoading = t1 === void 0 ? false : t1;
	if (t2 === void 0 ? false : t2) {
		let t3;
		if ($[7] !== className || $[8] !== props) {
			t3 = /* @__PURE__ */ jsx(SectionError, {
				className,
				title: "Couldn't load exports",
				description: "Please try again shortly.",
				...props
			});
			$[7] = className;
			$[8] = props;
			$[9] = t3;
		} else t3 = $[9];
		return t3;
	}
	if (isLoading) {
		let t3;
		if ($[10] !== className) {
			t3 = cn("gap-0 overflow-hidden rounded-[6px] border-[#26272f] bg-[#111116] py-0 shadow-none", className);
			$[10] = className;
			$[11] = t3;
		} else t3 = $[11];
		let t4;
		if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
			t4 = [
				0,
				1,
				2
			].map(_temp$4);
			$[12] = t4;
		} else t4 = $[12];
		let t5;
		if ($[13] !== props || $[14] !== t3) {
			t5 = /* @__PURE__ */ jsx(Card, {
				className: t3,
				...props,
				children: t4
			});
			$[13] = props;
			$[14] = t3;
			$[15] = t5;
		} else t5 = $[15];
		return t5;
	}
	if (exports.length === 0) {
		let t3;
		if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
			t3 = /* @__PURE__ */ jsx(FileDownIcon, {});
			$[16] = t3;
		} else t3 = $[16];
		let t4;
		if ($[17] !== className || $[18] !== props) {
			t4 = /* @__PURE__ */ jsx(SectionState, {
				className,
				icon: t3,
				title: "No exports yet",
				description: "Your recent exports will appear here.",
				...props
			});
			$[17] = className;
			$[18] = props;
			$[19] = t4;
		} else t4 = $[19];
		return t4;
	}
	let t3;
	if ($[20] !== className) {
		t3 = cn("gap-0 overflow-hidden rounded-[6px] border-[#26272f] bg-[#111116] py-0 shadow-none", className);
		$[20] = className;
		$[21] = t3;
	} else t3 = $[21];
	let t4;
	if ($[22] !== exports) {
		t4 = exports.map(_temp2$2);
		$[22] = exports;
		$[23] = t4;
	} else t4 = $[23];
	let t5;
	if ($[24] !== props || $[25] !== t3 || $[26] !== t4) {
		t5 = /* @__PURE__ */ jsx(Card, {
			className: t3,
			...props,
			children: t4
		});
		$[24] = props;
		$[25] = t3;
		$[26] = t4;
		$[27] = t5;
	} else t5 = $[27];
	return t5;
}
function _temp2$2(item) {
	return /* @__PURE__ */ jsx(ExportCard, {
		name: item.name,
		meta: item.meta,
		status: item.status,
		onRetry: item.onRetry,
		onClick: item.onClick
	}, item.id);
}
function _temp$4(row) {
	return /* @__PURE__ */ jsxs("div", {
		className: "flex items-center gap-3 border-b border-[#26272f] px-4 py-3 last:border-b-0",
		children: [
			/* @__PURE__ */ jsx(Skeleton, { className: "size-7" }),
			/* @__PURE__ */ jsxs("div", {
				className: "flex-1 space-y-1.5",
				children: [/* @__PURE__ */ jsx(Skeleton, { className: "h-3.5 w-2/5" }), /* @__PURE__ */ jsx(Skeleton, { className: "h-3 w-1/4" })]
			}),
			/* @__PURE__ */ jsx(Skeleton, { className: "h-3 w-12" })
		]
	}, row);
}
//#endregion
//#region src/components/home/watchlist-tile.tsx
const WATCHLIST_NAME_MIN_LENGTH = 1;
const WATCHLIST_NAME_MAX_LENGTH = 60;
/** Homepage-specific market tile with editing, removal, and an inline chart. */
function WatchlistTileView(t0) {
	const $ = c(84);
	if ($[0] !== "5964b7503f49d8f5e2c035fc417813dad43bdd55642397152a2d55bb109ffd03") {
		for (let $i = 0; $i < 84; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "5964b7503f49d8f5e2c035fc417813dad43bdd55642397152a2d55bb109ffd03";
	}
	const { item, onRemove, onRename, onViewCatalog } = t0;
	const [name, setName] = useState(item.title);
	const [nameError, setNameError] = useState(null);
	const [shakeName, setShakeName] = useState(false);
	const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
	const nameInputRef = useRef(null);
	const { schedule: scheduleShakeReset } = useManagedTimeout();
	let t1;
	if ($[1] !== item.id || $[2] !== item.title || $[3] !== name || $[4] !== onRename || $[5] !== scheduleShakeReset) {
		t1 = () => {
			const nextName = name.trim();
			if (!nextName) {
				setName(item.title);
				setNameError("Name is required");
				setShakeName(true);
				scheduleShakeReset(() => setShakeName(false), 450);
				nameInputRef.current?.focus();
				return;
			}
			setNameError(null);
			if (nextName !== item.title) onRename?.(item.id, nextName);
		};
		$[1] = item.id;
		$[2] = item.title;
		$[3] = name;
		$[4] = onRename;
		$[5] = scheduleShakeReset;
		$[6] = t1;
	} else t1 = $[6];
	const commitName = t1;
	const t2 = item.trend === "up" && "bg-gx-success";
	const t3 = item.trend === "down" && "bg-gx-failure-light";
	let t4;
	if ($[7] !== t2 || $[8] !== t3) {
		t4 = cn("absolute top-3.5 bottom-3.5 left-0 z-[2] w-0.5 bg-gx-neutral", t2, t3);
		$[7] = t2;
		$[8] = t3;
		$[9] = t4;
	} else t4 = $[9];
	let t5;
	if ($[10] !== t4) {
		t5 = /* @__PURE__ */ jsx("span", {
			"aria-hidden": "true",
			className: t4
		});
		$[10] = t4;
		$[11] = t5;
	} else t5 = $[11];
	let t6;
	if ($[12] !== item.points || $[13] !== item.trend) {
		t6 = /* @__PURE__ */ jsx(WatchlistChart, {
			points: item.points,
			trend: item.trend
		});
		$[12] = item.points;
		$[13] = item.trend;
		$[14] = t6;
	} else t6 = $[14];
	let t7;
	if ($[15] !== item.code) {
		t7 = /* @__PURE__ */ jsx("span", {
			className: "relative z-[1] block text-[11px] font-mono tracking-[0.06em] text-gx-text-tertiary",
			children: item.code
		});
		$[15] = item.code;
		$[16] = t7;
	} else t7 = $[16];
	const t8 = `Edit ${item.title}`;
	const t9 = nameError ? `${item.code}-name-error` : void 0;
	const t10 = nameError ? "true" : void 0;
	let t11;
	if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
		t11 = (event) => {
			setNameError(null);
			setName(event.target.value.slice(0, WATCHLIST_NAME_MAX_LENGTH));
		};
		$[17] = t11;
	} else t11 = $[17];
	let t12;
	if ($[18] !== item.title) {
		t12 = (event_0) => {
			if (event_0.key === "Enter") event_0.currentTarget.blur();
			if (event_0.key === "Escape") {
				setName(item.title);
				setNameError(null);
				event_0.currentTarget.blur();
			}
		};
		$[18] = item.title;
		$[19] = t12;
	} else t12 = $[19];
	const t13 = shakeName && "animate-[export-field-shake_0.4s_ease]";
	const t14 = nameError && "border-gx-failure-dark";
	let t15;
	if ($[20] !== t13 || $[21] !== t14) {
		t15 = cn("mt-0.5 mb-2 block min-w-0 w-full overflow-hidden border-0 border-b border-transparent bg-transparent px-0 pt-0 pb-[3px] font-serif text-[15px] leading-[1.3] font-bold text-gx-text outline-none transition-colors hover:border-gx-neutral focus:border-gx-highlight focus:ring-0", t13, t14);
		$[20] = t13;
		$[21] = t14;
		$[22] = t15;
	} else t15 = $[22];
	let t16;
	if ($[23] !== commitName || $[24] !== name || $[25] !== t10 || $[26] !== t12 || $[27] !== t15 || $[28] !== t8 || $[29] !== t9) {
		t16 = /* @__PURE__ */ jsx("input", {
			"aria-label": t8,
			"aria-describedby": t9,
			"aria-invalid": t10,
			title: "Click to rename",
			minLength: WATCHLIST_NAME_MIN_LENGTH,
			maxLength: WATCHLIST_NAME_MAX_LENGTH,
			ref: nameInputRef,
			value: name,
			onChange: t11,
			onBlur: commitName,
			onKeyDown: t12,
			className: t15
		});
		$[23] = commitName;
		$[24] = name;
		$[25] = t10;
		$[26] = t12;
		$[27] = t15;
		$[28] = t8;
		$[29] = t9;
		$[30] = t16;
	} else t16 = $[30];
	let t17;
	if ($[31] !== item.code || $[32] !== nameError) {
		t17 = nameError ? /* @__PURE__ */ jsx("p", {
			id: `${item.code}-name-error`,
			role: "alert",
			className: "-mt-1 mb-2 text-[11px] leading-none text-gx-failure-light",
			children: nameError
		}) : null;
		$[31] = item.code;
		$[32] = nameError;
		$[33] = t17;
	} else t17 = $[33];
	let t18;
	if ($[34] !== t16 || $[35] !== t17) {
		t18 = /* @__PURE__ */ jsxs("span", {
			className: "relative z-[1] block min-h-[34px] text-[15px] leading-[1.3] font-bold text-gx-text",
			children: [t16, t17]
		});
		$[34] = t16;
		$[35] = t17;
		$[36] = t18;
	} else t18 = $[36];
	const t19 = `View ${item.code} in Catalog`;
	let t20;
	if ($[37] !== item.code || $[38] !== onViewCatalog) {
		t20 = () => onViewCatalog?.(item.code);
		$[37] = item.code;
		$[38] = onViewCatalog;
		$[39] = t20;
	} else t20 = $[39];
	let t21;
	if ($[40] !== item.price) {
		t21 = /* @__PURE__ */ jsx("span", {
			className: "block text-[20px] leading-tight font-mono font-bold tabular-nums text-gx-text transition-colors group-hover/price-zone:text-gx-highlight",
			children: item.price
		});
		$[40] = item.price;
		$[41] = t21;
	} else t21 = $[41];
	const t22 = item.trend === "up" && "text-gx-success text-shadow-[0_0_12px_rgba(51,214,144,0.35)]";
	const t23 = item.trend === "down" && "text-gx-failure-light text-shadow-[0_0_12px_rgba(255,92,103,0.35)]";
	const t24 = item.trend === "neutral" && "text-gx-text-secondary";
	let t25;
	if ($[42] !== t22 || $[43] !== t23 || $[44] !== t24) {
		t25 = cn("relative z-[1] mt-1 inline-flex w-fit items-center gap-1 rounded-full bg-white/5 px-2 py-0.5 text-xs leading-none font-bold tabular-nums", t22, t23, t24);
		$[42] = t22;
		$[43] = t23;
		$[44] = t24;
		$[45] = t25;
	} else t25 = $[45];
	let t26;
	if ($[46] !== item.trend) {
		t26 = item.trend !== "neutral" ? /* @__PURE__ */ jsx("span", {
			"aria-hidden": "true",
			className: cn("size-0 border-x-[4px] border-b-[6px] border-x-transparent border-b-current", item.trend === "down" && "rotate-180")
		}) : null;
		$[46] = item.trend;
		$[47] = t26;
	} else t26 = $[47];
	let t27;
	if ($[48] !== item.delta || $[49] !== t25 || $[50] !== t26) {
		t27 = /* @__PURE__ */ jsxs("span", {
			className: t25,
			children: [t26, item.delta]
		});
		$[48] = item.delta;
		$[49] = t25;
		$[50] = t26;
		$[51] = t27;
	} else t27 = $[51];
	let t28;
	if ($[52] !== t19 || $[53] !== t20 || $[54] !== t21 || $[55] !== t27) {
		t28 = /* @__PURE__ */ jsxs("button", {
			type: "button",
			title: t19,
			onClick: t20,
			className: "group/price-zone relative z-[1] block w-full cursor-pointer border-0 bg-transparent p-0 text-left",
			children: [t21, t27]
		});
		$[52] = t19;
		$[53] = t20;
		$[54] = t21;
		$[55] = t27;
		$[56] = t28;
	} else t28 = $[56];
	const t29 = `Remove ${item.title}`;
	let t30;
	if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
		t30 = () => setRemoveDialogOpen(true);
		$[57] = t30;
	} else t30 = $[57];
	let t31;
	if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
		t31 = /* @__PURE__ */ jsx(XIcon, { className: "size-3.5" });
		$[58] = t31;
	} else t31 = $[58];
	let t32;
	if ($[59] !== t29) {
		t32 = /* @__PURE__ */ jsx("button", {
			type: "button",
			"aria-label": t29,
			onClick: t30,
			className: "absolute top-1 right-1 flex size-6 items-center justify-center bg-transparent text-gx-text-secondary opacity-0 transition-opacity group-hover:opacity-100 focus-visible:opacity-100 hover:text-gx-failure-light",
			children: t31
		});
		$[59] = t29;
		$[60] = t32;
	} else t32 = $[60];
	let t33;
	if ($[61] !== item.title) {
		t33 = /* @__PURE__ */ jsxs(DialogTitle, { children: [
			"Remove ",
			item.title,
			"?"
		] });
		$[61] = item.title;
		$[62] = t33;
	} else t33 = $[62];
	let t34;
	if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
		t34 = /* @__PURE__ */ jsx("p", {
			className: "text-sm text-muted-foreground",
			children: "This index will be removed from your homepage watchlist."
		});
		$[63] = t34;
	} else t34 = $[63];
	let t35;
	if ($[64] !== t33) {
		t35 = /* @__PURE__ */ jsxs(DialogHeader, { children: [t33, t34] });
		$[64] = t33;
		$[65] = t35;
	} else t35 = $[65];
	let t36;
	if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
		t36 = /* @__PURE__ */ jsx(Button, {
			variant: "outline",
			onClick: () => setRemoveDialogOpen(false),
			children: "Cancel"
		});
		$[66] = t36;
	} else t36 = $[66];
	let t37;
	if ($[67] !== item.id || $[68] !== onRemove) {
		t37 = /* @__PURE__ */ jsxs(DialogFooter, { children: [t36, /* @__PURE__ */ jsx(Button, {
			variant: "destructive",
			onClick: () => {
				setRemoveDialogOpen(false);
				onRemove?.(item.id);
			},
			children: "Remove"
		})] });
		$[67] = item.id;
		$[68] = onRemove;
		$[69] = t37;
	} else t37 = $[69];
	let t38;
	if ($[70] !== t35 || $[71] !== t37) {
		t38 = /* @__PURE__ */ jsxs(DialogContent, {
			showCloseButton: false,
			children: [t35, t37]
		});
		$[70] = t35;
		$[71] = t37;
		$[72] = t38;
	} else t38 = $[72];
	let t39;
	if ($[73] !== removeDialogOpen || $[74] !== t38) {
		t39 = /* @__PURE__ */ jsx(Dialog, {
			open: removeDialogOpen,
			onOpenChange: setRemoveDialogOpen,
			children: t38
		});
		$[73] = removeDialogOpen;
		$[74] = t38;
		$[75] = t39;
	} else t39 = $[75];
	let t40;
	if ($[76] !== t18 || $[77] !== t28 || $[78] !== t32 || $[79] !== t39 || $[80] !== t5 || $[81] !== t6 || $[82] !== t7) {
		t40 = /* @__PURE__ */ jsxs("div", {
			className: "group relative h-full min-h-[110px] overflow-hidden rounded-[6px] border border-gx-border bg-gx-tile-dark px-4 py-3 pl-[22px] transition-colors hover:border-gx-neutral",
			children: [
				t5,
				t6,
				t7,
				t18,
				t28,
				t32,
				t39
			]
		});
		$[76] = t18;
		$[77] = t28;
		$[78] = t32;
		$[79] = t39;
		$[80] = t5;
		$[81] = t6;
		$[82] = t7;
		$[83] = t40;
	} else t40 = $[83];
	return t40;
}
function WatchlistTileSkeleton(t0) {
	const $ = c(14);
	if ($[0] !== "5964b7503f49d8f5e2c035fc417813dad43bdd55642397152a2d55bb109ffd03") {
		for (let $i = 0; $i < 14; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "5964b7503f49d8f5e2c035fc417813dad43bdd55642397152a2d55bb109ffd03";
	}
	let className;
	let props;
	if ($[1] !== t0) {
		({className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = props;
	} else {
		className = $[2];
		props = $[3];
	}
	let t1;
	if ($[4] !== className) {
		t1 = cn("relative h-full min-h-[110px] overflow-hidden rounded-[6px] border border-gx-border bg-gx-tile-dark px-4 py-3 pl-[22px]", className);
		$[4] = className;
		$[5] = t1;
	} else t1 = $[5];
	let t2;
	let t3;
	let t4;
	let t5;
	let t6;
	if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
		t2 = /* @__PURE__ */ jsx("span", { className: "absolute top-3.5 bottom-3.5 left-0 w-0.5 bg-gx-neutral" });
		t3 = /* @__PURE__ */ jsx(Skeleton, { className: "h-3 w-20" });
		t4 = /* @__PURE__ */ jsx(Skeleton, { className: "mt-2 h-4 w-3/4" });
		t5 = /* @__PURE__ */ jsx(Skeleton, { className: "mt-3 h-6 w-20" });
		t6 = /* @__PURE__ */ jsx(Skeleton, { className: "mt-1 h-[18px] w-14 rounded-full" });
		$[6] = t2;
		$[7] = t3;
		$[8] = t4;
		$[9] = t5;
		$[10] = t6;
	} else {
		t2 = $[6];
		t3 = $[7];
		t4 = $[8];
		t5 = $[9];
		t6 = $[10];
	}
	let t7;
	if ($[11] !== props || $[12] !== t1) {
		t7 = /* @__PURE__ */ jsxs("div", {
			"aria-hidden": "true",
			className: t1,
			...props,
			children: [
				t2,
				t3,
				t4,
				t5,
				t6
			]
		});
		$[11] = props;
		$[12] = t1;
		$[13] = t7;
	} else t7 = $[13];
	return t7;
}
function WatchlistChart(t0) {
	const $ = c(23);
	if ($[0] !== "5964b7503f49d8f5e2c035fc417813dad43bdd55642397152a2d55bb109ffd03") {
		for (let $i = 0; $i < 23; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "5964b7503f49d8f5e2c035fc417813dad43bdd55642397152a2d55bb109ffd03";
	}
	const { points, trend } = t0;
	const t1 = useId();
	let t2;
	if ($[1] !== t1) {
		t2 = t1.replaceAll(":", "");
		$[1] = t1;
		$[2] = t2;
	} else t2 = $[2];
	const chartId = t2;
	if (points.length < 2) return null;
	let t3;
	if ($[3] !== points) {
		t3 = normalizeSparklinePoints(points).map(_temp$3).join(" ");
		$[3] = points;
		$[4] = t3;
	} else t3 = $[4];
	const line = t3;
	const area = `0,110 ${line} 300,110`;
	const t4 = trend === "up" && "text-gx-success";
	const t5 = trend === "down" && "text-gx-failure-light";
	const t6 = trend === "neutral" && "text-gx-text-secondary";
	let t7;
	if ($[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
		t7 = cn("pointer-events-none absolute inset-0 z-0 h-full w-full opacity-60", t4, t5, t6);
		$[5] = t4;
		$[6] = t5;
		$[7] = t6;
		$[8] = t7;
	} else t7 = $[8];
	let t8;
	let t9;
	if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
		t8 = /* @__PURE__ */ jsx("stop", {
			offset: "0%",
			stopColor: "currentColor",
			stopOpacity: "0.18"
		});
		t9 = /* @__PURE__ */ jsx("stop", {
			offset: "100%",
			stopColor: "currentColor",
			stopOpacity: "0"
		});
		$[9] = t8;
		$[10] = t9;
	} else {
		t8 = $[9];
		t9 = $[10];
	}
	let t10;
	if ($[11] !== chartId) {
		t10 = /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs("linearGradient", {
			id: chartId,
			x1: "0",
			y1: "0",
			x2: "0",
			y2: "1",
			children: [t8, t9]
		}) });
		$[11] = chartId;
		$[12] = t10;
	} else t10 = $[12];
	const t11 = `url(#${chartId})`;
	let t12;
	if ($[13] !== area || $[14] !== t11) {
		t12 = /* @__PURE__ */ jsx("polygon", {
			points: area,
			fill: t11
		});
		$[13] = area;
		$[14] = t11;
		$[15] = t12;
	} else t12 = $[15];
	let t13;
	if ($[16] !== line) {
		t13 = /* @__PURE__ */ jsx("polyline", {
			points: line,
			fill: "none",
			stroke: "currentColor",
			strokeOpacity: "0.55",
			strokeWidth: "1.5"
		});
		$[16] = line;
		$[17] = t13;
	} else t13 = $[17];
	let t14;
	if ($[18] !== t10 || $[19] !== t12 || $[20] !== t13 || $[21] !== t7) {
		t14 = /* @__PURE__ */ jsxs("svg", {
			"aria-hidden": "true",
			className: t7,
			viewBox: "0 0 300 110",
			preserveAspectRatio: "none",
			children: [
				t10,
				t12,
				t13
			]
		});
		$[18] = t10;
		$[19] = t12;
		$[20] = t13;
		$[21] = t7;
		$[22] = t14;
	} else t14 = $[22];
	return t14;
}
function _temp$3(t0) {
	const { t, v } = t0;
	return `${(t * 300).toFixed(1)},${(110 - v * 100).toFixed(1)}`;
}
//#endregion
//#region src/components/home/watchlist-section.tsx
const MAX_WATCHLIST_TILES = 8;
/**
* The homepage Watchlist: a responsive grid of `WatchlistTile` components,
* followed by a dashed "+ Add index" tile until the eight-item limit is
* reached. When there are no items the grid shows just that tile — there is no
* separate card empty state.
*/
function WatchlistSection(t0) {
	const $ = c(31);
	if ($[0] !== "ad7b174f235d79deb3f9079e4f378c8ea4ff8638165cda7380edcd9da95c811e") {
		for (let $i = 0; $i < 31; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "ad7b174f235d79deb3f9079e4f378c8ea4ff8638165cda7380edcd9da95c811e";
	}
	let className;
	let items;
	let onAddIndex;
	let onRemove;
	let onRename;
	let onViewCatalog;
	let props;
	let t1;
	let t2;
	if ($[1] !== t0) {
		({items, isLoading: t1, isError: t2, onAddIndex, onRemove, onRename, onViewCatalog, className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = items;
		$[4] = onAddIndex;
		$[5] = onRemove;
		$[6] = onRename;
		$[7] = onViewCatalog;
		$[8] = props;
		$[9] = t1;
		$[10] = t2;
	} else {
		className = $[2];
		items = $[3];
		onAddIndex = $[4];
		onRemove = $[5];
		onRename = $[6];
		onViewCatalog = $[7];
		props = $[8];
		t1 = $[9];
		t2 = $[10];
	}
	const isLoading = t1 === void 0 ? false : t1;
	if (t2 === void 0 ? false : t2) {
		let t3;
		if ($[11] !== className || $[12] !== props) {
			t3 = /* @__PURE__ */ jsx(SectionError, {
				className,
				title: "Couldn't load watchlist",
				description: "Please try again shortly.",
				...props
			});
			$[11] = className;
			$[12] = props;
			$[13] = t3;
		} else t3 = $[13];
		return t3;
	}
	let t3;
	if ($[14] !== className) {
		t3 = cn("grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4", className);
		$[14] = className;
		$[15] = t3;
	} else t3 = $[15];
	let t4;
	if ($[16] !== isLoading || $[17] !== items || $[18] !== onRemove || $[19] !== onRename || $[20] !== onViewCatalog) {
		t4 = isLoading ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("output", {
			className: "sr-only",
			children: "Loading watchlist market data"
		}), items.slice(0, MAX_WATCHLIST_TILES).map(_temp$2)] }) : items.slice(0, MAX_WATCHLIST_TILES).map((item_0) => /* @__PURE__ */ jsx(WatchlistTileView, {
			item: item_0,
			onRemove,
			onRename,
			onViewCatalog
		}, item_0.id));
		$[16] = isLoading;
		$[17] = items;
		$[18] = onRemove;
		$[19] = onRename;
		$[20] = onViewCatalog;
		$[21] = t4;
	} else t4 = $[21];
	let t5;
	if ($[22] !== items.length || $[23] !== onAddIndex) {
		t5 = items.length < MAX_WATCHLIST_TILES ? /* @__PURE__ */ jsx("button", {
			type: "button",
			onClick: onAddIndex,
			className: "flex h-full min-h-[110px] items-center justify-center gap-2 rounded-[6px] border border-dashed border-gx-neutral bg-transparent text-[13px] font-semibold text-gx-text-tertiary transition-colors hover:border-gx-highlight hover:text-gx-highlight",
			children: "+ Add index"
		}) : null;
		$[22] = items.length;
		$[23] = onAddIndex;
		$[24] = t5;
	} else t5 = $[24];
	let t6;
	if ($[25] !== isLoading || $[26] !== props || $[27] !== t3 || $[28] !== t4 || $[29] !== t5) {
		t6 = /* @__PURE__ */ jsxs("div", {
			"data-slot": "watchlist-section",
			"aria-busy": isLoading,
			className: t3,
			...props,
			children: [t4, t5]
		});
		$[25] = isLoading;
		$[26] = props;
		$[27] = t3;
		$[28] = t4;
		$[29] = t5;
		$[30] = t6;
	} else t6 = $[30];
	return t6;
}
function _temp$2(item) {
	return /* @__PURE__ */ jsx(WatchlistTileSkeleton, {}, item.id);
}
//#endregion
//#region src/components/home/whats-new-section.tsx
/** Editorial update banners from the approved Home prototype. */
function WhatsNewSection(t0) {
	const $ = c(3);
	if ($[0] !== "26c5e79ba4d67751517250f686bdccb120f7d5f07c1cc295dcc30a0105e95a4b") {
		for (let $i = 0; $i < 3; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "26c5e79ba4d67751517250f686bdccb120f7d5f07c1cc295dcc30a0105e95a4b";
	}
	const { updates } = t0;
	let t1;
	if ($[1] !== updates) {
		t1 = /* @__PURE__ */ jsx(HomeCarousel, {
			ariaLabel: "What's New",
			items: updates,
			itemKey: _temp$1,
			renderItem: _temp2$1
		});
		$[1] = updates;
		$[2] = t1;
	} else t1 = $[2];
	return t1;
}
function _temp2$1(update_0) {
	return /* @__PURE__ */ jsxs("article", {
		className: cn("group relative h-27.5 overflow-hidden border border-[#26272f] bg-[#111116] transition-[height] duration-200 ease-out", update_0.description && "has-[a:focus-visible]:h-42.5 hover:h-42.5"),
		children: [/* @__PURE__ */ jsxs("div", {
			className: "absolute inset-6 flex flex-col justify-start pt-3.5",
			children: [/* @__PURE__ */ jsx("h4", {
				className: "pr-37.5 text-[16px] font-extrabold leading-[1.3] text-[#f3f2ed]",
				children: update_0.title
			}), update_0.description ? /* @__PURE__ */ jsx("p", {
				className: "max-h-0 max-w-115 overflow-hidden text-[13px] leading-[1.6] text-[#9fa0ad] opacity-0 transition-[max-height,opacity,margin-bottom] duration-200 ease-out group-has-[a:focus-visible]:mb-2.5 group-has-[a:focus-visible]:max-h-15 group-has-[a:focus-visible]:opacity-100 group-hover:mb-2.5 group-hover:max-h-15 group-hover:opacity-100",
				children: update_0.description
			}) : null]
		}), /* @__PURE__ */ jsxs("a", {
			href: update_0.href,
			target: "_blank",
			rel: "noreferrer",
			className: "absolute top-9.5 right-11.5 z-[2] inline-flex h-6 items-center gap-2 rounded-[3px] bg-[linear-gradient(160deg,#ff7a3d,#e84e0f)] px-3 text-[12px] leading-4 font-bold text-[#141008] shadow-[0_1px_0_rgba(255,255,255,0.15)_inset,0_6px_16px_-8px_rgba(232,78,15,0.35)] transition-[box-shadow,transform] duration-150 hover:-translate-y-px hover:shadow-[0_1px_0_rgba(255,255,255,0.2)_inset,0_8px_22px_-6px_rgba(232,78,15,0.35)] active:translate-y-0",
			children: [update_0.actionLabel, /* @__PURE__ */ jsx(ArrowRight, {
				className: "size-3.5",
				"aria-hidden": true
			})]
		})]
	});
}
function _temp$1(update) {
	return update.id;
}
//#endregion
//#region src/components/home/home-page.tsx
/**
* The homepage content region: greeting + Watchlist (with a "Browse full
* Catalog" hook), Morning Intel, My Dashboards, and a full-width Export
* section, in prototype order.
* Purely presentational — all data and section-header action nodes are supplied
* by the consumer. Layout-neutral: it fills its parent's width with no padding
* or max-width of its own, so the app shell (or a wrapper) owns the page gutter
* and reading width. Does NOT include the app shell (navbar/rail); that is wired
* separately when this is integrated into the app.
*
* Import path: `@design-system/components/home/home-page`.
*/
function HomePage(t0) {
	const $ = c(83);
	if ($[0] !== "cd0e4f8b93ca67716c1c74e7e8970b80836e00225b62451cc3d59654619e33b1") {
		for (let $i = 0; $i < 83; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "cd0e4f8b93ca67716c1c74e7e8970b80836e00225b62451cc3d59654619e33b1";
	}
	let className;
	let dashboards;
	let dashboardsAction;
	let exports;
	let exportsAction;
	let greeting;
	let intelAction;
	let onAddIndex;
	let onBrowseCatalog;
	let onRemoveWatchlistItem;
	let onRenameWatchlistItem;
	let onSignalSelect;
	let onViewWatchlistItemInCatalog;
	let props;
	let signals;
	let t1;
	let t2;
	let t3;
	let t4;
	let t5;
	let t6;
	let t7;
	let watchlist;
	if ($[1] !== t0) {
		({greeting, watchlist, signals, dashboards, exports, updates: t1, watchlistLoading: t2, watchlistError: t3, onAddIndex, onRemoveWatchlistItem, onRenameWatchlistItem, onViewWatchlistItemInCatalog, onSignalSelect, intelAction, dashboardsAction, exportsAction, onBrowseCatalog, dashboardsLoading: t4, exportsLoading: t5, dashboardsError: t6, exportsError: t7, className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = dashboards;
		$[4] = dashboardsAction;
		$[5] = exports;
		$[6] = exportsAction;
		$[7] = greeting;
		$[8] = intelAction;
		$[9] = onAddIndex;
		$[10] = onBrowseCatalog;
		$[11] = onRemoveWatchlistItem;
		$[12] = onRenameWatchlistItem;
		$[13] = onSignalSelect;
		$[14] = onViewWatchlistItemInCatalog;
		$[15] = props;
		$[16] = signals;
		$[17] = t1;
		$[18] = t2;
		$[19] = t3;
		$[20] = t4;
		$[21] = t5;
		$[22] = t6;
		$[23] = t7;
		$[24] = watchlist;
	} else {
		className = $[2];
		dashboards = $[3];
		dashboardsAction = $[4];
		exports = $[5];
		exportsAction = $[6];
		greeting = $[7];
		intelAction = $[8];
		onAddIndex = $[9];
		onBrowseCatalog = $[10];
		onRemoveWatchlistItem = $[11];
		onRenameWatchlistItem = $[12];
		onSignalSelect = $[13];
		onViewWatchlistItemInCatalog = $[14];
		props = $[15];
		signals = $[16];
		t1 = $[17];
		t2 = $[18];
		t3 = $[19];
		t4 = $[20];
		t5 = $[21];
		t6 = $[22];
		t7 = $[23];
		watchlist = $[24];
	}
	let t8;
	if ($[25] !== t1) {
		t8 = t1 === void 0 ? [] : t1;
		$[25] = t1;
		$[26] = t8;
	} else t8 = $[26];
	const updates = t8;
	const watchlistLoading = t2 === void 0 ? false : t2;
	const watchlistError = t3 === void 0 ? false : t3;
	const dashboardsLoading = t4 === void 0 ? false : t4;
	const exportsLoading = t5 === void 0 ? false : t5;
	const dashboardsError = t6 === void 0 ? false : t6;
	const exportsError = t7 === void 0 ? false : t7;
	let t9;
	if ($[27] !== className) {
		t9 = cn("w-full bg-[#0a0a0f] text-[#f3f2ed]", className);
		$[27] = className;
		$[28] = t9;
	} else t9 = $[28];
	let t10;
	if ($[29] !== greeting.date || $[30] !== greeting.title) {
		t10 = /* @__PURE__ */ jsx(HomeGreeting, {
			title: greeting.title,
			date: greeting.date
		});
		$[29] = greeting.date;
		$[30] = greeting.title;
		$[31] = t10;
	} else t10 = $[31];
	let t11;
	if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
		t11 = /* @__PURE__ */ jsx(HomeSectionHeader, {
			title: "Watchlist",
			variant: "secondary"
		});
		$[32] = t11;
	} else t11 = $[32];
	let t12;
	if ($[33] !== onAddIndex || $[34] !== onRemoveWatchlistItem || $[35] !== onRenameWatchlistItem || $[36] !== onViewWatchlistItemInCatalog || $[37] !== watchlist || $[38] !== watchlistError || $[39] !== watchlistLoading) {
		t12 = /* @__PURE__ */ jsx(WatchlistSection, {
			items: watchlist,
			isLoading: watchlistLoading,
			isError: watchlistError,
			onAddIndex,
			onRemove: onRemoveWatchlistItem,
			onRename: onRenameWatchlistItem,
			onViewCatalog: onViewWatchlistItemInCatalog
		});
		$[33] = onAddIndex;
		$[34] = onRemoveWatchlistItem;
		$[35] = onRenameWatchlistItem;
		$[36] = onViewWatchlistItemInCatalog;
		$[37] = watchlist;
		$[38] = watchlistError;
		$[39] = watchlistLoading;
		$[40] = t12;
	} else t12 = $[40];
	let t13;
	if ($[41] !== onBrowseCatalog) {
		t13 = onBrowseCatalog ? /* @__PURE__ */ jsxs("div", {
			role: "button",
			tabIndex: 0,
			onClick: onBrowseCatalog,
			onKeyDown: activateOnEnterSpace(),
			className: "mt-3 flex cursor-pointer items-center justify-between gap-4 rounded-[6px] border border-gx-border bg-gx-tile-dark px-4 py-3 text-[13px] text-gx-text-secondary transition-colors hover:border-gx-info-main hover:bg-gx-tile-light",
			children: [/* @__PURE__ */ jsxs("span", { children: [/* @__PURE__ */ jsx("strong", {
				className: "text-gx-text",
				children: "Looking for more?"
			}), " Browse the full Catalog for every index, curve and data series we cover."] }), /* @__PURE__ */ jsxs("span", {
				className: "inline-flex shrink-0 items-center gap-1 font-semibold text-gx-info-main",
				children: ["Browse catalog", /* @__PURE__ */ jsx(ArrowRight, {
					className: "size-3.5",
					"aria-hidden": true
				})]
			})]
		}) : null;
		$[41] = onBrowseCatalog;
		$[42] = t13;
	} else t13 = $[42];
	let t14;
	if ($[43] !== t12 || $[44] !== t13) {
		t14 = /* @__PURE__ */ jsxs("div", { children: [
			t11,
			t12,
			t13
		] });
		$[43] = t12;
		$[44] = t13;
		$[45] = t14;
	} else t14 = $[45];
	let t15;
	if ($[46] !== intelAction) {
		t15 = /* @__PURE__ */ jsx(HomeSectionHeader, {
			title: "Morning Intel",
			action: intelAction
		});
		$[46] = intelAction;
		$[47] = t15;
	} else t15 = $[47];
	let t16;
	if ($[48] !== onSignalSelect || $[49] !== signals) {
		t16 = /* @__PURE__ */ jsx(MorningIntelSection, {
			signals,
			onSignalSelect
		});
		$[48] = onSignalSelect;
		$[49] = signals;
		$[50] = t16;
	} else t16 = $[50];
	let t17;
	if ($[51] !== t15 || $[52] !== t16) {
		t17 = /* @__PURE__ */ jsxs("div", {
			className: "mt-6",
			children: [t15, t16]
		});
		$[51] = t15;
		$[52] = t16;
		$[53] = t17;
	} else t17 = $[53];
	let t18;
	if ($[54] !== dashboardsAction) {
		t18 = /* @__PURE__ */ jsx(HomeSectionHeader, {
			title: "My Dashboards",
			variant: "secondary",
			action: dashboardsAction
		});
		$[54] = dashboardsAction;
		$[55] = t18;
	} else t18 = $[55];
	let t19;
	if ($[56] !== dashboards || $[57] !== dashboardsError || $[58] !== dashboardsLoading) {
		t19 = /* @__PURE__ */ jsx(MyDashboardsSection, {
			dashboards,
			isLoading: dashboardsLoading,
			isError: dashboardsError
		});
		$[56] = dashboards;
		$[57] = dashboardsError;
		$[58] = dashboardsLoading;
		$[59] = t19;
	} else t19 = $[59];
	let t20;
	if ($[60] !== t18 || $[61] !== t19) {
		t20 = /* @__PURE__ */ jsxs("div", {
			className: "mt-6",
			children: [t18, t19]
		});
		$[60] = t18;
		$[61] = t19;
		$[62] = t20;
	} else t20 = $[62];
	let t21;
	if ($[63] !== exportsAction) {
		t21 = /* @__PURE__ */ jsx(HomeSectionHeader, {
			title: "Export",
			variant: "secondary",
			action: exportsAction
		});
		$[63] = exportsAction;
		$[64] = t21;
	} else t21 = $[64];
	let t22;
	if ($[65] !== exports || $[66] !== exportsError || $[67] !== exportsLoading) {
		t22 = /* @__PURE__ */ jsx(RecentExportsSection, {
			exports,
			isLoading: exportsLoading,
			isError: exportsError,
			className: "flex-1"
		});
		$[65] = exports;
		$[66] = exportsError;
		$[67] = exportsLoading;
		$[68] = t22;
	} else t22 = $[68];
	let t23;
	if ($[69] !== t21 || $[70] !== t22) {
		t23 = /* @__PURE__ */ jsx("div", {
			className: "mt-6",
			children: /* @__PURE__ */ jsxs("div", {
				className: "flex flex-col",
				children: [t21, t22]
			})
		});
		$[69] = t21;
		$[70] = t22;
		$[71] = t23;
	} else t23 = $[71];
	let t24;
	if ($[72] !== updates) {
		t24 = updates.length > 0 ? /* @__PURE__ */ jsxs("div", {
			className: "mt-6",
			children: [/* @__PURE__ */ jsx(HomeSectionHeader, {
				title: "What's New",
				variant: "secondary"
			}), /* @__PURE__ */ jsx(WhatsNewSection, { updates })]
		}) : null;
		$[72] = updates;
		$[73] = t24;
	} else t24 = $[73];
	let t25;
	if ($[74] !== props || $[75] !== t10 || $[76] !== t14 || $[77] !== t17 || $[78] !== t20 || $[79] !== t23 || $[80] !== t24 || $[81] !== t9) {
		t25 = /* @__PURE__ */ jsxs("div", {
			"data-slot": "home-page",
			className: t9,
			...props,
			children: [
				t10,
				t14,
				t17,
				t20,
				t23,
				t24
			]
		});
		$[74] = props;
		$[75] = t10;
		$[76] = t14;
		$[77] = t17;
		$[78] = t20;
		$[79] = t23;
		$[80] = t24;
		$[81] = t9;
		$[82] = t25;
	} else t25 = $[82];
	return t25;
}
//#endregion
//#region src/components/morning-intel/morning-intel-feed.tsx
const LIT_DOTS = {
	high: 3,
	medium: 2,
	low: 0
};
function SeverityDots(t0) {
	const $ = c(4);
	if ($[0] !== "dea2d6368b5e89741ba42bf78587e0b915dbd2b0440e5bb319dc96eb0702588e") {
		for (let $i = 0; $i < 4; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "dea2d6368b5e89741ba42bf78587e0b915dbd2b0440e5bb319dc96eb0702588e";
	}
	const { importance } = t0;
	const lit = LIT_DOTS[importance];
	const color = IMPORTANCE[importance].color;
	let t1;
	if ($[1] !== color || $[2] !== lit) {
		t1 = /* @__PURE__ */ jsx("span", {
			className: "flex items-center gap-1",
			"aria-hidden": "true",
			children: Array.from({ length: 3 }, (_, index) => /* @__PURE__ */ jsx("span", {
				className: "size-1.5 rounded-full",
				style: { backgroundColor: index < lit ? color : "var(--gx-text-disabled)" }
			}, index))
		});
		$[1] = color;
		$[2] = lit;
		$[3] = t1;
	} else t1 = $[3];
	return t1;
}
function ImportanceGroup(t0) {
	const $ = c(28);
	if ($[0] !== "dea2d6368b5e89741ba42bf78587e0b915dbd2b0440e5bb319dc96eb0702588e") {
		for (let $i = 0; $i < 28; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "dea2d6368b5e89741ba42bf78587e0b915dbd2b0440e5bb319dc96eb0702588e";
	}
	const { importance, signals, defaultOpen, selectedSignalId, onSignalSelect } = t0;
	const cfg = IMPORTANCE[importance];
	let t1;
	if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
		t1 = /* @__PURE__ */ jsx("button", {
			type: "button",
			className: "group/importance-trigger flex w-full items-center gap-2 rounded-[10px] border border-white/10 bg-gx-tile-dark px-4 py-3 text-left"
		});
		$[1] = t1;
	} else t1 = $[1];
	let t2;
	let t3;
	if ($[2] !== importance) {
		t2 = /* @__PURE__ */ jsx(SeverityDots, { importance });
		t3 = /* @__PURE__ */ jsxs("span", {
			className: "text-[12px] font-extrabold tracking-[0.08em] text-gx-text uppercase",
			children: [importance, " importance"]
		});
		$[2] = importance;
		$[3] = t2;
		$[4] = t3;
	} else {
		t2 = $[3];
		t3 = $[4];
	}
	const t4 = signals.length === 1 ? "signal" : "signals";
	let t5;
	if ($[5] !== signals.length || $[6] !== t4) {
		t5 = /* @__PURE__ */ jsxs("span", {
			className: "text-[12px] text-gx-text-secondary",
			children: [
				signals.length,
				" ",
				t4
			]
		});
		$[5] = signals.length;
		$[6] = t4;
		$[7] = t5;
	} else t5 = $[7];
	let t6;
	if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
		t6 = /* @__PURE__ */ jsx(ChevronDownIcon, { className: "ml-auto size-4 text-gx-text-secondary transition-transform group-data-panel-open/importance-trigger:rotate-180" });
		$[8] = t6;
	} else t6 = $[8];
	let t7;
	if ($[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
		t7 = /* @__PURE__ */ jsxs(CollapsibleTrigger, {
			render: t1,
			children: [
				t2,
				t3,
				t5,
				t6
			]
		});
		$[9] = t2;
		$[10] = t3;
		$[11] = t5;
		$[12] = t7;
	} else t7 = $[12];
	let t8;
	if ($[13] !== cfg || $[14] !== onSignalSelect || $[15] !== selectedSignalId || $[16] !== signals) {
		let t9;
		if ($[18] !== cfg || $[19] !== onSignalSelect || $[20] !== selectedSignalId) {
			t9 = (signal) => {
				const selected = signal.id === selectedSignalId;
				return /* @__PURE__ */ jsx(IntelSignalCard, {
					title: signal.title,
					badge: /* @__PURE__ */ jsx(Badge, {
						variant: cfg.badge,
						children: cfg.label
					}),
					tag: /* @__PURE__ */ jsx(Badge, {
						variant: "mutedOutline",
						children: signal.region
					}),
					color: cfg.color,
					timestamp: `Produced ${signal.timestamp}`,
					selected,
					role: "button",
					tabIndex: 0,
					"aria-label": signal.title,
					"aria-pressed": selected,
					onClick: () => onSignalSelect?.(signal),
					onKeyDown: (event) => {
						if (event.key !== "Enter" && event.key !== " ") return;
						event.preventDefault();
						onSignalSelect?.(signal);
					},
					action: /* @__PURE__ */ jsx(Button, {
						"aria-hidden": "true",
						nativeButton: false,
						render: /* @__PURE__ */ jsx("span", {}),
						variant: "outline-highlight",
						size: "sm",
						children: "Deep dive →"
					}),
					children: signal.blurb
				}, signal.id);
			};
			$[18] = cfg;
			$[19] = onSignalSelect;
			$[20] = selectedSignalId;
			$[21] = t9;
		} else t9 = $[21];
		t8 = signals.map(t9);
		$[13] = cfg;
		$[14] = onSignalSelect;
		$[15] = selectedSignalId;
		$[16] = signals;
		$[17] = t8;
	} else t8 = $[17];
	let t9;
	if ($[22] !== t8) {
		t9 = /* @__PURE__ */ jsx(CollapsibleContent, {
			className: "flex flex-col gap-2 pt-2",
			children: t8
		});
		$[22] = t8;
		$[23] = t9;
	} else t9 = $[23];
	let t10;
	if ($[24] !== defaultOpen || $[25] !== t7 || $[26] !== t9) {
		t10 = /* @__PURE__ */ jsxs(Collapsible, {
			defaultOpen,
			children: [t7, t9]
		});
		$[24] = defaultOpen;
		$[25] = t7;
		$[26] = t9;
		$[27] = t10;
	} else t10 = $[27];
	return t10;
}
/**
* The full-page Morning Intel feed: a status line, a stat strip (total/high/
* medium counts, derived from `signals`), and the signals grouped into
* independently-collapsible High/Medium/Low importance sections. Renders the
* shared empty state when `signals` is empty. Each signal card is clickable
* (`onSignalSelect`) and shows the selected outline when its id matches
* `selectedSignalId`. For the compact homepage preview widget, use
* `MorningIntelSection` instead. Presentational — the consumer supplies
* pre-formatted signal and status values and owns what selection means (e.g.
* syncing it to a URL query param).
*
* Import path: `@design-system/components/morning-intel/morning-intel-feed`.
*/
function MorningIntelFeed(t0) {
	const $ = c(54);
	if ($[0] !== "dea2d6368b5e89741ba42bf78587e0b915dbd2b0440e5bb319dc96eb0702588e") {
		for (let $i = 0; $i < 54; $i += 1) $[$i] = Symbol.for("react.memo_cache_sentinel");
		$[0] = "dea2d6368b5e89741ba42bf78587e0b915dbd2b0440e5bb319dc96eb0702588e";
	}
	let className;
	let onSignalSelect;
	let props;
	let selectedSignalId;
	let signals;
	let statusLine;
	if ($[1] !== t0) {
		({signals, statusLine, selectedSignalId, onSignalSelect, className, ...props} = t0);
		$[1] = t0;
		$[2] = className;
		$[3] = onSignalSelect;
		$[4] = props;
		$[5] = selectedSignalId;
		$[6] = signals;
		$[7] = statusLine;
	} else {
		className = $[2];
		onSignalSelect = $[3];
		props = $[4];
		selectedSignalId = $[5];
		signals = $[6];
		statusLine = $[7];
	}
	if (signals.length === 0) {
		let t1;
		if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
			t1 = /* @__PURE__ */ jsx(SparklesIcon, {});
			$[8] = t1;
		} else t1 = $[8];
		let t2;
		if ($[9] !== className || $[10] !== props) {
			t2 = /* @__PURE__ */ jsx(SectionState, {
				className,
				framed: false,
				icon: t1,
				title: "No signals yet",
				description: "Market intelligence will appear here.",
				...props
			});
			$[9] = className;
			$[10] = props;
			$[11] = t2;
		} else t2 = $[11];
		return t2;
	}
	let t1;
	if ($[12] !== signals) {
		t1 = signals.filter(_temp);
		$[12] = signals;
		$[13] = t1;
	} else t1 = $[13];
	const high = t1;
	let t2;
	if ($[14] !== signals) {
		t2 = signals.filter(_temp2);
		$[14] = signals;
		$[15] = t2;
	} else t2 = $[15];
	const medium = t2;
	let t3;
	if ($[16] !== signals) {
		t3 = signals.filter(_temp3);
		$[16] = signals;
		$[17] = t3;
	} else t3 = $[17];
	const low = t3;
	let t4;
	if ($[18] !== high) {
		t4 = {
			importance: "high",
			signals: high
		};
		$[18] = high;
		$[19] = t4;
	} else t4 = $[19];
	let t5;
	if ($[20] !== medium) {
		t5 = {
			importance: "medium",
			signals: medium
		};
		$[20] = medium;
		$[21] = t5;
	} else t5 = $[21];
	let t6;
	if ($[22] !== low) {
		t6 = {
			importance: "low",
			signals: low
		};
		$[22] = low;
		$[23] = t6;
	} else t6 = $[23];
	let t7;
	if ($[24] !== t4 || $[25] !== t5 || $[26] !== t6) {
		t7 = [
			t4,
			t5,
			t6
		].filter(_temp4);
		$[24] = t4;
		$[25] = t5;
		$[26] = t6;
		$[27] = t7;
	} else t7 = $[27];
	const groups = t7;
	const firstNonEmptyImportance = groups[0]?.importance;
	let t8;
	if ($[28] !== className) {
		t8 = cn("flex flex-col gap-4", className);
		$[28] = className;
		$[29] = t8;
	} else t8 = $[29];
	let t9;
	if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
		t9 = /* @__PURE__ */ jsx("span", {
			className: "size-2 rounded-full bg-gx-success",
			"aria-hidden": "true"
		});
		$[30] = t9;
	} else t9 = $[30];
	let t10;
	if ($[31] !== statusLine) {
		t10 = /* @__PURE__ */ jsxs("div", {
			className: "flex items-center gap-2 text-[13px] text-gx-text-secondary",
			children: [t9, statusLine]
		});
		$[31] = statusLine;
		$[32] = t10;
	} else t10 = $[32];
	let t11;
	if ($[33] !== signals.length) {
		t11 = /* @__PURE__ */ jsx(StatTile, {
			value: signals.length,
			label: "Signals today"
		});
		$[33] = signals.length;
		$[34] = t11;
	} else t11 = $[34];
	let t12;
	if ($[35] !== high.length) {
		t12 = /* @__PURE__ */ jsx(StatTile, {
			value: high.length,
			label: "High importance",
			accent: "accent"
		});
		$[35] = high.length;
		$[36] = t12;
	} else t12 = $[36];
	let t13;
	if ($[37] !== medium.length) {
		t13 = /* @__PURE__ */ jsx(StatTile, {
			value: medium.length,
			label: "Medium importance",
			accent: "warning"
		});
		$[37] = medium.length;
		$[38] = t13;
	} else t13 = $[38];
	let t14;
	if ($[39] !== t11 || $[40] !== t12 || $[41] !== t13) {
		t14 = /* @__PURE__ */ jsxs("div", {
			className: "flex divide-x divide-white/10 rounded-[10px] border border-white/10 bg-gx-tile-dark",
			children: [
				t11,
				t12,
				t13
			]
		});
		$[39] = t11;
		$[40] = t12;
		$[41] = t13;
		$[42] = t14;
	} else t14 = $[42];
	let t15;
	if ($[43] !== firstNonEmptyImportance || $[44] !== groups || $[45] !== onSignalSelect || $[46] !== selectedSignalId) {
		t15 = /* @__PURE__ */ jsx("div", {
			className: "flex flex-col gap-3",
			children: groups.map((group_0) => /* @__PURE__ */ jsx(ImportanceGroup, {
				importance: group_0.importance,
				signals: group_0.signals,
				defaultOpen: group_0.importance === firstNonEmptyImportance,
				selectedSignalId,
				onSignalSelect
			}, group_0.importance))
		});
		$[43] = firstNonEmptyImportance;
		$[44] = groups;
		$[45] = onSignalSelect;
		$[46] = selectedSignalId;
		$[47] = t15;
	} else t15 = $[47];
	let t16;
	if ($[48] !== props || $[49] !== t10 || $[50] !== t14 || $[51] !== t15 || $[52] !== t8) {
		t16 = /* @__PURE__ */ jsxs("div", {
			"data-slot": "morning-intel-feed",
			className: t8,
			...props,
			children: [
				t10,
				t14,
				t15
			]
		});
		$[48] = props;
		$[49] = t10;
		$[50] = t14;
		$[51] = t15;
		$[52] = t8;
		$[53] = t16;
	} else t16 = $[53];
	return t16;
}
function _temp4(group) {
	return group.signals.length > 0;
}
function _temp3(signal_1) {
	return signal_1.importance === "low";
}
function _temp2(signal_0) {
	return signal_0.importance === "medium";
}
function _temp(signal) {
	return signal.importance === "high";
}
//#endregion
export { Alert, AlertAction, AlertDescription, AlertTitle, AppSidebar, Badge, Button, ButtonGroup, Calendar, CalendarDayButton, Card, CardAction, CardContent, CardDescription, CardFooter, CardHeader, CardTitle, Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, Checkbox, Collapsible, CollapsibleContent, CollapsibleTrigger, Combobox, ComboboxCollection, ComboboxContent, ComboboxEmpty, ComboboxGroup, ComboboxInput, ComboboxItem, ComboboxLabel, ComboboxList, DataTableActiveFilterChips, DataTableColumnHeader, DataTableColumnResizeHandle, DataTableDetailPanel, DataTableExpandToggle, DataTableFilterMenu, DataTableFilterPanel, DataTableFilterToggle, DataTableHierarchyCell, DataTableSaveFilterForm, DataTableSavedFiltersList, DataTableSearchInput, DataTableSelectionCheckbox, DataTableShowSelectedToggle, DataTableSurface, DataTableToolbar, DataTableViewOptions, DataTableViewOptionsPanel, DataTableVirtualized, DateInput, DateRangeInput, Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger, Drawer, DrawerBody, DrawerClose, DrawerContent, DrawerDescription, DrawerFooter, DrawerHeader, DrawerHeaderButton, DrawerTitle, DrawerTrigger, DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger, Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle, Field, FieldContent, FieldDescription, FieldError, FieldGroup, FieldLabel, FieldLegend, FieldSeparator, FieldSet, FieldTitle, HighlightedPrice, HomePage, IconButton, Input, InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput, InputGroupText, InputGroupTextarea, IntelSignalCard, IntelSignalCardCompact, Label, Markdown, Marker, MarkerContent, MarkerIcon, MarketingBar, MessageScroller, MessageScrollerButton, MessageScrollerContent, MessageScrollerItem, MessageScrollerProvider, MessageScrollerViewport, MorningIntelFeed, MorningIntelSection, PageHeader, Popover, PopoverContent, PopoverDescription, PopoverHeader, PopoverTitle, PopoverTrigger, RadioGroup, RadioGroupItem, SORT_SEARCH_PARAM, Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectScrollDownButton, SelectScrollUpButton, SelectSeparator, SelectTrigger, SelectValue, Separator, SettingsCard, SettingsCardFooter, SettingsCardRow, Sheet, SheetClose, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle, SheetTrigger, SidebarInset, SidebarProvider, Skeleton, Slider, Sparkline, Spinner, StatTile, Switch, Table, TableBody, TableCaption, TableCell, TableFooter, TableHead, TableHeader, TableRow, Tabs, TabsContent, TabsList, TabsTrigger, Textarea, Toast, ToastAction, ToastClose, ToastContent, ToastDescription, ToastPortal, ToastProvider, ToastTitle, ToastViewport, Toaster, ToggleGroup, ToggleGroupItem, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, WatchlistTileSkeleton, WatchlistTileView, chartThemeTokens, createAppColumnHelper, createToastManager, dataTableFeatures, getExpandColumn, getGroupSelectionColumn, getHiddenColumnCount, getSelectionColumn, markerVariants, toast, useAppTable, useCarousel, useDataTable, useFilterOptionsWithCounts, useFrozenSelectionSnapshot, useManagedTimeout, useMessageScroller, useMessageScrollerScrollable, useMessageScrollerVisibility, useProgressiveReveal, useSidebar, useTableContext, useToastManager, useUrlSyncedTableState };
